import './index.css';var Tl = Object.defineProperty;
var El = (n, e, t) => e in n ? Tl(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var hs = (n, e, t) => El(n, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as de, jsx as F, Fragment as yl } from "react/jsx-runtime";
import { DownloadLight as xl, CalendarLight as vl, ArrowAltLeft as Sl, ArrowAltRight as Al, PlayFill as Ll, PauseFill as Rl, ZoomOutCustom as Dl, ZoomLightCustom as Il, PinedFill as ki, PinLightLeft as Fi, ViewHideLight as Pi, SettingLineLight as bl, FrameLight as _l, FullLight as Cl, EyeLight as wl } from "@repo/go-icons";
import { LoaderIcon as ho } from "@repo/go-ui";
import { useRef as ae, useState as ne, useCallback as q, useMemo as Ee, useEffect as se, forwardRef as Ml, useLayoutEffect as fo } from "react";
import { useTranslation as lt, initReactI18next as kl, I18nextProvider as Fl } from "react-i18next";
import Pl from "i18next";
import Ol from "i18next-browser-languagedetector";
function mo(n) {
  var e, t, s = "";
  if (typeof n == "string" || typeof n == "number") s += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var i = n.length;
    for (e = 0; e < i; e++) n[e] && (t = mo(n[e])) && (s && (s += " "), s += t);
  } else for (t in n) n[t] && (s && (s += " "), s += t);
  return s;
}
function ue() {
  for (var n, e, t = 0, s = "", i = arguments.length; t < i; t++) (n = arguments[t]) && (e = mo(n)) && (s && (s += " "), s += e);
  return s;
}
function Js(n) {
  return typeof n == "number" && Number.isFinite(n) ? n : 0;
}
function On(n, e = 0) {
  return n + Js(e);
}
function Nn(n, e = 0) {
  return n - Js(e);
}
function Je(n, e = 0) {
  return new Date(On(n, e));
}
function is(n, e = 0) {
  const t = Je(n, e);
  return `${we(t.getHours())}:${we(
    t.getMinutes()
  )}:${we(t.getSeconds())}`;
}
function Nl(n, e = 0) {
  const t = Je(n, e);
  return `${we(t.getDate())}.${we(t.getMonth() + 1)}.${t.getFullYear()}`;
}
function Ul(n, e = 0) {
  return `${Nl(n, e)} ${is(n, e)}`;
}
function we(n) {
  return String(n).padStart(2, "0");
}
const Bl = 500;
function $l({
  displayTimeOffsetMs: n,
  title: e
}) {
  const t = ae(!1), [s, i] = ne(!1), [r, o] = ne(null), a = q(() => {
    o(null);
  }, []), l = q(
    (c) => {
      if (!t.current) {
        t.current = !0, i(!0), o(null);
        try {
          Gl({
            displayTimeOffsetMs: n,
            part: c,
            title: e
          });
        } catch (u) {
          t.current = !1, i(!1), o(u instanceof Error ? u : new Error("Failed to download DVR export"));
          return;
        }
        setTimeout(() => {
          t.current = !1, i(!1);
        }, Bl);
      }
    },
    [n, e]
  );
  return {
    clearDownloadError: a,
    downloadError: r,
    downloading: s,
    downloadPart: l
  };
}
function Gl({
  displayTimeOffsetMs: n,
  part: e,
  title: t
}) {
  const s = document.createElement("a");
  s.href = e.url, s.download = Hl({
    displayTimeOffsetMs: n,
    fromMs: e.fromMs,
    title: t,
    toMs: e.toMs
  }), s.rel = "noopener noreferrer", document.body.appendChild(s), s.click(), s.remove();
}
function Hl({
  displayTimeOffsetMs: n,
  fromMs: e,
  title: t,
  toMs: s
}) {
  return `${Kl(t)}_${Oi(
    e,
    n
  )}_${Oi(s, n)}.mp4`;
}
function Kl(n) {
  return n.replace(/[<>:"/\\|?*]/g, "_").replace(/\s+/g, " ").trim() || "video";
}
function Oi(n, e) {
  const t = Je(n, e);
  return `${t.getFullYear()}-${we(
    t.getMonth() + 1
  )}-${we(t.getDate())}_${Vl(n, e).replace(
    /:/g,
    "-"
  )}`;
}
function Vl(n, e) {
  return is(n, e);
}
const Wl = "HlsDvrExportButton-module__root__CDKPo", Yl = "HlsDvrExportButton-module__iconButton__zENqO", ql = "HlsDvrExportButton-module__partButton__7FXhU", zl = "HlsDvrExportButton-module__partsMenu__2-dLi", fs = {
  root: Wl,
  iconButton: Yl,
  partButton: ql,
  partsMenu: zl
};
function jl({ displayTimeOffsetMs: n, exportState: e, title: t }) {
  const { t: s } = lt("hlsFlussonicVideoPlayer"), i = ae(null), [r, o] = ne(!1), a = e.status === "multiple" && r, { clearDownloadError: l, downloadError: c, downloading: u, downloadPart: d } = $l({
    displayTimeOffsetMs: n,
    title: t
  }), h = u || e.status === "loading" || e.status === "empty", m = Ee(() => c != null ? s("download.error") : u ? s("download.starting") : Xl(e, s), [c, u, e, s]), f = q(
    (p) => {
      o(!1), ms(i.current), d(p);
    },
    [d]
  ), g = q(() => {
    if (l(), ms(i.current), e.status === "single") {
      f(e.part);
      return;
    }
    e.status === "multiple" && o((p) => !p);
  }, [l, e, f]);
  return se(() => {
    if (!a)
      return;
    const p = (E) => {
      var y;
      (y = i.current) != null && y.contains(E.target) || (o(!1), ms(i.current));
    };
    return document.addEventListener("pointerdown", p), () => {
      document.removeEventListener("pointerdown", p);
    };
  }, [a]), e.status === "hidden" ? null : /* @__PURE__ */ de(
    "div",
    {
      className: fs.root,
      "data-carousel-drag-disabled": !0,
      onKeyDown: (p) => {
        p.key === "Escape" && (o(!1), ms(i.current));
      },
      ref: i,
      children: [
        /* @__PURE__ */ F(
          "button",
          {
            "aria-label": m,
            className: fs.iconButton,
            disabled: h,
            onClick: g,
            title: m,
            type: "button",
            children: u ? /* @__PURE__ */ F(ho, { size: "s" }) : /* @__PURE__ */ F(xl, {})
          }
        ),
        a && /* @__PURE__ */ F("div", { className: fs.partsMenu, role: "menu", children: e.parts.map((p) => /* @__PURE__ */ F(
          "button",
          {
            className: fs.partButton,
            disabled: u,
            onClick: () => f(p),
            role: "menuitem",
            type: "button",
            children: Ql(p, n)
          },
          `${p.fromMs}:${p.toMs}`
        )) })
      ]
    }
  );
}
function Xl(n, e) {
  switch (n.status) {
    case "loading":
      return e("download.checking");
    case "empty":
      switch (n.reason) {
        case "archive-error":
          return e("download.archiveError");
        case "no-archive":
          return e("download.noArchive");
        case "no-track":
          return e("download.noTrack");
        default:
          return e("download.interval");
      }
    case "multiple":
      return e("download.multiple");
    case "single":
      return n.complete ? e("download.interval") : e("download.availableFragment");
    default:
      return e("download.interval");
  }
}
function Ql(n, e) {
  return `${Ni(n.fromMs, e)} - ${Ni(
    n.toMs,
    e
  )}`;
}
function Ni(n, e) {
  return is(n, e);
}
function ms(n) {
  const e = document.activeElement;
  e instanceof HTMLElement && (n != null && n.contains(e)) && e.blur();
}
const Zl = "HlsDvrTimeline-module__root__JPs2F", Jl = "HlsDvrTimeline-module__controlsRow__v2emc", ec = "HlsDvrTimeline-module__trackColumn__4B7u9", tc = "HlsDvrTimeline-module__labelsRow__07PyX", sc = "HlsDvrTimeline-module__liveButton__1kKlU", nc = "HlsDvrTimeline-module__liveButtonActive__egOPv", ic = "HlsDvrTimeline-module__timelineButton__4OrxO", rc = "HlsDvrTimeline-module__timeLabel__OYCxm", oc = "HlsDvrTimeline-module__timelineButtonSeekable__Jzt1a", ac = "HlsDvrTimeline-module__timelineButtonDragging__xTI3j", lc = "HlsDvrTimeline-module__trackBase__D58cR", cc = "HlsDvrTimeline-module__trackBaseDragging__X8X05", uc = "HlsDvrTimeline-module__archiveSegment__nBzPC", dc = "HlsDvrTimeline-module__progressBar__Y3uFE", hc = "HlsDvrTimeline-module__progressBarDragging__qM6-Z", fc = "HlsDvrTimeline-module__timelineHandle__OuF5i", mc = "HlsDvrTimeline-module__timelineHandleSeekable__L4H-u", gc = "HlsDvrTimeline-module__timelineHandleDragging__39V2q", pc = "HlsDvrTimeline-module__timeTooltip__-cshr", Tc = "HlsDvrTimeline-module__timeTooltipImage__fTx1I", Ec = "HlsDvrTimeline-module__timeTooltipVideo__8z9QA", yc = "HlsDvrTimeline-module__timeTooltipPlaceholder__jD6CQ", xc = "HlsDvrTimeline-module__timeTooltipLabel__mbs-Z", vc = "HlsDvrTimeline-module__tick__kWlkB", Sc = "HlsDvrTimeline-module__tickMark__fOxpo", Ac = "HlsDvrTimeline-module__tickMarkMajor__4ynqx", Lc = "HlsDvrTimeline-module__tickLabel__-ONjl", ce = {
  root: Zl,
  controlsRow: Jl,
  trackColumn: ec,
  labelsRow: tc,
  liveButton: sc,
  liveButtonActive: nc,
  timelineButton: ic,
  timeLabel: rc,
  timelineButtonSeekable: oc,
  timelineButtonDragging: ac,
  trackBase: lc,
  trackBaseDragging: cc,
  archiveSegment: uc,
  progressBar: dc,
  progressBarDragging: hc,
  timelineHandle: fc,
  timelineHandleSeekable: mc,
  timelineHandleDragging: gc,
  timeTooltip: pc,
  timeTooltipImage: Tc,
  timeTooltipVideo: Ec,
  timeTooltipPlaceholder: yc,
  timeTooltipLabel: xc,
  tick: vc,
  tickMark: Sc,
  tickMarkMajor: Ac,
  tickLabel: Lc
};
function Un(n, e) {
  return is(n, e);
}
function Rc(n, e) {
  const t = Je(n, e);
  return `${we(t.getDate())}.${we(
    t.getMonth() + 1
  )}.${String(t.getFullYear()).slice(-2)} ${Un(n, e)}`;
}
const Dc = 4, Ic = 36e5, bc = 5 * 6e4, Ui = 5 * 6e4, _c = 12, Bi = 0.75;
function $i({
  clientX: n,
  element: e,
  fullBounds: t,
  startBounds: s,
  startClientX: i
}) {
  const r = e.getBoundingClientRect(), o = s.endMs - s.startMs;
  if (r.width <= 0 || o <= 0)
    return s;
  const l = -((n - i) / r.width) * o;
  return es(
    {
      startMs: s.startMs + l,
      endMs: s.endMs + l
    },
    t
  );
}
function Cc({
  clientX: n,
  element: e,
  handleVisible: t,
  progressPercent: s
}) {
  if (!t)
    return !1;
  const i = e.getBoundingClientRect(), r = i.left + i.width * (s / 100);
  return Math.abs(n - r) <= _c;
}
function wc({
  clientX: n,
  element: e,
  fullBounds: t,
  visibleBounds: s,
  zoomIn: i
}) {
  const r = t.endMs - t.startMs, o = s.endMs - s.startMs;
  if (r <= 0 || o <= 0)
    return null;
  const a = Math.min(bc, r), l = St(
    i ? o * Bi : o / Bi,
    a,
    r
  );
  if (l >= r)
    return t;
  const c = To({
    clientX: n,
    element: e
  }), d = s.startMs + o * c - l * c;
  return es(
    {
      startMs: d,
      endMs: d + l
    },
    t
  );
}
function Mc({
  fullBounds: n,
  previousFullBounds: e,
  visibleBounds: t
}) {
  if (t == null)
    return null;
  if (e != null && n.endMs > e.endMs && Nc({
    bounds: t,
    fullBounds: e
  })) {
    const s = t.endMs - t.startMs;
    return es(
      {
        startMs: n.endMs - s,
        endMs: n.endMs
      },
      n
    );
  }
  return es(t, n);
}
function Bn({
  bounds: n,
  fullBounds: e,
  mode: t
}) {
  return t !== "live" || n == null || n.endMs < e.endMs ? null : n.startMs <= e.startMs ? {
    mode: "full"
  } : {
    mode: "window",
    windowMs: n.endMs - n.startMs
  };
}
function Gi({ fullBounds: n, timeMs: e }) {
  return e >= n.endMs - 1;
}
function kc({
  archiveRanges: n,
  fullBounds: e
}) {
  const t = n.reduce((s, i) => !s || i.toMs > s.toMs ? i : s, null);
  return t ? Math.max(t.fromMs, t.toMs - 1e3) : Math.max(e.startMs, e.endMs - 1e3);
}
function go({
  fullBounds: n,
  mode: e,
  state: t
}) {
  if (e !== "live" || t == null)
    return null;
  if (t.mode === "full")
    return t;
  const s = n.endMs - n.startMs;
  return s <= 0 ? null : t.windowMs >= s ? {
    mode: "full"
  } : {
    mode: "window",
    windowMs: St(t.windowMs, 1, s)
  };
}
function po({
  fullBounds: n,
  liveFollowState: e
}) {
  if (e.mode === "full")
    return n;
  const t = n.endMs - n.startMs, s = St(e.windowMs, 1, Math.max(t, 1));
  return {
    startMs: n.endMs - s,
    endMs: n.endMs
  };
}
function es(n, e) {
  const t = e.endMs - e.startMs, s = n.endMs - n.startMs;
  if (t <= 0 || s <= 0)
    return null;
  if (s >= t)
    return e;
  const i = Math.min(s, t), r = St(n.startMs, e.startMs, e.endMs - i);
  return {
    startMs: r,
    endMs: r + i
  };
}
function Fc({ fullBounds: n, mode: e }) {
  const t = n.endMs - n.startMs;
  return e !== "live" || t <= Ui ? n : {
    startMs: n.endMs - Ui,
    endMs: n.endMs
  };
}
function qt({
  bounds: n,
  clientX: e,
  element: t
}) {
  const s = To({
    clientX: e,
    element: t
  });
  return Math.round(n.startMs + (n.endMs - n.startMs) * s);
}
function Pc({ bounds: n, ranges: e }) {
  const t = n.endMs - n.startMs;
  return t <= 0 ? [] : e.map((s) => {
    const i = St(s.fromMs, n.startMs, n.endMs), r = St(s.toMs, n.startMs, n.endMs);
    return r <= i ? null : {
      fromMs: i,
      toMs: r,
      leftPercent: (i - n.startMs) / t * 100,
      widthPercent: (r - i) / t * 100
    };
  }).filter((s) => s !== null);
}
function Oc({
  mode: n,
  currentTimeMs: e,
  playbackStartTimeMs: t,
  durationSec: s,
  windowEndMs: i,
  windowStartMs: r
}) {
  var l;
  if (r != null && i != null && i > r)
    return {
      startMs: r,
      endMs: i
    };
  if (n === "live") {
    const c = Date.now();
    return {
      startMs: c - Ic,
      endMs: c
    };
  }
  const o = Math.max(s * 1e3, 1), a = (l = t != null ? t : e) != null ? l : Date.now() - o;
  return {
    startMs: a,
    endMs: a + o
  };
}
function Nc({ bounds: n, fullBounds: e }) {
  return n.endMs >= e.endMs - 1;
}
function To({ clientX: n, element: e }) {
  const t = e.getBoundingClientRect();
  return t.width <= 0 ? 0 : St((n - t.left) / t.width, 0, 1);
}
function St(n, e, t) {
  return Number.isFinite(n) ? Math.min(Math.max(n, e), t) : e;
}
function Uc({
  displayTimeOffsetMs: n,
  media: e,
  percent: t,
  thumbnailAvailable: s,
  timeMs: i,
  onMediaError: r,
  onMediaLoad: o
}) {
  const { t: a } = lt("hlsFlussonicVideoPlayer"), l = Rc(i, n);
  return /* @__PURE__ */ de(
    "span",
    {
      className: ce.timeTooltip,
      style: {
        "--timeline-tooltip-percent": `${t}%`
      },
      children: [
        e ? e.type === "video" ? /* @__PURE__ */ F(
          "video",
          {
            autoPlay: !0,
            className: ce.timeTooltipVideo,
            muted: !0,
            onError: () => r(e),
            onLoadedData: () => o(e),
            playsInline: !0,
            src: e.url
          }
        ) : /* @__PURE__ */ F(
          "img",
          {
            alt: l,
            className: ce.timeTooltipImage,
            onError: () => r(e),
            onLoad: () => o(e),
            src: e.url
          }
        ) : /* @__PURE__ */ F("span", { className: ce.timeTooltipPlaceholder, children: s === !1 ? a("errors.noArchive") : l }),
        /* @__PURE__ */ F("span", { className: ce.timeTooltipLabel, children: l })
      ]
    }
  );
}
const Bc = 180, $c = 64, Gc = 128, Hc = 28, Hi = 6, Kc = 8, Ot = 1440 * 6e4, Vc = [
  6e4,
  5 * 6e4,
  15 * 6e4,
  30 * 6e4,
  60 * 6e4,
  120 * 6e4,
  360 * 6e4,
  720 * 6e4,
  Ot,
  7 * Ot,
  30 * Ot
];
function Wc({
  bounds: n,
  displayTimeOffsetMs: e,
  widthPx: t
}) {
  const s = n.endMs - n.startMs;
  if (s <= 0)
    return [];
  const i = Yc({
    durationMs: s,
    widthPx: t
  }), r = Js(e), o = i * 2, a = Nn(
    Math.ceil(On(n.startMs, r) / i) * i,
    r
  ), l = [];
  let c = -1 / 0;
  for (let u = a; u < n.endMs; u += i) {
    if (u <= n.startMs)
      continue;
    const h = On(u, r) % o === 0, m = (u - n.startMs) / s * 100, f = h ? qc({
      displayTimeOffsetMs: r,
      durationMs: s,
      lastLabelRightPx: c,
      leftPercent: m,
      tickMs: u,
      widthPx: t
    }) : "";
    if (f) {
      const g = yo({
        durationMs: s,
        label: f
      });
      c = Eo({
        leftPercent: m,
        widthPx: t
      }) + g / 2;
    }
    l.push({
      label: f,
      leftPercent: m,
      major: h,
      timeMs: u
    });
  }
  return l;
}
function Yc({ durationMs: n, widthPx: e }) {
  var i;
  const t = e == null ? 10 : Math.max(2, Math.floor(e / Hc)), s = n / t;
  return (i = Vc.find((r) => r >= s)) != null ? i : 30 * Ot;
}
function qc({
  displayTimeOffsetMs: n,
  durationMs: e,
  lastLabelRightPx: t,
  leftPercent: s,
  tickMs: i,
  widthPx: r
}) {
  const o = Xc(i, e, n);
  if (r == null)
    return o;
  if (r < Bc)
    return "";
  const a = yo({
    durationMs: e,
    label: o
  }), l = Eo({
    leftPercent: s,
    widthPx: r
  }), c = l - a / 2, u = l + a / 2;
  return c < Hi || u > r - Hi || c < t + Kc ? "" : o;
}
function Eo({ leftPercent: n, widthPx: e }) {
  return (e != null ? e : 0) * n / 100;
}
function yo({ durationMs: n, label: e }) {
  return Math.max(zc(e), jc(n));
}
function zc(n) {
  return n.length * 7;
}
function jc(n) {
  return n >= Ot ? Gc : $c;
}
function Xc(n, e, t) {
  const s = Je(n, t);
  return e >= Ot ? `${we(s.getDate())}.${we(
    s.getMonth() + 1
  )}.${String(s.getFullYear()).slice(-2)} ${we(
    s.getHours()
  )}:${we(s.getMinutes())}` : `${we(s.getHours())}:${we(s.getMinutes())}`;
}
function Qc({ bounds: n, displayTimeOffsetMs: e, widthPx: t }) {
  const s = Wc({
    bounds: n,
    displayTimeOffsetMs: e,
    widthPx: t
  });
  return /* @__PURE__ */ F(yl, { children: s.map((i) => /* @__PURE__ */ de(
    "span",
    {
      className: ce.tick,
      style: {
        "--timeline-tick-left-percent": `${i.leftPercent}%`
      },
      children: [
        /* @__PURE__ */ F("span", { className: ue(ce.tickMark, i.major && ce.tickMarkMajor) }),
        i.label && /* @__PURE__ */ F("span", { className: ce.tickLabel, children: i.label })
      ]
    },
    i.timeMs
  )) });
}
const Ki = 12, Zc = Ml(function({
  archiveSegments: e,
  archiveSegmentHeight: t,
  bounds: s,
  displayTimeOffsetMs: i,
  handleSize: r,
  handleVisible: o,
  isInteracting: a,
  isSeeking: l,
  progressPercent: c,
  progressVisible: u,
  previewPercent: d,
  seekable: h,
  thumbnailAvailable: m,
  timelineWidthPx: f,
  tooltipMedia: g,
  tooltipTimeMs: p,
  trackHeight: E,
  trackLabel: y,
  onPointerCancel: x,
  onPointerDown: S,
  onPointerEnter: v,
  onPointerLeave: D,
  onPointerMove: L,
  onPointerUp: _,
  onThumbnailMediaError: A,
  onThumbnailMediaLoad: R
}, w) {
  const B = {
    "--timeline-track-height": `${E}px`,
    "--timeline-track-top": `${Ki - E / 2}px`
  }, M = {
    "--timeline-archive-height": `${t}px`,
    "--timeline-archive-top": `${Ki - t / 2}px`
  };
  return /* @__PURE__ */ de(
    "button",
    {
      "aria-label": y,
      className: ue(
        ce.timelineButton,
        h && ce.timelineButtonSeekable,
        a && ce.timelineButtonDragging
      ),
      disabled: !h,
      onPointerCancel: x,
      onPointerDown: S,
      onPointerEnter: v,
      onPointerLeave: D,
      onPointerMove: L,
      onPointerUp: _,
      ref: w,
      type: "button",
      children: [
        /* @__PURE__ */ F("span", { className: ue(ce.trackBase, a && ce.trackBaseDragging), style: B }),
        e.map((N) => /* @__PURE__ */ F(
          "span",
          {
            className: ce.archiveSegment,
            style: {
              ...M,
              "--timeline-left-percent": `${N.leftPercent}%`,
              "--timeline-width-percent": `${N.widthPercent}%`
            }
          },
          `${N.fromMs}:${N.toMs}`
        )),
        u && /* @__PURE__ */ F(
          "span",
          {
            className: ue(ce.progressBar, l && ce.progressBarDragging),
            style: {
              ...B,
              "--timeline-progress-percent": `${c}%`
            }
          }
        ),
        o && /* @__PURE__ */ F(
          "span",
          {
            className: ue(
              ce.timelineHandle,
              h && ce.timelineHandleSeekable,
              l && ce.timelineHandleDragging
            ),
            style: {
              "--timeline-handle-size": `${r}px`,
              "--timeline-progress-percent": `${c}%`
            }
          }
        ),
        p != null && /* @__PURE__ */ F(
          Uc,
          {
            displayTimeOffsetMs: i,
            media: g,
            onMediaError: A,
            onMediaLoad: R,
            percent: d,
            thumbnailAvailable: m,
            timeMs: p
          }
        ),
        /* @__PURE__ */ F(Qc, { bounds: s, displayTimeOffsetMs: i, widthPx: f })
      ]
    }
  );
});
function xo(n) {
  const [e, t] = ne(null);
  return se(() => {
    const s = n.current;
    if (!s)
      return;
    const i = () => {
      t(Math.round(s.getBoundingClientRect().width));
    };
    if (i(), typeof ResizeObserver == "undefined")
      return window.addEventListener("resize", i), () => {
        window.removeEventListener("resize", i);
      };
    const r = new ResizeObserver((o) => {
      const a = o[0], l = a == null ? void 0 : a.contentRect.width;
      t(Math.round(l != null ? l : s.getBoundingClientRect().width));
    });
    return r.observe(s), () => {
      r.disconnect();
    };
  }, [n]), e;
}
function Jc({
  applyViewportState: n,
  applyVisibleBounds: e,
  archiveRanges: t,
  boundsRef: s,
  fullBounds: i,
  gestureState: r,
  handleVisible: o,
  liveAvailable: a,
  mode: l,
  onLive: c,
  onSeek: u,
  progressPercent: d,
  seekable: h,
  setDragPreviewTimeMs: m,
  setGestureState: f,
  setHoverPreviewTimeMs: g,
  viewportLocked: p
}) {
  const E = q(() => s.current, [s]), y = q(
    (A) => {
      A.preventDefault(), A.stopPropagation(), h && (g(null), A.currentTarget.setPointerCapture(A.pointerId), f({
        kind: "pending",
        pointerId: A.pointerId,
        startBounds: E(),
        startClientX: A.clientX,
        startedOnHandle: Cc({
          clientX: A.clientX,
          element: A.currentTarget,
          handleVisible: o,
          progressPercent: d
        })
      }));
    },
    [E, o, d, h, f, g]
  ), x = q(
    (A, R) => {
      const w = A.clientX - R.startClientX;
      if (!(Math.abs(w) < Dc)) {
        if (R.startedOnHandle || p) {
          f({
            kind: "seek",
            pointerId: R.pointerId
          }), m(
            qt({
              bounds: R.startBounds,
              clientX: A.clientX,
              element: A.currentTarget
            })
          );
          return;
        }
        f({
          kind: "pan",
          pointerId: R.pointerId,
          startBounds: R.startBounds,
          startClientX: R.startClientX
        }), e(
          $i({
            clientX: A.clientX,
            element: A.currentTarget,
            fullBounds: i,
            startBounds: R.startBounds,
            startClientX: R.startClientX
          }),
          !1
        );
      }
    },
    [e, i, m, f, p]
  ), S = q(
    (A) => {
      if (r == null) {
        h && g(
          qt({
            bounds: E(),
            clientX: A.clientX,
            element: A.currentTarget
          })
        );
        return;
      }
      if (!(!h || A.pointerId !== r.pointerId)) {
        if (A.preventDefault(), A.stopPropagation(), r.kind === "pending") {
          x(A, r);
          return;
        }
        if (r.kind === "seek") {
          m(
            qt({
              bounds: E(),
              clientX: A.clientX,
              element: A.currentTarget
            })
          );
          return;
        }
        p || e(
          $i({
            clientX: A.clientX,
            element: A.currentTarget,
            fullBounds: i,
            startBounds: r.startBounds,
            startClientX: r.startClientX
          }),
          !1
        );
      }
    },
    [
      e,
      i,
      r,
      E,
      x,
      h,
      m,
      g,
      p
    ]
  ), v = q(
    (A) => {
      if (!h || r == null || A.pointerId !== r.pointerId)
        return;
      if (A.preventDefault(), A.stopPropagation(), A.currentTarget.hasPointerCapture(A.pointerId) && A.currentTarget.releasePointerCapture(A.pointerId), r.kind === "pan") {
        const M = E(), N = Bn({
          bounds: M,
          fullBounds: i,
          mode: l
        });
        f(null), g(null), n({
          liveFollowState: N,
          visibleBounds: N == null ? M : null
        });
        return;
      }
      const R = qt({
        bounds: r.kind === "pending" ? r.startBounds : E(),
        clientX: A.clientX,
        element: A.currentTarget
      });
      if (f(null), m(null), g(null), r.kind === "seek" && !p && a && Gi({
        fullBounds: i,
        timeMs: R
      })) {
        const M = Bn({
          bounds: E(),
          fullBounds: i,
          mode: "live"
        });
        n({
          liveFollowState: M,
          visibleBounds: null
        }), c();
        return;
      }
      const w = !a && Gi({
        fullBounds: i,
        timeMs: R
      }) ? kc({
        archiveRanges: t,
        fullBounds: i
      }) : R, B = E();
      p || n({
        liveFollowState: null,
        visibleBounds: B
      }), u(w);
    },
    [
      n,
      t,
      i,
      r,
      E,
      a,
      l,
      c,
      u,
      h,
      m,
      f,
      g,
      p
    ]
  ), D = q(
    (A) => {
      r != null && A.pointerId !== r.pointerId || (A.currentTarget.hasPointerCapture(A.pointerId) && A.currentTarget.releasePointerCapture(A.pointerId), f(null), m(null), g(null));
    },
    [r, m, f, g]
  ), L = q(
    (A) => {
      !h || r != null || g(
        qt({
          bounds: E(),
          clientX: A.clientX,
          element: A.currentTarget
        })
      );
    },
    [r, E, h, g]
  ), _ = q(() => {
    r == null && g(null);
  }, [r, g]);
  return {
    handlePointerCancel: D,
    handlePointerDown: y,
    handlePointerEnter: L,
    handlePointerLeave: _,
    handlePointerMove: S,
    handlePointerUp: v
  };
}
function eu({
  fullBounds: n,
  isInteracting: e,
  mode: t,
  onTimelineViewportChange: s,
  timelineViewport: i
}) {
  const r = ae(null), o = ae(null), [a, l] = ne(null), [c, u] = ne(null), d = Ee(
    () => Fc({
      fullBounds: n,
      mode: t
    }),
    [n, t]
  ), h = Ee(
    () => c != null ? po({
      fullBounds: n,
      liveFollowState: c
    }) : null,
    [n, c]
  ), m = Ee(
    () => {
      var S;
      return (S = h != null ? h : a) != null ? S : d;
    },
    [d, h, a]
  ), f = ae(m), g = Ee(() => Vi(i), [i]);
  se(() => {
    f.current = m;
  }, [m]);
  const p = q(
    ({
      liveFollowState: S,
      visibleBounds: v
    }) => {
      const D = su({
        liveFollowState: S,
        visibleBounds: v
      });
      o.current = Vi(D), s == null || s(D);
    },
    [s]
  ), E = q(
    ({
      liveFollowState: S,
      visibleBounds: v
    }, D = !0) => {
      u(S), l(v), f.current = nu({
        defaultBounds: d,
        fullBounds: n,
        liveFollowState: S,
        visibleBounds: v
      }), D && p({
        liveFollowState: S,
        visibleBounds: v
      });
    },
    [d, n, p]
  ), y = q(
    (S, v = !0) => {
      const D = Bn({
        bounds: S,
        fullBounds: n,
        mode: t
      });
      if (D != null) {
        E(
          {
            liveFollowState: D,
            visibleBounds: null
          },
          v
        );
        return;
      }
      E(
        {
          liveFollowState: null,
          visibleBounds: S
        },
        v
      );
    },
    [E, n, t]
  ), x = q(() => {
    E({
      liveFollowState: null,
      visibleBounds: null
    });
  }, [E]);
  return se(() => {
    if (e)
      return;
    const S = r.current;
    u(
      (v) => go({
        fullBounds: n,
        mode: t,
        state: v
      })
    ), l(
      (v) => Mc({
        fullBounds: n,
        previousFullBounds: S,
        visibleBounds: v
      })
    ), r.current = n;
  }, [n, e, t]), se(() => {
    if (i == null || g == null || e || o.current === g)
      return;
    const S = tu({
      fullBounds: n,
      mode: t,
      viewport: i
    });
    E(S, !1), o.current = g;
  }, [E, n, e, t, i, g]), {
    applyViewportState: E,
    applyVisibleBounds: y,
    bounds: m,
    boundsRef: f,
    reportTimelineViewport: p,
    resetViewport: x
  };
}
function tu({
  fullBounds: n,
  mode: e,
  viewport: t
}) {
  return t.mode === "auto" ? {
    liveFollowState: null,
    visibleBounds: null
  } : t.mode === "live-follow" ? {
    liveFollowState: go({
      fullBounds: n,
      mode: e,
      state: t.windowMs == null ? { mode: "full" } : { mode: "window", windowMs: t.windowMs }
    }),
    visibleBounds: null
  } : {
    liveFollowState: null,
    visibleBounds: es(
      {
        startMs: t.startMs,
        endMs: t.endMs
      },
      n
    )
  };
}
function su({
  liveFollowState: n,
  visibleBounds: e
}) {
  return (n == null ? void 0 : n.mode) === "full" ? {
    mode: "live-follow",
    windowMs: null
  } : (n == null ? void 0 : n.mode) === "window" ? {
    mode: "live-follow",
    windowMs: n.windowMs
  } : e ? {
    mode: "fixed",
    startMs: Math.round(e.startMs),
    endMs: Math.round(e.endMs)
  } : {
    mode: "auto"
  };
}
function nu({
  defaultBounds: n,
  fullBounds: e,
  liveFollowState: t,
  visibleBounds: s
}) {
  return t != null ? po({
    fullBounds: e,
    liveFollowState: t
  }) : s != null ? s : n;
}
function Vi(n) {
  var e;
  return n == null ? null : n.mode === "fixed" ? `${n.mode}:${Math.round(n.startMs)}:${Math.round(n.endMs)}` : n.mode === "live-follow" ? `${n.mode}:${(e = n.windowMs) != null ? e : "full"}` : n.mode;
}
function iu({
  archiveRanges: n,
  liveAvailable: e,
  mode: t,
  currentTimeMs: s,
  displayTimeOffsetMs: i,
  playbackStartTimeMs: r,
  durationSec: o,
  seekable: a,
  thumbnailAvailable: l,
  thumbnailMedia: c = [],
  thumbnailTimeMs: u,
  timelineViewport: d,
  timelineZoomCommand: h,
  viewportLocked: m = !1,
  windowEndMs: f,
  windowStartMs: g,
  onPreviewTimeChange: p,
  onThumbnailMediaError: E,
  onThumbnailMediaLoad: y,
  onTimelineViewportChange: x,
  onSeek: S,
  onLive: v
}) {
  var _t, us;
  const { t: D } = lt("hlsFlussonicVideoPlayer"), L = ae(null), _ = ae(null), A = xo(L), [R, w] = ne(null), [B, M] = ne(null), [N, $] = ne(null), W = g != null && f != null && f > g ? null : s, U = Ee(
    () => Oc({
      mode: t,
      currentTimeMs: W,
      playbackStartTimeMs: r,
      durationSec: o,
      windowEndMs: f,
      windowStartMs: g
    }),
    [o, W, t, r, f, g]
  ), P = R != null, O = (N == null ? void 0 : N.kind) === "pan", K = P || O, { applyViewportState: V, applyVisibleBounds: J, bounds: Z, boundsRef: ie, resetViewport: X } = eu({
    fullBounds: U,
    isInteracting: K,
    mode: t,
    onTimelineViewportChange: x,
    timelineViewport: d
  }), oe = (_t = R != null ? R : s) != null ? _t : t === "live" ? Date.now() : Z.startMs, Me = t === "live" && e && oe > Z.endMs, Pe = P || oe >= Z.startMs && (oe <= Z.endMs || Me), ct = P || oe > Z.startMs, Ge = au(oe, Z), ut = Wi(Ge, Z), gt = Pc({
    bounds: Z,
    ranges: n
  }), Ne = R != null ? R : B, dt = Ne == null ? 0 : Wi(Ne, Z), tt = u != null ? u : Ne, [Ye, ee] = ne(() => ({
    mediaKey: "",
    urls: []
  })), st = Ee(
    () => c.filter(
      (pe, Se, Ie) => Ie.findIndex((Tt) => Tt.url === pe.url) === Se
    ),
    [c]
  ), Oe = Ee(
    () => st.map((pe) => pe.url).join(`
`),
    [st]
  ), pt = Ye.mediaKey === Oe ? Ye.urls : [], Dt = (us = st.find((pe) => !pt.includes(pe.url))) != null ? us : null, It = q(
    (pe) => {
      E == null || E(pe), ee((Se) => ({
        mediaKey: Oe,
        urls: ou({
          currentFailedUrls: Se.mediaKey === Oe ? Se.urls : [],
          failedUrl: pe.url
        })
      }));
    },
    [E, Oe]
  ), nn = q(
    (pe) => {
      y == null || y(pe);
    },
    [y]
  );
  se(() => {
    p == null || p(Ne);
  }, [R, B, p, Ne]);
  const rn = () => {
    m || !e || (X(), v());
  }, bt = q(
    (pe, Se) => {
      const Ie = L.current;
      if (!Ie)
        return;
      const Tt = Ie.getBoundingClientRect();
      Tt.width <= 0 || J(
        wc({
          clientX: Se != null ? Se : Tt.left + Tt.width * ru(Ge, Z),
          element: Ie,
          fullBounds: U,
          visibleBounds: Z,
          zoomIn: pe
        })
      );
    },
    [J, Z, U, Ge]
  );
  se(() => {
    const pe = L.current;
    if (!pe)
      return;
    const Se = (Ie) => {
      m || !a || Ie.deltaY === 0 || (Ie.preventDefault(), Ie.stopPropagation(), bt(Ie.deltaY < 0, Ie.clientX));
    };
    return pe.addEventListener("wheel", Se, {
      passive: !1
    }), () => {
      pe.removeEventListener("wheel", Se);
    };
  }, [bt, a, m]), se(() => {
    h == null || _.current === h.revision || (_.current = h.revision, !(m || !a) && bt(h.direction === "in"));
  }, [bt, a, h, m]);
  const {
    handlePointerCancel: on,
    handlePointerDown: Vt,
    handlePointerEnter: He,
    handlePointerLeave: an,
    handlePointerMove: as,
    handlePointerUp: ls
  } = Jc({
    applyViewportState: V,
    applyVisibleBounds: J,
    archiveRanges: n,
    boundsRef: ie,
    fullBounds: U,
    gestureState: N,
    handleVisible: Pe,
    liveAvailable: e,
    mode: t,
    onLive: v,
    onSeek: S,
    progressPercent: ut,
    seekable: a,
    setDragPreviewTimeMs: w,
    setGestureState: $,
    setHoverPreviewTimeMs: M,
    viewportLocked: m
  }), Wt = P ? 12 : 10, ln = P ? 8 : 6, cs = P ? 20 : 18;
  return /* @__PURE__ */ F("div", { className: ce.root, "data-carousel-drag-disabled": !0, children: /* @__PURE__ */ de("div", { className: ce.controlsRow, children: [
    e && /* @__PURE__ */ F(
      "button",
      {
        "aria-pressed": t === "live",
        className: ue(ce.liveButton, t === "live" && ce.liveButtonActive),
        onClick: rn,
        type: "button",
        children: "Live"
      }
    ),
    /* @__PURE__ */ de("div", { className: ce.trackColumn, children: [
      /* @__PURE__ */ de("div", { className: ce.labelsRow, children: [
        /* @__PURE__ */ F("span", { className: ce.timeLabel, children: Un(Z.startMs, i) }),
        /* @__PURE__ */ F("span", { className: ce.timeLabel, children: Un(Z.endMs, i) })
      ] }),
      /* @__PURE__ */ F(
        Zc,
        {
          archiveSegmentHeight: ln,
          archiveSegments: gt,
          bounds: Z,
          displayTimeOffsetMs: i,
          handleSize: cs,
          handleVisible: Pe,
          isInteracting: K,
          isSeeking: P,
          onPointerCancel: on,
          onPointerDown: Vt,
          onPointerEnter: He,
          onPointerLeave: an,
          onPointerMove: as,
          onPointerUp: ls,
          onThumbnailMediaError: It,
          onThumbnailMediaLoad: nn,
          previewPercent: dt,
          progressPercent: ut,
          progressVisible: ct,
          ref: L,
          seekable: a,
          thumbnailAvailable: l,
          timelineWidthPx: A,
          tooltipMedia: Dt,
          tooltipTimeMs: tt,
          trackHeight: Wt,
          trackLabel: D("timeline.seek")
        }
      )
    ] })
  ] }) });
}
function Wi(n, e) {
  return (n - e.startMs) / (e.endMs - e.startMs) * 100;
}
function ru(n, e) {
  const t = e.endMs - e.startMs;
  return t <= 0 ? 0.5 : Math.min(Math.max((n - e.startMs) / t, 0), 1);
}
function ou({
  currentFailedUrls: n,
  failedUrl: e
}) {
  return n.includes(e) ? n : [...n, e];
}
function au(n, e) {
  return Number.isFinite(n) ? Math.min(Math.max(n, e.startMs), e.endMs) : e.startMs;
}
const $n = [1, 2, 4, 8, 16], Yi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Us(n, e) {
  return typeof n == "function" ? n(e) : n && typeof n == "object" && Yi in n ? n[Yi](e) : n instanceof Date ? new n.constructor(e) : new Date(e);
}
function Lt(n, e) {
  return Us(e || n, n);
}
function vo(n, e, t) {
  const s = Lt(n, t == null ? void 0 : t.in);
  return isNaN(e) ? Us(n, NaN) : (s.setDate(s.getDate() + e), s);
}
function So(n, e, t) {
  const s = Lt(n, t == null ? void 0 : t.in);
  if (isNaN(e)) return Us(n, NaN);
  if (!e)
    return s;
  const i = s.getDate(), r = Us(n, s.getTime());
  r.setMonth(s.getMonth() + e + 1, 0);
  const o = r.getDate();
  return i >= o ? r : (s.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    i
  ), s);
}
function lu(n, e) {
  const t = e == null ? void 0 : e.weekStartsOn, s = Lt(n, e == null ? void 0 : e.in), i = s.getDay(), r = (i < t ? 7 : 0) + i - t;
  return s.setDate(s.getDate() - r), s.setHours(0, 0, 0, 0), s;
}
function qi(n, e) {
  const t = Lt(n, e == null ? void 0 : e.in);
  return t.setHours(0, 0, 0, 0), t;
}
function cu(n, e) {
  const t = Lt(n, e == null ? void 0 : e.in), s = t.getMonth();
  return t.setFullYear(t.getFullYear(), s + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Ao(n, e) {
  const t = Lt(n, e == null ? void 0 : e.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function uu(n, e) {
  const t = e == null ? void 0 : e.weekStartsOn, s = Lt(n, e == null ? void 0 : e.in), i = s.getDay(), r = (i < t ? -7 : 0) + 6 - (i - t);
  return s.setDate(s.getDate() + r), s.setHours(23, 59, 59, 999), s;
}
function du(n, e, t) {
  return So(n, -1, t);
}
const zi = 1;
function hu(n, e) {
  const t = /* @__PURE__ */ new Map(), s = Js(e);
  return n.forEach((i) => {
    if (!gu(i))
      return;
    let r = qi(Je(i.fromMs, s)).getTime();
    const o = qi(
      Je(Math.max(i.fromMs, i.toMs - 1), s)
    ).getTime();
    for (; r <= o; ) {
      const a = vo(new Date(r), 1).getTime(), l = Nn(r, s), c = Nn(a, s), u = Math.max(i.fromMs, l), d = Math.min(i.toMs, c);
      if (d > u) {
        const h = Bs(l, s), m = t.get(h);
        m ? (m.firstArchiveTimeMs = Math.min(m.firstArchiveTimeMs, u), m.lastArchiveTimeMs = Math.max(m.lastArchiveTimeMs, d)) : t.set(h, {
          dayEndMs: c,
          dayKey: h,
          dayStartMs: l,
          firstArchiveTimeMs: u,
          lastArchiveTimeMs: d
        });
      }
      r = a;
    }
  }), Array.from(t.values()).sort((i, r) => i.dayStartMs - r.dayStartMs);
}
function fu({
  archiveDaysByKey: n,
  monthMs: e
}) {
  var c;
  const t = new Date(e), s = Ao(t).getTime(), i = cu(t).getTime(), r = lu(new Date(s), {
    weekStartsOn: zi
  }).getTime(), o = uu(new Date(i), {
    weekStartsOn: zi
  }).getTime(), a = [];
  let l = r;
  for (; l <= o; ) {
    const u = Bs(l);
    a.push({
      archiveDay: (c = n.get(u)) != null ? c : null,
      dayKey: u,
      dayStartMs: l,
      inMonth: l >= s && l <= i
    }), l = vo(new Date(l), 1).getTime();
  }
  return a;
}
function Bs(n, e) {
  const t = Je(n, e);
  return `${t.getFullYear()}-${ji(t.getMonth() + 1)}-${ji(t.getDate())}`;
}
function mu(n, e) {
  return Ao(Je(n, e)).getTime();
}
function gu(n) {
  return Number.isFinite(n.fromMs) && Number.isFinite(n.toMs) && n.toMs > n.fromMs;
}
function ji(n) {
  return String(n).padStart(2, "0");
}
const pu = "HlsDvrCalendar-module__root__shV81", Tu = "HlsDvrCalendar-module__trigger__1xDjL", Eu = "HlsDvrCalendar-module__triggerOpen__UCSOM", yu = "HlsDvrCalendar-module__navButton__tLlxU", xu = "HlsDvrCalendar-module__dayButton__kdktU", vu = "HlsDvrCalendar-module__popover__lbfGu", Su = "HlsDvrCalendar-module__header__QQbK7", Au = "HlsDvrCalendar-module__monthLabel__sfOOS", Lu = "HlsDvrCalendar-module__weekdays__eeNlv", Ru = "HlsDvrCalendar-module__grid__aFqU8", Du = "HlsDvrCalendar-module__weekday__5m30g", Iu = "HlsDvrCalendar-module__dayAvailable__SFTfj", bu = "HlsDvrCalendar-module__daySelected__8QNYi", _u = "HlsDvrCalendar-module__dayToday__wVPfR", Cu = "HlsDvrCalendar-module__dayOutOfMonth__lU2cY", wu = "HlsDvrCalendar-module__archiveMarker__WJtIH", Mu = "HlsDvrCalendar-module__archiveMarkerSelected__ViIfz", ku = "HlsDvrCalendar-module__status__dce4V", Fu = "HlsDvrCalendar-module__statusError__704-L", Pu = "HlsDvrCalendar-module__legend__DKeWv", Ou = "HlsDvrCalendar-module__legendMarker__xCfIm", fe = {
  root: pu,
  trigger: Tu,
  triggerOpen: Eu,
  navButton: yu,
  dayButton: xu,
  popover: vu,
  header: Su,
  monthLabel: Au,
  weekdays: Lu,
  grid: Ru,
  weekday: Du,
  dayAvailable: Iu,
  daySelected: bu,
  dayToday: _u,
  dayOutOfMonth: Cu,
  archiveMarker: wu,
  archiveMarkerSelected: Mu,
  status: ku,
  statusError: Fu,
  legend: Pu,
  legendMarker: Ou
}, Nu = $u();
function Uu({
  archiveRanges: n,
  archiveRangesError: e = null,
  archiveRangesLoading: t = !1,
  currentTimeMs: s,
  disabled: i = !1,
  displayTimeOffsetMs: r,
  onDaySelect: o
}) {
  var G, W;
  const { t: a } = lt("hlsFlussonicVideoPlayer"), l = ae(null), c = ae(null), [u, d] = ne(!1), [h, m] = ne({ x: 0, y: 0 }), f = Ee(
    () => hu(n, r),
    [n, r]
  ), g = Ee(() => new Map(f.map((U) => [U.dayKey, U])), [f]), p = (W = s != null ? s : (G = f[f.length - 1]) == null ? void 0 : G.firstArchiveTimeMs) != null ? W : Date.now(), E = mu(p, r), [y, x] = ne(() => E), S = u && !i, v = s == null ? null : Bs(s, r), D = Bs(Date.now(), r), L = Ee(
    () => fu({
      archiveDaysByKey: g,
      monthMs: y
    }),
    [g, y]
  ), _ = f.length > 0, A = t && !_, R = !t && e != null && !_, w = !t && e == null && !_, B = q(() => {
    const U = l.current, P = c.current, O = U == null ? void 0 : U.closest("[data-hls-video-player-root]");
    if (!U || !P || !(O instanceof HTMLElement)) {
      m({ x: 0, y: 0 });
      return;
    }
    const K = 8, V = O.getBoundingClientRect(), J = P.style.transform;
    P.style.transform = "none";
    const Z = P.getBoundingClientRect();
    P.style.transform = J;
    let ie = 0, X = 0;
    Z.left < V.left + K && (ie += V.left + K - Z.left), Z.right + ie > V.right - K && (ie -= Z.right + ie - (V.right - K)), Z.top < V.top + K && (X += V.top + K - Z.top), m({
      x: Math.round(ie),
      y: Math.round(X)
    });
  }, []);
  se(() => {
    if (!S)
      return;
    const U = (O) => {
      var V;
      const K = O.target;
      K instanceof Node && ((V = l.current) != null && V.contains(K)) || d(!1);
    }, P = (O) => {
      O.key === "Escape" && d(!1);
    };
    return document.addEventListener("pointerdown", U), document.addEventListener("keydown", P), () => {
      document.removeEventListener("pointerdown", U), document.removeEventListener("keydown", P);
    };
  }, [S]), fo(() => {
    if (!S) {
      m({ x: 0, y: 0 });
      return;
    }
    return B(), window.addEventListener("resize", B), window.addEventListener("scroll", B, !0), () => {
      window.removeEventListener("resize", B), window.removeEventListener("scroll", B, !0);
    };
  }, [S, B, y]);
  const M = () => {
    if (S) {
      d(!1), Qi(l.current);
      return;
    }
    x(E), d(!0);
  }, N = (U) => {
    o(U), d(!1), Qi(l.current);
  }, $ = dn(p, r);
  return /* @__PURE__ */ de("div", { className: fe.root, ref: l, children: [
    /* @__PURE__ */ F(
      "button",
      {
        "aria-expanded": S,
        "aria-haspopup": "dialog",
        "aria-label": `${a("calendar.open")}: ${$}`,
        className: ue(fe.trigger, S && fe.triggerOpen),
        disabled: i,
        onClick: M,
        title: $,
        type: "button",
        children: /* @__PURE__ */ F(vl, {})
      }
    ),
    S && /* @__PURE__ */ de(
      "div",
      {
        "aria-label": a("calendar.title"),
        className: fe.popover,
        ref: c,
        role: "dialog",
        style: Hu(h),
        children: [
          /* @__PURE__ */ de("div", { className: fe.header, children: [
            /* @__PURE__ */ F(
              "button",
              {
                className: fe.navButton,
                onClick: () => x((U) => du(new Date(U)).getTime()),
                title: a("calendar.previousMonth"),
                type: "button",
                children: /* @__PURE__ */ F(Sl, {})
              }
            ),
            /* @__PURE__ */ F("div", { className: fe.monthLabel, children: Bu(y) }),
            /* @__PURE__ */ F(
              "button",
              {
                className: fe.navButton,
                onClick: () => x((U) => So(new Date(U), 1).getTime()),
                title: a("calendar.nextMonth"),
                type: "button",
                children: /* @__PURE__ */ F(Al, {})
              }
            )
          ] }),
          A && /* @__PURE__ */ F("div", { className: fe.status, children: a("calendar.loading") }),
          R && /* @__PURE__ */ F("div", { className: ue(fe.status, fe.statusError), children: a("calendar.error") }),
          w && /* @__PURE__ */ F("div", { className: fe.status, children: a("calendar.empty") }),
          /* @__PURE__ */ F("div", { "aria-hidden": !0, className: fe.weekdays, children: Nu.map((U) => /* @__PURE__ */ F("span", { className: fe.weekday, children: U }, U)) }),
          /* @__PURE__ */ F("div", { className: fe.grid, children: L.map((U) => {
            const P = U.archiveDay, O = P != null, K = U.dayKey === v, V = U.dayKey === D, J = O ? `${a("calendar.openDay")}: ${dn(U.dayStartMs)}` : dn(U.dayStartMs);
            return /* @__PURE__ */ de(
              "button",
              {
                "aria-label": J,
                className: ue(
                  fe.dayButton,
                  O && fe.dayAvailable,
                  !U.inMonth && fe.dayOutOfMonth,
                  K && fe.daySelected,
                  V && fe.dayToday
                ),
                disabled: !O,
                onClick: () => {
                  P && N(P);
                },
                title: J,
                type: "button",
                children: [
                  new Date(U.dayStartMs).getDate(),
                  O && /* @__PURE__ */ F("span", { className: ue(fe.archiveMarker, K && fe.archiveMarkerSelected) })
                ]
              },
              U.dayKey
            );
          }) }),
          /* @__PURE__ */ de("div", { className: fe.legend, children: [
            /* @__PURE__ */ F("span", { className: fe.legendMarker }),
            /* @__PURE__ */ F("span", { children: a("calendar.recordedDay") })
          ] })
        ]
      }
    )
  ] });
}
function dn(n, e) {
  const t = Je(n, e);
  return `${Xi(t.getDate())}.${Xi(t.getMonth() + 1)}.${t.getFullYear()}`;
}
function Bu(n) {
  return new Intl.DateTimeFormat(void 0, {
    month: "long",
    year: "numeric"
  }).format(new Date(n));
}
function $u() {
  const n = new Date(2024, 0, 1);
  return Array.from(
    { length: 7 },
    (e, t) => new Intl.DateTimeFormat(void 0, {
      weekday: "short"
    }).format(Gu(n, t))
  );
}
function Gu(n, e) {
  const t = new Date(n);
  return t.setDate(n.getDate() + e), t;
}
function Xi(n) {
  return String(n).padStart(2, "0");
}
function Qi(n) {
  const e = document.activeElement;
  e instanceof HTMLElement && (n != null && n.contains(e)) && e.blur();
}
function Hu(n) {
  if (!(n.x === 0 && n.y === 0))
    return {
      transform: `translate(${n.x}px, ${n.y}px)`
    };
}
const Ku = "HlsPlayerControls-module__controlsRow__BPR2L", Vu = "HlsPlayerControls-module__iconButton__yJk33", Wu = "HlsPlayerControls-module__iconButtonActive__25rms", Yu = "HlsPlayerControls-module__dropdownTrigger__2Vlx3", qu = "HlsPlayerControls-module__option__VOWE6", zu = "HlsPlayerControls-module__playbackTime__4gega", ju = "HlsPlayerControls-module__timelineZoomControls__8B07O", Xu = "HlsPlayerControls-module__controlsSpacer__S-d8M", Qu = "HlsPlayerControls-module__secondaryControl__9rUvz", Zu = "HlsPlayerControls-module__secondaryControlCompact__bCou3", Ju = "HlsPlayerControls-module__dropdown__VRnvj", ed = "HlsPlayerControls-module__dropdownTriggerOpen__TZ0LY", td = "HlsPlayerControls-module__playbackRateTrigger__tBYIh", sd = "HlsPlayerControls-module__triggerText__LQ0o9", nd = "HlsPlayerControls-module__menu__mch9T", id = "HlsPlayerControls-module__playbackRateMenu__C-BM-", rd = "HlsPlayerControls-module__optionSelected__lEn3i", od = "HlsPlayerControls-module__playbackRateOption__lq7MP", ad = "HlsPlayerControls-module__settingsDropdown__ivbzE", ld = "HlsPlayerControls-module__settingsDropdownCompact__XduZX", cd = "HlsPlayerControls-module__settingsTriggerOpen__WcWdQ", ud = "HlsPlayerControls-module__settingsMenu__DbJ7b", dd = "HlsPlayerControls-module__settingsSection__T44l9", hd = "HlsPlayerControls-module__settingsSectionTitle__q-x4s", fd = "HlsPlayerControls-module__settingsOptionsGrid__GabGj", md = "HlsPlayerControls-module__settingsOption__GB0eL", gd = "HlsPlayerControls-module__settingsActionButton__Xz7ic", Y = {
  controlsRow: Ku,
  iconButton: Vu,
  iconButtonActive: Wu,
  dropdownTrigger: Yu,
  option: qu,
  playbackTime: zu,
  timelineZoomControls: ju,
  controlsSpacer: Xu,
  secondaryControl: Qu,
  secondaryControlCompact: Zu,
  dropdown: Ju,
  dropdownTriggerOpen: ed,
  playbackRateTrigger: td,
  triggerText: sd,
  menu: nd,
  playbackRateMenu: id,
  optionSelected: rd,
  playbackRateOption: od,
  settingsDropdown: ad,
  settingsDropdownCompact: ld,
  settingsTriggerOpen: cd,
  settingsMenu: ud,
  settingsSection: dd,
  settingsSectionTitle: hd,
  settingsOptionsGrid: fd,
  settingsOption: md,
  settingsActionButton: gd
};
function pd({
  archiveCalendarDisabled: n = !1,
  archiveRanges: e,
  archiveRangesError: t = null,
  archiveRangesLoading: s = !1,
  controlsMode: i,
  currentTimeMs: r,
  displayTimeOffsetMs: o,
  fullscreen: a,
  paused: l,
  playbackRate: c,
  playbackRateDisabled: u = !1,
  selectedVideoTrackId: d,
  timelineZoomDisabled: h = !1,
  videoTracks: m,
  onHideControls: f,
  onArchiveCalendarDaySelect: g,
  onFullscreenToggle: p,
  onPlaybackRateChange: E,
  onPlayToggle: y,
  onPinToggle: x,
  onTimelineZoomIn: S,
  onTimelineZoomOut: v,
  onVideoTrackChange: D
}) {
  var dt, tt, Ye;
  const { t: L } = lt("hlsFlussonicVideoPlayer"), _ = ae(null), A = ae(null), R = ae(null), w = ae(null), [B, M] = ne(null), N = i === "pinned", $ = (tt = (dt = m.find((ee) => ee.id === d)) != null ? dt : m[0]) != null ? tt : null, G = xo(_), W = G != null && G <= 460, U = m.length === 0, P = B === "playback-rate", O = B === "quality", K = B === "settings", V = L("playbackRate"), J = L("videoQuality"), Z = L("settings"), ie = L("timeline.zoomIn"), X = L("timeline.zoomOut"), oe = L(N ? "controls.unpinPanel" : "controls.pinPanel"), Me = L("controls.hidePanel");
  se(() => {
    if (!B)
      return;
    const ee = (st) => {
      var pt, Dt, It;
      const Oe = st.target;
      Oe instanceof Node && ((pt = A.current) != null && pt.contains(Oe) || (Dt = R.current) != null && Dt.contains(Oe) || (It = w.current) != null && It.contains(Oe) || M(null));
    };
    return document.addEventListener("pointerdown", ee), () => {
      document.removeEventListener("pointerdown", ee);
    };
  }, [B]);
  const Pe = (ee) => {
    M((st) => st === ee ? null : ee);
  }, ct = (ee) => {
    E(ee), M(null), zt(A.current), zt(w.current);
  }, Ge = (ee) => {
    D(ee), M(null), zt(R.current), zt(w.current);
  }, ut = () => {
    x(), M(null), zt(w.current);
  }, gt = () => {
    M(null), f();
  }, Ne = (ee) => {
    ee.key === "Escape" && M(null);
  };
  return /* @__PURE__ */ de("div", { className: Y.controlsRow, ref: _, children: [
    /* @__PURE__ */ F(
      "button",
      {
        className: Y.iconButton,
        onClick: y,
        title: L(l ? "play" : "pause"),
        type: "button",
        children: l ? /* @__PURE__ */ F(Ll, {}) : /* @__PURE__ */ F(Rl, {})
      }
    ),
    /* @__PURE__ */ F("span", { className: Y.playbackTime, children: Td(r, o) }),
    /* @__PURE__ */ de("div", { className: Y.timelineZoomControls, children: [
      /* @__PURE__ */ F(
        "button",
        {
          "aria-label": X,
          className: Y.iconButton,
          disabled: h,
          onClick: v,
          title: X,
          type: "button",
          children: /* @__PURE__ */ F(Dl, {})
        }
      ),
      /* @__PURE__ */ F(
        "button",
        {
          "aria-label": ie,
          className: Y.iconButton,
          disabled: h,
          onClick: S,
          title: ie,
          type: "button",
          children: /* @__PURE__ */ F(Il, {})
        }
      )
    ] }),
    /* @__PURE__ */ F("span", { className: Y.controlsSpacer }),
    /* @__PURE__ */ F(
      Uu,
      {
        archiveRanges: e,
        archiveRangesError: t,
        archiveRangesLoading: s,
        currentTimeMs: r,
        disabled: n,
        displayTimeOffsetMs: o,
        onDaySelect: g
      }
    ),
    /* @__PURE__ */ F("div", { className: ue(Y.secondaryControl, W && Y.secondaryControlCompact), children: /* @__PURE__ */ de("div", { className: Y.dropdown, ref: A, children: [
      /* @__PURE__ */ F(
        "button",
        {
          "aria-expanded": P,
          "aria-haspopup": "listbox",
          className: ue(
            Y.dropdownTrigger,
            Y.playbackRateTrigger,
            P && Y.dropdownTriggerOpen
          ),
          disabled: u,
          onClick: () => Pe("playback-rate"),
          onKeyDown: Ne,
          title: V,
          type: "button",
          children: /* @__PURE__ */ F("span", { className: Y.triggerText, children: hn(c) })
        }
      ),
      P && /* @__PURE__ */ F("div", { className: ue(Y.menu, Y.playbackRateMenu), role: "listbox", children: $n.map((ee) => /* @__PURE__ */ F(
        "button",
        {
          "aria-selected": ee === c,
          className: ue(
            Y.option,
            Y.playbackRateOption,
            ee === c && Y.optionSelected
          ),
          onClick: () => ct(ee),
          role: "option",
          type: "button",
          children: hn(ee)
        },
        ee
      )) })
    ] }) }),
    /* @__PURE__ */ F("div", { className: ue(Y.secondaryControl, W && Y.secondaryControlCompact), children: /* @__PURE__ */ de("div", { className: Y.dropdown, ref: R, children: [
      /* @__PURE__ */ F(
        "button",
        {
          "aria-expanded": O,
          "aria-haspopup": "listbox",
          className: ue(Y.dropdownTrigger, O && Y.dropdownTriggerOpen),
          disabled: U,
          onClick: () => Pe("quality"),
          onKeyDown: Ne,
          title: J,
          type: "button",
          children: /* @__PURE__ */ F("span", { className: Y.triggerText, children: (Ye = $ == null ? void 0 : $.label) != null ? Ye : "" })
        }
      ),
      O && /* @__PURE__ */ F("div", { className: Y.menu, role: "listbox", children: m.map((ee) => /* @__PURE__ */ F(
        "button",
        {
          "aria-selected": ee.id === ($ == null ? void 0 : $.id),
          className: ue(Y.option, ee.id === ($ == null ? void 0 : $.id) && Y.optionSelected),
          onClick: () => Ge(ee.id),
          role: "option",
          type: "button",
          children: ee.label
        },
        ee.id
      )) })
    ] }) }),
    /* @__PURE__ */ F("div", { className: ue(Y.secondaryControl, W && Y.secondaryControlCompact), children: /* @__PURE__ */ F(
      "button",
      {
        className: ue(Y.iconButton, N && Y.iconButtonActive),
        onClick: ut,
        title: oe,
        type: "button",
        children: N ? /* @__PURE__ */ F(ki, {}) : /* @__PURE__ */ F(Fi, {})
      }
    ) }),
    /* @__PURE__ */ F("div", { className: ue(Y.secondaryControl, W && Y.secondaryControlCompact), children: /* @__PURE__ */ F("button", { className: Y.iconButton, onClick: gt, title: Me, type: "button", children: /* @__PURE__ */ F(Pi, {}) }) }),
    /* @__PURE__ */ de(
      "div",
      {
        className: ue(Y.settingsDropdown, W && Y.settingsDropdownCompact),
        ref: w,
        children: [
          /* @__PURE__ */ F(
            "button",
            {
              "aria-expanded": K,
              "aria-haspopup": "dialog",
              className: ue(Y.iconButton, K && Y.settingsTriggerOpen),
              onClick: () => Pe("settings"),
              onKeyDown: Ne,
              title: Z,
              type: "button",
              children: /* @__PURE__ */ F(bl, {})
            }
          ),
          K && /* @__PURE__ */ de("div", { "aria-label": Z, className: Y.settingsMenu, role: "dialog", children: [
            /* @__PURE__ */ de("div", { className: Y.settingsSection, children: [
              /* @__PURE__ */ F("div", { className: Y.settingsSectionTitle, children: V }),
              /* @__PURE__ */ F("div", { className: Y.settingsOptionsGrid, children: $n.map((ee) => /* @__PURE__ */ F(
                "button",
                {
                  "aria-pressed": ee === c,
                  className: ue(
                    Y.option,
                    Y.settingsOption,
                    ee === c && Y.optionSelected
                  ),
                  disabled: u,
                  onClick: () => ct(ee),
                  type: "button",
                  children: hn(ee)
                },
                ee
              )) })
            ] }),
            !U && /* @__PURE__ */ de("div", { className: Y.settingsSection, children: [
              /* @__PURE__ */ F("div", { className: Y.settingsSectionTitle, children: J }),
              m.map((ee) => /* @__PURE__ */ F(
                "button",
                {
                  "aria-pressed": ee.id === ($ == null ? void 0 : $.id),
                  className: ue(
                    Y.option,
                    Y.settingsOption,
                    ee.id === ($ == null ? void 0 : $.id) && Y.optionSelected
                  ),
                  onClick: () => Ge(ee.id),
                  type: "button",
                  children: ee.label
                },
                ee.id
              ))
            ] }),
            /* @__PURE__ */ de("div", { className: Y.settingsSection, children: [
              /* @__PURE__ */ de(
                "button",
                {
                  className: ue(Y.option, Y.settingsActionButton, N && Y.optionSelected),
                  onClick: ut,
                  type: "button",
                  children: [
                    N ? /* @__PURE__ */ F(ki, {}) : /* @__PURE__ */ F(Fi, {}),
                    /* @__PURE__ */ F("span", { children: oe })
                  ]
                }
              ),
              /* @__PURE__ */ de(
                "button",
                {
                  className: ue(Y.option, Y.settingsActionButton),
                  onClick: gt,
                  type: "button",
                  children: [
                    /* @__PURE__ */ F(Pi, {}),
                    /* @__PURE__ */ F("span", { children: Me })
                  ]
                }
              )
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ F(
      "button",
      {
        className: Y.iconButton,
        onClick: p,
        title: L(a ? "fullscreen.exit" : "fullscreen.enter"),
        type: "button",
        children: a ? /* @__PURE__ */ F(_l, {}) : /* @__PURE__ */ F(Cl, {})
      }
    )
  ] });
}
function Td(n, e) {
  return n == null ? "--:--:--" : is(n, e);
}
function hn(n) {
  return `${n}x`;
}
function zt(n) {
  const e = document.activeElement;
  e instanceof HTMLElement && (n != null && n.contains(e)) && e.blur();
}
const Ed = "PlayerPlaceholder-module__placeholder__ogwUS", yd = "PlayerPlaceholder-module__title__zbLHY", xd = "PlayerPlaceholder-module__meta__3DTgL", Zt = {
  placeholder: Ed,
  title: yd,
  meta: xd
};
function vd() {
  const { t: n } = lt("hlsFlussonicVideoPlayer");
  return /* @__PURE__ */ F("div", { className: Zt.placeholder, children: n("errors.liveUnavailable") });
}
function Sd({ displayTimeOffsetMs: n, timeMs: e }) {
  const { t } = lt("hlsFlussonicVideoPlayer");
  return /* @__PURE__ */ de("div", { className: Zt.placeholder, children: [
    /* @__PURE__ */ F("div", { className: Zt.title, children: t("errors.noArchive") }),
    /* @__PURE__ */ F("div", { className: Zt.meta, children: Ul(e, n) })
  ] });
}
function Ad() {
  const { t: n } = lt("hlsFlussonicVideoPlayer");
  return /* @__PURE__ */ F("div", { className: Zt.placeholder, children: n("errors.streamUnavailable") });
}
const Ld = "HlsVideoPlayer-module__root__aoyuI", Rd = "HlsVideoPlayer-module__video__iuTuw", Dd = "HlsVideoPlayer-module__loadingOverlay__oakam", Id = "HlsVideoPlayer-module__controlsOverlay__8uzhw", bd = "HlsVideoPlayer-module__controlsOverlayVisible__16rws", _d = "HlsVideoPlayer-module__errorOverlay__fR5B-", Cd = "HlsVideoPlayer-module__errorOverlayMessage__s-lQH", wd = "HlsVideoPlayer-module__restoreControlsButton__mtGip", Md = "HlsVideoPlayer-module__cameraNameBadge__Jr6QX", nt = {
  root: Ld,
  video: Rd,
  loadingOverlay: Dd,
  controlsOverlay: Id,
  controlsOverlayVisible: bd,
  errorOverlay: _d,
  errorOverlayMessage: Cd,
  restoreControlsButton: wd,
  cameraNameBadge: Md
};
function Rt(n) {
  const e = new URL(n), t = Hd(e.pathname);
  return {
    origin: e.origin,
    streamName: t.replace(/^\/+/, ""),
    streamPath: t,
    searchParams: new URLSearchParams(e.search)
  };
}
function kd({
  config: n,
  playbackMode: e,
  playbackStartTimeMs: t,
  playlistDurationSec: s,
  videoTrackId: i
}) {
  const r = mt(
    n,
    Gd({
      playbackMode: e,
      playbackStartTimeMs: t,
      playlistDurationSec: s
    })
  );
  return i && r.searchParams.set("filter.tracks", i), r.toString();
}
function Fd({
  config: n,
  playbackStartTimeMs: e,
  playlistDurationSec: t
}) {
  const s = mt(
    n,
    `archive-${Math.floor(e / 1e3)}-${t}.json`
  );
  return s.searchParams.delete("filter.tracks"), s.searchParams.delete("tracks"), s.toString();
}
function Pd({
  authToken: n,
  config: e,
  fromMs: t,
  toMs: s,
  videoTrackId: i
}) {
  const r = Math.floor(t / 1e3), o = Math.ceil(s / 1e3), a = o - r, l = i.trim();
  if (!Number.isFinite(r) || !Number.isFinite(o) || r < 0 || a <= 0)
    throw new RangeError("Invalid Flussonic DVR export interval");
  if (!l)
    throw new RangeError("Invalid Flussonic DVR export video track");
  const c = mt(e, `archive-${r}-${a}.mp4`);
  return c.searchParams.delete("tracks"), c.searchParams.set("filter.tracks", l), Lo(c, n), c.toString();
}
function Od(n) {
  return mt(n, "recording_status.json").toString();
}
function Nd(n) {
  return mt(n, "media_info.json").toString();
}
function Ud(n) {
  return mt(n, "info.json").toString();
}
function Bd({
  config: n,
  closedAtGteMs: e,
  openedAtLteMs: t,
  resolutionSec: s
}) {
  const i = mt(n, "ranges.json");
  return i.searchParams.set("closed_at_gte", Zi(e)), i.searchParams.set("opened_at_lte", Zi(t)), s != null && i.searchParams.set("resolution", String(s)), i.toString();
}
function $d({
  authToken: n,
  config: e,
  timeMs: t
}) {
  const s = mt(e, `${Math.floor(t / 1e3)}-preview.jpg`);
  return Lo(s, n), s.toString();
}
function mt(n, e) {
  const t = e.replace(/^\/+/, ""), s = n.streamPath === "/" ? "" : n.streamPath, i = new URL(`${n.origin}${s}/${t}`);
  return n.searchParams.forEach((r, o) => {
    i.searchParams.append(o, r);
  }), i;
}
function Lo(n, e) {
  !e || n.searchParams.has("token") || n.searchParams.set("token", e);
}
function Gd({
  playbackMode: n,
  playbackStartTimeMs: e,
  playlistDurationSec: t
}) {
  return n === "archive" && e != null ? `index-${Math.floor(e / 1e3)}-${t}.fmp4.m3u8` : "index.fmp4.m3u8";
}
function Hd(n) {
  const e = n.replace(/\/+$/, "");
  return e.endsWith("/embed.html") || e.endsWith("/index.m3u8") ? e.slice(0, -11) || "/" : e.endsWith("/index.fmp4.m3u8") ? e.slice(0, -16) || "/" : e.endsWith("/mpegts") ? e.slice(0, -7) || "/" : e || "/";
}
function Zi(n) {
  return String(Math.floor(n / 1e3));
}
function Kd({ elementRef: n }) {
  const [e, t] = ne(!1);
  se(() => {
    const i = () => {
      t(document.fullscreenElement === n.current);
    };
    return document.addEventListener("fullscreenchange", i), () => {
      document.removeEventListener("fullscreenchange", i);
    };
  }, [n]);
  const s = q(() => {
    const i = n.current;
    if (i) {
      if (document.fullscreenElement === i) {
        document.exitFullscreen().catch(() => {
        });
        return;
      }
      i.requestFullscreen().catch(() => {
      });
    }
  }, [n]);
  return {
    fullscreen: e,
    toggleFullscreen: s
  };
}
function rs(n, e) {
  return n.some((t) => e >= t.fromMs && e <= t.toMs);
}
function Vd({
  archiveRanges: n,
  fromMs: e,
  toMs: t
}) {
  const s = Yd({ fromMs: e, toMs: t });
  if (s == null)
    return {
      requestedInterval: s,
      status: "empty"
    };
  const i = jd(
    n.map((r) => qd(s, r)).filter((r) => r !== null)
  );
  if (i.length === 0)
    return {
      requestedInterval: s,
      status: "empty"
    };
  if (i.length === 1) {
    const [r] = i;
    return {
      complete: zd(r, s),
      part: r,
      requestedInterval: s,
      status: "single"
    };
  }
  return {
    complete: !1,
    parts: i,
    requestedInterval: s,
    status: "multiple"
  };
}
function Wd(n) {
  const e = Gn(n).map(Xd).filter((t) => t !== null).sort((t, s) => t.fromMs - s.fromMs);
  return Jd(e);
}
function Gn(n) {
  return n == null ? [] : Array.isArray(n) ? eh(n) || er(n) ? [n] : n.flatMap(Gn) : typeof n == "object" ? er(n) ? [n] : Object.values(n).flatMap(Gn) : [];
}
function Yd({ fromMs: n, toMs: e }) {
  const t = Math.min(n, e), s = Math.max(n, e);
  return !Number.isFinite(t) || !Number.isFinite(s) || t >= s ? null : {
    fromMs: t,
    toMs: s
  };
}
function qd(n, e) {
  const t = Math.max(n.fromMs, e.fromMs), s = Math.min(n.toMs, e.toMs);
  return t >= s ? null : {
    fromMs: t,
    toMs: s
  };
}
function zd(n, e) {
  return n.fromMs === e.fromMs && n.toMs === e.toMs;
}
function jd(n) {
  return n.slice().sort((e, t) => e.fromMs - t.fromMs).reduce((e, t) => {
    const s = e[e.length - 1];
    return !s || t.fromMs > s.toMs ? (e.push({ ...t }), e) : (s.toMs = Math.max(s.toMs, t.toMs), e);
  }, []);
}
function Xd(n) {
  var i, r, o, a, l;
  if (Array.isArray(n)) {
    const c = gs(n[0]), u = gs(n[1]);
    return Ji(c, u);
  }
  if (!Ro(n))
    return null;
  const e = n, t = gs((r = (i = e.from) != null ? i : e.start) != null ? r : e.opened_at), s = (l = gs((a = (o = e.to) != null ? o : e.end) != null ? a : e.closed_at)) != null ? l : Qd(t, e.duration);
  return Ji(t, s);
}
function Qd(n, e) {
  if (n == null)
    return null;
  const t = Zd(e);
  return t == null ? null : n + t;
}
function Zd(n) {
  const e = Number(n);
  return !Number.isFinite(e) || e < 0 ? null : e > 1e5 ? Math.round(e) : e * 1e3;
}
function gs(n) {
  const e = Number(n);
  return !Number.isFinite(e) || e <= 0 ? null : e > 1e11 ? Math.round(e) : Math.round(e * 1e3);
}
function Ji(n, e) {
  return n == null || e == null || e < n ? null : { fromMs: n, toMs: e };
}
function Jd(n) {
  return n.reduce((e, t) => {
    const s = e[e.length - 1];
    return !s || t.fromMs > s.toMs ? (e.push({ ...t }), e) : (s.toMs = Math.max(s.toMs, t.toMs), e);
  }, []);
}
function er(n) {
  return Ro(n) ? ("from" in n || "start" in n || "opened_at" in n) && ("to" in n || "end" in n || "closed_at" in n || "duration" in n) : !1;
}
function eh(n) {
  return n.length >= 2 && Number.isFinite(Number(n[0])) && Number.isFinite(Number(n[1]));
}
function Ro(n) {
  return typeof n == "object" && n !== null;
}
function th(n) {
  var e;
  return !(n != null && n.dvrEnabled) || n.fromMs == null || n.toMs != null && n.toMs <= n.fromMs ? null : {
    startMs: n.fromMs,
    endMs: (e = n.toMs) != null ? e : Date.now()
  };
}
function sh({
  archiveRanges: n,
  dvrWindow: e
}) {
  const t = n.reduce((s, i) => !s || i.toMs > s.toMs ? i : s, null);
  return t ? Math.max(t.fromMs, t.toMs - 1e3) : e ? Math.max(e.startMs, e.endMs - 1e3) : null;
}
function nh({
  dvrWindow: n,
  liveAvailable: e,
  liveEdgeMs: t
}) {
  return n ? !e || t == null ? n : {
    startMs: n.startMs,
    endMs: Math.max(n.endMs, t)
  } : null;
}
class ih extends Error {
  constructor({ status: t, statusText: s, url: i }) {
    super(`Flussonic request failed: ${t} ${s}`);
    hs(this, "status");
    hs(this, "statusText");
    hs(this, "url");
    this.name = "FlussonicRequestError", this.status = t, this.statusText = s, this.url = i;
  }
}
async function rh({
  sourceUrl: n,
  signal: e
}) {
  const t = Rt(n), s = await os({
    signal: e,
    url: Od(t)
  });
  return dh(s, t.streamName);
}
async function oh({
  closedAtGteMs: n,
  openedAtLteMs: e,
  resolutionSec: t,
  signal: s,
  sourceUrl: i
}) {
  const r = Rt(i), o = await os({
    signal: s,
    url: Bd({
      closedAtGteMs: n,
      config: r,
      openedAtLteMs: e,
      resolutionSec: t
    })
  });
  return Wd(o);
}
async function ah({
  playbackMode: n,
  playbackStartTimeMs: e = null,
  playlistDurationSec: t = null,
  signal: s,
  sourceUrl: i
}) {
  return n === "archive" && e != null && t != null && Number.isFinite(e) && Number.isFinite(t) && t > 0 ? ch({
    playbackStartTimeMs: e,
    playlistDurationSec: t,
    signal: s,
    sourceUrl: i
  }) : lh({
    signal: s,
    sourceUrl: i
  });
}
async function lh({ signal: n, sourceUrl: e }) {
  const t = Rt(e), s = await os({
    signal: n,
    url: Nd(t)
  });
  return Hn(s);
}
async function ch({
  playbackStartTimeMs: n,
  playlistDurationSec: e,
  signal: t,
  sourceUrl: s
}) {
  const i = Rt(s), r = await os({
    signal: t,
    url: Fd({
      config: i,
      playbackStartTimeMs: n,
      playlistDurationSec: e
    })
  });
  return Th(r);
}
async function uh({ signal: n, sourceUrl: e }) {
  const t = Rt(e), s = await os({
    signal: n,
    url: Ud(t)
  });
  return yh(s);
}
async function os({ signal: n, url: e }) {
  const t = await fetch(e, { signal: n });
  if (!t.ok)
    throw new ih({
      status: t.status,
      statusText: t.statusText,
      url: e
    });
  return t.json();
}
function dh(n, e) {
  const t = hh(n, e), s = _e(t), i = $s(xe(s, ["from", "start", "opened_at", "begin"])), r = $s(xe(s, ["to", "end", "closed_at", "until"])), o = Do(xe(s, ["duration", "depth"])), a = r != null ? r : mh(i, o);
  return {
    dvrEnabled: fh(t),
    fromMs: i,
    toMs: a,
    durationMs: o,
    raw: n
  };
}
function hh(n, e) {
  if (ps(n))
    return n;
  const t = _e(n);
  if (!t)
    return n;
  if (ps(t[e]))
    return t[e];
  const s = e.split("/").pop();
  if (s && ps(t[s]))
    return t[s];
  const i = Object.values(t).find(ps);
  return i != null ? i : n;
}
function ps(n) {
  const e = _e(n);
  return e != null && xe(e, [
    "from",
    "start",
    "opened_at",
    "begin",
    "to",
    "end",
    "closed_at",
    "until",
    "duration",
    "depth"
  ]) != null;
}
function fh(n) {
  if (typeof n == "boolean")
    return n;
  const e = _e(n);
  if (!e)
    return !1;
  const t = xe(e, ["recording", "recording_enabled", "dvr", "dvr_enabled", "enabled"]);
  return typeof t == "boolean" ? t : typeof t == "string" ? ["true", "1", "active", "enabled", "recording"].includes(t.toLowerCase()) : typeof t == "number" ? t > 0 : $s(xe(e, ["from", "start", "opened_at", "begin"])) != null || Do(xe(e, ["duration", "depth"])) != null;
}
function mh(n, e) {
  return n == null || e == null ? null : n + e;
}
function Do(n) {
  const e = Number(n);
  return !Number.isFinite(e) || e < 0 ? null : e > 1e5 ? Math.round(e) : e * 1e3;
}
function $s(n) {
  const e = Number(n);
  return !Number.isFinite(e) || e <= 0 ? null : e > 1e11 ? Math.round(e) : Math.round(e * 1e3);
}
function xe(n, e) {
  if (n) {
    for (const t of e)
      if (n[t] != null)
        return n[t];
  }
}
function _e(n) {
  return typeof n == "object" && n !== null ? n : null;
}
const gh = ["active", "alive", "online", "publishing", "running", "started"], ph = ["closed", "failed", "inactive", "no_input", "offline", "stopped", "waiting"];
function Hn(n) {
  return Sh(n).map(Ah).filter((t) => t != null).sort(Io);
}
function Th(n) {
  const e = _e(n), t = e == null ? void 0 : e.periods;
  return Array.isArray(t) ? Eh(
    t.flatMap((s) => {
      var r;
      const i = _e(s);
      return Hn((r = i == null ? void 0 : i.media_info) != null ? r : s);
    })
  ).sort(Io) : Hn(n);
}
function Eh(n) {
  const e = /* @__PURE__ */ new Map();
  return n.forEach((t) => {
    e.has(t.id) || e.set(t.id, t);
  }), Array.from(e.values());
}
function yh(n) {
  const e = xh(n), t = _e(e == null ? void 0 : e.stats), s = Bt(xe(t != null ? t : e, ["status", "state"])), i = $s(
    xe(t != null ? t : e, ["last_dts_at", "lastDtsAt", "last_dts", "lastDts"])
  );
  return {
    authToken: Bt(xe(e, ["auth_token", "authToken", "token"])),
    lastDtsAtMs: i,
    liveAvailable: vh({
      lastDtsAtMs: i,
      stats: t != null ? t : e,
      status: s
    }),
    raw: n,
    status: s
  };
}
function xh(n) {
  var i;
  const e = _e(n);
  if (!e)
    return null;
  if (_e(e.stats))
    return e;
  const s = Object.values(e).find((r) => {
    const o = _e(r);
    return o != null && _e(o.stats) != null;
  });
  return (i = _e(s)) != null ? i : e;
}
function vh({
  lastDtsAtMs: n,
  stats: e,
  status: t
}) {
  const s = xe(e, ["live", "online", "alive", "running", "source_alive", "sourceAlive"]);
  if (typeof s == "boolean")
    return s;
  const i = t == null ? void 0 : t.toLowerCase();
  if (i) {
    if (gh.includes(i))
      return !0;
    if (ph.includes(i))
      return !1;
  }
  return n != null && Date.now() - n < 3e4 ? !0 : null;
}
function Sh(n) {
  var r;
  const e = _e(n), t = (r = _e(e == null ? void 0 : e.media_info)) != null ? r : e, s = t == null ? void 0 : t.tracks;
  if (Array.isArray(s))
    return s;
  const i = _e(s);
  return i ? Object.entries(i).map(([o, a]) => {
    const l = _e(a);
    return l ? { id: o, ...l } : a;
  }) : [];
}
function Ah(n) {
  const e = _e(n);
  if (!e || !Lh(e))
    return null;
  const t = Rh(e);
  if (!t)
    return null;
  const s = Xt(xe(e, ["width", "w"])), i = Xt(xe(e, ["height", "h"])), r = Xt(xe(e, ["bitrate", "bit_rate", "bps"])), o = Xt(xe(e, ["fps", "framerate"])), a = Bt(xe(e, ["codec", "codec_name"]));
  return {
    id: t,
    label: Dh({ height: i, id: t }),
    bitrate: r,
    codec: a,
    fps: o,
    height: i,
    raw: n,
    width: s
  };
}
function Lh(n) {
  const e = Bt(xe(n, ["id", "track_id", "trackId", "name"])), t = Bt(xe(n, ["content", "type", "media_type", "kind"]));
  return (e == null ? void 0 : e.startsWith("v")) || (t == null ? void 0 : t.toLowerCase()) === "video" || Xt(xe(n, ["width", "height"])) != null;
}
function Rh(n) {
  const e = Bt(xe(n, ["id", "track_id", "trackId", "name"]));
  return e && e.startsWith("v") ? e : null;
}
function Dh({ height: n, id: e }) {
  return n != null ? `${n}p` : e;
}
function Io(n, e) {
  return tr(n.height, e.height) || tr(n.bitrate, e.bitrate) || n.id.localeCompare(e.id);
}
function tr(n, e) {
  return n == null && e == null ? 0 : n == null ? -1 : e == null ? 1 : n - e;
}
function Xt(n) {
  const e = Number(n);
  return Number.isFinite(e) ? e : null;
}
function Bt(n) {
  return typeof n == "string" && n.trim() !== "" ? n.trim() : null;
}
function en({
  enabled: n = !0,
  initialData: e,
  loadingStrategy: t = "always",
  load: s,
  preserveDataOnError: i = !1,
  refreshIntervalMs: r = null,
  resetOnLoadChange: o = !0
}) {
  const a = ae(e), l = ae(!1), [c, u] = ne(e), [d, h] = ne(null), [m, f] = ne(!1), [g, p] = ne(0), E = q(() => {
    p((y) => y + 1);
  }, []);
  return se(() => {
    o && (a.current = e, l.current = !1, u(e), h(null));
  }, [e, s, o]), se(() => {
    if (!n) {
      a.current = e, l.current = !1, u(e), h(null), f(!1);
      return;
    }
    const y = new AbortController();
    let x = !0;
    const S = t === "always" || !l.current;
    return f(S), h(null), s(y.signal).then((v) => {
      x && (a.current = v, l.current = !0, u(v), f(!1));
    }).catch((v) => {
      !x || Ih(v) || (h(bh(v)), (!i || !l.current) && (a.current = e, l.current = !1, u(e)), f(!1));
    }), () => {
      x = !1, y.abort();
    };
  }, [n, e, s, t, i, g]), se(() => {
    if (!n || r == null || !Number.isFinite(r) || r <= 0)
      return;
    const y = setInterval(E, r);
    return () => {
      clearInterval(y);
    };
  }, [n, r, E]), {
    data: c,
    error: d,
    loading: m,
    reload: E
  };
}
function Ih(n) {
  return n instanceof DOMException && n.name === "AbortError";
}
function bh(n) {
  return n instanceof Error ? n : new Error(String(n));
}
const _h = 720, sr = [];
function Ch({
  sourceUrl: n,
  windowEndMs: e,
  windowStartMs: t
}) {
  const s = t != null && e != null && e > t, i = q(
    (r) => t == null || e == null || e <= t ? Promise.resolve(sr) : oh({
      closedAtGteMs: t,
      openedAtLteMs: e,
      resolutionSec: wh(t, e),
      signal: r,
      sourceUrl: n
    }),
    [n, e, t]
  );
  return en({
    enabled: s,
    initialData: sr,
    load: i,
    resetOnLoadChange: !1
  });
}
function wh(n, e) {
  const t = Math.max((e - n) / 1e3, 1);
  return Math.max(Math.floor(t / _h), 1);
}
const Mh = 1e4;
function kh(n, e = {}) {
  var i;
  const t = (i = e.refreshIntervalMs) != null ? i : Mh, s = q(
    (r) => rh({
      signal: r,
      sourceUrl: n
    }),
    [n]
  );
  return en({
    initialData: null,
    load: s,
    loadingStrategy: "initial",
    preserveDataOnError: !0,
    refreshIntervalMs: t
  });
}
const Fh = 1e4;
function Ph(n, e = {}) {
  var i;
  const t = (i = e.refreshIntervalMs) != null ? i : Fh, s = q(
    (r) => uh({
      signal: r,
      sourceUrl: n
    }),
    [n]
  );
  return en({
    initialData: null,
    load: s,
    loadingStrategy: "initial",
    preserveDataOnError: !0,
    refreshIntervalMs: t
  });
}
const Oh = [];
function Nh({
  enabled: n = !0,
  playbackMode: e,
  playbackStartTimeMs: t = null,
  playlistDurationSec: s = null,
  sourceUrl: i
}) {
  const r = ae({
    playbackMode: e,
    playbackStartTimeMs: t,
    playlistDurationSec: s
  }), o = Uh({
    playbackMode: e,
    playbackStartTimeMs: t,
    playlistDurationSec: s
  }), a = ae(o), l = q(
    (d) => {
      const h = r.current;
      return ah({
        playbackMode: h.playbackMode,
        playbackStartTimeMs: h.playbackStartTimeMs,
        playlistDurationSec: h.playlistDurationSec,
        signal: d,
        sourceUrl: i
      });
    },
    [i]
  );
  se(() => {
    r.current = {
      playbackMode: e,
      playbackStartTimeMs: t,
      playlistDurationSec: s
    };
  }, [e, t, s]);
  const c = en({
    enabled: n,
    initialData: Oh,
    load: l,
    loadingStrategy: "initial",
    preserveDataOnError: !0
  }), { reload: u } = c;
  return se(() => {
    if (!n) {
      a.current = o;
      return;
    }
    a.current !== o && (a.current = o, u());
  }, [o, n, u]), c;
}
function Uh({
  playbackMode: n,
  playbackStartTimeMs: e,
  playlistDurationSec: t
}) {
  return n !== "archive" || e == null || t == null || !Number.isFinite(e) || !Number.isFinite(t) || t <= 0 ? null : `${Math.floor(e / 1e3)}:${t}`;
}
function Bh({
  liveEdgeMs: n,
  playbackMode: e,
  playbackStartTimeMs: t,
  playlistDurationSec: s,
  sourceUrl: i
}) {
  var y, x, S, v, D, L, _, A, R;
  const r = Ph(i), o = (x = (y = r.data) == null ? void 0 : y.liveAvailable) != null ? x : null, a = (v = (S = r.data) == null ? void 0 : S.authToken) != null ? v : null, l = o !== !1, c = o === !1 ? null : (L = (D = r.data) == null ? void 0 : D.lastDtsAtMs) != null ? L : null, u = kh(i), d = Ee(() => th(u.data), [u.data]), h = Ee(
    () => nh({
      dvrWindow: d,
      liveAvailable: l,
      liveEdgeMs: n
    }),
    [d, l, n]
  ), m = Ch({
    sourceUrl: i,
    windowEndMs: (_ = d == null ? void 0 : d.endMs) != null ? _ : null,
    windowStartMs: (A = d == null ? void 0 : d.startMs) != null ? A : null
  }), f = m.loading || u.loading || u.data == null && u.error == null, g = Nh({
    enabled: $h({
      archiveRanges: m.data,
      archiveRangesError: m.error,
      archiveRangesLoading: f,
      playbackMode: e,
      playbackStartTimeMs: t
    }),
    playbackMode: e,
    playbackStartTimeMs: t,
    playlistDurationSec: s,
    sourceUrl: i
  }), p = ((R = r.data) == null ? void 0 : R.liveAvailable) === !1 && u.data != null && d == null, E = h != null;
  return {
    archiveRanges: {
      ...m,
      loading: f
    },
    canSeekArchive: E,
    dvrWindow: d,
    liveAvailable: l,
    recordingStatus: u,
    streamLiveAvailable: o,
    streamAuthToken: a,
    streamLiveEdgeMs: c,
    streamStatus: r,
    streamUnavailable: p,
    timelineWindow: h,
    videoTracks: g
  };
}
function $h({
  archiveRanges: n,
  archiveRangesError: e,
  archiveRangesLoading: t,
  playbackMode: s,
  playbackStartTimeMs: i
}) {
  return s !== "archive" ? !0 : i == null || !Number.isFinite(i) ? !1 : t || e != null ? !0 : rs(n, i);
}
function Gh({
  archiveRanges: n,
  archiveRangesError: e,
  archiveRangesLoading: t,
  authToken: s,
  config: i,
  playbackBounds: r,
  videoTrackId: o
}) {
  return Ee(
    () => Hh({
      archiveRanges: n,
      archiveRangesError: e,
      archiveRangesLoading: t,
      authToken: s,
      config: i,
      playbackBounds: r,
      videoTrackId: o
    }),
    [n, e, t, s, i, r, o]
  );
}
function Hh({
  archiveRanges: n,
  archiveRangesError: e,
  archiveRangesLoading: t,
  authToken: s,
  config: i,
  playbackBounds: r,
  videoTrackId: o
}) {
  if ((r == null ? void 0 : r.locked) !== !0)
    return {
      status: "hidden"
    };
  const a = {
    fromMs: r.startMs,
    toMs: r.endMs
  };
  if (!o)
    return {
      reason: "no-track",
      requestedInterval: a,
      status: "empty"
    };
  if (t)
    return {
      requestedInterval: a,
      status: "loading"
    };
  if (e != null)
    return {
      reason: "archive-error",
      requestedInterval: a,
      status: "empty"
    };
  const l = Vd({
    archiveRanges: n,
    fromMs: r.startMs,
    toMs: r.endMs
  });
  return l.status === "empty" ? {
    reason: "no-archive",
    requestedInterval: l.requestedInterval,
    status: "empty"
  } : l.status === "single" ? {
    complete: l.complete,
    part: nr({
      authToken: s,
      config: i,
      part: l.part,
      videoTrackId: o
    }),
    requestedInterval: l.requestedInterval,
    status: "single"
  } : {
    complete: !1,
    parts: l.parts.map(
      (c) => nr({
        authToken: s,
        config: i,
        part: c,
        videoTrackId: o
      })
    ),
    requestedInterval: l.requestedInterval,
    status: "multiple"
  };
}
function nr({
  authToken: n,
  config: e,
  part: t,
  videoTrackId: s
}) {
  return {
    ...t,
    url: Pd({
      authToken: n,
      config: e,
      fromMs: t.fromMs,
      toMs: t.toMs,
      videoTrackId: s
    })
  };
}
function Kh({
  liveAvailable: n,
  streamLiveEdgeMs: e
}) {
  const t = ae(null);
  return se(() => {
    if (!n || e == null) {
      t.current = null;
      return;
    }
    t.current = {
      capturedAtMs: Date.now(),
      liveEdgeMs: e
    };
  }, [n, e]), {
    getLivePlaybackTimeMs: q(() => {
      const i = t.current;
      return !n || i == null ? Date.now() : i.liveEdgeMs + (Date.now() - i.capturedAtMs);
    }, [n])
  };
}
function Vh(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var bo = { exports: {} };
(function(n, e) {
  (function(t) {
    var s = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, i = /^(?=([^\/?#]*))\1([^]*)$/, r = /(?:\/|^)\.(?=\/)/g, o = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, a = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(l, c, u) {
        if (u = u || {}, l = l.trim(), c = c.trim(), !c) {
          if (!u.alwaysNormalize)
            return l;
          var d = a.parseURL(l);
          if (!d)
            throw new Error("Error trying to parse base URL.");
          return d.path = a.normalizePath(
            d.path
          ), a.buildURLFromParts(d);
        }
        var h = a.parseURL(c);
        if (!h)
          throw new Error("Error trying to parse relative URL.");
        if (h.scheme)
          return u.alwaysNormalize ? (h.path = a.normalizePath(h.path), a.buildURLFromParts(h)) : c;
        var m = a.parseURL(l);
        if (!m)
          throw new Error("Error trying to parse base URL.");
        if (!m.netLoc && m.path && m.path[0] !== "/") {
          var f = i.exec(m.path);
          m.netLoc = f[1], m.path = f[2];
        }
        m.netLoc && !m.path && (m.path = "/");
        var g = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: m.scheme,
          netLoc: h.netLoc,
          path: null,
          params: h.params,
          query: h.query,
          fragment: h.fragment
        };
        if (!h.netLoc && (g.netLoc = m.netLoc, h.path[0] !== "/"))
          if (!h.path)
            g.path = m.path, h.params || (g.params = m.params, h.query || (g.query = m.query));
          else {
            var p = m.path, E = p.substring(0, p.lastIndexOf("/") + 1) + h.path;
            g.path = a.normalizePath(E);
          }
        return g.path === null && (g.path = u.alwaysNormalize ? a.normalizePath(h.path) : h.path), a.buildURLFromParts(g);
      },
      parseURL: function(l) {
        var c = s.exec(l);
        return c ? {
          scheme: c[1] || "",
          netLoc: c[2] || "",
          path: c[3] || "",
          params: c[4] || "",
          query: c[5] || "",
          fragment: c[6] || ""
        } : null;
      },
      normalizePath: function(l) {
        for (l = l.split("").reverse().join("").replace(r, ""); l.length !== (l = l.replace(o, "")).length; )
          ;
        return l.split("").reverse().join("");
      },
      buildURLFromParts: function(l) {
        return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
      }
    };
    n.exports = a;
  })();
})(bo);
var ri = bo.exports;
function ir(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    e && (s = s.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, s);
  }
  return t;
}
function De(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ir(Object(t), !0).forEach(function(s) {
      qh(n, s, t[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : ir(Object(t)).forEach(function(s) {
      Object.defineProperty(n, s, Object.getOwnPropertyDescriptor(t, s));
    });
  }
  return n;
}
function Wh(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(n, e);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Yh(n) {
  var e = Wh(n, "string");
  return typeof e == "symbol" ? e : String(e);
}
function qh(n, e, t) {
  return e = Yh(e), e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function ve() {
  return ve = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (n[s] = t[s]);
    }
    return n;
  }, ve.apply(this, arguments);
}
const H = Number.isFinite || function(n) {
  return typeof n == "number" && isFinite(n);
}, zh = Number.isSafeInteger || function(n) {
  return typeof n == "number" && Math.abs(n) <= jh;
}, jh = Number.MAX_SAFE_INTEGER || 9007199254740991;
let T = /* @__PURE__ */ (function(n) {
  return n.MEDIA_ATTACHING = "hlsMediaAttaching", n.MEDIA_ATTACHED = "hlsMediaAttached", n.MEDIA_DETACHING = "hlsMediaDetaching", n.MEDIA_DETACHED = "hlsMediaDetached", n.BUFFER_RESET = "hlsBufferReset", n.BUFFER_CODECS = "hlsBufferCodecs", n.BUFFER_CREATED = "hlsBufferCreated", n.BUFFER_APPENDING = "hlsBufferAppending", n.BUFFER_APPENDED = "hlsBufferAppended", n.BUFFER_EOS = "hlsBufferEos", n.BUFFER_FLUSHING = "hlsBufferFlushing", n.BUFFER_FLUSHED = "hlsBufferFlushed", n.MANIFEST_LOADING = "hlsManifestLoading", n.MANIFEST_LOADED = "hlsManifestLoaded", n.MANIFEST_PARSED = "hlsManifestParsed", n.LEVEL_SWITCHING = "hlsLevelSwitching", n.LEVEL_SWITCHED = "hlsLevelSwitched", n.LEVEL_LOADING = "hlsLevelLoading", n.LEVEL_LOADED = "hlsLevelLoaded", n.LEVEL_UPDATED = "hlsLevelUpdated", n.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", n.LEVELS_UPDATED = "hlsLevelsUpdated", n.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", n.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", n.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", n.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", n.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", n.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", n.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", n.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", n.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", n.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", n.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", n.CUES_PARSED = "hlsCuesParsed", n.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", n.INIT_PTS_FOUND = "hlsInitPtsFound", n.FRAG_LOADING = "hlsFragLoading", n.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", n.FRAG_LOADED = "hlsFragLoaded", n.FRAG_DECRYPTED = "hlsFragDecrypted", n.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", n.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", n.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", n.FRAG_PARSED = "hlsFragParsed", n.FRAG_BUFFERED = "hlsFragBuffered", n.FRAG_CHANGED = "hlsFragChanged", n.FPS_DROP = "hlsFpsDrop", n.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", n.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", n.ERROR = "hlsError", n.DESTROYING = "hlsDestroying", n.KEY_LOADING = "hlsKeyLoading", n.KEY_LOADED = "hlsKeyLoaded", n.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", n.BACK_BUFFER_REACHED = "hlsBackBufferReached", n.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", n;
})({}), Q = /* @__PURE__ */ (function(n) {
  return n.NETWORK_ERROR = "networkError", n.MEDIA_ERROR = "mediaError", n.KEY_SYSTEM_ERROR = "keySystemError", n.MUX_ERROR = "muxError", n.OTHER_ERROR = "otherError", n;
})({}), C = /* @__PURE__ */ (function(n) {
  return n.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", n.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", n.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", n.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", n.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", n.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", n.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", n.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", n.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", n.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", n.MANIFEST_LOAD_ERROR = "manifestLoadError", n.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", n.MANIFEST_PARSING_ERROR = "manifestParsingError", n.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", n.LEVEL_EMPTY_ERROR = "levelEmptyError", n.LEVEL_LOAD_ERROR = "levelLoadError", n.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", n.LEVEL_PARSING_ERROR = "levelParsingError", n.LEVEL_SWITCH_ERROR = "levelSwitchError", n.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", n.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", n.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", n.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", n.FRAG_LOAD_ERROR = "fragLoadError", n.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", n.FRAG_DECRYPT_ERROR = "fragDecryptError", n.FRAG_PARSING_ERROR = "fragParsingError", n.FRAG_GAP = "fragGap", n.REMUX_ALLOC_ERROR = "remuxAllocError", n.KEY_LOAD_ERROR = "keyLoadError", n.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", n.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", n.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", n.BUFFER_APPEND_ERROR = "bufferAppendError", n.BUFFER_APPENDING_ERROR = "bufferAppendingError", n.BUFFER_STALLED_ERROR = "bufferStalledError", n.BUFFER_FULL_ERROR = "bufferFullError", n.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", n.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", n.INTERNAL_EXCEPTION = "internalException", n.INTERNAL_ABORTED = "aborted", n.UNKNOWN = "unknown", n;
})({});
const yt = function() {
}, Kn = {
  trace: yt,
  debug: yt,
  log: yt,
  warn: yt,
  info: yt,
  error: yt
};
let Jt = Kn;
function Xh(n) {
  const e = self.console[n];
  return e ? e.bind(self.console, `[${n}] >`) : yt;
}
function Qh(n, ...e) {
  e.forEach(function(t) {
    Jt[t] = n[t] ? n[t].bind(n) : Xh(t);
  });
}
function Zh(n, e) {
  if (typeof console == "object" && n === !0 || typeof n == "object") {
    Qh(
      n,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    );
    try {
      Jt.log(`Debug logs enabled for "${e}" in hls.js version 1.5.13`);
    } catch {
      Jt = Kn;
    }
  } else
    Jt = Kn;
}
const I = Jt, Jh = /^(\d+)x(\d+)$/, rr = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class ge {
  constructor(e) {
    typeof e == "string" && (e = ge.parseAttrList(e)), ve(this, e);
  }
  get clientAttrs() {
    return Object.keys(this).filter((e) => e.substring(0, 2) === "X-");
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const s = new Uint8Array(t.length / 2);
      for (let i = 0; i < t.length / 2; i++)
        s[i] = parseInt(t.slice(i * 2, i * 2 + 2), 16);
      return s;
    } else
      return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const s = this[e];
    return s ? parseFloat(s) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = Jh.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e) {
    let t;
    const s = {};
    for (rr.lastIndex = 0; (t = rr.exec(e)) !== null; ) {
      let r = t[2];
      r.indexOf('"') === 0 && r.lastIndexOf('"') === r.length - 1 && (r = r.slice(1, -1));
      const o = t[1].trim();
      s[o] = r;
    }
    return s;
  }
}
function ef(n) {
  return n !== "ID" && n !== "CLASS" && n !== "START-DATE" && n !== "DURATION" && n !== "END-DATE" && n !== "END-ON-NEXT";
}
function tf(n) {
  return n === "SCTE35-OUT" || n === "SCTE35-IN";
}
class _o {
  constructor(e, t) {
    if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, t) {
      const s = t.attr;
      for (const i in s)
        if (Object.prototype.hasOwnProperty.call(e, i) && e[i] !== s[i]) {
          I.warn(`DATERANGE tag attribute: "${i}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = i;
          break;
        }
      e = ve(new ge({}), s, e);
    }
    if (this.attr = e, this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const s = new Date(this.attr["END-DATE"]);
      H(s.getTime()) && (this._endDate = s);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate)
      return this._endDate;
    const e = this.duration;
    return e !== null ? new Date(this._startDate.getTime() + e * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (H(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && H(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}
class tn {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var le = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class Co {
  constructor(e) {
    this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = {
      [le.AUDIO]: null,
      [le.VIDEO]: null,
      [le.AUDIOVIDEO]: null
    }, this.baseurl = e;
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const s = e.split("@", 2);
    let i;
    s.length === 1 ? i = (t == null ? void 0 : t.byteRangeEndOffset) || 0 : i = parseInt(s[1]), this._byteRange = [i, parseInt(s[0]) + i];
  }
  get byteRange() {
    return this._byteRange ? this._byteRange : [];
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = ri.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
}
class fn extends Co {
  constructor(e, t) {
    super(t), this._decryptdata = null, this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.stats = new tn(), this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.urlId = 0, this.type = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const t = this.levelkeys.identity;
      if (t)
        this._decryptdata = t.getDecryptData(this.sn);
      else {
        const s = Object.keys(this.levelkeys);
        if (s.length === 1)
          return this._decryptdata = this.levelkeys[s[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null || !H(this.programDateTime))
      return null;
    const e = H(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      const t = Object.keys(this.levelkeys), s = t.length;
      if (s > 1 || s === 1 && this.levelkeys[t[0]].encrypted)
        return !0;
    }
    return !1;
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const t = this.levelkeys[e];
      t && !this._decryptdata && (this._decryptdata = t.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, s, i, r, o = !1) {
    const {
      elementaryStreams: a
    } = this, l = a[e];
    if (!l) {
      a[e] = {
        startPTS: t,
        endPTS: s,
        startDTS: i,
        endDTS: r,
        partial: o
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, s), l.startDTS = Math.min(l.startDTS, i), l.endDTS = Math.max(l.endDTS, r);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[le.AUDIO] = null, e[le.VIDEO] = null, e[le.AUDIOVIDEO] = null;
  }
}
class sf extends Co {
  constructor(e, t, s, i, r) {
    super(s), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.stats = new tn(), this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = i;
    const o = e.enumeratedString("BYTERANGE");
    o && this.setByteRange(o, r), r && (this.fragOffset = r.fragOffset + r.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
const nf = 10;
class rf {
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, s = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!s || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && s > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1, this.availabilityDelay = e.availabilityDelay;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? H(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || nf;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
}
function oi(n) {
  return Uint8Array.from(atob(n), (e) => e.charCodeAt(0));
}
function of(n) {
  const e = Vn(n).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function af(n) {
  const e = function(s, i, r) {
    const o = s[i];
    s[i] = s[r], s[r] = o;
  };
  e(n, 0, 3), e(n, 1, 2), e(n, 4, 5), e(n, 6, 7);
}
function lf(n) {
  const e = n.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const s = e[1].split(";"), i = s[s.length - 1].split(",");
    if (i.length === 2) {
      const r = i[0] === "base64", o = i[1];
      r ? (s.splice(-1, 1), t = oi(o)) : t = of(o);
    }
  }
  return t;
}
function Vn(n) {
  return Uint8Array.from(unescape(encodeURIComponent(n)), (e) => e.charCodeAt(0));
}
const $t = typeof self != "undefined" ? self : void 0;
var me = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, Fe = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function or(n) {
  switch (n) {
    case Fe.FAIRPLAY:
      return me.FAIRPLAY;
    case Fe.PLAYREADY:
      return me.PLAYREADY;
    case Fe.WIDEVINE:
      return me.WIDEVINE;
    case Fe.CLEARKEY:
      return me.CLEARKEY;
  }
}
var wo = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function cf(n) {
  if (n === wo.WIDEVINE)
    return me.WIDEVINE;
}
function ar(n) {
  switch (n) {
    case me.FAIRPLAY:
      return Fe.FAIRPLAY;
    case me.PLAYREADY:
      return Fe.PLAYREADY;
    case me.WIDEVINE:
      return Fe.WIDEVINE;
    case me.CLEARKEY:
      return Fe.CLEARKEY;
  }
}
function mn(n) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = n, s = e ? [me.FAIRPLAY, me.WIDEVINE, me.PLAYREADY, me.CLEARKEY].filter((i) => !!e[i]) : [];
  return !s[me.WIDEVINE] && t && s.push(me.WIDEVINE), s;
}
const Mo = (function(n) {
  return $t != null && (n = $t.navigator) != null && n.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
})();
function uf(n, e, t, s) {
  let i;
  switch (n) {
    case me.FAIRPLAY:
      i = ["cenc", "sinf"];
      break;
    case me.WIDEVINE:
    case me.PLAYREADY:
      i = ["cenc"];
      break;
    case me.CLEARKEY:
      i = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${n}`);
  }
  return df(i, e, t, s);
}
function df(n, e, t, s) {
  return [{
    initDataTypes: n,
    persistentState: s.persistentState || "optional",
    distinctiveIdentifier: s.distinctiveIdentifier || "optional",
    sessionTypes: s.sessionTypes || [s.sessionType || "temporary"],
    audioCapabilities: e.map((r) => ({
      contentType: `audio/mp4; codecs="${r}"`,
      robustness: s.audioRobustness || "",
      encryptionScheme: s.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((r) => ({
      contentType: `video/mp4; codecs="${r}"`,
      robustness: s.videoRobustness || "",
      encryptionScheme: s.videoEncryptionScheme || null
    }))
  }];
}
function vt(n, e, t) {
  return Uint8Array.prototype.slice ? n.slice(e, t) : new Uint8Array(Array.prototype.slice.call(n, e, t));
}
const ai = (n, e) => e + 10 <= n.length && n[e] === 73 && n[e + 1] === 68 && n[e + 2] === 51 && n[e + 3] < 255 && n[e + 4] < 255 && n[e + 6] < 128 && n[e + 7] < 128 && n[e + 8] < 128 && n[e + 9] < 128, ko = (n, e) => e + 10 <= n.length && n[e] === 51 && n[e + 1] === 68 && n[e + 2] === 73 && n[e + 3] < 255 && n[e + 4] < 255 && n[e + 6] < 128 && n[e + 7] < 128 && n[e + 8] < 128 && n[e + 9] < 128, ts = (n, e) => {
  const t = e;
  let s = 0;
  for (; ai(n, e); ) {
    s += 10;
    const i = sn(n, e + 6);
    s += i, ko(n, e + 10) && (s += 10), e += s;
  }
  if (s > 0)
    return n.subarray(t, t + s);
}, sn = (n, e) => {
  let t = 0;
  return t = (n[e] & 127) << 21, t |= (n[e + 1] & 127) << 14, t |= (n[e + 2] & 127) << 7, t |= n[e + 3] & 127, t;
}, hf = (n, e) => ai(n, e) && sn(n, e + 6) + 10 <= n.length - e, li = (n) => {
  const e = Po(n);
  for (let t = 0; t < e.length; t++) {
    const s = e[t];
    if (Fo(s))
      return Ef(s);
  }
}, Fo = (n) => n && n.key === "PRIV" && n.info === "com.apple.streaming.transportStreamTimestamp", ff = (n) => {
  const e = String.fromCharCode(n[0], n[1], n[2], n[3]), t = sn(n, 4), s = 10;
  return {
    type: e,
    size: t,
    data: n.subarray(s, s + t)
  };
}, Po = (n) => {
  let e = 0;
  const t = [];
  for (; ai(n, e); ) {
    const s = sn(n, e + 6);
    e += 10;
    const i = e + s;
    for (; e + 8 < i; ) {
      const r = ff(n.subarray(e)), o = mf(r);
      o && t.push(o), e += r.size + 10;
    }
    ko(n, e) && (e += 10);
  }
  return t;
}, mf = (n) => n.type === "PRIV" ? gf(n) : n.type[0] === "W" ? Tf(n) : pf(n), gf = (n) => {
  if (n.size < 2)
    return;
  const e = Ze(n.data, !0), t = new Uint8Array(n.data.subarray(e.length + 1));
  return {
    key: n.type,
    info: e,
    data: t.buffer
  };
}, pf = (n) => {
  if (n.size < 2)
    return;
  if (n.type === "TXXX") {
    let t = 1;
    const s = Ze(n.data.subarray(t), !0);
    t += s.length + 1;
    const i = Ze(n.data.subarray(t));
    return {
      key: n.type,
      info: s,
      data: i
    };
  }
  const e = Ze(n.data.subarray(1));
  return {
    key: n.type,
    data: e
  };
}, Tf = (n) => {
  if (n.type === "WXXX") {
    if (n.size < 2)
      return;
    let t = 1;
    const s = Ze(n.data.subarray(t), !0);
    t += s.length + 1;
    const i = Ze(n.data.subarray(t));
    return {
      key: n.type,
      info: s,
      data: i
    };
  }
  const e = Ze(n.data);
  return {
    key: n.type,
    data: e
  };
}, Ef = (n) => {
  if (n.data.byteLength === 8) {
    const e = new Uint8Array(n.data), t = e[3] & 1;
    let s = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return s /= 45, t && (s += 4772185884e-2), Math.round(s);
  }
}, Ze = (n, e = !1) => {
  const t = yf();
  if (t) {
    const c = t.decode(n);
    if (e) {
      const u = c.indexOf("\0");
      return u !== -1 ? c.substring(0, u) : c;
    }
    return c.replace(/\0/g, "");
  }
  const s = n.length;
  let i, r, o, a = "", l = 0;
  for (; l < s; ) {
    if (i = n[l++], i === 0 && e)
      return a;
    if (i === 0 || i === 3)
      continue;
    switch (i >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        a += String.fromCharCode(i);
        break;
      case 12:
      case 13:
        r = n[l++], a += String.fromCharCode((i & 31) << 6 | r & 63);
        break;
      case 14:
        r = n[l++], o = n[l++], a += String.fromCharCode((i & 15) << 12 | (r & 63) << 6 | (o & 63) << 0);
        break;
    }
  }
  return a;
};
let gn;
function yf() {
  if (!navigator.userAgent.includes("PlayStation 4"))
    return !gn && typeof self.TextDecoder != "undefined" && (gn = new self.TextDecoder("utf-8")), gn;
}
const ze = {
  hexDump: function(n) {
    let e = "";
    for (let t = 0; t < n.length; t++) {
      let s = n[t].toString(16);
      s.length < 2 && (s = "0" + s), e += s;
    }
    return e;
  }
}, Gs = Math.pow(2, 32) - 1, xf = [].push, Oo = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function Ae(n) {
  return String.fromCharCode.apply(null, n);
}
function No(n, e) {
  const t = n[e] << 8 | n[e + 1];
  return t < 0 ? 65536 + t : t;
}
function z(n, e) {
  const t = Uo(n, e);
  return t < 0 ? 4294967296 + t : t;
}
function lr(n, e) {
  let t = z(n, e);
  return t *= Math.pow(2, 32), t += z(n, e + 4), t;
}
function Uo(n, e) {
  return n[e] << 24 | n[e + 1] << 16 | n[e + 2] << 8 | n[e + 3];
}
function pn(n, e, t) {
  n[e] = t >> 24, n[e + 1] = t >> 16 & 255, n[e + 2] = t >> 8 & 255, n[e + 3] = t & 255;
}
function vf(n) {
  const e = n.byteLength;
  for (let t = 0; t < e; ) {
    const s = z(n, t);
    if (s > 8 && n[t + 4] === 109 && n[t + 5] === 111 && n[t + 6] === 111 && n[t + 7] === 102)
      return !0;
    t = s > 1 ? t + s : e;
  }
  return !1;
}
function te(n, e) {
  const t = [];
  if (!e.length)
    return t;
  const s = n.byteLength;
  for (let i = 0; i < s; ) {
    const r = z(n, i), o = Ae(n.subarray(i + 4, i + 8)), a = r > 1 ? i + r : s;
    if (o === e[0])
      if (e.length === 1)
        t.push(n.subarray(i + 8, a));
      else {
        const l = te(n.subarray(i + 8, a), e.slice(1));
        l.length && xf.apply(t, l);
      }
    i = a;
  }
  return t;
}
function Sf(n) {
  const e = [], t = n[0];
  let s = 8;
  const i = z(n, s);
  s += 4;
  let r = 0, o = 0;
  t === 0 ? (r = z(n, s), o = z(n, s + 4), s += 8) : (r = lr(n, s), o = lr(n, s + 8), s += 16), s += 2;
  let a = n.length + o;
  const l = No(n, s);
  s += 2;
  for (let c = 0; c < l; c++) {
    let u = s;
    const d = z(n, u);
    u += 4;
    const h = d & 2147483647;
    if ((d & 2147483648) >>> 31 === 1)
      return I.warn("SIDX has hierarchical references (not supported)"), null;
    const f = z(n, u);
    u += 4, e.push({
      referenceSize: h,
      subsegmentDuration: f,
      // unscaled
      info: {
        duration: f / i,
        start: a,
        end: a + h - 1
      }
    }), a += h, u += 4, s = u;
  }
  return {
    earliestPresentationTime: r,
    timescale: i,
    version: t,
    referencesCount: l,
    references: e
  };
}
function Bo(n) {
  const e = [], t = te(n, ["moov", "trak"]);
  for (let i = 0; i < t.length; i++) {
    const r = t[i], o = te(r, ["tkhd"])[0];
    if (o) {
      let a = o[0];
      const l = z(o, a === 0 ? 12 : 20), c = te(r, ["mdia", "mdhd"])[0];
      if (c) {
        a = c[0];
        const u = z(c, a === 0 ? 12 : 20), d = te(r, ["mdia", "hdlr"])[0];
        if (d) {
          const h = Ae(d.subarray(8, 12)), m = {
            soun: le.AUDIO,
            vide: le.VIDEO
          }[h];
          if (m) {
            const f = te(r, ["mdia", "minf", "stbl", "stsd"])[0], g = Af(f);
            e[l] = {
              timescale: u,
              type: m
            }, e[m] = De({
              timescale: u,
              id: l
            }, g);
          }
        }
      }
    }
  }
  return te(n, ["moov", "mvex", "trex"]).forEach((i) => {
    const r = z(i, 4), o = e[r];
    o && (o.default = {
      duration: z(i, 12),
      flags: z(i, 20)
    });
  }), e;
}
function Af(n) {
  const e = n.subarray(8), t = e.subarray(86), s = Ae(e.subarray(4, 8));
  let i = s;
  const r = s === "enca" || s === "encv";
  if (r) {
    const a = te(e, [s])[0].subarray(s === "enca" ? 28 : 78);
    te(a, ["sinf"]).forEach((c) => {
      const u = te(c, ["schm"])[0];
      if (u) {
        const d = Ae(u.subarray(4, 8));
        if (d === "cbcs" || d === "cenc") {
          const h = te(c, ["frma"])[0];
          h && (i = Ae(h));
        }
      }
    });
  }
  switch (i) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4": {
      const o = te(t, ["avcC"])[0];
      i += "." + Ts(o[1]) + Ts(o[2]) + Ts(o[3]);
      break;
    }
    case "mp4a": {
      const o = te(e, [s])[0], a = te(o.subarray(28), ["esds"])[0];
      if (a && a.length > 12) {
        let l = 4;
        if (a[l++] !== 3)
          break;
        l = Tn(a, l), l += 2;
        const c = a[l++];
        if (c & 128 && (l += 2), c & 64 && (l += a[l++]), a[l++] !== 4)
          break;
        l = Tn(a, l);
        const u = a[l++];
        if (u === 64)
          i += "." + Ts(u);
        else
          break;
        if (l += 12, a[l++] !== 5)
          break;
        l = Tn(a, l);
        const d = a[l++];
        let h = (d & 248) >> 3;
        h === 31 && (h += 1 + ((d & 7) << 3) + ((a[l] & 224) >> 5)), i += "." + h;
      }
      break;
    }
    case "hvc1":
    case "hev1": {
      const o = te(t, ["hvcC"])[0], a = o[1], l = ["", "A", "B", "C"][a >> 6], c = a & 31, u = z(o, 2), d = (a & 32) >> 5 ? "H" : "L", h = o[12], m = o.subarray(6, 12);
      i += "." + l + c, i += "." + u.toString(16).toUpperCase(), i += "." + d + h;
      let f = "";
      for (let g = m.length; g--; ) {
        const p = m[g];
        (p || f) && (f = "." + p.toString(16).toUpperCase() + f);
      }
      i += f;
      break;
    }
    case "dvh1":
    case "dvhe": {
      const o = te(t, ["dvcC"])[0], a = o[2] >> 1 & 127, l = o[2] << 5 & 32 | o[3] >> 3 & 31;
      i += "." + qe(a) + "." + qe(l);
      break;
    }
    case "vp09": {
      const o = te(t, ["vpcC"])[0], a = o[4], l = o[5], c = o[6] >> 4 & 15;
      i += "." + qe(a) + "." + qe(l) + "." + qe(c);
      break;
    }
    case "av01": {
      const o = te(t, ["av1C"])[0], a = o[1] >>> 5, l = o[1] & 31, c = o[2] >>> 7 ? "H" : "M", u = (o[2] & 64) >> 6, d = (o[2] & 32) >> 5, h = a === 2 && u ? d ? 12 : 10 : u ? 10 : 8, m = (o[2] & 16) >> 4, f = (o[2] & 8) >> 3, g = (o[2] & 4) >> 2, p = o[2] & 3;
      i += "." + a + "." + qe(l) + c + "." + qe(h) + "." + m + "." + f + g + p + "." + qe(1) + "." + qe(1) + "." + qe(1) + "." + 0;
      break;
    }
  }
  return {
    codec: i,
    encrypted: r
  };
}
function Tn(n, e) {
  const t = e + 5;
  for (; n[e++] & 128 && e < t; )
    ;
  return e;
}
function Ts(n) {
  return ("0" + n.toString(16).toUpperCase()).slice(-2);
}
function qe(n) {
  return (n < 10 ? "0" : "") + n;
}
function Lf(n, e) {
  if (!n || !e)
    return n;
  const t = e.keyId;
  return t && e.isCommonEncryption && te(n, ["moov", "trak"]).forEach((i) => {
    const o = te(i, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let a = te(o, ["enca"]);
    const l = a.length > 0;
    l || (a = te(o, ["encv"])), a.forEach((c) => {
      const u = l ? c.subarray(28) : c.subarray(78);
      te(u, ["sinf"]).forEach((h) => {
        const m = $o(h);
        if (m) {
          const f = m.subarray(8, 24);
          f.some((g) => g !== 0) || (I.log(`[eme] Patching keyId in 'enc${l ? "a" : "v"}>sinf>>tenc' box: ${ze.hexDump(f)} -> ${ze.hexDump(t)}`), m.set(t, 8));
        }
      });
    });
  }), n;
}
function $o(n) {
  const e = te(n, ["schm"])[0];
  if (e) {
    const t = Ae(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc")
      return te(n, ["schi", "tenc"])[0];
  }
  return I.error("[eme] missing 'schm' box"), null;
}
function Rf(n, e) {
  return te(e, ["moof", "traf"]).reduce((t, s) => {
    const i = te(s, ["tfdt"])[0], r = i[0], o = te(s, ["tfhd"]).reduce((a, l) => {
      const c = z(l, 4), u = n[c];
      if (u) {
        let d = z(i, 4);
        if (r === 1) {
          if (d === Gs)
            return I.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"), a;
          d *= Gs + 1, d += z(i, 8);
        }
        const h = u.timescale || 9e4, m = d / h;
        if (H(m) && (a === null || m < a))
          return m;
      }
      return a;
    }, null);
    return o !== null && H(o) && (t === null || o < t) ? o : t;
  }, null);
}
function Df(n, e) {
  let t = 0, s = 0, i = 0;
  const r = te(n, ["moof", "traf"]);
  for (let o = 0; o < r.length; o++) {
    const a = r[o], l = te(a, ["tfhd"])[0], c = z(l, 4), u = e[c];
    if (!u)
      continue;
    const d = u.default, h = z(l, 0) | (d == null ? void 0 : d.flags);
    let m = d == null ? void 0 : d.duration;
    h & 8 && (h & 2 ? m = z(l, 12) : m = z(l, 8));
    const f = u.timescale || 9e4, g = te(a, ["trun"]);
    for (let p = 0; p < g.length; p++) {
      if (t = If(g[p]), !t && m) {
        const E = z(g[p], 4);
        t = m * E;
      }
      u.type === le.VIDEO ? s += t / f : u.type === le.AUDIO && (i += t / f);
    }
  }
  if (s === 0 && i === 0) {
    let o = 1 / 0, a = 0, l = 0;
    const c = te(n, ["sidx"]);
    for (let u = 0; u < c.length; u++) {
      const d = Sf(c[u]);
      if (d != null && d.references) {
        o = Math.min(o, d.earliestPresentationTime / d.timescale);
        const h = d.references.reduce((m, f) => m + f.info.duration || 0, 0);
        a = Math.max(a, h + d.earliestPresentationTime / d.timescale), l = a - o;
      }
    }
    if (l && H(l))
      return l;
  }
  return s || i;
}
function If(n) {
  const e = z(n, 0);
  let t = 8;
  e & 1 && (t += 4), e & 4 && (t += 4);
  let s = 0;
  const i = z(n, 4);
  for (let r = 0; r < i; r++) {
    if (e & 256) {
      const o = z(n, t);
      s += o, t += 4;
    }
    e & 512 && (t += 4), e & 1024 && (t += 4), e & 2048 && (t += 4);
  }
  return s;
}
function bf(n, e, t) {
  te(e, ["moof", "traf"]).forEach((s) => {
    te(s, ["tfhd"]).forEach((i) => {
      const r = z(i, 4), o = n[r];
      if (!o)
        return;
      const a = o.timescale || 9e4;
      te(s, ["tfdt"]).forEach((l) => {
        const c = l[0], u = t * a;
        if (u) {
          let d = z(l, 4);
          if (c === 0)
            d -= u, d = Math.max(d, 0), pn(l, 4, d);
          else {
            d *= Math.pow(2, 32), d += z(l, 8), d -= u, d = Math.max(d, 0);
            const h = Math.floor(d / (Gs + 1)), m = Math.floor(d % (Gs + 1));
            pn(l, 4, h), pn(l, 8, m);
          }
        }
      });
    });
  });
}
function _f(n) {
  const e = {
    valid: null,
    remainder: null
  }, t = te(n, ["moof"]);
  if (t.length < 2)
    return e.remainder = n, e;
  const s = t[t.length - 1];
  return e.valid = vt(n, 0, s.byteOffset - 8), e.remainder = vt(n, s.byteOffset - 8), e;
}
function $e(n, e) {
  const t = new Uint8Array(n.length + e.length);
  return t.set(n), t.set(e, n.length), t;
}
function cr(n, e) {
  const t = [], s = e.samples, i = e.timescale, r = e.id;
  let o = !1;
  return te(s, ["moof"]).map((l) => {
    const c = l.byteOffset - 8;
    te(l, ["traf"]).map((d) => {
      const h = te(d, ["tfdt"]).map((m) => {
        const f = m[0];
        let g = z(m, 4);
        return f === 1 && (g *= Math.pow(2, 32), g += z(m, 8)), g / i;
      })[0];
      return h !== void 0 && (n = h), te(d, ["tfhd"]).map((m) => {
        const f = z(m, 4), g = z(m, 0) & 16777215, p = (g & 1) !== 0, E = (g & 2) !== 0, y = (g & 8) !== 0;
        let x = 0;
        const S = (g & 16) !== 0;
        let v = 0;
        const D = (g & 32) !== 0;
        let L = 8;
        f === r && (p && (L += 8), E && (L += 4), y && (x = z(m, L), L += 4), S && (v = z(m, L), L += 4), D && (L += 4), e.type === "video" && (o = Cf(e.codec)), te(d, ["trun"]).map((_) => {
          const A = _[0], R = z(_, 0) & 16777215, w = (R & 1) !== 0;
          let B = 0;
          const M = (R & 4) !== 0, N = (R & 256) !== 0;
          let $ = 0;
          const G = (R & 512) !== 0;
          let W = 0;
          const U = (R & 1024) !== 0, P = (R & 2048) !== 0;
          let O = 0;
          const K = z(_, 4);
          let V = 8;
          w && (B = z(_, V), V += 4), M && (V += 4);
          let J = B + c;
          for (let Z = 0; Z < K; Z++) {
            if (N ? ($ = z(_, V), V += 4) : $ = x, G ? (W = z(_, V), V += 4) : W = v, U && (V += 4), P && (A === 0 ? O = z(_, V) : O = Uo(_, V), V += 4), e.type === le.VIDEO) {
              let ie = 0;
              for (; ie < W; ) {
                const X = z(s, J);
                if (J += 4, wf(o, s[J])) {
                  const oe = s.subarray(J, J + X);
                  Go(oe, o ? 2 : 1, n + O / i, t);
                }
                J += X, ie += X + 4;
              }
            }
            n += $ / i;
          }
        }));
      });
    });
  }), t;
}
function Cf(n) {
  if (!n)
    return !1;
  const e = n.indexOf("."), t = e < 0 ? n : n.substring(0, e);
  return t === "hvc1" || t === "hev1" || // Dolby Vision
  t === "dvh1" || t === "dvhe";
}
function wf(n, e) {
  if (n) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function Go(n, e, t, s) {
  const i = Ho(n);
  let r = 0;
  r += e;
  let o = 0, a = 0, l = 0;
  for (; r < i.length; ) {
    o = 0;
    do {
      if (r >= i.length)
        break;
      l = i[r++], o += l;
    } while (l === 255);
    a = 0;
    do {
      if (r >= i.length)
        break;
      l = i[r++], a += l;
    } while (l === 255);
    const c = i.length - r;
    let u = r;
    if (a < c)
      r += a;
    else if (a > c) {
      I.error(`Malformed SEI payload. ${a} is too small, only ${c} bytes left to parse.`);
      break;
    }
    if (o === 4) {
      if (i[u++] === 181) {
        const h = No(i, u);
        if (u += 2, h === 49) {
          const m = z(i, u);
          if (u += 4, m === 1195456820) {
            const f = i[u++];
            if (f === 3) {
              const g = i[u++], p = 31 & g, E = 64 & g, y = E ? 2 + p * 3 : 0, x = new Uint8Array(y);
              if (E) {
                x[0] = g;
                for (let S = 1; S < y; S++)
                  x[S] = i[u++];
              }
              s.push({
                type: f,
                payloadType: o,
                pts: t,
                bytes: x
              });
            }
          }
        }
      }
    } else if (o === 5 && a > 16) {
      const d = [];
      for (let f = 0; f < 16; f++) {
        const g = i[u++].toString(16);
        d.push(g.length == 1 ? "0" + g : g), (f === 3 || f === 5 || f === 7 || f === 9) && d.push("-");
      }
      const h = a - 16, m = new Uint8Array(h);
      for (let f = 0; f < h; f++)
        m[f] = i[u++];
      s.push({
        payloadType: o,
        pts: t,
        uuid: d.join(""),
        userData: Ze(m),
        userDataBytes: m
      });
    }
  }
}
function Ho(n) {
  const e = n.byteLength, t = [];
  let s = 1;
  for (; s < e - 2; )
    n[s] === 0 && n[s + 1] === 0 && n[s + 2] === 3 ? (t.push(s + 2), s += 2) : s++;
  if (t.length === 0)
    return n;
  const i = e - t.length, r = new Uint8Array(i);
  let o = 0;
  for (s = 0; s < i; o++, s++)
    o === t[0] && (o++, t.shift()), r[s] = n[o];
  return r;
}
function Mf(n) {
  const e = n[0];
  let t = "", s = "", i = 0, r = 0, o = 0, a = 0, l = 0, c = 0;
  if (e === 0) {
    for (; Ae(n.subarray(c, c + 1)) !== "\0"; )
      t += Ae(n.subarray(c, c + 1)), c += 1;
    for (t += Ae(n.subarray(c, c + 1)), c += 1; Ae(n.subarray(c, c + 1)) !== "\0"; )
      s += Ae(n.subarray(c, c + 1)), c += 1;
    s += Ae(n.subarray(c, c + 1)), c += 1, i = z(n, 12), r = z(n, 16), a = z(n, 20), l = z(n, 24), c = 28;
  } else if (e === 1) {
    c += 4, i = z(n, c), c += 4;
    const d = z(n, c);
    c += 4;
    const h = z(n, c);
    for (c += 4, o = 2 ** 32 * d + h, zh(o) || (o = Number.MAX_SAFE_INTEGER, I.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), a = z(n, c), c += 4, l = z(n, c), c += 4; Ae(n.subarray(c, c + 1)) !== "\0"; )
      t += Ae(n.subarray(c, c + 1)), c += 1;
    for (t += Ae(n.subarray(c, c + 1)), c += 1; Ae(n.subarray(c, c + 1)) !== "\0"; )
      s += Ae(n.subarray(c, c + 1)), c += 1;
    s += Ae(n.subarray(c, c + 1)), c += 1;
  }
  const u = n.subarray(c, n.byteLength);
  return {
    schemeIdUri: t,
    value: s,
    timeScale: i,
    presentationTime: o,
    presentationTimeDelta: r,
    eventDuration: a,
    id: l,
    payload: u
  };
}
function kf(n, ...e) {
  const t = e.length;
  let s = 8, i = t;
  for (; i--; )
    s += e[i].byteLength;
  const r = new Uint8Array(s);
  for (r[0] = s >> 24 & 255, r[1] = s >> 16 & 255, r[2] = s >> 8 & 255, r[3] = s & 255, r.set(n, 4), i = 0, s = 8; i < t; i++)
    r.set(e[i], s), s += e[i].byteLength;
  return r;
}
function Ff(n, e, t) {
  if (n.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let s, i;
  s = 0, i = new Uint8Array();
  let r;
  s > 0 ? (r = new Uint8Array(4), e.length > 0 && new DataView(r.buffer).setUint32(0, e.length, !1)) : r = new Uint8Array();
  const o = new Uint8Array(4);
  return t && t.byteLength > 0 && new DataView(o.buffer).setUint32(0, t.byteLength, !1), kf(
    [112, 115, 115, 104],
    new Uint8Array([
      s,
      0,
      0,
      0
      // Flags
    ]),
    n,
    // 16 bytes
    r,
    i,
    o,
    t || new Uint8Array()
  );
}
function Pf(n) {
  if (!(n instanceof ArrayBuffer) || n.byteLength < 32)
    return null;
  const e = {
    version: 0,
    systemId: "",
    kids: null,
    data: null
  }, t = new DataView(n), s = t.getUint32(0);
  if (n.byteLength !== s && s > 44 || t.getUint32(4) !== 1886614376 || (e.version = t.getUint32(8) >>> 24, e.version > 1))
    return null;
  e.systemId = ze.hexDump(new Uint8Array(n, 12, 16));
  const r = t.getUint32(28);
  if (e.version === 0) {
    if (s - 32 < r)
      return null;
    e.data = new Uint8Array(n, 32, r);
  } else if (e.version === 1) {
    e.kids = [];
    for (let o = 0; o < r; o++)
      e.kids.push(new Uint8Array(n, 32 + o * 16, 16));
  }
  return e;
}
let Es = {};
class ss {
  static clearKeyUriToKeyIdMap() {
    Es = {};
  }
  constructor(e, t, s, i = [1], r = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = s, this.keyFormatVersions = i, this.iv = r, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && e !== "AES-128";
  }
  isSupported() {
    if (this.method) {
      if (this.method === "AES-128" || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case Fe.FAIRPLAY:
        case Fe.WIDEVINE:
        case Fe.PLAYREADY:
        case Fe.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (this.method === "AES-128" && this.uri && !this.iv) {
      typeof e != "number" && (this.method === "AES-128" && !this.iv && I.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const s = Of(e);
      return new ss(this.method, this.uri, "identity", this.keyFormatVersions, s);
    }
    const t = lf(this.uri);
    if (t)
      switch (this.keyFormat) {
        case Fe.WIDEVINE:
          this.pssh = t, t.length >= 22 && (this.keyId = t.subarray(t.length - 22, t.length - 6));
          break;
        case Fe.PLAYREADY: {
          const s = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = Ff(s, null, t);
          const i = new Uint16Array(t.buffer, t.byteOffset, t.byteLength / 2), r = String.fromCharCode.apply(null, Array.from(i)), o = r.substring(r.indexOf("<"), r.length), c = new DOMParser().parseFromString(o, "text/xml").getElementsByTagName("KID")[0];
          if (c) {
            const u = c.childNodes[0] ? c.childNodes[0].nodeValue : c.getAttribute("VALUE");
            if (u) {
              const d = oi(u).subarray(0, 16);
              af(d), this.keyId = d;
            }
          }
          break;
        }
        default: {
          let s = t.subarray(0, 16);
          if (s.length !== 16) {
            const i = new Uint8Array(16);
            i.set(s, 16 - s.length), s = i;
          }
          this.keyId = s;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let s = Es[this.uri];
      if (!s) {
        const i = Object.keys(Es).length % Number.MAX_SAFE_INTEGER;
        s = new Uint8Array(16), new DataView(s.buffer, 12, 4).setUint32(0, i), Es[this.uri] = s;
      }
      this.keyId = s;
    }
    return this;
  }
}
function Of(n) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = n >> 8 * (15 - t) & 255;
  return e;
}
const Ko = /\{\$([a-zA-Z0-9-_]+)\}/g;
function ur(n) {
  return Ko.test(n);
}
function ke(n, e, t) {
  if (n.variableList !== null || n.hasVariableRefs)
    for (let s = t.length; s--; ) {
      const i = t[s], r = e[i];
      r && (e[i] = Wn(n, r));
    }
}
function Wn(n, e) {
  if (n.variableList !== null || n.hasVariableRefs) {
    const t = n.variableList;
    return e.replace(Ko, (s) => {
      const i = s.substring(2, s.length - 1), r = t == null ? void 0 : t[i];
      return r === void 0 ? (n.playlistParsingError || (n.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${i}"`)), s) : r;
    });
  }
  return e;
}
function dr(n, e, t) {
  let s = n.variableList;
  s || (n.variableList = s = {});
  let i, r;
  if ("QUERYPARAM" in e) {
    i = e.QUERYPARAM;
    try {
      const o = new self.URL(t).searchParams;
      if (o.has(i))
        r = o.get(i);
      else
        throw new Error(`"${i}" does not match any query parameter in URI: "${t}"`);
    } catch (o) {
      n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${o.message}`));
    }
  } else
    i = e.NAME, r = e.VALUE;
  i in s ? n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${i}"`)) : s[i] = r || "";
}
function Nf(n, e, t) {
  const s = e.IMPORT;
  if (t && s in t) {
    let i = n.variableList;
    i || (n.variableList = i = {}), i[s] = t[s];
  } else
    n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${s}"`));
}
function At(n = !0) {
  return typeof self == "undefined" ? void 0 : (n || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
function Uf(n) {
  return typeof self != "undefined" && n === self.ManagedMediaSource;
}
const Hs = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function Bf(n, e) {
  const t = Hs[e];
  return !!t && !!t[n.slice(0, 4)];
}
function En(n, e, t = !0) {
  return !n.split(",").some((s) => !Vo(s, e, t));
}
function Vo(n, e, t = !0) {
  var s;
  const i = At(t);
  return (s = i == null ? void 0 : i.isTypeSupported(ns(n, e))) != null ? s : !1;
}
function ns(n, e) {
  return `${e}/mp4;codecs="${n}"`;
}
function hr(n) {
  if (n) {
    const e = n.substring(0, 4);
    return Hs.video[e];
  }
  return 2;
}
function Ks(n) {
  return n.split(",").reduce((e, t) => {
    const s = Hs.video[t];
    return s ? (s * 2 + e) / (e ? 3 : 2) : (Hs.audio[t] + e) / (e ? 2 : 1);
  }, 0);
}
const yn = {};
function $f(n, e = !0) {
  if (yn[n])
    return yn[n];
  const t = {
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"]
  }[n];
  for (let s = 0; s < t.length; s++)
    if (Vo(t[s], "audio", e))
      return yn[n] = t[s], t[s];
  return n;
}
const Gf = /flac|opus/i;
function Vs(n, e = !0) {
  return n.replace(Gf, (t) => $f(t.toLowerCase(), e));
}
function fr(n, e) {
  return n && n !== "mp4a" ? n : e && e.split(",")[0];
}
function Hf(n) {
  const e = n.split(",");
  for (let t = 0; t < e.length; t++) {
    const s = e[t].split(".");
    if (s.length > 2) {
      let i = s.shift() + ".";
      i += parseInt(s.shift()).toString(16), i += ("000" + parseInt(s.shift()).toString(16)).slice(-4), e[t] = i;
    }
  }
  return e.join(",");
}
const mr = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, gr = /#EXT-X-MEDIA:(.*)/g, Kf = /^#EXT(?:INF|-X-TARGETDURATION):/m, pr = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[^\r\n]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#EXT-X-BYTERANGE:*(.+)/.source,
  // next segment's byterange, group 4 => range spec (x@y)
  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
  // next segment's program date/time group 5 => the datetime spec
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), Vf = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class Xe {
  static findGroup(e, t) {
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      if (i.id === t)
        return i;
    }
  }
  static resolve(e, t) {
    return ri.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return Kf.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const s = ur(e), i = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: s
    }, r = [];
    mr.lastIndex = 0;
    let o;
    for (; (o = mr.exec(e)) != null; )
      if (o[1]) {
        var a;
        const c = new ge(o[1]);
        ke(i, c, ["CODECS", "SUPPLEMENTAL-CODECS", "ALLOWED-CPC", "PATHWAY-ID", "STABLE-VARIANT-ID", "AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS", "NAME"]);
        const u = Wn(i, o[2]), d = {
          attrs: c,
          bitrate: c.decimalInteger("BANDWIDTH") || c.decimalInteger("AVERAGE-BANDWIDTH"),
          name: c.NAME,
          url: Xe.resolve(u, t)
        }, h = c.decimalResolution("RESOLUTION");
        h && (d.width = h.width, d.height = h.height), Wf(c.CODECS, d), (a = d.unknownCodecs) != null && a.length || r.push(d), i.levels.push(d);
      } else if (o[3]) {
        const c = o[3], u = o[4];
        switch (c) {
          case "SESSION-DATA": {
            const d = new ge(u);
            ke(i, d, ["DATA-ID", "LANGUAGE", "VALUE", "URI"]);
            const h = d["DATA-ID"];
            h && (i.sessionData === null && (i.sessionData = {}), i.sessionData[h] = d);
            break;
          }
          case "SESSION-KEY": {
            const d = Tr(u, t, i);
            d.encrypted && d.isSupported() ? (i.sessionKeys === null && (i.sessionKeys = []), i.sessionKeys.push(d)) : I.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${u}"`);
            break;
          }
          case "DEFINE": {
            {
              const d = new ge(u);
              ke(i, d, ["NAME", "VALUE", "QUERYPARAM"]), dr(i, d, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const d = new ge(u);
            ke(i, d, ["SERVER-URI", "PATHWAY-ID"]), i.contentSteering = {
              uri: Xe.resolve(d["SERVER-URI"], t),
              pathwayId: d["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            i.startTimeOffset = Er(u);
            break;
          }
        }
      }
    const l = r.length > 0 && r.length < i.levels.length;
    return i.levels = l ? r : i.levels, i.levels.length === 0 && (i.playlistParsingError = new Error("no levels found in manifest")), i;
  }
  static parseMasterPlaylistMedia(e, t, s) {
    let i;
    const r = {}, o = s.levels, a = {
      AUDIO: o.map((c) => ({
        id: c.attrs.AUDIO,
        audioCodec: c.audioCodec
      })),
      SUBTITLES: o.map((c) => ({
        id: c.attrs.SUBTITLES,
        textCodec: c.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (gr.lastIndex = 0; (i = gr.exec(e)) !== null; ) {
      const c = new ge(i[1]), u = c.TYPE;
      if (u) {
        const d = a[u], h = r[u] || [];
        r[u] = h, ke(s, c, ["URI", "GROUP-ID", "LANGUAGE", "ASSOC-LANGUAGE", "STABLE-RENDITION-ID", "NAME", "INSTREAM-ID", "CHARACTERISTICS", "CHANNELS"]);
        const m = c.LANGUAGE, f = c["ASSOC-LANGUAGE"], g = c.CHANNELS, p = c.CHARACTERISTICS, E = c["INSTREAM-ID"], y = {
          attrs: c,
          bitrate: 0,
          id: l++,
          groupId: c["GROUP-ID"] || "",
          name: c.NAME || m || "",
          type: u,
          default: c.bool("DEFAULT"),
          autoselect: c.bool("AUTOSELECT"),
          forced: c.bool("FORCED"),
          lang: m,
          url: c.URI ? Xe.resolve(c.URI, t) : ""
        };
        if (f && (y.assocLang = f), g && (y.channels = g), p && (y.characteristics = p), E && (y.instreamId = E), d != null && d.length) {
          const x = Xe.findGroup(d, y.groupId) || d[0];
          yr(y, x, "audioCodec"), yr(y, x, "textCodec");
        }
        h.push(y);
      }
    }
    return r;
  }
  static parseLevelPlaylist(e, t, s, i, r, o) {
    const a = new rf(t), l = a.fragments;
    let c = null, u = 0, d = 0, h = 0, m = 0, f = null, g = new fn(i, t), p, E, y, x = -1, S = !1, v = null;
    for (pr.lastIndex = 0, a.m3u8 = e, a.hasVariableRefs = ur(e); (p = pr.exec(e)) !== null; ) {
      S && (S = !1, g = new fn(i, t), g.start = h, g.sn = u, g.cc = m, g.level = s, c && (g.initSegment = c, g.rawProgramDateTime = c.rawProgramDateTime, c.rawProgramDateTime = null, v && (g.setByteRange(v), v = null)));
      const A = p[1];
      if (A) {
        g.duration = parseFloat(A);
        const R = (" " + p[2]).slice(1);
        g.title = R || null, g.tagList.push(R ? ["INF", A, R] : ["INF", A]);
      } else if (p[3]) {
        if (H(g.duration)) {
          g.start = h, y && Sr(g, y, a), g.sn = u, g.level = s, g.cc = m, l.push(g);
          const R = (" " + p[3]).slice(1);
          g.relurl = Wn(a, R), xr(g, f), f = g, h += g.duration, u++, d = 0, S = !0;
        }
      } else if (p[4]) {
        const R = (" " + p[4]).slice(1);
        f ? g.setByteRange(R, f) : g.setByteRange(R);
      } else if (p[5])
        g.rawProgramDateTime = (" " + p[5]).slice(1), g.tagList.push(["PROGRAM-DATE-TIME", g.rawProgramDateTime]), x === -1 && (x = l.length);
      else {
        if (p = p[0].match(Vf), !p) {
          I.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (E = 1; E < p.length && typeof p[E] == "undefined"; E++)
          ;
        const R = (" " + p[E]).slice(1), w = (" " + p[E + 1]).slice(1), B = p[E + 2] ? (" " + p[E + 2]).slice(1) : "";
        switch (R) {
          case "PLAYLIST-TYPE":
            a.type = w.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            u = a.startSN = parseInt(w);
            break;
          case "SKIP": {
            const M = new ge(w);
            ke(a, M, ["RECENTLY-REMOVED-DATERANGES"]);
            const N = M.decimalInteger("SKIPPED-SEGMENTS");
            if (H(N)) {
              a.skippedSegments = N;
              for (let G = N; G--; )
                l.unshift(null);
              u += N;
            }
            const $ = M.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            $ && (a.recentlyRemovedDateranges = $.split("	"));
            break;
          }
          case "TARGETDURATION":
            a.targetduration = Math.max(parseInt(w), 1);
            break;
          case "VERSION":
            a.version = parseInt(w);
            break;
          case "INDEPENDENT-SEGMENTS":
          case "EXTM3U":
            break;
          case "ENDLIST":
            a.live = !1;
            break;
          case "#":
            (w || B) && g.tagList.push(B ? [w, B] : [w]);
            break;
          case "DISCONTINUITY":
            m++, g.tagList.push(["DIS"]);
            break;
          case "GAP":
            g.gap = !0, g.tagList.push([R]);
            break;
          case "BITRATE":
            g.tagList.push([R, w]);
            break;
          case "DATERANGE": {
            const M = new ge(w);
            ke(a, M, ["ID", "CLASS", "START-DATE", "END-DATE", "SCTE35-CMD", "SCTE35-OUT", "SCTE35-IN"]), ke(a, M, M.clientAttrs);
            const N = new _o(M, a.dateRanges[M.ID]);
            N.isValid || a.skippedSegments ? a.dateRanges[N.id] = N : I.warn(`Ignoring invalid DATERANGE tag: "${w}"`), g.tagList.push(["EXT-X-DATERANGE", w]);
            break;
          }
          case "DEFINE": {
            {
              const M = new ge(w);
              ke(a, M, ["NAME", "VALUE", "IMPORT", "QUERYPARAM"]), "IMPORT" in M ? Nf(a, M, o) : dr(a, M, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            m = parseInt(w);
            break;
          case "KEY": {
            const M = Tr(w, t, a);
            if (M.isSupported()) {
              if (M.method === "NONE") {
                y = void 0;
                break;
              }
              y || (y = {}), y[M.keyFormat] && (y = ve({}, y)), y[M.keyFormat] = M;
            } else
              I.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${w}"`);
            break;
          }
          case "START":
            a.startTimeOffset = Er(w);
            break;
          case "MAP": {
            const M = new ge(w);
            if (ke(a, M, ["BYTERANGE", "URI"]), g.duration) {
              const N = new fn(i, t);
              vr(N, M, s, y), c = N, g.initSegment = c, c.rawProgramDateTime && !g.rawProgramDateTime && (g.rawProgramDateTime = c.rawProgramDateTime);
            } else {
              const N = g.byteRangeEndOffset;
              if (N) {
                const $ = g.byteRangeStartOffset;
                v = `${N - $}@${$}`;
              } else
                v = null;
              vr(g, M, s, y), c = g, S = !0;
            }
            break;
          }
          case "SERVER-CONTROL": {
            const M = new ge(w);
            a.canBlockReload = M.bool("CAN-BLOCK-RELOAD"), a.canSkipUntil = M.optionalFloat("CAN-SKIP-UNTIL", 0), a.canSkipDateRanges = a.canSkipUntil > 0 && M.bool("CAN-SKIP-DATERANGES"), a.partHoldBack = M.optionalFloat("PART-HOLD-BACK", 0), a.holdBack = M.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            const M = new ge(w);
            a.partTarget = M.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let M = a.partList;
            M || (M = a.partList = []);
            const N = d > 0 ? M[M.length - 1] : void 0, $ = d++, G = new ge(w);
            ke(a, G, ["BYTERANGE", "URI"]);
            const W = new sf(G, g, t, $, N);
            M.push(W), g.duration += W.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const M = new ge(w);
            ke(a, M, ["URI"]), a.preloadHint = M;
            break;
          }
          case "RENDITION-REPORT": {
            const M = new ge(w);
            ke(a, M, ["URI"]), a.renditionReports = a.renditionReports || [], a.renditionReports.push(M);
            break;
          }
          default:
            I.warn(`line parsed but not handled: ${p}`);
            break;
        }
      }
    }
    f && !f.relurl ? (l.pop(), h -= f.duration, a.partList && (a.fragmentHint = f)) : a.partList && (xr(g, f), g.cc = m, a.fragmentHint = g, y && Sr(g, y, a));
    const D = l.length, L = l[0], _ = l[D - 1];
    if (h += a.skippedSegments * a.targetduration, h > 0 && D && _) {
      a.averagetargetduration = h / D;
      const A = _.sn;
      a.endSN = A !== "initSegment" ? A : 0, a.live || (_.endList = !0), L && (a.startCC = L.cc);
    } else
      a.endSN = 0, a.startCC = 0;
    return a.fragmentHint && (h += a.fragmentHint.duration), a.totalduration = h, a.endCC = m, x > 0 && Yf(l, x), a;
  }
}
function Tr(n, e, t) {
  var s, i;
  const r = new ge(n);
  ke(t, r, ["KEYFORMAT", "KEYFORMATVERSIONS", "URI", "IV", "URI"]);
  const o = (s = r.METHOD) != null ? s : "", a = r.URI, l = r.hexadecimalInteger("IV"), c = r.KEYFORMATVERSIONS, u = (i = r.KEYFORMAT) != null ? i : "identity";
  a && r.IV && !l && I.error(`Invalid IV: ${r.IV}`);
  const d = a ? Xe.resolve(a, e) : "", h = (c || "1").split("/").map(Number).filter(Number.isFinite);
  return new ss(o, d, u, h, l);
}
function Er(n) {
  const t = new ge(n).decimalFloatingPoint("TIME-OFFSET");
  return H(t) ? t : null;
}
function Wf(n, e) {
  let t = (n || "").split(/[ ,]+/).filter((s) => s);
  ["video", "audio", "text"].forEach((s) => {
    const i = t.filter((r) => Bf(r, s));
    i.length && (e[`${s}Codec`] = i.join(","), t = t.filter((r) => i.indexOf(r) === -1));
  }), e.unknownCodecs = t;
}
function yr(n, e, t) {
  const s = e[t];
  s && (n[t] = s);
}
function Yf(n, e) {
  let t = n[e];
  for (let s = e; s--; ) {
    const i = n[s];
    if (!i)
      return;
    i.programDateTime = t.programDateTime - i.duration * 1e3, t = i;
  }
}
function xr(n, e) {
  n.rawProgramDateTime ? n.programDateTime = Date.parse(n.rawProgramDateTime) : e != null && e.programDateTime && (n.programDateTime = e.endProgramDateTime), H(n.programDateTime) || (n.programDateTime = null, n.rawProgramDateTime = null);
}
function vr(n, e, t, s) {
  n.relurl = e.URI, e.BYTERANGE && n.setByteRange(e.BYTERANGE), n.level = t, n.sn = "initSegment", s && (n.levelkeys = s), n.initSegment = null;
}
function Sr(n, e, t) {
  n.levelkeys = e;
  const {
    encryptedFragments: s
  } = t;
  (!s.length || s[s.length - 1].levelkeys !== e) && Object.keys(e).some((i) => e[i].isCommonEncryption) && s.push(n);
}
var re = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, j = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
function Ar(n) {
  const {
    type: e
  } = n;
  switch (e) {
    case re.AUDIO_TRACK:
      return j.AUDIO;
    case re.SUBTITLE_TRACK:
      return j.SUBTITLE;
    default:
      return j.MAIN;
  }
}
function xn(n, e) {
  let t = n.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class qf {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(T.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(T.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, s = t.pLoader, i = t.loader, r = s || i, o = new r(t);
    return this.loaders[e.type] = o, o;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: s
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: re.MANIFEST,
      url: s,
      deliveryDirectives: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: s,
      level: i,
      pathwayId: r,
      url: o,
      deliveryDirectives: a
    } = t;
    this.load({
      id: s,
      level: i,
      pathwayId: r,
      responseType: "text",
      type: re.LEVEL,
      url: o,
      deliveryDirectives: a
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: s,
      groupId: i,
      url: r,
      deliveryDirectives: o
    } = t;
    this.load({
      id: s,
      groupId: i,
      level: null,
      responseType: "text",
      type: re.AUDIO_TRACK,
      url: r,
      deliveryDirectives: o
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: s,
      groupId: i,
      url: r,
      deliveryDirectives: o
    } = t;
    this.load({
      id: s,
      groupId: i,
      level: null,
      responseType: "text",
      type: re.SUBTITLE_TRACK,
      url: r,
      deliveryDirectives: o
    });
  }
  load(e) {
    var t;
    const s = this.hls.config;
    let i = this.getInternalLoader(e);
    if (i) {
      const c = i.context;
      if (c && c.url === e.url && c.level === e.level) {
        I.trace("[playlist-loader]: playlist request ongoing");
        return;
      }
      I.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), i.abort();
    }
    let r;
    if (e.type === re.MANIFEST ? r = s.manifestLoadPolicy.default : r = ve({}, s.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), i = this.createInternalLoader(e), H((t = e.deliveryDirectives) == null ? void 0 : t.part)) {
      let c;
      if (e.type === re.LEVEL && e.level !== null ? c = this.hls.levels[e.level].details : e.type === re.AUDIO_TRACK && e.id !== null ? c = this.hls.audioTracks[e.id].details : e.type === re.SUBTITLE_TRACK && e.id !== null && (c = this.hls.subtitleTracks[e.id].details), c) {
        const u = c.partTarget, d = c.targetduration;
        if (u && d) {
          const h = Math.max(u * 3, d * 0.8) * 1e3;
          r = ve({}, r, {
            maxTimeToFirstByteMs: Math.min(h, r.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(h, r.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const o = r.errorRetry || r.timeoutRetry || {}, a = {
      loadPolicy: r,
      timeout: r.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (c, u, d, h) => {
        const m = this.getInternalLoader(d);
        this.resetInternalLoader(d.type);
        const f = c.data;
        if (f.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(c, d, new Error("no EXTM3U delimiter"), h || null, u);
          return;
        }
        u.parsing.start = performance.now(), Xe.isMediaPlaylist(f) ? this.handleTrackOrLevelPlaylist(c, u, d, h || null, m) : this.handleMasterPlaylist(c, u, d, h);
      },
      onError: (c, u, d, h) => {
        this.handleNetworkError(u, d, !1, c, h);
      },
      onTimeout: (c, u, d) => {
        this.handleNetworkError(u, d, !0, void 0, c);
      }
    };
    i.load(e, a, l);
  }
  handleMasterPlaylist(e, t, s, i) {
    const r = this.hls, o = e.data, a = xn(e, s), l = Xe.parseMasterPlaylist(o, a);
    if (l.playlistParsingError) {
      this.handleManifestParsingError(e, s, l.playlistParsingError, i, t);
      return;
    }
    const {
      contentSteering: c,
      levels: u,
      sessionData: d,
      sessionKeys: h,
      startTimeOffset: m,
      variableList: f
    } = l;
    this.variableList = f;
    const {
      AUDIO: g = [],
      SUBTITLES: p,
      "CLOSED-CAPTIONS": E
    } = Xe.parseMasterPlaylistMedia(o, a, l);
    g.length && !g.some((x) => !x.url) && u[0].audioCodec && !u[0].attrs.AUDIO && (I.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), g.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new ge({}),
      bitrate: 0,
      url: ""
    })), r.trigger(T.MANIFEST_LOADED, {
      levels: u,
      audioTracks: g,
      subtitles: p,
      captions: E,
      contentSteering: c,
      url: a,
      stats: t,
      networkDetails: i,
      sessionData: d,
      sessionKeys: h,
      startTimeOffset: m,
      variableList: f
    });
  }
  handleTrackOrLevelPlaylist(e, t, s, i, r) {
    const o = this.hls, {
      id: a,
      level: l,
      type: c
    } = s, u = xn(e, s), d = 0, h = H(l) ? l : H(a) ? a : 0, m = Ar(s), f = Xe.parseLevelPlaylist(e.data, u, h, m, d, this.variableList);
    if (c === re.MANIFEST) {
      const g = {
        attrs: new ge({}),
        bitrate: 0,
        details: f,
        name: "",
        url: u
      };
      o.trigger(T.MANIFEST_LOADED, {
        levels: [g],
        audioTracks: [],
        url: u,
        stats: t,
        networkDetails: i,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), s.levelDetails = f, this.handlePlaylistLoaded(f, e, t, s, i, r);
  }
  handleManifestParsingError(e, t, s, i, r) {
    this.hls.trigger(T.ERROR, {
      type: Q.NETWORK_ERROR,
      details: C.MANIFEST_PARSING_ERROR,
      fatal: t.type === re.MANIFEST,
      url: e.url,
      err: s,
      error: s,
      reason: s.message,
      response: e,
      context: t,
      networkDetails: i,
      stats: r
    });
  }
  handleNetworkError(e, t, s = !1, i, r) {
    let o = `A network ${s ? "timeout" : "error" + (i ? " (status " + i.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === re.LEVEL ? o += `: ${e.level} id: ${e.id}` : (e.type === re.AUDIO_TRACK || e.type === re.SUBTITLE_TRACK) && (o += ` id: ${e.id} group-id: "${e.groupId}"`);
    const a = new Error(o);
    I.warn(`[playlist-loader]: ${o}`);
    let l = C.UNKNOWN, c = !1;
    const u = this.getInternalLoader(e);
    switch (e.type) {
      case re.MANIFEST:
        l = s ? C.MANIFEST_LOAD_TIMEOUT : C.MANIFEST_LOAD_ERROR, c = !0;
        break;
      case re.LEVEL:
        l = s ? C.LEVEL_LOAD_TIMEOUT : C.LEVEL_LOAD_ERROR, c = !1;
        break;
      case re.AUDIO_TRACK:
        l = s ? C.AUDIO_TRACK_LOAD_TIMEOUT : C.AUDIO_TRACK_LOAD_ERROR, c = !1;
        break;
      case re.SUBTITLE_TRACK:
        l = s ? C.SUBTITLE_TRACK_LOAD_TIMEOUT : C.SUBTITLE_LOAD_ERROR, c = !1;
        break;
    }
    u && this.resetInternalLoader(e.type);
    const d = {
      type: Q.NETWORK_ERROR,
      details: l,
      fatal: c,
      url: e.url,
      loader: u,
      context: e,
      error: a,
      networkDetails: t,
      stats: r
    };
    if (i) {
      const h = (t == null ? void 0 : t.url) || e.url;
      d.response = De({
        url: h,
        data: void 0
      }, i);
    }
    this.hls.trigger(T.ERROR, d);
  }
  handlePlaylistLoaded(e, t, s, i, r, o) {
    const a = this.hls, {
      type: l,
      level: c,
      id: u,
      groupId: d,
      deliveryDirectives: h
    } = i, m = xn(t, i), f = Ar(i), g = typeof i.level == "number" && f === j.MAIN ? c : void 0;
    if (!e.fragments.length) {
      const E = new Error("No Segments found in Playlist");
      a.trigger(T.ERROR, {
        type: Q.NETWORK_ERROR,
        details: C.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: m,
        error: E,
        reason: E.message,
        response: t,
        context: i,
        level: g,
        parent: f,
        networkDetails: r,
        stats: s
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const p = e.playlistParsingError;
    if (p) {
      a.trigger(T.ERROR, {
        type: Q.NETWORK_ERROR,
        details: C.LEVEL_PARSING_ERROR,
        fatal: !1,
        url: m,
        error: p,
        reason: p.message,
        response: t,
        context: i,
        level: g,
        parent: f,
        networkDetails: r,
        stats: s
      });
      return;
    }
    switch (e.live && o && (o.getCacheAge && (e.ageHeader = o.getCacheAge() || 0), (!o.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case re.MANIFEST:
      case re.LEVEL:
        a.trigger(T.LEVEL_LOADED, {
          details: e,
          level: g || 0,
          id: u || 0,
          stats: s,
          networkDetails: r,
          deliveryDirectives: h
        });
        break;
      case re.AUDIO_TRACK:
        a.trigger(T.AUDIO_TRACK_LOADED, {
          details: e,
          id: u || 0,
          groupId: d || "",
          stats: s,
          networkDetails: r,
          deliveryDirectives: h
        });
        break;
      case re.SUBTITLE_TRACK:
        a.trigger(T.SUBTITLE_TRACK_LOADED, {
          details: e,
          id: u || 0,
          groupId: d || "",
          stats: s,
          networkDetails: r,
          deliveryDirectives: h
        });
        break;
    }
  }
}
function Wo(n, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = n, e.dispatchEvent(t);
}
function Yo(n, e) {
  const t = n.mode;
  if (t === "disabled" && (n.mode = "hidden"), n.cues && !n.cues.getCueById(e.id))
    try {
      if (n.addCue(e), !n.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (s) {
      I.debug(`[texttrack-utils]: ${s}`);
      try {
        const i = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        i.id = e.id, n.addCue(i);
      } catch (i) {
        I.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${i}`);
      }
    }
  t === "disabled" && (n.mode = t);
}
function Pt(n) {
  const e = n.mode;
  if (e === "disabled" && (n.mode = "hidden"), n.cues)
    for (let t = n.cues.length; t--; )
      n.removeCue(n.cues[t]);
  e === "disabled" && (n.mode = e);
}
function Yn(n, e, t, s) {
  const i = n.mode;
  if (i === "disabled" && (n.mode = "hidden"), n.cues && n.cues.length > 0) {
    const r = jf(n.cues, e, t);
    for (let o = 0; o < r.length; o++)
      (!s || s(r[o])) && n.removeCue(r[o]);
  }
  i === "disabled" && (n.mode = i);
}
function zf(n, e) {
  if (e < n[0].startTime)
    return 0;
  const t = n.length - 1;
  if (e > n[t].endTime)
    return -1;
  let s = 0, i = t;
  for (; s <= i; ) {
    const r = Math.floor((i + s) / 2);
    if (e < n[r].startTime)
      i = r - 1;
    else if (e > n[r].startTime && s < t)
      s = r + 1;
    else
      return r;
  }
  return n[s].startTime - e < e - n[i].startTime ? s : i;
}
function jf(n, e, t) {
  const s = [], i = zf(n, e);
  if (i > -1)
    for (let r = i, o = n.length; r < o; r++) {
      const a = n[r];
      if (a.startTime >= e && a.endTime <= t)
        s.push(a);
      else if (a.startTime > t)
        return s;
    }
  return s;
}
function _s(n) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const s = n[t];
    (s.kind === "subtitles" || s.kind === "captions") && s.label && e.push(n[t]);
  }
  return e;
}
var We = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};
const Xf = 0.25;
function qn() {
  if (typeof self != "undefined")
    return self.VTTCue || self.TextTrackCue;
}
function Lr(n, e, t, s, i) {
  let r = new n(e, t, "");
  try {
    r.value = s, i && (r.type = i);
  } catch {
    r = new n(e, t, JSON.stringify(i ? De({
      type: i
    }, s) : s));
  }
  return r;
}
const ys = (() => {
  const n = qn();
  try {
    n && new n(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function vn(n, e) {
  return n.getTime() / 1e3 - e;
}
function Qf(n) {
  return Uint8Array.from(n.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class Zf {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttached(e, t) {
    this.media = t.media;
  }
  onMediaDetaching() {
    this.id3Track && (Pt(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const s = e[t];
        if (s.kind === "metadata" && s.label === "id3")
          return Wo(s, this.media), s;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: s,
          enableID3MetadataCues: i
        }
      }
    } = this;
    if (!s && !i)
      return;
    const {
      samples: r
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const o = qn();
    if (o)
      for (let a = 0; a < r.length; a++) {
        const l = r[a].type;
        if (l === We.emsg && !s || !i)
          continue;
        const c = Po(r[a].data);
        if (c) {
          const u = r[a].pts;
          let d = u + r[a].duration;
          d > ys && (d = ys), d - u <= 0 && (d = u + Xf);
          for (let m = 0; m < c.length; m++) {
            const f = c[m];
            if (!Fo(f)) {
              this.updateId3CueEnds(u, l);
              const g = Lr(o, u, d, f, l);
              g && this.id3Track.addCue(g);
            }
          }
        }
      }
  }
  updateId3CueEnds(e, t) {
    var s;
    const i = (s = this.id3Track) == null ? void 0 : s.cues;
    if (i)
      for (let r = i.length; r--; ) {
        const o = i[r];
        o.type === t && o.startTime < e && o.endTime === ys && (o.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: s,
    type: i
  }) {
    const {
      id3Track: r,
      hls: o
    } = this;
    if (!o)
      return;
    const {
      config: {
        enableEmsgMetadataCues: a,
        enableID3MetadataCues: l
      }
    } = o;
    if (r && (a || l)) {
      let c;
      i === "audio" ? c = (u) => u.type === We.audioId3 && l : i === "video" ? c = (u) => u.type === We.emsg && a : c = (u) => u.type === We.audioId3 && l || u.type === We.emsg && a, Yn(r, t, s, c);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    if (!this.media || !t.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      dateRangeCuesAppended: s,
      id3Track: i
    } = this, {
      dateRanges: r
    } = t, o = Object.keys(r);
    if (i) {
      const u = Object.keys(s).filter((d) => !o.includes(d));
      for (let d = u.length; d--; ) {
        const h = u[d];
        Object.keys(s[h].cues).forEach((m) => {
          i.removeCue(s[h].cues[m]);
        }), delete s[h];
      }
    }
    const a = t.fragments[t.fragments.length - 1];
    if (o.length === 0 || !H(a == null ? void 0 : a.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const l = a.programDateTime / 1e3 - a.start, c = qn();
    for (let u = 0; u < o.length; u++) {
      const d = o[u], h = r[d], m = vn(h.startDate, l), f = s[d], g = (f == null ? void 0 : f.cues) || {};
      let p = (f == null ? void 0 : f.durationKnown) || !1, E = ys;
      const y = h.endDate;
      if (y)
        E = vn(y, l), p = !0;
      else if (h.endOnNext && !p) {
        const S = o.reduce((v, D) => {
          if (D !== h.id) {
            const L = r[D];
            if (L.class === h.class && L.startDate > h.startDate && (!v || h.startDate < v.startDate))
              return L;
          }
          return v;
        }, null);
        S && (E = vn(S.startDate, l), p = !0);
      }
      const x = Object.keys(h.attr);
      for (let S = 0; S < x.length; S++) {
        const v = x[S];
        if (!ef(v))
          continue;
        const D = g[v];
        if (D)
          p && !f.durationKnown && (D.endTime = E);
        else if (c) {
          let L = h.attr[v];
          tf(v) && (L = Qf(L));
          const _ = Lr(c, m, E, {
            key: v,
            data: L
          }, We.dateRange);
          _ && (_.id = d, this.id3Track.addCue(_), g[v] = _);
        }
      }
      s[d] = {
        cues: g,
        dateRange: h,
        durationKnown: p
      };
    }
  }
}
class Jf {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = () => this.timeupdate(), this.hls = e, this.config = e.config, this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e,
      levelDetails: t
    } = this;
    return e.liveMaxLatencyDuration !== void 0 ? e.liveMaxLatencyDuration : t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: s,
      targetduration: i
    } = e, {
      liveSyncDuration: r,
      liveSyncDurationCount: o,
      lowLatencyMode: a
    } = this.config, l = this.hls.userConfig;
    let c = a && s || t;
    (l.liveSyncDuration || l.liveSyncDurationCount || c === 0) && (c = r !== void 0 ? r : o * i);
    const u = i;
    return c + Math.min(this.stallCount * 1, u);
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency, s = this.levelDetails;
    if (e === null || t === null || s === null)
      return null;
    const i = s.edge, r = e - t - this.edgeStalled, o = i - s.totalduration, a = i - (this.config.lowLatencyMode && s.partTarget || s.targetduration);
    return Math.min(Math.max(o, r), a);
  }
  get drift() {
    const {
      levelDetails: e
    } = this;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return 0;
    const s = e.buffered.length;
    return (s ? e.buffered.end(s - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.off(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.off(T.ERROR, this.onError, this);
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
  }
  onManifestLoading() {
    this.levelDetails = null, this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.levelDetails = t, t.advanced && this.timeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
  }
  onError(e, t) {
    var s;
    t.details === C.BUFFER_STALLED_ERROR && (this.stallCount++, (s = this.levelDetails) != null && s.live && I.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
  }
  timeupdate() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return;
    this.currentTime = e.currentTime;
    const s = this.computeLatency();
    if (s === null)
      return;
    this._latency = s;
    const {
      lowLatencyMode: i,
      maxLiveSyncPlaybackRate: r
    } = this.config;
    if (!i || r === 1 || !t.live)
      return;
    const o = this.targetLatency;
    if (o === null)
      return;
    const a = s - o, l = Math.min(this.maxLatency, o + t.targetduration);
    if (a < l && a > 0.05 && this.forwardBufferLength > 1) {
      const u = Math.min(2, Math.max(1, r)), d = Math.round(2 / (1 + Math.exp(-0.75 * a - this.edgeStalled)) * 20) / 20;
      e.playbackRate = Math.min(u, Math.max(1, d));
    } else e.playbackRate !== 1 && e.playbackRate !== 0 && (e.playbackRate = 1);
  }
  estimateLiveEdge() {
    const {
      levelDetails: e
    } = this;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
const zn = ["NONE", "TYPE-0", "TYPE-1", null];
function em(n) {
  return zn.indexOf(n) > -1;
}
const Ws = ["SDR", "PQ", "HLG"];
function tm(n) {
  return !!n && Ws.indexOf(n) > -1;
}
var Cs = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function Rr(n) {
  const {
    canSkipUntil: e,
    canSkipDateRanges: t,
    age: s
  } = n, i = s < e / 2;
  return e && i ? t ? Cs.v2 : Cs.Yes : Cs.No;
}
class Dr {
  constructor(e, t, s) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = s;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class Gt {
  constructor(e) {
    this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.url = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._avgBitrate = 0, this._audioGroups = void 0, this._subtitleGroups = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.frameRate = e.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = e.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.codecSet = [e.videoCodec, e.audioCodec].filter((t) => !!t).map((t) => t.substring(0, 4)).join(","), this.addGroupId("audio", e.attrs.AUDIO), this.addGroupId("text", e.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[0] || "";
  }
  hasAudioGroup(e) {
    return Ir(this._audioGroups, e);
  }
  hasSubtitleGroup(e) {
    return Ir(this._subtitleGroups, e);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(e, t) {
    if (t) {
      if (e === "audio") {
        let s = this._audioGroups;
        s || (s = this._audioGroups = []), s.indexOf(t) === -1 && s.push(t);
      } else if (e === "text") {
        let s = this._subtitleGroups;
        s || (s = this._subtitleGroups = []), s.indexOf(t) === -1 && s.push(t);
      }
    }
  }
  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(e) {
  }
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : void 0;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : void 0;
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroups) == null ? void 0 : e[0];
  }
  get textGroupId() {
    var e;
    return (e = this.subtitleGroups) == null ? void 0 : e[0];
  }
  addFallback() {
  }
}
function Ir(n, e) {
  return !e || !n ? !1 : n.indexOf(e) !== -1;
}
function Sn(n, e) {
  const t = e.startPTS;
  if (H(t)) {
    let s = 0, i;
    e.sn > n.sn ? (s = t - n.start, i = n) : (s = n.start - t, i = e), i.duration !== s && (i.duration = s);
  } else e.sn > n.sn ? n.cc === e.cc && n.minEndPTS ? e.start = n.start + (n.minEndPTS - n.start) : e.start = n.start + n.duration : e.start = Math.max(n.start - e.duration, 0);
}
function qo(n, e, t, s, i, r) {
  s - t <= 0 && (I.warn("Fragment should have a positive duration", e), s = t + e.duration, r = i + e.duration);
  let a = t, l = s;
  const c = e.startPTS, u = e.endPTS;
  if (H(c)) {
    const p = Math.abs(c - t);
    H(e.deltaPTS) ? e.deltaPTS = Math.max(p, e.deltaPTS) : e.deltaPTS = p, a = Math.max(t, c), t = Math.min(t, c), i = Math.min(i, e.startDTS), l = Math.min(s, u), s = Math.max(s, u), r = Math.max(r, e.endDTS);
  }
  const d = t - e.start;
  e.start !== 0 && (e.start = t), e.duration = s - e.start, e.startPTS = t, e.maxStartPTS = a, e.startDTS = i, e.endPTS = s, e.minEndPTS = l, e.endDTS = r;
  const h = e.sn;
  if (!n || h < n.startSN || h > n.endSN)
    return 0;
  let m;
  const f = h - n.startSN, g = n.fragments;
  for (g[f] = e, m = f; m > 0; m--)
    Sn(g[m], g[m - 1]);
  for (m = f; m < g.length - 1; m++)
    Sn(g[m], g[m + 1]);
  return n.fragmentHint && Sn(g[g.length - 1], n.fragmentHint), n.PTSKnown = n.alignedSliding = !0, d;
}
function sm(n, e) {
  let t = null;
  const s = n.fragments;
  for (let l = s.length - 1; l >= 0; l--) {
    const c = s[l].initSegment;
    if (c) {
      t = c;
      break;
    }
  }
  n.fragmentHint && delete n.fragmentHint.endPTS;
  let i = 0, r;
  if (rm(n, e, (l, c) => {
    l.relurl && (i = l.cc - c.cc), H(l.startPTS) && H(l.endPTS) && (c.start = c.startPTS = l.startPTS, c.startDTS = l.startDTS, c.maxStartPTS = l.maxStartPTS, c.endPTS = l.endPTS, c.endDTS = l.endDTS, c.minEndPTS = l.minEndPTS, c.duration = l.endPTS - l.startPTS, c.duration && (r = c), e.PTSKnown = e.alignedSliding = !0), c.elementaryStreams = l.elementaryStreams, c.loader = l.loader, c.stats = l.stats, l.initSegment && (c.initSegment = l.initSegment, t = l.initSegment);
  }), t && (e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments).forEach((c) => {
    var u;
    c && (!c.initSegment || c.initSegment.relurl === ((u = t) == null ? void 0 : u.relurl)) && (c.initSegment = t);
  }), e.skippedSegments)
    if (e.deltaUpdateFailed = e.fragments.some((l) => !l), e.deltaUpdateFailed) {
      I.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let l = e.skippedSegments; l--; )
        e.fragments.shift();
      e.startSN = e.fragments[0].sn, e.startCC = e.fragments[0].cc;
    } else e.canSkipDateRanges && (e.dateRanges = nm(n.dateRanges, e.dateRanges, e.recentlyRemovedDateranges));
  const o = e.fragments;
  if (i) {
    I.warn("discontinuity sliding from playlist, take drift into account");
    for (let l = 0; l < o.length; l++)
      o[l].cc += i;
  }
  e.skippedSegments && (e.startCC = e.fragments[0].cc), im(n.partList, e.partList, (l, c) => {
    c.elementaryStreams = l.elementaryStreams, c.stats = l.stats;
  }), r ? qo(e, r, r.startPTS, r.endPTS, r.startDTS, r.endDTS) : zo(n, e), o.length && (e.totalduration = e.edge - o[0].start), e.driftStartTime = n.driftStartTime, e.driftStart = n.driftStart;
  const a = e.advancedDateTime;
  if (e.advanced && a) {
    const l = e.edge;
    e.driftStart || (e.driftStartTime = a, e.driftStart = l), e.driftEndTime = a, e.driftEnd = l;
  } else
    e.driftEndTime = n.driftEndTime, e.driftEnd = n.driftEnd, e.advancedDateTime = n.advancedDateTime;
}
function nm(n, e, t) {
  const s = ve({}, n);
  return t && t.forEach((i) => {
    delete s[i];
  }), Object.keys(e).forEach((i) => {
    const r = new _o(e[i].attr, s[i]);
    r.isValid ? s[i] = r : I.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(e[i].attr)}"`);
  }), s;
}
function im(n, e, t) {
  if (n && e) {
    let s = 0;
    for (let i = 0, r = n.length; i <= r; i++) {
      const o = n[i], a = e[i + s];
      o && a && o.index === a.index && o.fragment.sn === a.fragment.sn ? t(o, a) : s--;
    }
  }
}
function rm(n, e, t) {
  const s = e.skippedSegments, i = Math.max(n.startSN, e.startSN) - e.startSN, r = (n.fragmentHint ? 1 : 0) + (s ? e.endSN : Math.min(n.endSN, e.endSN)) - e.startSN, o = e.startSN - n.startSN, a = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = n.fragmentHint ? n.fragments.concat(n.fragmentHint) : n.fragments;
  for (let c = i; c <= r; c++) {
    const u = l[o + c];
    let d = a[c];
    s && !d && c < s && (d = e.fragments[c] = u), u && d && t(u, d);
  }
}
function zo(n, e) {
  const t = e.startSN + e.skippedSegments - n.startSN, s = n.fragments;
  t < 0 || t >= s.length || jn(e, s[t].start);
}
function jn(n, e) {
  if (e) {
    const t = n.fragments;
    for (let s = n.skippedSegments; s < t.length; s++)
      t[s].start += e;
    n.fragmentHint && (n.fragmentHint.start += e);
  }
}
function om(n, e = 1 / 0) {
  let t = 1e3 * n.targetduration;
  if (n.updated) {
    const s = n.fragments;
    if (s.length && t * 4 > e) {
      const r = s[s.length - 1].duration * 1e3;
      r < t && (t = r);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function am(n, e, t) {
  if (!(n != null && n.details))
    return null;
  const s = n.details;
  let i = s.fragments[e - s.startSN];
  return i || (i = s.fragmentHint, i && i.sn === e) ? i : e < s.startSN && t && t.sn === e ? t : null;
}
function br(n, e, t) {
  var s;
  return n != null && n.details ? jo((s = n.details) == null ? void 0 : s.partList, e, t) : null;
}
function jo(n, e, t) {
  if (n)
    for (let s = n.length; s--; ) {
      const i = n[s];
      if (i.index === t && i.fragment.sn === e)
        return i;
    }
  return null;
}
function Xo(n) {
  n.forEach((e, t) => {
    const {
      details: s
    } = e;
    s != null && s.fragments && s.fragments.forEach((i) => {
      i.level = t;
    });
  });
}
function Ys(n) {
  switch (n.details) {
    case C.FRAG_LOAD_TIMEOUT:
    case C.KEY_LOAD_TIMEOUT:
    case C.LEVEL_LOAD_TIMEOUT:
    case C.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function _r(n, e) {
  const t = Ys(e);
  return n.default[`${t ? "timeout" : "error"}Retry`];
}
function ci(n, e) {
  const t = n.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * n.retryDelayMs, n.maxRetryDelayMs);
}
function Cr(n) {
  return De(De({}, n), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function qs(n, e, t, s) {
  if (!n)
    return !1;
  const i = s == null ? void 0 : s.code, r = e < n.maxNumRetry && (lm(i) || !!t);
  return n.shouldRetry ? n.shouldRetry(n, e, t, s, r) : r;
}
function lm(n) {
  return n === 0 && navigator.onLine === !1 || !!n && (n < 400 || n > 499);
}
const Qo = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(n, e) {
    let t = 0, s = n.length - 1, i = null, r = null;
    for (; t <= s; ) {
      i = (t + s) / 2 | 0, r = n[i];
      const o = e(r);
      if (o > 0)
        t = i + 1;
      else if (o < 0)
        s = i - 1;
      else
        return r;
    }
    return null;
  }
};
function cm(n, e, t) {
  if (e === null || !Array.isArray(n) || !n.length || !H(e))
    return null;
  const s = n[0].programDateTime;
  if (e < (s || 0))
    return null;
  const i = n[n.length - 1].endProgramDateTime;
  if (e >= (i || 0))
    return null;
  t = t || 0;
  for (let r = 0; r < n.length; ++r) {
    const o = n[r];
    if (dm(e, t, o))
      return o;
  }
  return null;
}
function zs(n, e, t = 0, s = 0, i = 5e-3) {
  let r = null;
  if (n) {
    r = e[n.sn - e[0].sn + 1] || null;
    const a = n.endDTS - t;
    a > 0 && a < 15e-7 && (t += 15e-7);
  } else t === 0 && e[0].start === 0 && (r = e[0]);
  if (r && ((!n || n.level === r.level) && Xn(t, s, r) === 0 || um(r, n, Math.min(i, s))))
    return r;
  const o = Qo.search(e, Xn.bind(null, t, s));
  return o && (o !== n || !r) ? o : r;
}
function um(n, e, t) {
  if (e && e.start === 0 && e.level < n.level && (e.endPTS || 0) > 0) {
    const s = e.tagList.reduce((i, r) => (r[0] === "INF" && (i += parseFloat(r[1])), i), t);
    return n.start <= s;
  }
  return !1;
}
function Xn(n = 0, e = 0, t) {
  if (t.start <= n && t.start + t.duration > n)
    return 0;
  const s = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - s <= n ? 1 : t.start - s > n && t.start ? -1 : 0;
}
function dm(n, e, t) {
  const s = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - s > n;
}
function hm(n, e) {
  return Qo.search(n, (t) => t.cc < e ? 1 : t.cc > e ? -1 : 0);
}
var be = {
  DoNothing: 0,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  RetryRequest: 5
}, Ke = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2
};
class fm {
  constructor(e) {
    this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.log = void 0, this.warn = void 0, this.error = void 0, this.hls = e, this.log = I.log.bind(I, "[info]:"), this.warn = I.warn.bind(I, "[warning]:"), this.error = I.error.bind(I, "[error]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.ERROR, this.onError, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(T.ERROR, this.onError, this), e.off(T.ERROR, this.onErrorOut, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(e) {
    return (e == null ? void 0 : e.type) === j.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var s, i;
    if (t.fatal)
      return;
    const r = this.hls, o = t.context;
    switch (t.details) {
      case C.FRAG_LOAD_ERROR:
      case C.FRAG_LOAD_TIMEOUT:
      case C.KEY_LOAD_ERROR:
      case C.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case C.FRAG_PARSING_ERROR:
        if ((s = t.frag) != null && s.gap) {
          t.errorAction = {
            action: be.DoNothing,
            flags: Ke.None
          };
          return;
        }
      // falls through
      case C.FRAG_GAP:
      case C.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = be.SendAlternateToPenaltyBox;
        return;
      }
      case C.LEVEL_EMPTY_ERROR:
      case C.LEVEL_PARSING_ERROR:
        {
          var a, l;
          const c = t.parent === j.MAIN ? t.level : r.loadLevel;
          t.details === C.LEVEL_EMPTY_ERROR && ((a = t.context) != null && (l = a.levelDetails) != null && l.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, c) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, c));
        }
        return;
      case C.LEVEL_LOAD_ERROR:
      case C.LEVEL_LOAD_TIMEOUT:
        typeof (o == null ? void 0 : o.level) == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, o.level));
        return;
      case C.AUDIO_TRACK_LOAD_ERROR:
      case C.AUDIO_TRACK_LOAD_TIMEOUT:
      case C.SUBTITLE_LOAD_ERROR:
      case C.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (o) {
          const c = r.levels[r.loadLevel];
          if (c && (o.type === re.AUDIO_TRACK && c.hasAudioGroup(o.groupId) || o.type === re.SUBTITLE_TRACK && c.hasSubtitleGroup(o.groupId))) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, r.loadLevel), t.errorAction.action = be.SendAlternateToPenaltyBox, t.errorAction.flags = Ke.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case C.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const c = r.levels[r.loadLevel], u = c == null ? void 0 : c.attrs["HDCP-LEVEL"];
          u ? t.errorAction = {
            action: be.SendAlternateToPenaltyBox,
            flags: Ke.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: u
          } : this.keySystemError(t);
        }
        return;
      case C.BUFFER_ADD_CODEC_ERROR:
      case C.REMUX_ALLOC_ERROR:
      case C.BUFFER_APPEND_ERROR:
        t.errorAction = this.getLevelSwitchAction(t, (i = t.level) != null ? i : r.loadLevel);
        return;
      case C.INTERNAL_EXCEPTION:
      case C.BUFFER_APPENDING_ERROR:
      case C.BUFFER_FULL_ERROR:
      case C.LEVEL_SWITCH_ERROR:
      case C.BUFFER_STALLED_ERROR:
      case C.BUFFER_SEEK_OVER_HOLE:
      case C.BUFFER_NUDGE_ON_STALL:
        t.errorAction = {
          action: be.DoNothing,
          flags: Ke.None
        };
        return;
    }
    t.type === Q.KEY_SYSTEM_ERROR && this.keySystemError(t);
  }
  keySystemError(e) {
    const t = this.getVariantLevelIndex(e.frag);
    e.levelRetry = !1, e.errorAction = this.getLevelSwitchAction(e, t);
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    const s = this.hls, i = _r(s.config.playlistLoadPolicy, e), r = this.playlistError++;
    if (qs(i, r, Ys(e), e.response))
      return {
        action: be.RetryRequest,
        flags: Ke.None,
        retryConfig: i,
        retryCount: r
      };
    const a = this.getLevelSwitchAction(e, t);
    return i && (a.retryConfig = i, a.retryCount = r), a;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, s = this.getVariantLevelIndex(e.frag), i = t.levels[s], {
      fragLoadPolicy: r,
      keyLoadPolicy: o
    } = t.config, a = _r(e.details.startsWith("key") ? o : r, e), l = t.levels.reduce((u, d) => u + d.fragmentError, 0);
    if (i && (e.details !== C.FRAG_GAP && i.fragmentError++, qs(a, l, Ys(e), e.response)))
      return {
        action: be.RetryRequest,
        flags: Ke.None,
        retryConfig: a,
        retryCount: l
      };
    const c = this.getLevelSwitchAction(e, s);
    return a && (c.retryConfig = a, c.retryCount = l), c;
  }
  getLevelSwitchAction(e, t) {
    const s = this.hls;
    t == null && (t = s.loadLevel);
    const i = this.hls.levels[t];
    if (i) {
      var r, o;
      const c = e.details;
      i.loadError++, c === C.BUFFER_APPEND_ERROR && i.fragmentError++;
      let u = -1;
      const {
        levels: d,
        loadLevel: h,
        minAutoLevel: m,
        maxAutoLevel: f
      } = s;
      s.autoLevelEnabled || (s.loadLevel = -1);
      const g = (r = e.frag) == null ? void 0 : r.type, E = (g === j.AUDIO && c === C.FRAG_PARSING_ERROR || e.sourceBufferName === "audio" && (c === C.BUFFER_ADD_CODEC_ERROR || c === C.BUFFER_APPEND_ERROR)) && d.some(({
        audioCodec: D
      }) => i.audioCodec !== D), x = e.sourceBufferName === "video" && (c === C.BUFFER_ADD_CODEC_ERROR || c === C.BUFFER_APPEND_ERROR) && d.some(({
        codecSet: D,
        audioCodec: L
      }) => i.codecSet !== D && i.audioCodec === L), {
        type: S,
        groupId: v
      } = (o = e.context) != null ? o : {};
      for (let D = d.length; D--; ) {
        const L = (D + h) % d.length;
        if (L !== h && L >= m && L <= f && d[L].loadError === 0) {
          var a, l;
          const _ = d[L];
          if (c === C.FRAG_GAP && g === j.MAIN && e.frag) {
            const A = d[L].details;
            if (A) {
              const R = zs(e.frag, A.fragments, e.frag.start);
              if (R != null && R.gap)
                continue;
            }
          } else {
            if (S === re.AUDIO_TRACK && _.hasAudioGroup(v) || S === re.SUBTITLE_TRACK && _.hasSubtitleGroup(v))
              continue;
            if (g === j.AUDIO && (a = i.audioGroups) != null && a.some((A) => _.hasAudioGroup(A)) || g === j.SUBTITLE && (l = i.subtitleGroups) != null && l.some((A) => _.hasSubtitleGroup(A)) || E && i.audioCodec === _.audioCodec || !E && i.audioCodec !== _.audioCodec || x && i.codecSet === _.codecSet)
              continue;
          }
          u = L;
          break;
        }
      }
      if (u > -1 && s.loadLevel !== u)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: be.SendAlternateToPenaltyBox,
          flags: Ke.None,
          nextAutoLevel: u
        };
    }
    return {
      action: be.SendAlternateToPenaltyBox,
      flags: Ke.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var s;
    switch ((s = t.errorAction) == null ? void 0 : s.action) {
      case be.DoNothing:
        break;
      case be.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== C.FRAG_GAP ? t.fatal = !0 : /MediaSource readyState: ended/.test(t.error.message) && (this.warn(`MediaSource ended after "${t.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`), this.hls.recoverMediaError());
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, s = e.errorAction;
    if (!s)
      return;
    const {
      flags: i,
      hdcpLevel: r,
      nextAutoLevel: o
    } = s;
    switch (i) {
      case Ke.None:
        this.switchLevel(e, o);
        break;
      case Ke.MoveAllAlternatesMatchingHDCP:
        r && (t.maxHdcpLevel = zn[zn.indexOf(r) - 1], s.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
        break;
    }
    s.resolved || this.switchLevel(e, o);
  }
  switchLevel(e, t) {
    t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel);
  }
}
class ui {
  constructor(e, t) {
    this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.log = void 0, this.warn = void 0, this.log = I.log.bind(I, `${t}:`), this.warn = I.warn.bind(I, `${t}:`), this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.requestScheduled = -1, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t, s) {
    const i = t == null ? void 0 : t.renditionReports;
    if (i) {
      let r = -1;
      for (let o = 0; o < i.length; o++) {
        const a = i[o];
        let l;
        try {
          l = new self.URL(a.URI, t.url).href;
        } catch (c) {
          I.warn(`Could not construct new URL for Rendition Report: ${c}`), l = a.URI || "";
        }
        if (l === e) {
          r = o;
          break;
        } else l === e.substring(0, l.length) && (r = o);
      }
      if (r !== -1) {
        const o = i[r], a = parseInt(o["LAST-MSN"]) || (t == null ? void 0 : t.lastPartSn);
        let l = parseInt(o["LAST-PART"]) || (t == null ? void 0 : t.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const u = Math.min(t.age - t.partTarget, t.targetduration);
          l >= 0 && u > t.partTarget && (l += 1);
        }
        const c = s && Rr(s);
        return new Dr(a, l >= 0 ? l : void 0, c);
      }
    }
  }
  loadPlaylist(e) {
    this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  shouldReloadPlaylist(e) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(e);
  }
  playlistLoaded(e, t, s) {
    const {
      details: i,
      stats: r
    } = t, o = self.performance.now(), a = r.loading.first ? Math.max(0, o - r.loading.first) : 0;
    if (i.advancedDateTime = Date.now() - a, i.live || s != null && s.live) {
      if (i.reloaded(s), s && this.log(`live playlist ${e} ${i.advanced ? "REFRESHED " + i.lastPartSn + "-" + i.lastPartIndex : i.updated ? "UPDATED" : "MISSED"}`), s && i.fragments.length > 0 && sm(s, i), !this.canLoad || !i.live)
        return;
      let l, c, u;
      if (i.canBlockReload && i.endSN && i.advanced) {
        const p = this.hls.config.lowLatencyMode, E = i.lastPartSn, y = i.endSN, x = i.lastPartIndex, S = x !== -1, v = E === y, D = p ? 0 : x;
        S ? (c = v ? y + 1 : E, u = v ? D : x + 1) : c = y + 1;
        const L = i.age, _ = L + i.ageHeader;
        let A = Math.min(_ - i.partTarget, i.targetduration * 1.5);
        if (A > 0) {
          if (s && A > s.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${s.tuneInGoal} to: ${A} with playlist age: ${i.age}`), A = 0;
          else {
            const R = Math.floor(A / i.targetduration);
            if (c += R, u !== void 0) {
              const w = Math.round(A % i.targetduration / i.partTarget);
              u += w;
            }
            this.log(`CDN Tune-in age: ${i.ageHeader}s last advanced ${L.toFixed(2)}s goal: ${A} skip sn ${R} to part ${u}`);
          }
          i.tuneInGoal = A;
        }
        if (l = this.getDeliveryDirectives(i, t.deliveryDirectives, c, u), p || !v) {
          this.loadPlaylist(l);
          return;
        }
      } else (i.canBlockReload || i.canSkipUntil) && (l = this.getDeliveryDirectives(i, t.deliveryDirectives, c, u));
      const d = this.hls.mainForwardBufferInfo, h = d ? d.end - d.len : 0, m = (i.edge - h) * 1e3, f = om(i, m);
      i.updated && o > this.requestScheduled + f && (this.requestScheduled = r.loading.start), c !== void 0 && i.canBlockReload ? this.requestScheduled = r.loading.first + f - (i.partTarget * 1e3 || 1e3) : this.requestScheduled === -1 || this.requestScheduled + f < o ? this.requestScheduled = o : this.requestScheduled - o <= 0 && (this.requestScheduled += f);
      let g = this.requestScheduled - o;
      g = Math.max(0, g), this.log(`reload live playlist ${e} in ${Math.round(g)} ms`), this.timer = self.setTimeout(() => this.loadPlaylist(l), g);
    } else
      this.clearTimer();
  }
  getDeliveryDirectives(e, t, s, i) {
    let r = Rr(e);
    return t != null && t.skip && e.deltaUpdateFailed && (s = t.msn, i = t.part, r = Cs.No), new Dr(s, i, r);
  }
  checkRetry(e) {
    const t = e.details, s = Ys(e), i = e.errorAction, {
      action: r,
      retryCount: o = 0,
      retryConfig: a
    } = i || {}, l = !!i && !!a && (r === be.RetryRequest || !i.resolved && r === be.SendAlternateToPenaltyBox);
    if (l) {
      var c;
      if (this.requestScheduled = -1, o >= a.maxNumRetry)
        return !1;
      if (s && (c = e.context) != null && c.deliveryDirectives)
        this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const u = ci(a, o);
        this.timer = self.setTimeout(() => this.loadPlaylist(), u), this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" in ${u}ms`);
      }
      e.levelRetry = !0, i.resolved = !0;
    }
    return l;
  }
}
class Ct {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, s = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = s;
  }
  sample(e, t) {
    const s = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - s) + s * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class mm {
  constructor(e, t, s, i = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = s, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new Ct(e), this.fast_ = new Ct(t), this.defaultTTFB_ = i, this.ttfb_ = new Ct(e);
  }
  update(e, t) {
    const {
      slow_: s,
      fast_: i,
      ttfb_: r
    } = this;
    s.halfLife !== e && (this.slow_ = new Ct(e, s.getEstimate(), s.getTotalWeight())), i.halfLife !== t && (this.fast_ = new Ct(t, i.getEstimate(), i.getTotalWeight())), r.halfLife !== e && (this.ttfb_ = new Ct(e, r.getEstimate(), r.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const s = 8 * t, i = e / 1e3, r = s / i;
    this.fast_.sample(i, r), this.slow_.sample(i, r);
  }
  sampleTTFB(e) {
    const t = e / 1e3, s = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(s, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  destroy() {
  }
}
const Zo = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [{
    supported: !0,
    powerEfficient: !0,
    smooth: !0
  }]
}, wr = {};
function gm(n, e, t, s, i, r) {
  const o = n.audioCodec ? n.audioGroups : null, a = r == null ? void 0 : r.audioCodec, l = r == null ? void 0 : r.channels, c = l ? parseInt(l) : a ? 1 / 0 : 2;
  let u = null;
  if (o != null && o.length)
    try {
      o.length === 1 && o[0] ? u = e.groups[o[0]].channels : u = o.reduce((d, h) => {
        if (h) {
          const m = e.groups[h];
          if (!m)
            throw new Error(`Audio track group ${h} not found`);
          Object.keys(m.channels).forEach((f) => {
            d[f] = (d[f] || 0) + m.channels[f];
          });
        }
        return d;
      }, {
        2: 0
      });
    } catch {
      return !0;
    }
  return n.videoCodec !== void 0 && (n.width > 1920 && n.height > 1088 || n.height > 1920 && n.width > 1088 || n.frameRate > Math.max(s, 30) || n.videoRange !== "SDR" && n.videoRange !== t || n.bitrate > Math.max(i, 8e6)) || !!u && H(c) && Object.keys(u).some((d) => parseInt(d) > c);
}
function pm(n, e, t) {
  const s = n.videoCodec, i = n.audioCodec;
  if (!s || !i || !t)
    return Promise.resolve(Zo);
  const r = {
    width: n.width,
    height: n.height,
    bitrate: Math.ceil(Math.max(n.bitrate * 0.9, n.averageBitrate)),
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    framerate: n.frameRate || 30
  }, o = n.videoRange;
  o !== "SDR" && (r.transferFunction = o.toLowerCase());
  const a = s.split(",").map((l) => ({
    type: "media-source",
    video: De(De({}, r), {}, {
      contentType: ns(l, "video")
    })
  }));
  return i && n.audioGroups && n.audioGroups.forEach((l) => {
    var c;
    l && ((c = e.groups[l]) == null || c.tracks.forEach((u) => {
      if (u.groupId === l) {
        const d = u.channels || "", h = parseFloat(d);
        H(h) && h > 2 && a.push.apply(a, i.split(",").map((m) => ({
          type: "media-source",
          audio: {
            contentType: ns(m, "audio"),
            channels: "" + h
            // spatialRendering:
            //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
          }
        })));
      }
    }));
  }), Promise.all(a.map((l) => {
    const c = Tm(l);
    return wr[c] || (wr[c] = t.decodingInfo(l));
  })).then((l) => ({
    supported: !l.some((c) => !c.supported),
    configurations: a,
    decodingInfoResults: l
  })).catch((l) => ({
    supported: !1,
    configurations: a,
    decodingInfoResults: [],
    error: l
  }));
}
function Tm(n) {
  const {
    audio: e,
    video: t
  } = n, s = t || e;
  if (s) {
    const i = s.contentType.split('"')[1];
    if (t)
      return `r${t.height}x${t.width}f${Math.ceil(t.framerate)}${t.transferFunction || "sd"}_${i}_${Math.ceil(t.bitrate / 1e5)}`;
    if (e)
      return `c${e.channels}${e.spatialRendering ? "s" : "n"}_${i}`;
  }
  return "";
}
function Em() {
  if (typeof matchMedia == "function") {
    const n = matchMedia("(dynamic-range: high)"), e = matchMedia("bad query");
    if (n.media !== e.media)
      return n.matches === !0;
  }
  return !1;
}
function ym(n, e) {
  let t = !1, s = [];
  return n && (t = n !== "SDR", s = [n]), e && (s = e.allowedVideoRanges || Ws.slice(0), t = e.preferHDR !== void 0 ? e.preferHDR : Em(), t ? s = s.filter((i) => i !== "SDR") : s = ["SDR"]), {
    preferHDR: t,
    allowedVideoRanges: s
  };
}
function xm(n, e, t, s, i) {
  const r = Object.keys(n), o = s == null ? void 0 : s.channels, a = s == null ? void 0 : s.audioCodec, l = o && parseInt(o) === 2;
  let c = !0, u = !1, d = 1 / 0, h = 1 / 0, m = 1 / 0, f = 0, g = [];
  const {
    preferHDR: p,
    allowedVideoRanges: E
  } = ym(e, i);
  for (let v = r.length; v--; ) {
    const D = n[r[v]];
    c = D.channels[2] > 0, d = Math.min(d, D.minHeight), h = Math.min(h, D.minFramerate), m = Math.min(m, D.minBitrate);
    const L = E.filter((_) => D.videoRanges[_] > 0);
    L.length > 0 && (u = !0, g = L);
  }
  d = H(d) ? d : 0, h = H(h) ? h : 0;
  const y = Math.max(1080, d), x = Math.max(30, h);
  return m = H(m) ? m : t, t = Math.max(m, t), u || (e = void 0, g = []), {
    codecSet: r.reduce((v, D) => {
      const L = n[D];
      if (D === v)
        return v;
      if (L.minBitrate > t)
        return it(D, `min bitrate of ${L.minBitrate} > current estimate of ${t}`), v;
      if (!L.hasDefaultAudio)
        return it(D, "no renditions with default or auto-select sound found"), v;
      if (a && D.indexOf(a.substring(0, 4)) % 5 !== 0)
        return it(D, `audio codec preference "${a}" not found`), v;
      if (o && !l) {
        if (!L.channels[o])
          return it(D, `no renditions with ${o} channel sound found (channels options: ${Object.keys(L.channels)})`), v;
      } else if ((!a || l) && c && L.channels[2] === 0)
        return it(D, "no renditions with stereo sound found"), v;
      return L.minHeight > y ? (it(D, `min resolution of ${L.minHeight} > maximum of ${y}`), v) : L.minFramerate > x ? (it(D, `min framerate of ${L.minFramerate} > maximum of ${x}`), v) : g.some((_) => L.videoRanges[_] > 0) ? L.maxScore < f ? (it(D, `max score of ${L.maxScore} < selected max of ${f}`), v) : v && (Ks(D) >= Ks(v) || L.fragmentError > n[v].fragmentError) ? v : (f = L.maxScore, D) : (it(D, `no variants with VIDEO-RANGE of ${JSON.stringify(g)} found`), v);
    }, void 0),
    videoRanges: g,
    preferHDR: p,
    minFramerate: h,
    minBitrate: m
  };
}
function it(n, e) {
  I.log(`[abr] start candidates with "${n}" ignored because ${e}`);
}
function vm(n) {
  return n.reduce((e, t) => {
    let s = e.groups[t.groupId];
    s || (s = e.groups[t.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), s.tracks.push(t);
    const i = t.channels || "2";
    return s.channels[i] = (s.channels[i] || 0) + 1, s.hasDefault = s.hasDefault || t.default, s.hasAutoSelect = s.hasAutoSelect || t.autoselect, s.hasDefault && (e.hasDefaultAudio = !0), s.hasAutoSelect && (e.hasAutoSelectAudio = !0), e;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function Sm(n, e, t, s) {
  return n.slice(t, s + 1).reduce((i, r) => {
    if (!r.codecSet)
      return i;
    const o = r.audioGroups;
    let a = i[r.codecSet];
    a || (i[r.codecSet] = a = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !o,
      fragmentError: 0
    }), a.minBitrate = Math.min(a.minBitrate, r.bitrate);
    const l = Math.min(r.height, r.width);
    return a.minHeight = Math.min(a.minHeight, l), a.minFramerate = Math.min(a.minFramerate, r.frameRate), a.maxScore = Math.max(a.maxScore, r.score), a.fragmentError += r.fragmentError, a.videoRanges[r.videoRange] = (a.videoRanges[r.videoRange] || 0) + 1, o && o.forEach((c) => {
      if (!c)
        return;
      const u = e.groups[c];
      u && (a.hasDefaultAudio = a.hasDefaultAudio || e.hasDefaultAudio ? u.hasDefault : u.hasAutoSelect || !e.hasDefaultAudio && !e.hasAutoSelectAudio, Object.keys(u.channels).forEach((d) => {
        a.channels[d] = (a.channels[d] || 0) + u.channels[d];
      }));
    }), i;
  }, {});
}
function Qe(n, e, t) {
  if ("attrs" in n) {
    const s = e.indexOf(n);
    if (s !== -1)
      return s;
  }
  for (let s = 0; s < e.length; s++) {
    const i = e[s];
    if (Nt(n, i, t))
      return s;
  }
  return -1;
}
function Nt(n, e, t) {
  const {
    groupId: s,
    name: i,
    lang: r,
    assocLang: o,
    characteristics: a,
    default: l
  } = n, c = n.forced;
  return (s === void 0 || e.groupId === s) && (i === void 0 || e.name === i) && (r === void 0 || e.lang === r) && (r === void 0 || e.assocLang === o) && (l === void 0 || e.default === l) && (c === void 0 || e.forced === c) && (a === void 0 || Am(a, e.characteristics)) && (t === void 0 || t(n, e));
}
function Am(n, e = "") {
  const t = n.split(","), s = e.split(",");
  return t.length === s.length && !t.some((i) => s.indexOf(i) === -1);
}
function wt(n, e) {
  const {
    audioCodec: t,
    channels: s
  } = n;
  return (t === void 0 || (e.audioCodec || "").substring(0, 4) === t.substring(0, 4)) && (s === void 0 || s === (e.channels || "2"));
}
function Lm(n, e, t, s, i) {
  const r = e[s], a = e.reduce((h, m, f) => {
    const g = m.uri;
    return (h[g] || (h[g] = [])).push(f), h;
  }, {})[r.uri];
  a.length > 1 && (s = Math.max.apply(Math, a));
  const l = r.videoRange, c = r.frameRate, u = r.codecSet.substring(0, 4), d = Mr(e, s, (h) => {
    if (h.videoRange !== l || h.frameRate !== c || h.codecSet.substring(0, 4) !== u)
      return !1;
    const m = h.audioGroups, f = t.filter((g) => !m || m.indexOf(g.groupId) !== -1);
    return Qe(n, f, i) > -1;
  });
  return d > -1 ? d : Mr(e, s, (h) => {
    const m = h.audioGroups, f = t.filter((g) => !m || m.indexOf(g.groupId) !== -1);
    return Qe(n, f, i) > -1;
  });
}
function Mr(n, e, t) {
  for (let s = e; s; s--)
    if (t(n[s]))
      return s;
  for (let s = e + 1; s < n.length; s++)
    if (t(n[s]))
      return s;
  return -1;
}
class Rm {
  constructor(e) {
    this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this.firstSelection = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this._abandonRulesCheck = () => {
      const {
        fragCurrent: t,
        partCurrent: s,
        hls: i
      } = this, {
        autoLevelEnabled: r,
        media: o
      } = i;
      if (!t || !o)
        return;
      const a = performance.now(), l = s ? s.stats : t.stats, c = s ? s.duration : t.duration, u = a - l.loading.start, d = i.minAutoLevel;
      if (l.aborted || l.loaded && l.loaded === l.total || t.level <= d) {
        this.clearTimer(), this._nextAutoLevel = -1;
        return;
      }
      if (!r || o.paused || !o.playbackRate || !o.readyState)
        return;
      const h = i.mainForwardBufferInfo;
      if (h === null)
        return;
      const m = this.bwEstimator.getEstimateTTFB(), f = Math.abs(o.playbackRate);
      if (u <= Math.max(m, 1e3 * (c / (f * 2))))
        return;
      const g = h.len / f, p = l.loading.first ? l.loading.first - l.loading.start : -1, E = l.loaded && p > -1, y = this.getBwEstimate(), x = i.levels, S = x[t.level], v = l.total || Math.max(l.loaded, Math.round(c * S.averageBitrate / 8));
      let D = E ? u - p : u;
      D < 1 && E && (D = Math.min(u, l.loaded * 8 / y));
      const L = E ? l.loaded * 1e3 / D : 0, _ = L ? (v - l.loaded) / L : v * 8 / y + m / 1e3;
      if (_ <= g)
        return;
      const A = L ? L * 8 : y;
      let R = Number.POSITIVE_INFINITY, w;
      for (w = t.level - 1; w > d; w--) {
        const M = x[w].maxBitrate;
        if (R = this.getTimeToLoadFrag(m / 1e3, A, c * M, !x[w].details), R < g)
          break;
      }
      if (R >= _ || R > c * 10)
        return;
      i.nextLoadLevel = i.nextAutoLevel = w, E ? this.bwEstimator.sample(u - Math.min(m, p), l.loaded) : this.bwEstimator.sampleTTFB(u);
      const B = x[w].maxBitrate;
      this.getBwEstimate() * this.hls.config.abrBandWidthUpFactor > B && this.resetEstimator(B), this.clearTimer(), I.warn(`[abr] Fragment ${t.sn}${s ? " part " + s.index : ""} of level ${t.level} is loading too slowly;
      Time to underbuffer: ${g.toFixed(3)} s
      Estimated load time for current fragment: ${_.toFixed(3)} s
      Estimated load time for down switch fragment: ${R.toFixed(3)} s
      TTFB estimate: ${p | 0} ms
      Current BW estimate: ${H(y) ? y | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${w} @ ${B | 0} bps`), i.trigger(T.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag: t,
        part: s,
        stats: l
      });
    }, this.hls = e, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(e) {
    e && (I.log(`setting initial bwe to ${e}`), this.hls.config.abrEwmaDefaultEstimate = e), this.firstSelection = -1, this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const e = this.hls.config;
    return new mm(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.FRAG_LOADING, this.onFragLoading, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.FRAG_LOADING, this.onFragLoading, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.off(T.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this._abandonRulesCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(e, t) {
    this.lastLoadedFragLevel = -1, this.firstSelection = -1, this.lastLevelLoadSec = 0, this.fragCurrent = this.partCurrent = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.onMaxAutoLevelUpdated(), this.codecTiers = null, this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1, this.nextAutoLevelKey = "";
  }
  onFragLoading(e, t) {
    const s = t.frag;
    if (!this.ignoreFragment(s)) {
      if (!s.bitrateTest) {
        var i;
        this.fragCurrent = s, this.partCurrent = (i = t.part) != null ? i : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  onError(e, t) {
    if (!t.fatal)
      switch (t.details) {
        case C.BUFFER_ADD_CODEC_ERROR:
        case C.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1, this.firstSelection = -1;
          break;
        case C.FRAG_LOAD_TIMEOUT: {
          const s = t.frag, {
            fragCurrent: i,
            partCurrent: r
          } = this;
          if (s && i && s.sn === i.sn && s.level === i.level) {
            const o = performance.now(), a = r ? r.stats : s.stats, l = o - a.loading.start, c = a.loading.first ? a.loading.first - a.loading.start : -1;
            if (a.loaded && c > -1) {
              const d = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(l - Math.min(d, c), a.loaded);
            } else
              this.bwEstimator.sampleTTFB(l);
          }
          break;
        }
      }
  }
  getTimeToLoadFrag(e, t, s, i) {
    const r = e + s / t, o = i ? this.lastLevelLoadSec : 0;
    return r + o;
  }
  onLevelLoaded(e, t) {
    const s = this.hls.config, {
      loading: i
    } = t.stats, r = i.end - i.start;
    H(r) && (this.lastLevelLoadSec = r / 1e3), t.details.live ? this.bwEstimator.update(s.abrEwmaSlowLive, s.abrEwmaFastLive) : this.bwEstimator.update(s.abrEwmaSlowVoD, s.abrEwmaFastVoD);
  }
  onFragLoaded(e, {
    frag: t,
    part: s
  }) {
    const i = s ? s.stats : t.stats;
    if (t.type === j.MAIN && this.bwEstimator.sampleTTFB(i.loading.first - i.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), t.level === this._nextAutoLevel && (this._nextAutoLevel = -1), this.firstSelection = -1, this.hls.config.abrMaxWithRealBitrate) {
        const r = s ? s.duration : t.duration, o = this.hls.levels[t.level], a = (o.loaded ? o.loaded.bytes : 0) + i.loaded, l = (o.loaded ? o.loaded.duration : 0) + r;
        o.loaded = {
          bytes: a,
          duration: l
        }, o.realBitrate = Math.round(8 * a / l);
      }
      if (t.bitrateTest) {
        const r = {
          stats: i,
          frag: t,
          part: s,
          id: t.type
        };
        this.onFragBuffered(T.FRAG_BUFFERED, r), t.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = t.level;
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: i
    } = t, r = i != null && i.stats.loaded ? i.stats : s.stats;
    if (r.aborted || this.ignoreFragment(s))
      return;
    const o = r.parsing.end - r.loading.start - Math.min(r.loading.first - r.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(o, r.loaded), r.bwEstimate = this.getBwEstimate(), s.bitrateTest ? this.bitrateTestDelay = o / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== j.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: e,
      minAutoLevel: t
    } = this.hls, s = this.getBwEstimate(), i = this.hls.config.maxStarvationDelay, r = this.findBestLevel(s, t, e, 0, i, 1, 1);
    if (r > -1)
      return r;
    const o = this.hls.firstLevel, a = Math.min(Math.max(o, t), e);
    return I.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${o} clamped to ${a}`), a;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this.forcedAutoLevel, s = this.bwEstimator.canEstimate(), i = this.lastLoadedFragLevel > -1;
    if (e !== -1 && (!s || !i || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return e;
    const r = s && i ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (e !== -1) {
      const o = this.hls.levels;
      if (o.length > Math.max(e, r) && o[e].loadError <= o[r].loadError)
        return e;
    }
    return this._nextAutoLevel = r, this.nextAutoLevelKey = this.getAutoLevelKey(), r;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: s
    } = this, {
      maxAutoLevel: i,
      config: r,
      minAutoLevel: o
    } = s, a = t ? t.duration : e ? e.duration : 0, l = this.getBwEstimate(), c = this.getStarvationDelay();
    let u = r.abrBandWidthFactor, d = r.abrBandWidthUpFactor;
    if (c) {
      const p = this.findBestLevel(l, o, i, c, 0, u, d);
      if (p >= 0)
        return p;
    }
    let h = a ? Math.min(a, r.maxStarvationDelay) : r.maxStarvationDelay;
    if (!c) {
      const p = this.bitrateTestDelay;
      p && (h = (a ? Math.min(a, r.maxLoadingDelay) : r.maxLoadingDelay) - p, I.info(`[abr] bitrate test took ${Math.round(1e3 * p)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * h)} ms`), u = d = 1);
    }
    const m = this.findBestLevel(l, o, i, c, h, u, d);
    if (I.info(`[abr] ${c ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${m}`), m > -1)
      return m;
    const f = s.levels[o], g = s.levels[s.loadLevel];
    return (f == null ? void 0 : f.bitrate) < (g == null ? void 0 : g.bitrate) ? o : s.loadLevel;
  }
  getStarvationDelay() {
    const e = this.hls, t = e.media;
    if (!t)
      return 1 / 0;
    const s = t && t.playbackRate !== 0 ? Math.abs(t.playbackRate) : 1, i = e.mainForwardBufferInfo;
    return (i ? i.len : 0) / s;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(e, t, s, i, r, o, a) {
    var l;
    const c = i + r, u = this.lastLoadedFragLevel, d = u === -1 ? this.hls.firstLevel : u, {
      fragCurrent: h,
      partCurrent: m
    } = this, {
      levels: f,
      allAudioTracks: g,
      loadLevel: p,
      config: E
    } = this.hls;
    if (f.length === 1)
      return 0;
    const y = f[d], x = !!(y != null && (l = y.details) != null && l.live), S = p === -1 || u === -1;
    let v, D = "SDR", L = (y == null ? void 0 : y.frameRate) || 0;
    const {
      audioPreference: _,
      videoPreference: A
    } = E, R = this.audioTracksByGroup || (this.audioTracksByGroup = vm(g));
    if (S) {
      if (this.firstSelection !== -1)
        return this.firstSelection;
      const $ = this.codecTiers || (this.codecTiers = Sm(f, R, t, s)), G = xm($, D, e, _, A), {
        codecSet: W,
        videoRanges: U,
        minFramerate: P,
        minBitrate: O,
        preferHDR: K
      } = G;
      v = W, D = K ? U[U.length - 1] : U[0], L = P, e = Math.max(e, O), I.log(`[abr] picked start tier ${JSON.stringify(G)}`);
    } else
      v = y == null ? void 0 : y.codecSet, D = y == null ? void 0 : y.videoRange;
    const w = m ? m.duration : h ? h.duration : 0, B = this.bwEstimator.getEstimateTTFB() / 1e3, M = [];
    for (let $ = s; $ >= t; $--) {
      var N;
      const G = f[$], W = $ > d;
      if (!G)
        continue;
      if (E.useMediaCapabilities && !G.supportedResult && !G.supportedPromise) {
        const Z = navigator.mediaCapabilities;
        typeof (Z == null ? void 0 : Z.decodingInfo) == "function" && gm(G, R, D, L, e, _) ? (G.supportedPromise = pm(G, R, Z), G.supportedPromise.then((ie) => {
          if (!this.hls)
            return;
          G.supportedResult = ie;
          const X = this.hls.levels, oe = X.indexOf(G);
          ie.error ? I.warn(`[abr] MediaCapabilities decodingInfo error: "${ie.error}" for level ${oe} ${JSON.stringify(ie)}`) : ie.supported || (I.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${oe} ${JSON.stringify(ie)}`), oe > -1 && X.length > 1 && (I.log(`[abr] Removing unsupported level ${oe}`), this.hls.removeLevel(oe)));
        })) : G.supportedResult = Zo;
      }
      if (v && G.codecSet !== v || D && G.videoRange !== D || W && L > G.frameRate || !W && L > 0 && L < G.frameRate || G.supportedResult && !((N = G.supportedResult.decodingInfoResults) != null && N[0].smooth)) {
        M.push($);
        continue;
      }
      const U = G.details, P = (m ? U == null ? void 0 : U.partTarget : U == null ? void 0 : U.averagetargetduration) || w;
      let O;
      W ? O = a * e : O = o * e;
      const K = w && i >= w * 2 && r === 0 ? f[$].averageBitrate : f[$].maxBitrate, V = this.getTimeToLoadFrag(B, O, K * P, U === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        O >= K && // no level change, or new level has no error history
        ($ === u || G.loadError === 0 && G.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (V <= B || !H(V) || x && !this.bitrateTestDelay || V < c)
      ) {
        const Z = this.forcedAutoLevel;
        return $ !== p && (Z === -1 || Z !== p) && (M.length && I.trace(`[abr] Skipped level(s) ${M.join(",")} of ${s} max with CODECS and VIDEO-RANGE:"${f[M[0]].codecs}" ${f[M[0]].videoRange}; not compatible with "${y.codecs}" ${D}`), I.info(`[abr] switch candidate:${d}->${$} adjustedbw(${Math.round(O)})-bitrate=${Math.round(O - K)} ttfb:${B.toFixed(1)} avgDuration:${P.toFixed(1)} maxFetchDuration:${c.toFixed(1)} fetchDuration:${V.toFixed(1)} firstSelection:${S} codecSet:${v} videoRange:${D} hls.loadLevel:${p}`)), S && (this.firstSelection = $), $;
      }
    }
    return -1;
  }
  set nextAutoLevel(e) {
    const {
      maxAutoLevel: t,
      minAutoLevel: s
    } = this.hls, i = Math.min(Math.max(e, s), t);
    this._nextAutoLevel !== i && (this.nextAutoLevelKey = "", this._nextAutoLevel = i);
  }
}
class Dm {
  constructor() {
    this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
var Re = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class Im {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.BUFFER_APPENDED, this.onBufferAppended, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.BUFFER_APPENDED, this.onBufferAppended, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const s = this.activePartLists[t];
    if (s)
      for (let i = s.length; i--; ) {
        const r = s[i];
        if (!r)
          break;
        const o = r.end;
        if (r.start <= e && o !== null && e <= o)
          return r;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    const {
      fragments: s
    } = this, i = Object.keys(s);
    for (let r = i.length; r--; ) {
      const o = s[i[r]];
      if ((o == null ? void 0 : o.body.type) === t && o.buffered) {
        const a = o.body;
        if (a.start <= e && e <= a.end)
          return a;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, s, i) {
    this.timeRanges && (this.timeRanges[e] = t);
    const r = (i == null ? void 0 : i.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((o) => {
      const a = this.fragments[o];
      if (!a || r >= a.body.sn)
        return;
      if (!a.buffered && !a.loaded) {
        a.body.type === s && this.removeFragment(a.body);
        return;
      }
      const l = a.range[e];
      l && l.time.some((c) => {
        const u = !this.isTimeBuffered(c.startPTS, c.endPTS, t);
        return u && this.removeFragment(a.body), u;
      });
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges, {
      frag: s,
      part: i
    } = e;
    if (!t || s.sn === "initSegment")
      return;
    const r = Mt(s), o = this.fragments[r];
    if (!o || o.buffered && s.gap)
      return;
    const a = !s.relurl;
    Object.keys(t).forEach((l) => {
      const c = s.elementaryStreams[l];
      if (!c)
        return;
      const u = t[l], d = a || c.partial === !0;
      o.range[l] = this.getBufferedTimes(s, i, d, u);
    }), o.loaded = null, Object.keys(o.range).length ? (o.buffered = !0, (o.body.endList = s.endList || o.body.endList) && (this.endListFragments[o.body.type] = o), xs(o) || this.removeParts(s.sn - 1, s.type)) : this.removeFragment(o.body);
  }
  removeParts(e, t) {
    const s = this.activePartLists[t];
    s && (this.activePartLists[t] = s.filter((i) => i.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const s = Mt(e);
    let i = this.fragments[s];
    !i && t && (i = this.fragments[s] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), i && (i.loaded = null, i.buffered = !0);
  }
  getBufferedTimes(e, t, s, i) {
    const r = {
      time: [],
      partial: s
    }, o = e.start, a = e.end, l = e.minEndPTS || a, c = e.maxStartPTS || o;
    for (let u = 0; u < i.length; u++) {
      const d = i.start(u) - this.bufferPadding, h = i.end(u) + this.bufferPadding;
      if (c >= d && l <= h) {
        r.time.push({
          startPTS: Math.max(o, i.start(u)),
          endPTS: Math.min(a, i.end(u))
        });
        break;
      } else if (o < h && a > d) {
        const m = Math.max(o, i.start(u)), f = Math.min(a, i.end(u));
        f > m && (r.partial = !0, r.time.push({
          startPTS: m,
          endPTS: f
        }));
      } else if (a <= d)
        break;
    }
    return r;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, s, i, r, o = 0;
    const {
      bufferPadding: a,
      fragments: l
    } = this;
    return Object.keys(l).forEach((c) => {
      const u = l[c];
      u && xs(u) && (i = u.body.start - a, r = u.body.end + a, e >= i && e <= r && (s = Math.min(e - i, r - e), o <= s && (t = u.body, o = s)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || xs(t));
  }
  getState(e) {
    const t = Mt(e), s = this.fragments[t];
    return s ? s.buffered ? xs(s) ? Re.PARTIAL : Re.OK : Re.APPENDING : Re.NOT_LOADED;
  }
  isTimeBuffered(e, t, s) {
    let i, r;
    for (let o = 0; o < s.length; o++) {
      if (i = s.start(o) - this.bufferPadding, r = s.end(o) + this.bufferPadding, e >= i && t <= r)
        return !0;
      if (t <= i)
        return !1;
    }
    return !1;
  }
  onFragLoaded(e, t) {
    const {
      frag: s,
      part: i
    } = t;
    if (s.sn === "initSegment" || s.bitrateTest)
      return;
    const r = i ? null : t, o = Mt(s);
    this.fragments[o] = {
      body: s,
      appendedPTS: null,
      loaded: r,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: s,
      part: i,
      timeRanges: r
    } = t;
    if (s.sn === "initSegment")
      return;
    const o = s.type;
    if (i) {
      let a = this.activePartLists[o];
      a || (this.activePartLists[o] = a = []), a.push(i);
    }
    this.timeRanges = r, Object.keys(r).forEach((a) => {
      const l = r[a];
      this.detectEvictedFragments(a, l, o, i);
    });
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = Mt(e);
    return !!this.fragments[t];
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, s, i, r) {
    i && !this.hasGaps || Object.keys(this.fragments).forEach((o) => {
      const a = this.fragments[o];
      if (!a)
        return;
      const l = a.body;
      l.type !== s || i && !l.gap || l.start < t && l.end > e && (a.buffered || r) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = Mt(e);
    e.stats.loaded = 0, e.clearElementaryStreamInfo();
    const s = this.activePartLists[e.type];
    if (s) {
      const i = e.sn;
      this.activePartLists[e.type] = s.filter((r) => r.fragment.sn !== i);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
  }
}
function xs(n) {
  var e, t, s;
  return n.buffered && (n.body.gap || ((e = n.range.video) == null ? void 0 : e.partial) || ((t = n.range.audio) == null ? void 0 : t.partial) || ((s = n.range.audiovideo) == null ? void 0 : s.partial));
}
function Mt(n) {
  return `${n.type}_${n.level}_${n.sn}`;
}
const bm = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class he {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    try {
      if (e) {
        const s = he.getBuffered(e);
        for (let i = 0; i < s.length; i++)
          if (t >= s.start(i) && t <= s.end(i))
            return !0;
      }
    } catch {
    }
    return !1;
  }
  static bufferInfo(e, t, s) {
    try {
      if (e) {
        const i = he.getBuffered(e), r = [];
        let o;
        for (o = 0; o < i.length; o++)
          r.push({
            start: i.start(o),
            end: i.end(o)
          });
        return this.bufferedInfo(r, t, s);
      }
    } catch {
    }
    return {
      len: 0,
      start: t,
      end: t,
      nextStart: void 0
    };
  }
  static bufferedInfo(e, t, s) {
    t = Math.max(0, t), e.sort(function(c, u) {
      const d = c.start - u.start;
      return d || u.end - c.end;
    });
    let i = [];
    if (s)
      for (let c = 0; c < e.length; c++) {
        const u = i.length;
        if (u) {
          const d = i[u - 1].end;
          e[c].start - d < s ? e[c].end > d && (i[u - 1].end = e[c].end) : i.push(e[c]);
        } else
          i.push(e[c]);
      }
    else
      i = e;
    let r = 0, o, a = t, l = t;
    for (let c = 0; c < i.length; c++) {
      const u = i[c].start, d = i[c].end;
      if (t + s >= u && t < d)
        a = u, l = d, r = l - t;
      else if (t + s < u) {
        o = u;
        break;
      }
    }
    return {
      len: r,
      start: a || 0,
      end: l || 0,
      nextStart: o
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered;
    } catch (t) {
      return I.log("failed to get media.buffered", t), bm;
    }
  }
}
class di {
  constructor(e, t, s, i = 0, r = -1, o = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = vs(), this.buffering = {
      audio: vs(),
      video: vs(),
      audiovideo: vs()
    }, this.level = e, this.sn = t, this.id = s, this.size = i, this.part = r, this.partial = o;
  }
}
function vs() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
function ws(n, e) {
  for (let s = 0, i = n.length; s < i; s++) {
    var t;
    if (((t = n[s]) == null ? void 0 : t.cc) === e)
      return n[s];
  }
  return null;
}
function _m(n, e, t) {
  return !!(e && (t.endCC > t.startCC || n && n.cc < t.startCC));
}
function Cm(n, e) {
  const t = n.fragments, s = e.fragments;
  if (!s.length || !t.length) {
    I.log("No fragments to align");
    return;
  }
  const i = ws(t, s[0].cc);
  if (!i || i && !i.startPTS) {
    I.log("No frag in previous level to align on");
    return;
  }
  return i;
}
function kr(n, e) {
  if (n) {
    const t = n.start + e;
    n.start = n.startPTS = t, n.endPTS = t + n.duration;
  }
}
function Jo(n, e) {
  const t = e.fragments;
  for (let s = 0, i = t.length; s < i; s++)
    kr(t[s], n);
  e.fragmentHint && kr(e.fragmentHint, n), e.alignedSliding = !0;
}
function wm(n, e, t) {
  e && (Mm(n, t, e), !t.alignedSliding && e && js(t, e), !t.alignedSliding && e && !t.skippedSegments && zo(e, t));
}
function Mm(n, e, t) {
  if (_m(n, t, e)) {
    const s = Cm(t, e);
    s && H(s.start) && (I.log(`Adjusting PTS using last level due to CC increase within current level ${e.url}`), Jo(s.start, e));
  }
}
function js(n, e) {
  if (!n.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = n.fragments, s = e.fragments;
  if (!t.length || !s.length)
    return;
  let i, r;
  const o = Math.min(e.endCC, n.endCC);
  e.startCC < o && n.startCC < o && (i = ws(s, o), r = ws(t, o)), (!i || !r) && (i = s[Math.floor(s.length / 2)], r = ws(t, i.cc) || t[Math.floor(t.length / 2)]);
  const a = i.programDateTime, l = r.programDateTime;
  if (!a || !l)
    return;
  const c = (l - a) / 1e3 - (r.start - i.start);
  Jo(c, n);
}
const Fr = Math.pow(2, 17);
class km {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const s = e.url;
    if (!s)
      return Promise.reject(new ot({
        type: Q.NETWORK_ERROR,
        details: C.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${s ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const i = this.config, r = i.fLoader, o = i.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((m) => m[0] === "GAP")) {
          l(Or(e));
          return;
        } else
          e.gap = !1;
      const c = this.loader = e.loader = r ? new r(i) : new o(i), u = Pr(e), d = Cr(i.fragLoadPolicy.default), h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : Fr
      };
      e.stats = c.stats, c.load(u, h, {
        onSuccess: (m, f, g, p) => {
          this.resetLoader(e, c);
          let E = m.data;
          g.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(E.slice(0, 16)), E = E.slice(16)), a({
            frag: e,
            part: null,
            payload: E,
            networkDetails: p
          });
        },
        onError: (m, f, g, p) => {
          this.resetLoader(e, c), l(new ot({
            type: Q.NETWORK_ERROR,
            details: C.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: De({
              url: s,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: g,
            stats: p
          }));
        },
        onAbort: (m, f, g) => {
          this.resetLoader(e, c), l(new ot({
            type: Q.NETWORK_ERROR,
            details: C.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: g,
            stats: m
          }));
        },
        onTimeout: (m, f, g) => {
          this.resetLoader(e, c), l(new ot({
            type: Q.NETWORK_ERROR,
            details: C.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${h.timeout}ms`),
            networkDetails: g,
            stats: m
          }));
        },
        onProgress: (m, f, g, p) => {
          t && t({
            frag: e,
            part: null,
            payload: g,
            networkDetails: p
          });
        }
      });
    });
  }
  loadPart(e, t, s) {
    this.abort();
    const i = this.config, r = i.fLoader, o = i.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l(Or(e, t));
        return;
      }
      const c = this.loader = e.loader = r ? new r(i) : new o(i), u = Pr(e, t), d = Cr(i.fragLoadPolicy.default), h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: Fr
      };
      t.stats = c.stats, c.load(u, h, {
        onSuccess: (m, f, g, p) => {
          this.resetLoader(e, c), this.updateStatsFromPart(e, t);
          const E = {
            frag: e,
            part: t,
            payload: m.data,
            networkDetails: p
          };
          s(E), a(E);
        },
        onError: (m, f, g, p) => {
          this.resetLoader(e, c), l(new ot({
            type: Q.NETWORK_ERROR,
            details: C.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: De({
              url: u.url,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: g,
            stats: p
          }));
        },
        onAbort: (m, f, g) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, c), l(new ot({
            type: Q.NETWORK_ERROR,
            details: C.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: g,
            stats: m
          }));
        },
        onTimeout: (m, f, g) => {
          this.resetLoader(e, c), l(new ot({
            type: Q.NETWORK_ERROR,
            details: C.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${h.timeout}ms`),
            networkDetails: g,
            stats: m
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const s = e.stats, i = t.stats, r = i.total;
    if (s.loaded += i.loaded, r) {
      const l = Math.round(e.duration / t.duration), c = Math.min(Math.round(s.loaded / r), l), d = (l - c) * Math.round(s.loaded / c);
      s.total = s.loaded + d;
    } else
      s.total = Math.max(s.loaded, s.total);
    const o = s.loading, a = i.loading;
    o.start ? o.first += a.first - a.start : (o.start = a.start, o.first = a.first), o.end = a.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function Pr(n, e = null) {
  const t = e || n, s = {
    frag: n,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, i = t.byteRangeStartOffset, r = t.byteRangeEndOffset;
  if (H(i) && H(r)) {
    var o;
    let a = i, l = r;
    if (n.sn === "initSegment" && ((o = n.decryptdata) == null ? void 0 : o.method) === "AES-128") {
      const c = r - i;
      c % 16 && (l = r + (16 - c % 16)), i !== 0 && (s.resetIV = !0, a = i - 16);
    }
    s.rangeStart = a, s.rangeEnd = l;
  }
  return s;
}
function Or(n, e) {
  const t = new Error(`GAP ${n.gap ? "tag" : "attribute"} found`), s = {
    type: Q.MEDIA_ERROR,
    details: C.FRAG_GAP,
    fatal: !1,
    frag: n,
    error: t,
    networkDetails: null
  };
  return e && (s.part = e), (e || n).stats.aborted = !0, new ot(s);
}
class ot extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class Fm {
  constructor(e, t) {
    this.subtle = void 0, this.aesIV = void 0, this.subtle = e, this.aesIV = t;
  }
  decrypt(e, t) {
    return this.subtle.decrypt({
      name: "AES-CBC",
      iv: this.aesIV
    }, t, e);
  }
}
class Pm {
  constructor(e, t) {
    this.subtle = void 0, this.key = void 0, this.subtle = e, this.key = t;
  }
  expandKey() {
    return this.subtle.importKey("raw", this.key, {
      name: "AES-CBC"
    }, !1, ["encrypt", "decrypt"]);
  }
}
function Om(n) {
  const e = n.byteLength, t = e && new DataView(n.buffer).getUint8(e - 1);
  return t ? vt(n, 0, e - t) : n;
}
class Nm {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), s = new Uint32Array(4);
    for (let i = 0; i < 4; i++)
      s[i] = t.getUint32(i * 4);
    return s;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, s = this.subMix, i = s[0], r = s[1], o = s[2], a = s[3], l = this.invSubMix, c = l[0], u = l[1], d = l[2], h = l[3], m = new Uint32Array(256);
    let f = 0, g = 0, p = 0;
    for (p = 0; p < 256; p++)
      p < 128 ? m[p] = p << 1 : m[p] = p << 1 ^ 283;
    for (p = 0; p < 256; p++) {
      let E = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4;
      E = E >>> 8 ^ E & 255 ^ 99, e[f] = E, t[E] = f;
      const y = m[f], x = m[y], S = m[x];
      let v = m[E] * 257 ^ E * 16843008;
      i[f] = v << 24 | v >>> 8, r[f] = v << 16 | v >>> 16, o[f] = v << 8 | v >>> 24, a[f] = v, v = S * 16843009 ^ x * 65537 ^ y * 257 ^ f * 16843008, c[E] = v << 24 | v >>> 8, u[E] = v << 16 | v >>> 16, d[E] = v << 8 | v >>> 24, h[E] = v, f ? (f = y ^ m[m[m[S ^ y]]], g ^= m[m[g]]) : f = g = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let s = !0, i = 0;
    for (; i < t.length && s; )
      s = t[i] === this.key[i], i++;
    if (s)
      return;
    this.key = t;
    const r = this.keySize = t.length;
    if (r !== 4 && r !== 6 && r !== 8)
      throw new Error("Invalid aes key size=" + r);
    const o = this.ksRows = (r + 6 + 1) * 4;
    let a, l;
    const c = this.keySchedule = new Uint32Array(o), u = this.invKeySchedule = new Uint32Array(o), d = this.sBox, h = this.rcon, m = this.invSubMix, f = m[0], g = m[1], p = m[2], E = m[3];
    let y, x;
    for (a = 0; a < o; a++) {
      if (a < r) {
        y = c[a] = t[a];
        continue;
      }
      x = y, a % r === 0 ? (x = x << 8 | x >>> 24, x = d[x >>> 24] << 24 | d[x >>> 16 & 255] << 16 | d[x >>> 8 & 255] << 8 | d[x & 255], x ^= h[a / r | 0] << 24) : r > 6 && a % r === 4 && (x = d[x >>> 24] << 24 | d[x >>> 16 & 255] << 16 | d[x >>> 8 & 255] << 8 | d[x & 255]), c[a] = y = (c[a - r] ^ x) >>> 0;
    }
    for (l = 0; l < o; l++)
      a = o - l, l & 3 ? x = c[a] : x = c[a - 4], l < 4 || a <= 4 ? u[l] = x : u[l] = f[d[x >>> 24]] ^ g[d[x >>> 16 & 255]] ^ p[d[x >>> 8 & 255]] ^ E[d[x & 255]], u[l] = u[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, s) {
    const i = this.keySize + 6, r = this.invKeySchedule, o = this.invSBox, a = this.invSubMix, l = a[0], c = a[1], u = a[2], d = a[3], h = this.uint8ArrayToUint32Array_(s);
    let m = h[0], f = h[1], g = h[2], p = h[3];
    const E = new Int32Array(e), y = new Int32Array(E.length);
    let x, S, v, D, L, _, A, R, w, B, M, N, $, G;
    const W = this.networkToHostOrderSwap;
    for (; t < E.length; ) {
      for (w = W(E[t]), B = W(E[t + 1]), M = W(E[t + 2]), N = W(E[t + 3]), L = w ^ r[0], _ = N ^ r[1], A = M ^ r[2], R = B ^ r[3], $ = 4, G = 1; G < i; G++)
        x = l[L >>> 24] ^ c[_ >> 16 & 255] ^ u[A >> 8 & 255] ^ d[R & 255] ^ r[$], S = l[_ >>> 24] ^ c[A >> 16 & 255] ^ u[R >> 8 & 255] ^ d[L & 255] ^ r[$ + 1], v = l[A >>> 24] ^ c[R >> 16 & 255] ^ u[L >> 8 & 255] ^ d[_ & 255] ^ r[$ + 2], D = l[R >>> 24] ^ c[L >> 16 & 255] ^ u[_ >> 8 & 255] ^ d[A & 255] ^ r[$ + 3], L = x, _ = S, A = v, R = D, $ = $ + 4;
      x = o[L >>> 24] << 24 ^ o[_ >> 16 & 255] << 16 ^ o[A >> 8 & 255] << 8 ^ o[R & 255] ^ r[$], S = o[_ >>> 24] << 24 ^ o[A >> 16 & 255] << 16 ^ o[R >> 8 & 255] << 8 ^ o[L & 255] ^ r[$ + 1], v = o[A >>> 24] << 24 ^ o[R >> 16 & 255] << 16 ^ o[L >> 8 & 255] << 8 ^ o[_ & 255] ^ r[$ + 2], D = o[R >>> 24] << 24 ^ o[L >> 16 & 255] << 16 ^ o[_ >> 8 & 255] << 8 ^ o[A & 255] ^ r[$ + 3], y[t] = W(x ^ m), y[t + 1] = W(D ^ f), y[t + 2] = W(v ^ g), y[t + 3] = W(S ^ p), m = w, f = B, g = M, p = N, t = t + 4;
    }
    return y.buffer;
  }
}
const Um = 16;
class hi {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const s = self.crypto;
        s && (this.subtle = s.subtle || s.webkitSubtle);
      } catch {
      }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const s = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? Om(s) : s;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, s) {
    return this.useSoftware ? new Promise((i, r) => {
      this.softwareDecrypt(new Uint8Array(e), t, s);
      const o = this.flush();
      o ? i(o.buffer) : r(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, s);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, s) {
    const {
      currentIV: i,
      currentResult: r,
      remainderData: o
    } = this;
    this.logOnce("JS AES decrypt"), o && (e = $e(o, e), this.remainderData = null);
    const a = this.getValidChunk(e);
    if (!a.length)
      return null;
    i && (s = i);
    let l = this.softwareDecrypter;
    l || (l = this.softwareDecrypter = new Nm()), l.expandKey(t);
    const c = r;
    return this.currentResult = l.decrypt(a.buffer, 0, s), this.currentIV = vt(a, -16).buffer, c || null;
  }
  webCryptoDecrypt(e, t, s) {
    if (this.key !== t || !this.fastAesKey) {
      if (!this.subtle)
        return Promise.resolve(this.onWebCryptoError(e, t, s));
      this.key = t, this.fastAesKey = new Pm(this.subtle, t);
    }
    return this.fastAesKey.expandKey().then((i) => this.subtle ? (this.logOnce("WebCrypto AES decrypt"), new Fm(this.subtle, new Uint8Array(s)).decrypt(e.buffer, i)) : Promise.reject(new Error("web crypto not initialized"))).catch((i) => (I.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${i.name}: ${i.message}`), this.onWebCryptoError(e, t, s)));
  }
  onWebCryptoError(e, t, s) {
    this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, s);
    const i = this.flush();
    if (i)
      return i.buffer;
    throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const s = e.length - e.length % Um;
    return s !== e.length && (t = vt(e, 0, s), this.remainderData = vt(e, s)), t;
  }
  logOnce(e) {
    this.logEnabled && (I.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const Bm = {
  toString: function(n) {
    let e = "";
    const t = n.length;
    for (let s = 0; s < t; s++)
      e += `[${n.start(s).toFixed(3)}-${n.end(s).toFixed(3)}]`;
    return e;
  }
}, k = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class fi extends Dm {
  constructor(e, t, s, i, r) {
    super(), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = k.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.loadedmetadata = !1, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.onvseeking = null, this.onvended = null, this.logPrefix = "", this.log = void 0, this.warn = void 0, this.playlistType = r, this.logPrefix = i, this.log = I.log.bind(I, `${i}:`), this.warn = I.warn.bind(I, `${i}:`), this.hls = e, this.fragmentLoader = new km(e.config), this.keyLoader = s, this.fragmentTracker = t, this.config = e.config, this.decrypter = new hi(e.config), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(e) {
  }
  stopLoad() {
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = k.STOPPED;
  }
  _streamEnded(e, t) {
    if (t.live || e.nextStart || !e.end || !this.media)
      return !1;
    const s = t.partList;
    if (s != null && s.length) {
      const r = s[s.length - 1];
      return he.isBuffered(this.media, r.start + r.duration / 2);
    }
    const i = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(i);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var e;
      return (e = this.levelLastLoaded) == null ? void 0 : e.details;
    }
  }
  onMediaAttached(e, t) {
    const s = this.media = this.mediaBuffer = t.media;
    this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), s.addEventListener("seeking", this.onvseeking), s.addEventListener("ended", this.onvended);
    const i = this.config;
    this.levels && i.autoStartLoad && this.state === k.STOPPED && this.startLoad(i.startPosition);
  }
  onMediaDetaching() {
    const e = this.media;
    e != null && e.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), e && this.onvseeking && this.onvended && (e.removeEventListener("seeking", this.onvseeking), e.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config: e,
      fragCurrent: t,
      media: s,
      mediaBuffer: i,
      state: r
    } = this, o = s ? s.currentTime : 0, a = he.bufferInfo(i || s, o, e.maxBufferHole);
    if (this.log(`media seeking to ${H(o) ? o.toFixed(3) : o}, state: ${r}`), this.state === k.ENDED)
      this.resetLoadingState();
    else if (t) {
      const l = e.maxFragLookUpTolerance, c = t.start - l, u = t.start + t.duration + l;
      if (!a.len || u < a.start || c > a.end) {
        const d = o > u;
        (o < c || d) && (d && t.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), t.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
      }
    }
    s && (this.fragmentTracker.removeFragmentsInRange(o, 1 / 0, this.playlistType, !0), this.lastCurrentTime = o), !this.loadedmetadata && !a.len && (this.nextLoadPosition = this.startPosition = o), this.tickImmediate();
  }
  onMediaEnded() {
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset, this.initPTS = [];
  }
  onHandlerDestroying() {
    this.hls.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), this.stopLoad(), super.onHandlerDestroying(), this.hls = null;
  }
  onHandlerDestroyed() {
    this.state = k.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, s) {
    this._loadFragForPlayback(e, t, s);
  }
  _loadFragForPlayback(e, t, s) {
    const i = (r) => {
      if (this.fragContextChanged(e)) {
        this.warn(`Fragment ${e.sn}${r.part ? " p: " + r.part.index : ""} of level ${e.level} was dropped during download.`), this.fragmentTracker.removeFragment(e);
        return;
      }
      e.stats.chunkCount++, this._handleFragmentLoadProgress(r);
    };
    this._doFragLoad(e, t, s, i).then((r) => {
      if (!r)
        return;
      const o = this.state;
      if (this.fragContextChanged(e)) {
        (o === k.FRAG_LOADING || !this.fragCurrent && o === k.PARSING) && (this.fragmentTracker.removeFragment(e), this.state = k.IDLE);
        return;
      }
      "payload" in r && (this.log(`Loaded fragment ${e.sn} of level ${e.level}`), this.hls.trigger(T.FRAG_LOADED, r)), this._handleFragmentLoadComplete(r);
    }).catch((r) => {
      this.state === k.STOPPED || this.state === k.ERROR || (this.warn(`Frag error: ${(r == null ? void 0 : r.message) || r}`), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: s
    } = this;
    if (s.getState(e) === Re.APPENDING) {
      const r = e.type, o = this.getFwdBufferInfo(this.mediaBuffer, r), a = Math.max(e.duration, o ? o.len : this.config.maxBufferLength), l = this.backtrackFragment;
      ((l ? e.sn - l.sn : 0) === 1 || this.reduceMaxBufferLength(a, e.duration)) && s.removeFragment(e);
    } else ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? s.removeAllFragments() : s.hasParts(e.type) && (s.detectPartialFragments({
      frag: e,
      part: null,
      stats: e.stats,
      id: e.type
    }), s.getState(e) === Re.PARTIAL && s.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  flushMainBuffer(e, t, s = null) {
    if (!(e - t))
      return;
    const i = {
      startOffset: e,
      endOffset: t,
      type: s
    };
    this.hls.trigger(T.BUFFER_FLUSHING, i);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((s) => {
      if (!s || this.fragContextChanged(e) || !this.levels)
        throw new Error("init load aborted");
      return s;
    }).then((s) => {
      const {
        hls: i
      } = this, {
        payload: r
      } = s, o = e.decryptdata;
      if (r && r.byteLength > 0 && o != null && o.key && o.iv && o.method === "AES-128") {
        const a = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(r), o.key.buffer, o.iv.buffer).catch((l) => {
          throw i.trigger(T.ERROR, {
            type: Q.MEDIA_ERROR,
            details: C.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: l,
            reason: l.message,
            frag: e
          }), l;
        }).then((l) => {
          const c = self.performance.now();
          return i.trigger(T.FRAG_DECRYPTED, {
            frag: e,
            payload: l,
            stats: {
              tstart: a,
              tdecrypt: c
            }
          }), s.payload = l, this.completeInitSegmentLoad(s);
        });
      }
      return this.completeInitSegmentLoad(s);
    }).catch((s) => {
      this.state === k.STOPPED || this.state === k.ERROR || (this.warn(s), this.resetFragmentLoading(e));
    });
  }
  completeInitSegmentLoad(e) {
    const {
      levels: t
    } = this;
    if (!t)
      throw new Error("init load aborted, missing levels");
    const s = e.frag.stats;
    this.state = k.IDLE, e.frag.data = new Uint8Array(e.payload), s.parsing.start = s.buffering.start = self.performance.now(), s.parsing.end = s.buffering.end = self.performance.now(), this.tick();
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.sn !== t.sn || e.level !== t.level;
  }
  fragBufferedComplete(e, t) {
    var s, i, r, o;
    const a = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.playlistType === j.MAIN ? "level" : "track"} ${e.level} (frag:[${((s = e.startPTS) != null ? s : NaN).toFixed(3)}-${((i = e.endPTS) != null ? i : NaN).toFixed(3)}] > buffer:${a ? Bm.toString(he.getBuffered(a)) : "(detached)"})`), e.sn !== "initSegment") {
      var l;
      if (e.type !== j.SUBTITLE) {
        const u = e.elementaryStreams;
        if (!Object.keys(u).some((d) => !!u[d])) {
          this.state = k.IDLE;
          return;
        }
      }
      const c = (l = this.levels) == null ? void 0 : l[e.level];
      c != null && c.fragmentError && (this.log(`Resetting level fragment error count of ${c.fragmentError} on frag buffered`), c.fragmentError = 0);
    }
    this.state = k.IDLE, a && (!this.loadedmetadata && e.type == j.MAIN && a.buffered.length && ((r = this.fragCurrent) == null ? void 0 : r.sn) === ((o = this.fragPrevious) == null ? void 0 : o.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
  }
  seekToStartPos() {
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: s,
      part: i,
      partsLoaded: r
    } = e, o = !r || r.length === 0 || r.some((l) => !l), a = new di(s.level, s.sn, s.stats.chunkCount + 1, 0, i ? i.index : -1, !o);
    t.flush(a);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, s = null, i) {
    var r;
    const o = t == null ? void 0 : t.details;
    if (!this.levels || !o)
      throw new Error(`frag load aborted, missing level${o ? "" : " detail"}s`);
    let a = null;
    if (e.encrypted && !((r = e.decryptdata) != null && r.key) ? (this.log(`Loading key for ${e.sn} of [${o.startSN}-${o.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${e.level}`), this.state = k.KEY_LOADING, this.fragCurrent = e, a = this.keyLoader.load(e).then((u) => {
      if (!this.fragContextChanged(u.frag))
        return this.hls.trigger(T.KEY_LOADED, u), this.state === k.KEY_LOADING && (this.state = k.IDLE), u;
    }), this.hls.trigger(T.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (a = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : !e.encrypted && o.encryptedFragments.length && this.keyLoader.loadClear(e, o.encryptedFragments), s = Math.max(e.start, s || 0), this.config.lowLatencyMode && e.sn !== "initSegment") {
      const u = o.partList;
      if (u && i) {
        s > e.end && o.fragmentHint && (e = o.fragmentHint);
        const d = this.getNextPart(u, e, s);
        if (d > -1) {
          const h = u[d];
          this.log(`Loading part sn: ${e.sn} p: ${h.index} cc: ${e.cc} of playlist [${o.startSN}-${o.endSN}] parts [0-${d}-${u.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(s.toFixed(3))}`), this.nextLoadPosition = h.start + h.duration, this.state = k.FRAG_LOADING;
          let m;
          return a ? m = a.then((f) => !f || this.fragContextChanged(f.frag) ? null : this.doFragPartsLoad(e, h, t, i)).catch((f) => this.handleFragLoadError(f)) : m = this.doFragPartsLoad(e, h, t, i).catch((f) => this.handleFragLoadError(f)), this.hls.trigger(T.FRAG_LOADING, {
            frag: e,
            part: h,
            targetBufferTime: s
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : m;
        } else if (!e.url || this.loadedEndOfParts(u, s))
          return Promise.resolve(null);
      }
    }
    this.log(`Loading fragment ${e.sn} cc: ${e.cc} ${o ? "of [" + o.startSN + "-" + o.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(s.toFixed(3))}`), H(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = k.FRAG_LOADING;
    const l = this.config.progressive;
    let c;
    return l && a ? c = a.then((u) => !u || this.fragContextChanged(u == null ? void 0 : u.frag) ? null : this.fragmentLoader.load(e, i)).catch((u) => this.handleFragLoadError(u)) : c = Promise.all([this.fragmentLoader.load(e, l ? i : void 0), a]).then(([u]) => (!l && u && i && i(u), u)).catch((u) => this.handleFragLoadError(u)), this.hls.trigger(T.FRAG_LOADING, {
      frag: e,
      targetBufferTime: s
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : c;
  }
  doFragPartsLoad(e, t, s, i) {
    return new Promise((r, o) => {
      var a;
      const l = [], c = (a = s.details) == null ? void 0 : a.partList, u = (d) => {
        this.fragmentLoader.loadPart(e, d, i).then((h) => {
          l[d.index] = h;
          const m = h.part;
          this.hls.trigger(T.FRAG_LOADED, h);
          const f = br(s, e.sn, d.index + 1) || jo(c, e.sn, d.index + 1);
          if (f)
            u(f);
          else
            return r({
              frag: e,
              part: m,
              partsLoaded: l
            });
        }).catch(o);
      };
      u(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      e.data && t.details === C.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(T.ERROR, t);
    } else
      this.hls.trigger(T.ERROR, {
        type: Q.OTHER_ERROR,
        details: C.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== k.PARSING) {
      !this.fragCurrent && this.state !== k.STOPPED && this.state !== k.ERROR && (this.state = k.IDLE);
      return;
    }
    const {
      frag: s,
      part: i,
      level: r
    } = t, o = self.performance.now();
    s.stats.parsing.end = o, i && (i.stats.parsing.end = o), this.updateLevelTiming(s, i, r, e.partial);
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: s
    } = this, {
      level: i,
      sn: r,
      part: o
    } = e;
    if (!(t != null && t[i]))
      return this.warn(`Levels object was unset while buffering fragment ${r} of level ${i}. The current chunk will not be buffered.`), null;
    const a = t[i], l = o > -1 ? br(a, r, o) : null, c = l ? l.fragment : am(a, r, s);
    return c ? (s && s !== c && (c.stats = s.stats), {
      frag: c,
      part: l,
      level: a
    }) : null;
  }
  bufferFragmentData(e, t, s, i, r) {
    var o;
    if (!e || this.state !== k.PARSING)
      return;
    const {
      data1: a,
      data2: l
    } = e;
    let c = a;
    if (a && l && (c = $e(a, l)), !((o = c) != null && o.length))
      return;
    const u = {
      type: e.type,
      frag: t,
      part: s,
      chunkMeta: i,
      parent: t.type,
      data: c
    };
    if (this.hls.trigger(T.BUFFER_APPENDING, u), e.dropped && e.independent && !s) {
      if (r)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!he.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const s = t.currentTime, i = he.bufferInfo(t, s, 0), r = e.duration, o = Math.min(this.config.maxFragLookUpTolerance * 2, r * 0.25), a = Math.max(Math.min(e.start - o, i.end - o), s + o);
    e.start - a > o && this.flushMainBuffer(a, e.start);
  }
  getFwdBufferInfo(e, t) {
    const s = this.getLoadPosition();
    return H(s) ? this.getFwdBufferInfoAtPos(e, s, t) : null;
  }
  getFwdBufferInfoAtPos(e, t, s) {
    const {
      config: {
        maxBufferHole: i
      }
    } = this, r = he.bufferInfo(e, t, i);
    if (r.len === 0 && r.nextStart !== void 0) {
      const o = this.fragmentTracker.getBufferedFrag(t, s);
      if (o && r.nextStart < o.end)
        return he.bufferInfo(e, t, Math.max(r.nextStart, i));
    }
    return r;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let s;
    return e ? s = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : s = t.maxBufferLength, Math.min(s, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e, t) {
    const s = this.config, i = Math.max(Math.min(e - t, s.maxBufferLength), t), r = Math.max(e - t * 3, s.maxMaxBufferLength / 2, i);
    return r >= i ? (s.maxMaxBufferLength = r, this.warn(`Reduce max buffer length to ${r}s`), !0) : !1;
  }
  getAppendedFrag(e, t = j.MAIN) {
    const s = this.fragmentTracker.getAppendedFrag(e, j.MAIN);
    return s && "fragment" in s ? s.fragment : s;
  }
  getNextFragment(e, t) {
    const s = t.fragments, i = s.length;
    if (!i)
      return null;
    const {
      config: r
    } = this, o = s[0].start;
    let a;
    if (t.live) {
      const l = r.initialLiveManifestSize;
      if (i < l)
        return this.warn(`Not enough fragments to start playback (have: ${i}, need: ${l})`), null;
      (!t.PTSKnown && !this.startFragRequested && this.startPosition === -1 || e < o) && (a = this.getInitialLiveFragment(t, s), this.startPosition = this.nextLoadPosition = a ? this.hls.liveSyncPosition || a.start : e);
    } else e <= o && (a = s[0]);
    if (!a) {
      const l = r.lowLatencyMode ? t.partEnd : t.fragmentEnd;
      a = this.getFragmentAtPosition(e, l, t);
    }
    return this.mapToInitFragWhenRequired(a);
  }
  isLoopLoading(e, t) {
    const s = this.fragmentTracker.getState(e);
    return (s === Re.OK || s === Re.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, s, i, r) {
    const o = e.gap, a = this.getNextFragment(this.nextLoadPosition, t);
    if (a === null)
      return a;
    if (e = a, o && e && !e.gap && s.nextStart) {
      const l = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, s.nextStart, i);
      if (l !== null && s.len + l.len >= r)
        return this.log(`buffer full after gaps in "${i}" playlist starting at sn: ${e.sn}`), null;
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !(e != null && e.initSegment.data) && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, s) {
    let i = -1, r = !1, o = !0;
    for (let a = 0, l = e.length; a < l; a++) {
      const c = e[a];
      if (o = o && !c.independent, i > -1 && s < c.start)
        break;
      const u = c.loaded;
      u ? i = -1 : (r || c.independent || o) && c.fragment === t && (i = a), r = u;
    }
    return i;
  }
  loadedEndOfParts(e, t) {
    const s = e[e.length - 1];
    return s && t > s.start && s.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e, t) {
    const s = this.fragPrevious;
    let i = null;
    if (s) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${s.programDateTime}`), i = cm(t, s.endProgramDateTime, this.config.maxFragLookUpTolerance)), !i) {
        const r = s.sn + 1;
        if (r >= e.startSN && r <= e.endSN) {
          const o = t[r - e.startSN];
          s.cc === o.cc && (i = o, this.log(`Live playlist, switching playlist, load frag with next SN: ${i.sn}`));
        }
        i || (i = hm(t, s.cc), i && this.log(`Live playlist, switching playlist, load frag with same CC: ${i.sn}`));
      }
    } else {
      const r = this.hls.liveSyncPosition;
      r !== null && (i = this.getFragmentAtPosition(r, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return i;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, s) {
    const {
      config: i
    } = this;
    let {
      fragPrevious: r
    } = this, {
      fragments: o,
      endSN: a
    } = s;
    const {
      fragmentHint: l
    } = s, {
      maxFragLookUpTolerance: c
    } = i, u = s.partList, d = !!(i.lowLatencyMode && u != null && u.length && l);
    d && l && !this.bitrateTest && (o = o.concat(l), a = l.sn);
    let h;
    if (e < t) {
      const m = e > t - c ? 0 : c;
      h = zs(r, o, e, m);
    } else
      h = o[o.length - 1];
    if (h) {
      const m = h.sn - s.startSN, f = this.fragmentTracker.getState(h);
      if ((f === Re.OK || f === Re.PARTIAL && h.gap) && (r = h), r && h.sn === r.sn && (!d || u[0].fragment.sn > h.sn) && r && h.level === r.level) {
        const p = o[m + 1];
        h.sn < a && this.fragmentTracker.getState(p) !== Re.OK ? h = p : h = null;
      }
    }
    return h;
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: s
    } = this;
    if (!s)
      return;
    const i = this.hls.liveSyncPosition, r = s.currentTime, o = e.fragments[0].start, a = e.edge, l = r >= o - t.maxFragLookUpTolerance && r <= a;
    if (i !== null && s.duration > i && (r < i || !l)) {
      const c = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      (!l && s.readyState < 4 || r < a - c) && (this.loadedmetadata || (this.nextLoadPosition = i), s.readyState && (this.warn(`Playback: ${r.toFixed(3)} is located too far from the end of live sliding playlist: ${a}, reset currentTime to : ${i.toFixed(3)}`), s.currentTime = i));
    }
  }
  alignPlaylists(e, t, s) {
    const i = e.fragments.length;
    if (!i)
      return this.warn("No fragments in live playlist"), 0;
    const r = e.fragments[0].start, o = !t, a = e.alignedSliding && H(r);
    if (o || !a && !r) {
      const {
        fragPrevious: l
      } = this;
      wm(l, s, e);
      const c = e.fragments[0].start;
      return this.log(`Live playlist sliding: ${c.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} prev-sn: ${l ? l.sn : "na"} fragments: ${i}`), c;
    }
    return r;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let s = this.startPosition;
    if (s < t && (s = -1), s === -1 || this.lastCurrentTime === -1) {
      const i = this.startTimeOffset !== null, r = i ? this.startTimeOffset : e.startTimeOffset;
      r !== null && H(r) ? (s = t + r, r < 0 && (s += e.totalduration), s = Math.min(Math.max(t, s), t + e.totalduration), this.log(`Start time offset ${r} found in ${i ? "multivariant" : "media"} playlist, adjust startPosition to ${s}`), this.startPosition = s) : e.live ? s = this.hls.liveSyncPosition || t : this.startPosition = s = 0, this.lastCurrentTime = s;
    }
    this.nextLoadPosition = s;
  }
  getLoadPosition() {
    const {
      media: e
    } = this;
    let t = 0;
    return this.loadedmetadata && e ? t = e.currentTime : this.nextLoadPosition && (t = this.nextLoadPosition), t;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.sn !== "initSegment" && e.stats.aborted && (this.warn(`Fragment ${e.sn}${t ? " part " + t.index : ""} of level ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== k.FRAG_LOADING_WAITING_RETRY) && (this.state = k.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    if (t.chunkMeta && !t.frag) {
      const u = this.getCurrentContext(t.chunkMeta);
      u && (t.frag = u.frag);
    }
    const s = t.frag;
    if (!s || s.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(s)) {
      var i;
      this.warn(`Frag load error must match current frag to retry ${s.url} > ${(i = this.fragCurrent) == null ? void 0 : i.url}`);
      return;
    }
    const r = t.details === C.FRAG_GAP;
    r && this.fragmentTracker.fragBuffered(s, !0);
    const o = t.errorAction, {
      action: a,
      retryCount: l = 0,
      retryConfig: c
    } = o || {};
    if (o && a === be.RetryRequest && c) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const u = ci(c, l);
      this.warn(`Fragment ${s.sn} of ${e} ${s.level} errored with ${t.details}, retrying loading ${l + 1}/${c.maxNumRetry} in ${u}ms`), o.resolved = !0, this.retryDate = self.performance.now() + u, this.state = k.FRAG_LOADING_WAITING_RETRY;
    } else if (c && o)
      if (this.resetFragmentErrors(e), l < c.maxNumRetry)
        !r && a !== be.RemoveAlternatePermanently && (o.resolved = !0);
      else {
        I.warn(`${t.details} reached or exceeded max retry (${l})`);
        return;
      }
    else (o == null ? void 0 : o.action) === be.SendAlternateToPenaltyBox ? this.state = k.WAITING_LEVEL : this.state = k.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === k.PARSING || this.state === k.PARSED) {
      const t = e.frag, s = e.parent, i = this.getFwdBufferInfo(this.mediaBuffer, s), r = i && i.len > 0.5;
      r && this.reduceMaxBufferLength(i.len, (t == null ? void 0 : t.duration) || 10);
      const o = !r;
      return o && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${s} buffer`), t && (this.fragmentTracker.removeFragment(t), this.nextLoadPosition = t.start), this.resetLoadingState(), o;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === j.AUDIO && (this.fragCurrent = null), this.loadedmetadata || (this.startFragRequested = !1), this.state !== k.STOPPED && (this.state = k.IDLE);
  }
  afterBufferFlushed(e, t, s) {
    if (!e)
      return;
    const i = he.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, i, s), this.state === k.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = k.IDLE;
  }
  resetStartWhenNotLoaded(e) {
    if (!this.loadedmetadata) {
      this.startFragRequested = !1;
      const t = e ? e.details : null;
      t != null && t.live ? (this.startPosition = -1, this.setStartPosition(t, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    this.warn(`The loading context changed while buffering fragment ${e.sn} of level ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, s, i) {
    var r;
    const o = s.details;
    if (!o) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(e.elementaryStreams).reduce((l, c) => {
      const u = e.elementaryStreams[c];
      if (u) {
        const d = u.endPTS - u.startPTS;
        if (d <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${c} duration reliably (${d})`), l || !1;
        const h = i ? 0 : qo(o, e, u.startPTS, u.endPTS, u.startDTS, u.endDTS);
        return this.hls.trigger(T.LEVEL_PTS_UPDATED, {
          details: o,
          level: s,
          drift: h,
          type: c,
          frag: e,
          start: u.startPTS,
          end: u.endPTS
        }), !0;
      }
      return l;
    }, !1) && ((r = this.transmuxer) == null ? void 0 : r.error) === null) {
      const l = new Error(`Found no media in fragment ${e.sn} of level ${e.level} resetting transmuxer to fallback to playlist timing`);
      if (s.fragmentError === 0 && (s.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0)), this.warn(l.message), this.hls.trigger(T.ERROR, {
        type: Q.MEDIA_ERROR,
        details: C.FRAG_PARSING_ERROR,
        fatal: !1,
        error: l,
        frag: e,
        reason: `Found no media in msn ${e.sn} of level "${s.url}"`
      }), !this.hls)
        return;
      this.resetTransmuxer();
    }
    this.state = k.PARSED, this.hls.trigger(T.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  resetTransmuxer() {
    this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
  }
  recoverWorkerError(e) {
    e.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.resetTransmuxer(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState());
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
class ea {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let s;
    if (e.length)
      e.length === 1 ? s = e[0] : s = $m(e, t);
    else return new Uint8Array(0);
    return this.reset(), s;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function $m(n, e) {
  const t = new Uint8Array(e);
  let s = 0;
  for (let i = 0; i < n.length; i++) {
    const r = n[i];
    t.set(r, s), s += r.length;
  }
  return t;
}
function Gm() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function Hm() {
  const n = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), e = self.URL.createObjectURL(n);
  return {
    worker: new self.Worker(e),
    objectURL: e
  };
}
function Km(n) {
  const e = new self.URL(n, self.location.href).href;
  return {
    worker: new self.Worker(e),
    scriptURL: e
  };
}
function je(n = "", e = 9e4) {
  return {
    type: n,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class mi {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, s, i) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, s) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = $e(this.cachedData, e), this.cachedData = null);
    let s = ts(e, 0), i = s ? s.length : 0, r;
    const o = this._audioTrack, a = this._id3Track, l = s ? li(s) : void 0, c = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && H(l)) && (this.basePTS = Vm(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), s && s.length > 0 && a.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: s,
      type: We.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); i < c; ) {
      if (this.canParse(e, i)) {
        const u = this.appendFrame(o, e, i);
        u ? (this.frameIndex++, this.lastPTS = u.sample.pts, i += u.length, r = i) : i = c;
      } else hf(e, i) ? (s = ts(e, i), a.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: s,
        type: We.audioId3,
        duration: Number.POSITIVE_INFINITY
      }), i += s.length, r = i) : i++;
      if (i === c && r !== c) {
        const u = vt(e, r);
        this.cachedData ? this.cachedData = $e(this.cachedData, u) : this.cachedData = u;
      }
    }
    return {
      audioTrack: o,
      videoTrack: je(),
      id3Track: a,
      textTrack: je()
    };
  }
  demuxSampleAes(e, t, s) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: je(),
      id3Track: this._id3Track,
      textTrack: je()
    };
  }
  destroy() {
  }
}
const Vm = (n, e, t) => {
  if (H(n))
    return n * 90;
  const s = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + s;
};
function Wm(n, e, t, s) {
  let i, r, o, a;
  const l = navigator.userAgent.toLowerCase(), c = s, u = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  i = ((e[t + 2] & 192) >>> 6) + 1;
  const d = (e[t + 2] & 60) >>> 2;
  if (d > u.length - 1) {
    const h = new Error(`invalid ADTS sampling index:${d}`);
    n.emit(T.ERROR, T.ERROR, {
      type: Q.MEDIA_ERROR,
      details: C.FRAG_PARSING_ERROR,
      fatal: !0,
      error: h,
      reason: h.message
    });
    return;
  }
  return o = (e[t + 2] & 1) << 2, o |= (e[t + 3] & 192) >>> 6, I.log(`manifest codec:${s}, ADTS type:${i}, samplingIndex:${d}`), /firefox/i.test(l) ? d >= 6 ? (i = 5, a = new Array(4), r = d - 3) : (i = 2, a = new Array(2), r = d) : l.indexOf("android") !== -1 ? (i = 2, a = new Array(2), r = d) : (i = 5, a = new Array(4), s && (s.indexOf("mp4a.40.29") !== -1 || s.indexOf("mp4a.40.5") !== -1) || !s && d >= 6 ? r = d - 3 : ((s && s.indexOf("mp4a.40.2") !== -1 && (d >= 6 && o === 1 || /vivaldi/i.test(l)) || !s && o === 1) && (i = 2, a = new Array(2)), r = d)), a[0] = i << 3, a[0] |= (d & 14) >> 1, a[1] |= (d & 1) << 7, a[1] |= o << 3, i === 5 && (a[1] |= (r & 14) >> 1, a[2] = (r & 1) << 7, a[2] |= 8, a[3] = 0), {
    config: a,
    samplerate: u[d],
    channelCount: o,
    codec: "mp4a.40." + i,
    manifestCodec: c
  };
}
function ta(n, e) {
  return n[e] === 255 && (n[e + 1] & 246) === 240;
}
function sa(n, e) {
  return n[e + 1] & 1 ? 7 : 9;
}
function gi(n, e) {
  return (n[e + 3] & 3) << 11 | n[e + 4] << 3 | (n[e + 5] & 224) >>> 5;
}
function Ym(n, e) {
  return e + 5 < n.length;
}
function Xs(n, e) {
  return e + 1 < n.length && ta(n, e);
}
function qm(n, e) {
  return Ym(n, e) && ta(n, e) && gi(n, e) <= n.length - e;
}
function zm(n, e) {
  if (Xs(n, e)) {
    const t = sa(n, e);
    if (e + t >= n.length)
      return !1;
    const s = gi(n, e);
    if (s <= t)
      return !1;
    const i = e + s;
    return i === n.length || Xs(n, i);
  }
  return !1;
}
function na(n, e, t, s, i) {
  if (!n.samplerate) {
    const r = Wm(e, t, s, i);
    if (!r)
      return;
    n.config = r.config, n.samplerate = r.samplerate, n.channelCount = r.channelCount, n.codec = r.codec, n.manifestCodec = r.manifestCodec, I.log(`parsed codec:${n.codec}, rate:${r.samplerate}, channels:${r.channelCount}`);
  }
}
function ia(n) {
  return 1024 * 9e4 / n;
}
function jm(n, e) {
  const t = sa(n, e);
  if (e + t <= n.length) {
    const s = gi(n, e) - t;
    if (s > 0)
      return {
        headerLength: t,
        frameLength: s
      };
  }
}
function ra(n, e, t, s, i) {
  const r = ia(n.samplerate), o = s + i * r, a = jm(e, t);
  let l;
  if (a) {
    const {
      frameLength: d,
      headerLength: h
    } = a, m = h + d, f = Math.max(0, t + m - e.length);
    f ? (l = new Uint8Array(m - h), l.set(e.subarray(t + h, e.length), 0)) : l = e.subarray(t + h, t + m);
    const g = {
      unit: l,
      pts: o
    };
    return f || n.samples.push(g), {
      sample: g,
      length: m,
      missing: f
    };
  }
  const c = e.length - t;
  return l = new Uint8Array(c), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: o
    },
    length: c,
    missing: -1
  };
}
let Ss = null;
const Xm = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], Qm = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], Zm = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], Jm = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function oa(n, e, t, s, i) {
  if (t + 24 > e.length)
    return;
  const r = aa(e, t);
  if (r && t + r.frameLength <= e.length) {
    const o = r.samplesPerFrame * 9e4 / r.sampleRate, a = s + i * o, l = {
      unit: e.subarray(t, t + r.frameLength),
      pts: a,
      dts: a
    };
    return n.config = [], n.channelCount = r.channelCount, n.samplerate = r.sampleRate, n.samples.push(l), {
      sample: l,
      length: r.frameLength,
      missing: 0
    };
  }
}
function aa(n, e) {
  const t = n[e + 1] >> 3 & 3, s = n[e + 1] >> 1 & 3, i = n[e + 2] >> 4 & 15, r = n[e + 2] >> 2 & 3;
  if (t !== 1 && i !== 0 && i !== 15 && r !== 3) {
    const o = n[e + 2] >> 1 & 1, a = n[e + 3] >> 6, l = t === 3 ? 3 - s : s === 3 ? 3 : 4, c = Xm[l * 14 + i - 1] * 1e3, d = Qm[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + r], h = a === 3 ? 1 : 2, m = Zm[t][s], f = Jm[s], g = m * 8 * f, p = Math.floor(m * c / d + o) * f;
    if (Ss === null) {
      const x = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Ss = x ? parseInt(x[1]) : 0;
    }
    return Ss && Ss <= 87 && s === 2 && c >= 224e3 && a === 0 && (n[e + 3] = n[e + 3] | 128), {
      sampleRate: d,
      channelCount: h,
      frameLength: p,
      samplesPerFrame: g
    };
  }
}
function pi(n, e) {
  return n[e] === 255 && (n[e + 1] & 224) === 224 && (n[e + 1] & 6) !== 0;
}
function la(n, e) {
  return e + 1 < n.length && pi(n, e);
}
function eg(n, e) {
  return pi(n, e) && 4 <= n.length - e;
}
function ca(n, e) {
  if (e + 1 < n.length && pi(n, e)) {
    const s = aa(n, e);
    let i = 4;
    s != null && s.frameLength && (i = s.frameLength);
    const r = e + i;
    return r === n.length || la(n, r);
  }
  return !1;
}
class tg extends mi {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, s, i) {
    super.resetInitSegment(e, t, s, i), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e) {
    if (!e)
      return !1;
    const t = ts(e, 0);
    let s = (t == null ? void 0 : t.length) || 0;
    if (ca(e, s))
      return !1;
    for (let i = e.length; s < i; s++)
      if (zm(e, s))
        return I.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return qm(e, t);
  }
  appendFrame(e, t, s) {
    na(e, this.observer, t, s, e.manifestCodec);
    const i = ra(e, t, s, this.basePTS, this.frameIndex);
    if (i && i.missing === 0)
      return i;
  }
}
const sg = /\/emsg[-/]ID3/i;
class ng {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, s, i) {
    const r = this.videoTrack = je("video", 1), o = this.audioTrack = je("audio", 1), a = this.txtTrack = je("text", 1);
    if (this.id3Track = je("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = Bo(e);
    if (l.video) {
      const {
        id: c,
        timescale: u,
        codec: d
      } = l.video;
      r.id = c, r.timescale = a.timescale = u, r.codec = d;
    }
    if (l.audio) {
      const {
        id: c,
        timescale: u,
        codec: d
      } = l.audio;
      o.id = c, o.timescale = u, o.codec = d;
    }
    a.id = Oo.text, r.sampleDuration = 0, r.duration = o.duration = i;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return vf(e);
  }
  demux(e, t) {
    this.timeOffset = t;
    let s = e;
    const i = this.videoTrack, r = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (s = $e(this.remainderData, e));
      const a = _f(s);
      this.remainderData = a.remainder, i.samples = a.valid || new Uint8Array();
    } else
      i.samples = s;
    const o = this.extractID3Track(i, t);
    return r.samples = cr(t, i), {
      videoTrack: i,
      audioTrack: this.audioTrack,
      id3Track: o,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, s = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const i = this.extractID3Track(t, this.timeOffset);
    return s.samples = cr(e, t), {
      videoTrack: t,
      audioTrack: je(),
      id3Track: i,
      textTrack: je()
    };
  }
  extractID3Track(e, t) {
    const s = this.id3Track;
    if (e.samples.length) {
      const i = te(e.samples, ["emsg"]);
      i && i.forEach((r) => {
        const o = Mf(r);
        if (sg.test(o.schemeIdUri)) {
          const a = H(o.presentationTime) ? o.presentationTime / o.timeScale : t + o.presentationTimeDelta / o.timeScale;
          let l = o.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : o.eventDuration / o.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const c = o.payload;
          s.samples.push({
            data: c,
            len: c.byteLength,
            dts: a,
            pts: a,
            type: We.emsg,
            duration: l
          });
        }
      });
    }
    return s;
  }
  demuxSampleAes(e, t, s) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
  }
}
const ua = (n, e) => {
  let t = 0, s = 5;
  e += s;
  const i = new Uint32Array(1), r = new Uint32Array(1), o = new Uint8Array(1);
  for (; s > 0; ) {
    o[0] = n[e];
    const a = Math.min(s, 8), l = 8 - a;
    r[0] = 4278190080 >>> 24 + l << l, i[0] = (o[0] & r[0]) >> l, t = t ? t << a | i[0] : i[0], e += 1, s -= a;
  }
  return t;
};
class ig extends mi {
  constructor(e) {
    super(), this.observer = void 0, this.observer = e;
  }
  resetInitSegment(e, t, s, i) {
    super.resetInitSegment(e, t, s, i), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(e, t) {
    return t + 64 < e.length;
  }
  appendFrame(e, t, s) {
    const i = da(e, t, s, this.basePTS, this.frameIndex);
    if (i !== -1)
      return {
        sample: e.samples[e.samples.length - 1],
        length: i,
        missing: 0
      };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = ts(e, 0);
    if (!t)
      return !1;
    const s = t.length;
    return e[s] === 11 && e[s + 1] === 119 && li(t) !== void 0 && // check the bsid to confirm ac-3
    ua(e, s) < 16;
  }
}
function da(n, e, t, s, i) {
  if (t + 8 > e.length || e[t] !== 11 || e[t + 1] !== 119)
    return -1;
  const r = e[t + 4] >> 6;
  if (r >= 3)
    return -1;
  const a = [48e3, 44100, 32e3][r], l = e[t + 4] & 63, u = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][l * 3 + r] * 2;
  if (t + u > e.length)
    return -1;
  const d = e[t + 6] >> 5;
  let h = 0;
  d === 2 ? h += 2 : (d & 1 && d !== 1 && (h += 2), d & 4 && (h += 2));
  const m = (e[t + 6] << 8 | e[t + 7]) >> 12 - h & 1, g = [2, 1, 2, 3, 3, 4, 4, 5][d] + m, p = e[t + 5] >> 3, E = e[t + 5] & 7, y = new Uint8Array([r << 6 | p << 1 | E >> 2, (E & 3) << 6 | d << 3 | m << 2 | l >> 4, l << 4 & 224]), x = 1536 / a * 9e4, S = s + i * x, v = e.subarray(t, t + u);
  return n.config = y, n.channelCount = g, n.samplerate = a, n.samples.push({
    unit: v,
    pts: S
  }), u;
}
class rg {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(e, t, s, i) {
    return {
      key: e,
      frame: !1,
      pts: t,
      dts: s,
      units: [],
      debug: i,
      length: 0
    };
  }
  getLastNalUnit(e) {
    var t;
    let s = this.VideoSample, i;
    if ((!s || s.units.length === 0) && (s = e[e.length - 1]), (t = s) != null && t.units) {
      const r = s.units;
      i = r[r.length - 1];
    }
    return i;
  }
  pushAccessUnit(e, t) {
    if (e.units.length && e.frame) {
      if (e.pts === void 0) {
        const s = t.samples, i = s.length;
        if (i) {
          const r = s[i - 1];
          e.pts = r.pts, e.dts = r.dts;
        } else {
          t.dropped++;
          return;
        }
      }
      t.samples.push(e);
    }
    e.debug.length && I.log(e.pts + "/" + e.dts + ":" + e.debug);
  }
}
class Nr {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, s = e.byteLength - t, i = new Uint8Array(4), r = Math.min(4, t);
    if (r === 0)
      throw new Error("no bytes available");
    i.set(e.subarray(s, s + r)), this.word = new DataView(i.buffer).getUint32(0), this.bitsAvailable = r * 8, this.bytesAvailable -= r;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const s = this.word >>> 32 - t;
    if (e > 32 && I.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? s << t | this.readBits(t) : s;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if ((this.word & 2147483648 >>> e) !== 0)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e) {
    let t = 8, s = 8, i;
    for (let r = 0; r < e; r++)
      s !== 0 && (i = this.readEG(), s = (t + i + 256) % 256), t = s === 0 ? t : s;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let e = 0, t = 0, s = 0, i = 0, r, o, a;
    const l = this.readUByte.bind(this), c = this.readBits.bind(this), u = this.readUEG.bind(this), d = this.readBoolean.bind(this), h = this.skipBits.bind(this), m = this.skipEG.bind(this), f = this.skipUEG.bind(this), g = this.skipScalingList.bind(this);
    l();
    const p = l();
    if (c(5), h(3), l(), f(), p === 100 || p === 110 || p === 122 || p === 244 || p === 44 || p === 83 || p === 86 || p === 118 || p === 128) {
      const D = u();
      if (D === 3 && h(1), f(), f(), h(1), d())
        for (o = D !== 3 ? 8 : 12, a = 0; a < o; a++)
          d() && (a < 6 ? g(16) : g(64));
    }
    f();
    const E = u();
    if (E === 0)
      u();
    else if (E === 1)
      for (h(1), m(), m(), r = u(), a = 0; a < r; a++)
        m();
    f(), h(1);
    const y = u(), x = u(), S = c(1);
    S === 0 && h(1), h(1), d() && (e = u(), t = u(), s = u(), i = u());
    let v = [1, 1];
    if (d() && d())
      switch (l()) {
        case 1:
          v = [1, 1];
          break;
        case 2:
          v = [12, 11];
          break;
        case 3:
          v = [10, 11];
          break;
        case 4:
          v = [16, 11];
          break;
        case 5:
          v = [40, 33];
          break;
        case 6:
          v = [24, 11];
          break;
        case 7:
          v = [20, 11];
          break;
        case 8:
          v = [32, 11];
          break;
        case 9:
          v = [80, 33];
          break;
        case 10:
          v = [18, 11];
          break;
        case 11:
          v = [15, 11];
          break;
        case 12:
          v = [64, 33];
          break;
        case 13:
          v = [160, 99];
          break;
        case 14:
          v = [4, 3];
          break;
        case 15:
          v = [3, 2];
          break;
        case 16:
          v = [2, 1];
          break;
        case 255: {
          v = [l() << 8 | l(), l() << 8 | l()];
          break;
        }
      }
    return {
      width: Math.ceil((y + 1) * 16 - e * 2 - t * 2),
      height: (2 - S) * (x + 1) * 16 - (S ? 2 : 4) * (s + i),
      pixelRatio: v
    };
  }
  readSliceType() {
    return this.readUByte(), this.readUEG(), this.readUEG();
  }
}
class og extends rg {
  parseAVCPES(e, t, s, i, r) {
    const o = this.parseAVCNALu(e, s.data);
    let a = this.VideoSample, l, c = !1;
    s.data = null, a && o.length && !e.audFound && (this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, s.pts, s.dts, "")), o.forEach((u) => {
      var d;
      switch (u.type) {
        // NDR
        case 1: {
          let g = !1;
          l = !0;
          const p = u.data;
          if (c && p.length > 4) {
            const E = new Nr(p).readSliceType();
            (E === 2 || E === 4 || E === 7 || E === 9) && (g = !0);
          }
          if (g) {
            var h;
            (h = a) != null && h.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null);
          }
          a || (a = this.VideoSample = this.createVideoSample(!0, s.pts, s.dts, "")), a.frame = !0, a.key = g;
          break;
        }
        case 5:
          l = !0, (d = a) != null && d.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null), a || (a = this.VideoSample = this.createVideoSample(!0, s.pts, s.dts, "")), a.key = !0, a.frame = !0;
          break;
        // SEI
        case 6: {
          l = !0, Go(u.data, 1, s.pts, t.samples);
          break;
        }
        case 7: {
          var m, f;
          l = !0, c = !0;
          const g = u.data, E = new Nr(g).readSPS();
          if (!e.sps || e.width !== E.width || e.height !== E.height || ((m = e.pixelRatio) == null ? void 0 : m[0]) !== E.pixelRatio[0] || ((f = e.pixelRatio) == null ? void 0 : f[1]) !== E.pixelRatio[1]) {
            e.width = E.width, e.height = E.height, e.pixelRatio = E.pixelRatio, e.sps = [g], e.duration = r;
            const y = g.subarray(1, 4);
            let x = "avc1.";
            for (let S = 0; S < 3; S++) {
              let v = y[S].toString(16);
              v.length < 2 && (v = "0" + v), x += v;
            }
            e.codec = x;
          }
          break;
        }
        // PPS
        case 8:
          l = !0, e.pps = [u.data];
          break;
        // AUD
        case 9:
          l = !0, e.audFound = !0, a && this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, s.pts, s.dts, "");
          break;
        // Filler Data
        case 12:
          l = !0;
          break;
        default:
          l = !1, a && (a.debug += "unknown NAL " + u.type + " ");
          break;
      }
      a && l && a.units.push(u);
    }), i && a && (this.pushAccessUnit(a, e), this.VideoSample = null);
  }
  parseAVCNALu(e, t) {
    const s = t.byteLength;
    let i = e.naluState || 0;
    const r = i, o = [];
    let a = 0, l, c, u, d = -1, h = 0;
    for (i === -1 && (d = 0, h = t[0] & 31, i = 0, a = 1); a < s; ) {
      if (l = t[a++], !i) {
        i = l ? 0 : 1;
        continue;
      }
      if (i === 1) {
        i = l ? 0 : 2;
        continue;
      }
      if (!l)
        i = 3;
      else if (l === 1) {
        if (c = a - i - 1, d >= 0) {
          const m = {
            data: t.subarray(d, c),
            type: h
          };
          o.push(m);
        } else {
          const m = this.getLastNalUnit(e.samples);
          m && (r && a <= 4 - r && m.state && (m.data = m.data.subarray(0, m.data.byteLength - r)), c > 0 && (m.data = $e(m.data, t.subarray(0, c)), m.state = 0));
        }
        a < s ? (u = t[a] & 31, d = a, h = u, i = 0) : i = -1;
      } else
        i = 0;
    }
    if (d >= 0 && i >= 0) {
      const m = {
        data: t.subarray(d, s),
        type: h,
        state: i
      };
      o.push(m);
    }
    if (o.length === 0) {
      const m = this.getLastNalUnit(e.samples);
      m && (m.data = $e(m.data, t));
    }
    return e.naluState = i, o;
  }
}
class ag {
  constructor(e, t, s) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = s, this.decrypter = new hi(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, s) {
    const i = e[t].unit;
    if (i.length <= 16)
      return;
    const r = i.subarray(16, i.length - i.length % 16), o = r.buffer.slice(r.byteOffset, r.byteOffset + r.length);
    this.decryptBuffer(o).then((a) => {
      const l = new Uint8Array(a);
      i.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, s);
    });
  }
  decryptAacSamples(e, t, s) {
    for (; ; t++) {
      if (t >= e.length) {
        s();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, s), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, s = new Int8Array(t);
    let i = 0;
    for (let r = 32; r < e.length - 16; r += 160, i += 16)
      s.set(e.subarray(r, r + 16), i);
    return s;
  }
  getAvcDecryptedUnit(e, t) {
    const s = new Uint8Array(t);
    let i = 0;
    for (let r = 32; r < e.length - 16; r += 160, i += 16)
      e.set(s.subarray(i, i + 16), r);
    return e;
  }
  decryptAvcSample(e, t, s, i, r) {
    const o = Ho(r.data), a = this.getAvcEncryptedData(o);
    this.decryptBuffer(a.buffer).then((l) => {
      r.data = this.getAvcDecryptedUnit(o, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, s + 1, i);
    });
  }
  decryptAvcSamples(e, t, s, i) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, s = 0) {
      if (t >= e.length) {
        i();
        return;
      }
      const r = e[t].units;
      for (; !(s >= r.length); s++) {
        const o = r[s];
        if (!(o.data.length <= 48 || o.type !== 1 && o.type !== 5) && (this.decryptAvcSample(e, t, s, i, o), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
const Le = 188;
class ft {
  constructor(e, t, s) {
    this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.observer = e, this.config = t, this.typeSupported = s, this.videoParser = new og();
  }
  static probe(e) {
    const t = ft.syncOffset(e);
    return t > 0 && I.warn(`MPEG2-TS detected but first sync word found @ offset ${t}`), t !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let s = Math.min(Le * 5, t - Le) + 1, i = 0;
    for (; i < s; ) {
      let r = !1, o = -1, a = 0;
      for (let l = i; l < t; l += Le)
        if (e[l] === 71 && (t - l === Le || e[l + Le] === 71)) {
          if (a++, o === -1 && (o = l, o !== 0 && (s = Math.min(o + Le * 99, e.length - Le) + 1)), r || (r = Qn(e, l) === 0), r && a > 1 && (o === 0 && a > 2 || l + Le > s))
            return o;
        } else {
          if (a)
            return -1;
          break;
        }
      i++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: Oo[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, s, i) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = ft.createTrack("video"), this._audioTrack = ft.createTrack("audio", i), this._id3Track = ft.createTrack("id3"), this._txtTrack = ft.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = s, this._duration = i;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _videoTrack: t,
      _id3Track: s
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), s && (s.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  demux(e, t, s = !1, i = !1) {
    s || (this.sampleAes = null);
    let r;
    const o = this._videoTrack, a = this._audioTrack, l = this._id3Track, c = this._txtTrack;
    let u = o.pid, d = o.pesData, h = a.pid, m = l.pid, f = a.pesData, g = l.pesData, p = null, E = this.pmtParsed, y = this._pmtId, x = e.length;
    if (this.remainderData && (e = $e(this.remainderData, e), x = e.length, this.remainderData = null), x < Le && !i)
      return this.remainderData = e, {
        audioTrack: a,
        videoTrack: o,
        id3Track: l,
        textTrack: c
      };
    const S = Math.max(0, ft.syncOffset(e));
    x -= (x - S) % Le, x < e.byteLength && !i && (this.remainderData = new Uint8Array(e.buffer, x, e.buffer.byteLength - x));
    let v = 0;
    for (let L = S; L < x; L += Le)
      if (e[L] === 71) {
        const _ = !!(e[L + 1] & 64), A = Qn(e, L), R = (e[L + 3] & 48) >> 4;
        let w;
        if (R > 1) {
          if (w = L + 5 + e[L + 4], w === L + Le)
            continue;
        } else
          w = L + 4;
        switch (A) {
          case u:
            _ && (d && (r = kt(d)) && this.videoParser.parseAVCPES(o, c, r, !1, this._duration), d = {
              data: [],
              size: 0
            }), d && (d.data.push(e.subarray(w, L + Le)), d.size += L + Le - w);
            break;
          case h:
            if (_) {
              if (f && (r = kt(f)))
                switch (a.segmentCodec) {
                  case "aac":
                    this.parseAACPES(a, r);
                    break;
                  case "mp3":
                    this.parseMPEGPES(a, r);
                    break;
                  case "ac3":
                    this.parseAC3PES(a, r);
                    break;
                }
              f = {
                data: [],
                size: 0
              };
            }
            f && (f.data.push(e.subarray(w, L + Le)), f.size += L + Le - w);
            break;
          case m:
            _ && (g && (r = kt(g)) && this.parseID3PES(l, r), g = {
              data: [],
              size: 0
            }), g && (g.data.push(e.subarray(w, L + Le)), g.size += L + Le - w);
            break;
          case 0:
            _ && (w += e[w] + 1), y = this._pmtId = lg(e, w);
            break;
          case y: {
            _ && (w += e[w] + 1);
            const B = cg(e, w, this.typeSupported, s, this.observer);
            u = B.videoPid, u > 0 && (o.pid = u, o.segmentCodec = B.segmentVideoCodec), h = B.audioPid, h > 0 && (a.pid = h, a.segmentCodec = B.segmentAudioCodec), m = B.id3Pid, m > 0 && (l.pid = m), p !== null && !E && (I.warn(`MPEG-TS PMT found at ${L} after unknown PID '${p}'. Backtracking to sync byte @${S} to parse all TS packets.`), p = null, L = S - 188), E = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            p = A;
            break;
        }
      } else
        v++;
    v > 0 && Qs(this.observer, new Error(`Found ${v} TS packet/s that do not start with 0x47`)), o.pesData = d, a.pesData = f, l.pesData = g;
    const D = {
      audioTrack: a,
      videoTrack: o,
      id3Track: l,
      textTrack: c
    };
    return i && this.extractRemainingSamples(D), D;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: s,
      id3Track: i,
      textTrack: r
    } = e, o = s.pesData, a = t.pesData, l = i.pesData;
    let c;
    if (o && (c = kt(o)) ? (this.videoParser.parseAVCPES(s, r, c, !0, this._duration), s.pesData = null) : s.pesData = o, a && (c = kt(a))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, c);
          break;
        case "mp3":
          this.parseMPEGPES(t, c);
          break;
        case "ac3":
          this.parseAC3PES(t, c);
          break;
      }
      t.pesData = null;
    } else
      a != null && a.size && I.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = a;
    l && (c = kt(l)) ? (this.parseID3PES(i, c), i.pesData = null) : i.pesData = l;
  }
  demuxSampleAes(e, t, s) {
    const i = this.demux(e, s, !0, !this.config.progressive), r = this.sampleAes = new ag(this.observer, this.config, t);
    return this.decrypt(i, r);
  }
  decrypt(e, t) {
    return new Promise((s) => {
      const {
        audioTrack: i,
        videoTrack: r
      } = e;
      i.samples && i.segmentCodec === "aac" ? t.decryptAacSamples(i.samples, 0, () => {
        r.samples ? t.decryptAvcSamples(r.samples, 0, 0, () => {
          s(e);
        }) : s(e);
      }) : r.samples && t.decryptAvcSamples(r.samples, 0, 0, () => {
        s(e);
      });
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAACPES(e, t) {
    let s = 0;
    const i = this.aacOverFlow;
    let r = t.data;
    if (i) {
      this.aacOverFlow = null;
      const d = i.missing, h = i.sample.unit.byteLength;
      if (d === -1)
        r = $e(i.sample.unit, r);
      else {
        const m = h - d;
        i.sample.unit.set(r.subarray(0, d), m), e.samples.push(i.sample), s = i.missing;
      }
    }
    let o, a;
    for (o = s, a = r.length; o < a - 1 && !Xs(r, o); o++)
      ;
    if (o !== s) {
      let d;
      const h = o < a - 1;
      if (h ? d = `AAC PES did not start with ADTS header,offset:${o}` : d = "No ADTS header found in AAC PES", Qs(this.observer, new Error(d), h), !h)
        return;
    }
    na(e, this.observer, r, o, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (i) {
      const d = ia(e.samplerate);
      l = i.sample.pts + d;
    } else {
      I.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let c = 0, u;
    for (; o < a; )
      if (u = ra(e, r, o, l, c), o += u.length, u.missing) {
        this.aacOverFlow = u;
        break;
      } else
        for (c++; o < a - 1 && !Xs(r, o); o++)
          ;
  }
  parseMPEGPES(e, t) {
    const s = t.data, i = s.length;
    let r = 0, o = 0;
    const a = t.pts;
    if (a === void 0) {
      I.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; o < i; )
      if (la(s, o)) {
        const l = oa(e, s, o, a, r);
        if (l)
          o += l.length, r++;
        else
          break;
      } else
        o++;
  }
  parseAC3PES(e, t) {
    {
      const s = t.data, i = t.pts;
      if (i === void 0) {
        I.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const r = s.length;
      let o = 0, a = 0, l;
      for (; a < r && (l = da(e, s, a, i, o++)) > 0; )
        a += l;
    }
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      I.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const s = ve({}, t, {
      type: this._videoTrack ? We.emsg : We.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(s);
  }
}
function Qn(n, e) {
  return ((n[e + 1] & 31) << 8) + n[e + 2];
}
function lg(n, e) {
  return (n[e + 10] & 31) << 8 | n[e + 11];
}
function cg(n, e, t, s, i) {
  const r = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, o = (n[e + 1] & 15) << 8 | n[e + 2], a = e + 3 + o - 4, l = (n[e + 10] & 15) << 8 | n[e + 11];
  for (e += 12 + l; e < a; ) {
    const c = Qn(n, e), u = (n[e + 3] & 15) << 8 | n[e + 4];
    switch (n[e]) {
      case 207:
        if (!s) {
          An("ADTS AAC");
          break;
        }
      /* falls through */
      case 15:
        r.audioPid === -1 && (r.audioPid = c);
        break;
      // Packetized metadata (ID3)
      case 21:
        r.id3Pid === -1 && (r.id3Pid = c);
        break;
      case 219:
        if (!s) {
          An("H.264");
          break;
        }
      /* falls through */
      case 27:
        r.videoPid === -1 && (r.videoPid = c, r.segmentVideoCodec = "avc");
        break;
      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 3:
      case 4:
        !t.mpeg && !t.mp3 ? I.log("MPEG audio found, not supported in this browser") : r.audioPid === -1 && (r.audioPid = c, r.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!s) {
          An("AC-3");
          break;
        }
      /* falls through */
      case 129:
        t.ac3 ? r.audioPid === -1 && (r.audioPid = c, r.segmentAudioCodec = "ac3") : I.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (r.audioPid === -1 && u > 0) {
          let d = e + 5, h = u;
          for (; h > 2; ) {
            n[d] === 106 && (t.ac3 !== !0 ? I.log("AC-3 audio found, not supported in this browser for now") : (r.audioPid = c, r.segmentAudioCodec = "ac3"));
            const f = n[d + 1] + 2;
            d += f, h -= f;
          }
        }
        break;
      case 194:
      // SAMPLE-AES EC3
      /* falls through */
      case 135:
        return Qs(i, new Error("Unsupported EC-3 in M2TS found")), r;
      case 36:
        return Qs(i, new Error("Unsupported HEVC in M2TS found")), r;
    }
    e += u + 5;
  }
  return r;
}
function Qs(n, e, t) {
  I.warn(`parsing error: ${e.message}`), n.emit(T.ERROR, T.ERROR, {
    type: Q.MEDIA_ERROR,
    details: C.FRAG_PARSING_ERROR,
    fatal: !1,
    levelRetry: t,
    error: e,
    reason: e.message
  });
}
function An(n) {
  I.log(`${n} with AES-128-CBC encryption found in unencrypted stream`);
}
function kt(n) {
  let e = 0, t, s, i, r, o;
  const a = n.data;
  if (!n || n.size === 0)
    return null;
  for (; a[0].length < 19 && a.length > 1; )
    a[0] = $e(a[0], a[1]), a.splice(1, 1);
  if (t = a[0], (t[0] << 16) + (t[1] << 8) + t[2] === 1) {
    if (s = (t[4] << 8) + t[5], s && s > n.size - 6)
      return null;
    const c = t[7];
    c & 192 && (r = (t[9] & 14) * 536870912 + // 1 << 29
    (t[10] & 255) * 4194304 + // 1 << 22
    (t[11] & 254) * 16384 + // 1 << 14
    (t[12] & 255) * 128 + // 1 << 7
    (t[13] & 254) / 2, c & 64 ? (o = (t[14] & 14) * 536870912 + // 1 << 29
    (t[15] & 255) * 4194304 + // 1 << 22
    (t[16] & 254) * 16384 + // 1 << 14
    (t[17] & 255) * 128 + // 1 << 7
    (t[18] & 254) / 2, r - o > 60 * 9e4 && (I.warn(`${Math.round((r - o) / 9e4)}s delta between PTS and DTS, align them`), r = o)) : o = r), i = t[8];
    let u = i + 9;
    if (n.size <= u)
      return null;
    n.size -= u;
    const d = new Uint8Array(n.size);
    for (let h = 0, m = a.length; h < m; h++) {
      t = a[h];
      let f = t.byteLength;
      if (u)
        if (u > f) {
          u -= f;
          continue;
        } else
          t = t.subarray(u), f -= u, u = 0;
      d.set(t, e), e += f;
    }
    return s && (s -= i + 3), {
      data: d,
      pts: r,
      dts: o,
      len: s
    };
  }
  return null;
}
class ug extends mi {
  resetInitSegment(e, t, s, i) {
    super.resetInitSegment(e, t, s, i), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = ts(e, 0);
    let s = (t == null ? void 0 : t.length) || 0;
    if (t && e[s] === 11 && e[s + 1] === 119 && li(t) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    ua(e, s) <= 16)
      return !1;
    for (let i = e.length; s < i; s++)
      if (ca(e, s))
        return I.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return eg(e, t);
  }
  appendFrame(e, t, s) {
    if (this.basePTS !== null)
      return oa(e, t, s, this.basePTS, this.frameIndex);
  }
}
class Ur {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const ht = Math.pow(2, 32) - 1;
class b {
  static init() {
    b.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in b.types)
      b.types.hasOwnProperty(e) && (b.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), s = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    b.HDLR_TYPES = {
      video: t,
      audio: s
    };
    const i = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), r = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    b.STTS = b.STSC = b.STCO = r, b.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), b.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), b.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), b.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const o = new Uint8Array([105, 115, 111, 109]), a = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    b.FTYP = b.box(b.types.ftyp, o, l, o, a), b.DINF = b.box(b.types.dinf, b.box(b.types.dref, i));
  }
  static box(e, ...t) {
    let s = 8, i = t.length;
    const r = i;
    for (; i--; )
      s += t[i].byteLength;
    const o = new Uint8Array(s);
    for (o[0] = s >> 24 & 255, o[1] = s >> 16 & 255, o[2] = s >> 8 & 255, o[3] = s & 255, o.set(e, 4), i = 0, s = 8; i < r; i++)
      o.set(t[i], s), s += t[i].byteLength;
    return o;
  }
  static hdlr(e) {
    return b.box(b.types.hdlr, b.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return b.box(b.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const s = Math.floor(t / (ht + 1)), i = Math.floor(t % (ht + 1));
    return b.box(b.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return b.box(b.types.mdia, b.mdhd(e.timescale, e.duration), b.hdlr(e.type), b.minf(e));
  }
  static mfhd(e) {
    return b.box(b.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? b.box(b.types.minf, b.box(b.types.smhd, b.SMHD), b.DINF, b.stbl(e)) : b.box(b.types.minf, b.box(b.types.vmhd, b.VMHD), b.DINF, b.stbl(e));
  }
  static moof(e, t, s) {
    return b.box(b.types.moof, b.mfhd(e), b.traf(s, t));
  }
  static moov(e) {
    let t = e.length;
    const s = [];
    for (; t--; )
      s[t] = b.trak(e[t]);
    return b.box.apply(null, [b.types.moov, b.mvhd(e[0].timescale, e[0].duration)].concat(s).concat(b.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const s = [];
    for (; t--; )
      s[t] = b.trex(e[t]);
    return b.box.apply(null, [b.types.mvex, ...s]);
  }
  static mvhd(e, t) {
    t *= e;
    const s = Math.floor(t / (ht + 1)), i = Math.floor(t % (ht + 1)), r = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return b.box(b.types.mvhd, r);
  }
  static sdtp(e) {
    const t = e.samples || [], s = new Uint8Array(4 + t.length);
    let i, r;
    for (i = 0; i < t.length; i++)
      r = t[i].flags, s[i + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
    return b.box(b.types.sdtp, s);
  }
  static stbl(e) {
    return b.box(b.types.stbl, b.stsd(e), b.box(b.types.stts, b.STTS), b.box(b.types.stsc, b.STSC), b.box(b.types.stsz, b.STSZ), b.box(b.types.stco, b.STCO));
  }
  static avc1(e) {
    let t = [], s = [], i, r, o;
    for (i = 0; i < e.sps.length; i++)
      r = e.sps[i], o = r.byteLength, t.push(o >>> 8 & 255), t.push(o & 255), t = t.concat(Array.prototype.slice.call(r));
    for (i = 0; i < e.pps.length; i++)
      r = e.pps[i], o = r.byteLength, s.push(o >>> 8 & 255), s.push(o & 255), s = s.concat(Array.prototype.slice.call(r));
    const a = b.box(b.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(s))), l = e.width, c = e.height, u = e.pixelRatio[0], d = e.pixelRatio[1];
    return b.box(
      b.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        c >> 8 & 255,
        c & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      a,
      b.box(b.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      b.box(b.types.pasp, new Uint8Array([
        u >> 24,
        // hSpacing
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255,
        d >> 24,
        // vSpacing
        d >> 16 & 255,
        d >> 8 & 255,
        d & 255
      ]))
    );
  }
  static esds(e) {
    const t = e.config.length;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      23 + t,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      15 + t,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5
      // descriptor_type
    ].concat([t]).concat(e.config).concat([6, 1, 2]));
  }
  static audioStsd(e) {
    const t = e.samplerate;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(e) {
    return b.box(b.types.mp4a, b.audioStsd(e), b.box(b.types.esds, b.esds(e)));
  }
  static mp3(e) {
    return b.box(b.types[".mp3"], b.audioStsd(e));
  }
  static ac3(e) {
    return b.box(b.types["ac-3"], b.audioStsd(e), b.box(b.types.dac3, e.config));
  }
  static stsd(e) {
    return e.type === "audio" ? e.segmentCodec === "mp3" && e.codec === "mp3" ? b.box(b.types.stsd, b.STSD, b.mp3(e)) : e.segmentCodec === "ac3" ? b.box(b.types.stsd, b.STSD, b.ac3(e)) : b.box(b.types.stsd, b.STSD, b.mp4a(e)) : b.box(b.types.stsd, b.STSD, b.avc1(e));
  }
  static tkhd(e) {
    const t = e.id, s = e.duration * e.timescale, i = e.width, r = e.height, o = Math.floor(s / (ht + 1)), a = Math.floor(s % (ht + 1));
    return b.box(b.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      a >> 24,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      i >> 8 & 255,
      i & 255,
      0,
      0,
      // width
      r >> 8 & 255,
      r & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const s = b.sdtp(e), i = e.id, r = Math.floor(t / (ht + 1)), o = Math.floor(t % (ht + 1));
    return b.box(
      b.types.traf,
      b.box(b.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        i >> 24,
        i >> 16 & 255,
        i >> 8 & 255,
        i & 255
        // track_ID
      ])),
      b.box(b.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        r >> 24,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255,
        o >> 24,
        o >> 16 & 255,
        o >> 8 & 255,
        o & 255
      ])),
      b.trun(e, s.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      s
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, b.box(b.types.trak, b.tkhd(e), b.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return b.box(b.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const s = e.samples || [], i = s.length, r = 12 + 16 * i, o = new Uint8Array(r);
    let a, l, c, u, d, h;
    for (t += 8 + r, o.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      i >>> 24 & 255,
      i >>> 16 & 255,
      i >>> 8 & 255,
      i & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), a = 0; a < i; a++)
      l = s[a], c = l.duration, u = l.size, d = l.flags, h = l.cts, o.set([
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_duration
        u >>> 24 & 255,
        u >>> 16 & 255,
        u >>> 8 & 255,
        u & 255,
        // sample_size
        d.isLeading << 2 | d.dependsOn,
        d.isDependedOn << 6 | d.hasRedundancy << 4 | d.paddingValue << 1 | d.isNonSync,
        d.degradPrio & 61440,
        d.degradPrio & 15,
        // sample_flags
        h >>> 24 & 255,
        h >>> 16 & 255,
        h >>> 8 & 255,
        h & 255
        // sample_composition_time_offset
      ], 12 + 16 * a);
    return b.box(b.types.trun, o);
  }
  static initSegment(e) {
    b.types || b.init();
    const t = b.moov(e);
    return $e(b.FTYP, t);
  }
}
b.types = void 0;
b.HDLR_TYPES = void 0;
b.STTS = void 0;
b.STSC = void 0;
b.STCO = void 0;
b.STSZ = void 0;
b.VMHD = void 0;
b.SMHD = void 0;
b.STSD = void 0;
b.FTYP = void 0;
b.DINF = void 0;
const ha = 9e4;
function Ti(n, e, t = 1, s = !1) {
  const i = n * e * t;
  return s ? Math.round(i) : i;
}
function dg(n, e, t = 1, s = !1) {
  return Ti(n, e, 1 / t, s);
}
function jt(n, e = !1) {
  return Ti(n, 1e3, 1 / ha, e);
}
function hg(n, e = 1) {
  return Ti(n, ha, 1 / e);
}
const fg = 10 * 1e3, Br = 1024, mg = 1152, gg = 1536;
let Ft = null, Ln = null;
class Ms {
  constructor(e, t, s, i = "") {
    if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = e, this.config = t, this.typeSupported = s, this.ISGenerated = !1, Ft === null) {
      const o = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Ft = o ? parseInt(o[1]) : 0;
    }
    if (Ln === null) {
      const r = navigator.userAgent.match(/Safari\/(\d+)/i);
      Ln = r ? parseInt(r[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(e) {
    I.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    I.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    I.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(e) {
    let t = !1;
    const s = e.reduce((i, r) => {
      const o = r.pts - i;
      return o < -4294967296 ? (t = !0, Be(i, r.pts)) : o > 0 ? i : r.pts;
    }, e[0].pts);
    return t && I.debug("PTS rollover detected"), s;
  }
  remux(e, t, s, i, r, o, a, l) {
    let c, u, d, h, m, f, g = r, p = r;
    const E = e.pid > -1, y = t.pid > -1, x = t.samples.length, S = e.samples.length > 0, v = a && x > 0 || x > 1;
    if ((!E || S) && (!y || v) || this.ISGenerated || a) {
      if (this.ISGenerated) {
        var L, _, A, R;
        const N = this.videoTrackConfig;
        N && (t.width !== N.width || t.height !== N.height || ((L = t.pixelRatio) == null ? void 0 : L[0]) !== ((_ = N.pixelRatio) == null ? void 0 : _[0]) || ((A = t.pixelRatio) == null ? void 0 : A[1]) !== ((R = N.pixelRatio) == null ? void 0 : R[1])) && this.resetInitSegment();
      } else
        d = this.generateIS(e, t, r, o);
      const w = this.isVideoContiguous;
      let B = -1, M;
      if (v && (B = pg(t.samples), !w && this.config.forceKeyFrameOnDiscontinuity))
        if (f = !0, B > 0) {
          I.warn(`[mp4-remuxer]: Dropped ${B} out of ${x} video samples due to a missing keyframe`);
          const N = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice(B), t.dropped += B, p += (t.samples[0].pts - N) / t.inputTimeScale, M = p;
        } else B === -1 && (I.warn(`[mp4-remuxer]: No keyframe found out of ${x} video samples`), f = !1);
      if (this.ISGenerated) {
        if (S && v) {
          const N = this.getVideoStartPts(t.samples), G = (Be(e.samples[0].pts, N) - N) / t.inputTimeScale;
          g += Math.max(0, G), p += Math.max(0, -G);
        }
        if (S) {
          if (e.samplerate || (I.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), d = this.generateIS(e, t, r, o)), u = this.remuxAudio(e, g, this.isAudioContiguous, o, y || v || l === j.AUDIO ? p : void 0), v) {
            const N = u ? u.endPTS - u.startPTS : 0;
            t.inputTimeScale || (I.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), d = this.generateIS(e, t, r, o)), c = this.remuxVideo(t, p, w, N);
          }
        } else v && (c = this.remuxVideo(t, p, w, 0));
        c && (c.firstKeyFrame = B, c.independent = B !== -1, c.firstKeyFramePTS = M);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (s.samples.length && (m = fa(s, r, this._initPTS, this._initDTS)), i.samples.length && (h = ma(i, r, this._initPTS))), {
      audio: u,
      video: c,
      initSegment: d,
      independent: f,
      text: h,
      id3: m
    };
  }
  generateIS(e, t, s, i) {
    const r = e.samples, o = t.samples, a = this.typeSupported, l = {}, c = this._initPTS;
    let u = !c || i, d = "audio/mp4", h, m, f;
    if (u && (h = m = 1 / 0), e.config && r.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          a.mpeg ? (d = "audio/mpeg", e.codec = "") : a.mp3 && (e.codec = "mp3");
          break;
        case "ac3":
          e.codec = "ac-3";
          break;
      }
      l.audio = {
        id: "audio",
        container: d,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && a.mpeg ? new Uint8Array(0) : b.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, u && (f = e.inputTimeScale, !c || f !== c.timescale ? h = m = r[0].pts - Math.round(f * s) : u = !1);
    }
    if (t.sps && t.pps && o.length) {
      if (t.timescale = t.inputTimeScale, l.video = {
        id: "main",
        container: "video/mp4",
        codec: t.codec,
        initSegment: b.initSegment([t]),
        metadata: {
          width: t.width,
          height: t.height
        }
      }, u)
        if (f = t.inputTimeScale, !c || f !== c.timescale) {
          const g = this.getVideoStartPts(o), p = Math.round(f * s);
          m = Math.min(m, Be(o[0].dts, g) - p), h = Math.min(h, g - p);
        } else
          u = !1;
      this.videoTrackConfig = {
        width: t.width,
        height: t.height,
        pixelRatio: t.pixelRatio
      };
    }
    if (Object.keys(l).length)
      return this.ISGenerated = !0, u ? (this._initPTS = {
        baseTime: h,
        timescale: f
      }, this._initDTS = {
        baseTime: m,
        timescale: f
      }) : h = f = void 0, {
        tracks: l,
        initPTS: h,
        timescale: f
      };
  }
  remuxVideo(e, t, s, i) {
    const r = e.inputTimeScale, o = e.samples, a = [], l = o.length, c = this._initPTS;
    let u = this.nextAvcDts, d = 8, h = this.videoSampleDuration, m, f, g = Number.POSITIVE_INFINITY, p = Number.NEGATIVE_INFINITY, E = !1;
    if (!s || u === null) {
      const P = t * r, O = o[0].pts - Be(o[0].dts, o[0].pts);
      Ft && u !== null && Math.abs(P - O - u) < 15e3 ? s = !0 : u = P - O;
    }
    const y = c.baseTime * r / c.timescale;
    for (let P = 0; P < l; P++) {
      const O = o[P];
      O.pts = Be(O.pts - y, u), O.dts = Be(O.dts - y, u), O.dts < o[P > 0 ? P - 1 : P].dts && (E = !0);
    }
    E && o.sort(function(P, O) {
      const K = P.dts - O.dts, V = P.pts - O.pts;
      return K || V;
    }), m = o[0].dts, f = o[o.length - 1].dts;
    const x = f - m, S = x ? Math.round(x / (l - 1)) : h || e.inputTimeScale / 30;
    if (s) {
      const P = m - u, O = P > S, K = P < -1;
      if ((O || K) && (O ? I.warn(`AVC: ${jt(P, !0)} ms (${P}dts) hole between fragments detected at ${t.toFixed(3)}`) : I.warn(`AVC: ${jt(-P, !0)} ms (${P}dts) overlapping between fragments detected at ${t.toFixed(3)}`), !K || u >= o[0].pts || Ft)) {
        m = u;
        const V = o[0].pts - P;
        if (O)
          o[0].dts = m, o[0].pts = V;
        else
          for (let J = 0; J < o.length && !(o[J].dts > V); J++)
            o[J].dts -= P, o[J].pts -= P;
        I.log(`Video: Initial PTS/DTS adjusted: ${jt(V, !0)}/${jt(m, !0)}, delta: ${jt(P, !0)} ms`);
      }
    }
    m = Math.max(0, m);
    let v = 0, D = 0, L = m;
    for (let P = 0; P < l; P++) {
      const O = o[P], K = O.units, V = K.length;
      let J = 0;
      for (let Z = 0; Z < V; Z++)
        J += K[Z].data.length;
      D += J, v += V, O.length = J, O.dts < L ? (O.dts = L, L += S / 4 | 0 || 1) : L = O.dts, g = Math.min(O.pts, g), p = Math.max(O.pts, p);
    }
    f = o[l - 1].dts;
    const _ = D + 4 * v + 8;
    let A;
    try {
      A = new Uint8Array(_);
    } catch (P) {
      this.observer.emit(T.ERROR, T.ERROR, {
        type: Q.MUX_ERROR,
        details: C.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: P,
        bytes: _,
        reason: `fail allocating video mdat ${_}`
      });
      return;
    }
    const R = new DataView(A.buffer);
    R.setUint32(0, _), A.set(b.types.mdat, 4);
    let w = !1, B = Number.POSITIVE_INFINITY, M = Number.POSITIVE_INFINITY, N = Number.NEGATIVE_INFINITY, $ = Number.NEGATIVE_INFINITY;
    for (let P = 0; P < l; P++) {
      const O = o[P], K = O.units;
      let V = 0;
      for (let ie = 0, X = K.length; ie < X; ie++) {
        const oe = K[ie], Me = oe.data, Pe = oe.data.byteLength;
        R.setUint32(d, Pe), d += 4, A.set(Me, d), d += Pe, V += 4 + Pe;
      }
      let J;
      if (P < l - 1)
        h = o[P + 1].dts - O.dts, J = o[P + 1].pts - O.pts;
      else {
        const ie = this.config, X = P > 0 ? O.dts - o[P - 1].dts : S;
        if (J = P > 0 ? O.pts - o[P - 1].pts : S, ie.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const oe = Math.floor(ie.maxBufferHole * r), Me = (i ? g + i * r : this.nextAudioPts) - O.pts;
          Me > oe ? (h = Me - X, h < 0 ? h = X : w = !0, I.log(`[mp4-remuxer]: It is approximately ${Me / 90} ms to the next segment; using duration ${h / 90} ms for the last video frame.`)) : h = X;
        } else
          h = X;
      }
      const Z = Math.round(O.pts - O.dts);
      B = Math.min(B, h), N = Math.max(N, h), M = Math.min(M, J), $ = Math.max($, J), a.push(new $r(O.key, h, V, Z));
    }
    if (a.length) {
      if (Ft) {
        if (Ft < 70) {
          const P = a[0].flags;
          P.dependsOn = 2, P.isNonSync = 0;
        }
      } else if (Ln && $ - M < N - B && S / N < 0.025 && a[0].cts === 0) {
        I.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let P = m;
        for (let O = 0, K = a.length; O < K; O++) {
          const V = P + a[O].duration, J = P + a[O].cts;
          if (O < K - 1) {
            const Z = V + a[O + 1].cts;
            a[O].duration = Z - J;
          } else
            a[O].duration = O ? a[O - 1].duration : S;
          a[O].cts = 0, P = V;
        }
      }
    }
    h = w || !h ? S : h, this.nextAvcDts = u = f + h, this.videoSampleDuration = h, this.isVideoContiguous = !0;
    const U = {
      data1: b.moof(e.sequenceNumber++, m, ve({}, e, {
        samples: a
      })),
      data2: A,
      startPTS: g / r,
      endPTS: (p + h) / r,
      startDTS: m / r,
      endDTS: u / r,
      type: "video",
      hasAudio: !1,
      hasVideo: !0,
      nb: a.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, U;
  }
  getSamplesPerFrame(e) {
    switch (e.segmentCodec) {
      case "mp3":
        return mg;
      case "ac3":
        return gg;
      default:
        return Br;
    }
  }
  remuxAudio(e, t, s, i, r) {
    const o = e.inputTimeScale, a = e.samplerate ? e.samplerate : o, l = o / a, c = this.getSamplesPerFrame(e), u = c * l, d = this._initPTS, h = e.segmentCodec === "mp3" && this.typeSupported.mpeg, m = [], f = r !== void 0;
    let g = e.samples, p = h ? 0 : 8, E = this.nextAudioPts || -1;
    const y = t * o, x = d.baseTime * o / d.timescale;
    if (this.isAudioContiguous = s = s || g.length && E > 0 && (i && Math.abs(y - E) < 9e3 || Math.abs(Be(g[0].pts - x, y) - E) < 20 * u), g.forEach(function(G) {
      G.pts = Be(G.pts - x, y);
    }), !s || E < 0) {
      if (g = g.filter((G) => G.pts >= 0), !g.length)
        return;
      r === 0 ? E = 0 : i && !f ? E = Math.max(0, y) : E = g[0].pts;
    }
    if (e.segmentCodec === "aac") {
      const G = this.config.maxAudioFramesDrift;
      for (let W = 0, U = E; W < g.length; W++) {
        const P = g[W], O = P.pts, K = O - U, V = Math.abs(1e3 * K / o);
        if (K <= -G * u && f)
          W === 0 && (I.warn(`Audio frame @ ${(O / o).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * K / o)} ms.`), this.nextAudioPts = E = U = O);
        else if (K >= G * u && V < fg && f) {
          let J = Math.round(K / u);
          U = O - J * u, U < 0 && (J--, U += u), W === 0 && (this.nextAudioPts = E = U), I.warn(`[mp4-remuxer]: Injecting ${J} audio frame @ ${(U / o).toFixed(3)}s due to ${Math.round(1e3 * K / o)} ms gap.`);
          for (let Z = 0; Z < J; Z++) {
            const ie = Math.max(U, 0);
            let X = Ur.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
            X || (I.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), X = P.unit.subarray()), g.splice(W, 0, {
              unit: X,
              pts: ie
            }), U += u, W++;
          }
        }
        P.pts = U, U += u;
      }
    }
    let S = null, v = null, D, L = 0, _ = g.length;
    for (; _--; )
      L += g[_].unit.byteLength;
    for (let G = 0, W = g.length; G < W; G++) {
      const U = g[G], P = U.unit;
      let O = U.pts;
      if (v !== null) {
        const V = m[G - 1];
        V.duration = Math.round((O - v) / l);
      } else if (s && e.segmentCodec === "aac" && (O = E), S = O, L > 0) {
        L += p;
        try {
          D = new Uint8Array(L);
        } catch (V) {
          this.observer.emit(T.ERROR, T.ERROR, {
            type: Q.MUX_ERROR,
            details: C.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: V,
            bytes: L,
            reason: `fail allocating audio mdat ${L}`
          });
          return;
        }
        h || (new DataView(D.buffer).setUint32(0, L), D.set(b.types.mdat, 4));
      } else
        return;
      D.set(P, p);
      const K = P.byteLength;
      p += K, m.push(new $r(!0, c, K, 0)), v = O;
    }
    const A = m.length;
    if (!A)
      return;
    const R = m[m.length - 1];
    this.nextAudioPts = E = v + l * R.duration;
    const w = h ? new Uint8Array(0) : b.moof(e.sequenceNumber++, S / l, ve({}, e, {
      samples: m
    }));
    e.samples = [];
    const B = S / o, M = E / o, $ = {
      data1: w,
      data2: D,
      startPTS: B,
      endPTS: M,
      startDTS: B,
      endDTS: M,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: A
    };
    return this.isAudioContiguous = !0, $;
  }
  remuxEmptyAudio(e, t, s, i) {
    const r = e.inputTimeScale, o = e.samplerate ? e.samplerate : r, a = r / o, l = this.nextAudioPts, c = this._initDTS, u = c.baseTime * 9e4 / c.timescale, d = (l !== null ? l : i.startDTS * r) + u, h = i.endDTS * r + u, m = a * Br, f = Math.ceil((h - d) / m), g = Ur.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
    if (I.warn("[mp4-remuxer]: remux empty Audio"), !g) {
      I.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
      return;
    }
    const p = [];
    for (let E = 0; E < f; E++) {
      const y = d + E * m;
      p.push({
        unit: g,
        pts: y,
        dts: y
      });
    }
    return e.samples = p, this.remuxAudio(e, t, s, !1);
  }
}
function Be(n, e) {
  let t;
  if (e === null)
    return n;
  for (e < n ? t = -8589934592 : t = 8589934592; Math.abs(n - e) > 4294967296; )
    n += t;
  return n;
}
function pg(n) {
  for (let e = 0; e < n.length; e++)
    if (n[e].key)
      return e;
  return -1;
}
function fa(n, e, t, s) {
  const i = n.samples.length;
  if (!i)
    return;
  const r = n.inputTimeScale;
  for (let a = 0; a < i; a++) {
    const l = n.samples[a];
    l.pts = Be(l.pts - t.baseTime * r / t.timescale, e * r) / r, l.dts = Be(l.dts - s.baseTime * r / s.timescale, e * r) / r;
  }
  const o = n.samples;
  return n.samples = [], {
    samples: o
  };
}
function ma(n, e, t) {
  const s = n.samples.length;
  if (!s)
    return;
  const i = n.inputTimeScale;
  for (let o = 0; o < s; o++) {
    const a = n.samples[o];
    a.pts = Be(a.pts - t.baseTime * i / t.timescale, e * i) / i;
  }
  n.samples.sort((o, a) => o.pts - a.pts);
  const r = n.samples;
  return n.samples = [], {
    samples: r
  };
}
class $r {
  constructor(e, t, s, i) {
    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = t, this.size = s, this.cts = i, this.flags = {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: e ? 2 : 1,
      isNonSync: e ? 0 : 1
    };
  }
}
class Tg {
  constructor() {
    this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(e, t, s, i) {
    this.audioCodec = t, this.videoCodec = s, this.generateInitSegment(Lf(e, i)), this.emitInitSegment = !0;
  }
  generateInitSegment(e) {
    let {
      audioCodec: t,
      videoCodec: s
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const i = this.initData = Bo(e);
    i.audio && (t = Gr(i.audio, le.AUDIO)), i.video && (s = Gr(i.video, le.VIDEO));
    const r = {};
    i.audio && i.video ? r.audiovideo = {
      container: "video/mp4",
      codec: t + "," + s,
      initSegment: e,
      id: "main"
    } : i.audio ? r.audio = {
      container: "audio/mp4",
      codec: t,
      initSegment: e,
      id: "audio"
    } : i.video ? r.video = {
      container: "video/mp4",
      codec: s,
      initSegment: e,
      id: "main"
    } : I.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = r;
  }
  remux(e, t, s, i, r, o) {
    var a, l;
    let {
      initPTS: c,
      lastEndTime: u
    } = this;
    const d = {
      audio: void 0,
      video: void 0,
      text: i,
      id3: s,
      initSegment: void 0
    };
    H(u) || (u = this.lastEndTime = r || 0);
    const h = t.samples;
    if (!(h != null && h.length))
      return d;
    const m = {
      initPTS: void 0,
      timescale: 1
    };
    let f = this.initData;
    if ((a = f) != null && a.length || (this.generateInitSegment(h), f = this.initData), !((l = f) != null && l.length))
      return I.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), d;
    this.emitInitSegment && (m.tracks = this.initTracks, this.emitInitSegment = !1);
    const g = Df(h, f), p = Rf(f, h), E = p === null ? r : p;
    (Eg(c, E, r, g) || m.timescale !== c.timescale && o) && (m.initPTS = E - r, c && c.timescale === 1 && I.warn(`Adjusting initPTS by ${m.initPTS - c.baseTime}`), this.initPTS = c = {
      baseTime: m.initPTS,
      timescale: 1
    });
    const y = e ? E - c.baseTime / c.timescale : u, x = y + g;
    bf(f, h, c.baseTime / c.timescale), g > 0 ? this.lastEndTime = x : (I.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const S = !!f.audio, v = !!f.video;
    let D = "";
    S && (D += "audio"), v && (D += "video");
    const L = {
      data1: h,
      startPTS: y,
      startDTS: y,
      endPTS: x,
      endDTS: x,
      type: D,
      hasAudio: S,
      hasVideo: v,
      nb: 1,
      dropped: 0
    };
    return d.audio = L.type === "audio" ? L : void 0, d.video = L.type !== "audio" ? L : void 0, d.initSegment = m, d.id3 = fa(s, r, c, c), i.samples.length && (d.text = ma(i, r, c)), d;
  }
}
function Eg(n, e, t, s) {
  if (n === null)
    return !0;
  const i = Math.max(s, 1), r = e - n.baseTime / n.timescale;
  return Math.abs(r - t) > i;
}
function Gr(n, e) {
  const t = n == null ? void 0 : n.codec;
  if (t && t.length > 4)
    return t;
  if (e === le.AUDIO) {
    if (t === "ec-3" || t === "ac-3" || t === "alac")
      return t;
    if (t === "fLaC" || t === "Opus")
      return Vs(t, !1);
    const s = "mp4a.40.5";
    return I.info(`Parsed audio codec "${t}" or audio object type not handled. Using "${s}"`), s;
  }
  return I.warn(`Unhandled video codec "${t}"`), t === "hvc1" || t === "hev1" ? "hvc1.1.6.L120.90" : t === "av01" ? "av01.0.04M.08" : "avc1.42e01e";
}
let at;
try {
  at = self.performance.now.bind(self.performance);
} catch {
  I.debug("Unable to use Performance API on this environment"), at = $t == null ? void 0 : $t.Date.now;
}
const ks = [{
  demux: ng,
  remux: Tg
}, {
  demux: ft,
  remux: Ms
}, {
  demux: tg,
  remux: Ms
}, {
  demux: ug,
  remux: Ms
}];
ks.splice(2, 0, {
  demux: ig,
  remux: Ms
});
class Hr {
  constructor(e, t, s, i, r) {
    this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = s, this.vendor = i, this.id = r;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, s, i) {
    const r = s.transmuxing;
    r.executeStart = at();
    let o = new Uint8Array(e);
    const {
      currentTransmuxState: a,
      transmuxConfig: l
    } = this;
    i && (this.currentTransmuxState = i);
    const {
      contiguous: c,
      discontinuity: u,
      trackSwitch: d,
      accurateTimeOffset: h,
      timeOffset: m,
      initSegmentChange: f
    } = i || a, {
      audioCodec: g,
      videoCodec: p,
      defaultInitPts: E,
      duration: y,
      initSegmentData: x
    } = l, S = yg(o, t);
    if (S && S.method === "AES-128") {
      const _ = this.getDecrypter();
      if (_.isSync()) {
        let A = _.softwareDecrypt(o, S.key.buffer, S.iv.buffer);
        if (s.part > -1 && (A = _.flush()), !A)
          return r.executeEnd = at(), Rn(s);
        o = new Uint8Array(A);
      } else
        return this.decryptionPromise = _.webCryptoDecrypt(o, S.key.buffer, S.iv.buffer).then((A) => {
          const R = this.push(A, null, s);
          return this.decryptionPromise = null, R;
        }), this.decryptionPromise;
    }
    const v = this.needsProbing(u, d);
    if (v) {
      const _ = this.configureTransmuxer(o);
      if (_)
        return I.warn(`[transmuxer] ${_.message}`), this.observer.emit(T.ERROR, T.ERROR, {
          type: Q.MEDIA_ERROR,
          details: C.FRAG_PARSING_ERROR,
          fatal: !1,
          error: _,
          reason: _.message
        }), r.executeEnd = at(), Rn(s);
    }
    (u || d || f || v) && this.resetInitSegment(x, g, p, y, t), (u || f || v) && this.resetInitialTimestamp(E), c || this.resetContiguity();
    const D = this.transmux(o, S, m, h, s), L = this.currentTransmuxState;
    return L.contiguous = !0, L.discontinuity = !1, L.trackSwitch = !1, r.executeEnd = at(), D;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = at();
    const {
      decrypter: s,
      currentTransmuxState: i,
      decryptionPromise: r
    } = this;
    if (r)
      return r.then(() => this.flush(e));
    const o = [], {
      timeOffset: a
    } = i;
    if (s) {
      const d = s.flush();
      d && o.push(this.push(d, null, e));
    }
    const {
      demuxer: l,
      remuxer: c
    } = this;
    if (!l || !c)
      return t.executeEnd = at(), [Rn(e)];
    const u = l.flush(a);
    return Fs(u) ? u.then((d) => (this.flushRemux(o, d, e), o)) : (this.flushRemux(o, u, e), o);
  }
  flushRemux(e, t, s) {
    const {
      audioTrack: i,
      videoTrack: r,
      id3Track: o,
      textTrack: a
    } = t, {
      accurateTimeOffset: l,
      timeOffset: c
    } = this.currentTransmuxState;
    I.log(`[transmuxer.ts]: Flushed fragment ${s.sn}${s.part > -1 ? " p: " + s.part : ""} of level ${s.level}`);
    const u = this.remuxer.remux(i, r, o, a, c, l, !0, this.id);
    e.push({
      remuxResult: u,
      chunkMeta: s
    }), s.transmuxing.executeEnd = at();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: s
    } = this;
    !t || !s || (t.resetTimeStamp(e), s.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, s, i, r) {
    const {
      demuxer: o,
      remuxer: a
    } = this;
    !o || !a || (o.resetInitSegment(e, t, s, i), a.resetInitSegment(e, t, s, r));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, s, i, r) {
    let o;
    return t && t.method === "SAMPLE-AES" ? o = this.transmuxSampleAes(e, t, s, i, r) : o = this.transmuxUnencrypted(e, s, i, r), o;
  }
  transmuxUnencrypted(e, t, s, i) {
    const {
      audioTrack: r,
      videoTrack: o,
      id3Track: a,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(r, o, a, l, t, s, !1, this.id),
      chunkMeta: i
    };
  }
  transmuxSampleAes(e, t, s, i, r) {
    return this.demuxer.demuxSampleAes(e, t, s).then((o) => ({
      remuxResult: this.remuxer.remux(o.audioTrack, o.videoTrack, o.id3Track, o.textTrack, s, i, !1, this.id),
      chunkMeta: r
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: s,
      typeSupported: i,
      vendor: r
    } = this;
    let o;
    for (let h = 0, m = ks.length; h < m; h++) {
      var a;
      if ((a = ks[h].demux) != null && a.probe(e)) {
        o = ks[h];
        break;
      }
    }
    if (!o)
      return new Error("Failed to find demuxer by probing fragment data");
    const l = this.demuxer, c = this.remuxer, u = o.remux, d = o.demux;
    (!c || !(c instanceof u)) && (this.remuxer = new u(s, t, i, r)), (!l || !(l instanceof d)) && (this.demuxer = new d(s, t, i), this.probe = d.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new hi(this.config)), e;
  }
}
function yg(n, e) {
  let t = null;
  return n.byteLength > 0 && (e == null ? void 0 : e.key) != null && e.iv !== null && e.method != null && (t = e), t;
}
const Rn = (n) => ({
  remuxResult: {},
  chunkMeta: n
});
function Fs(n) {
  return "then" in n && n.then instanceof Function;
}
class xg {
  constructor(e, t, s, i, r) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = s, this.duration = i, this.defaultInitPts = r || null;
  }
}
class vg {
  constructor(e, t, s, i, r, o) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = s, this.trackSwitch = i, this.timeOffset = r, this.initSegmentChange = o;
  }
}
var ga = { exports: {} };
(function(n) {
  var e = Object.prototype.hasOwnProperty, t = "~";
  function s() {
  }
  Object.create && (s.prototype = /* @__PURE__ */ Object.create(null), new s().__proto__ || (t = !1));
  function i(l, c, u) {
    this.fn = l, this.context = c, this.once = u || !1;
  }
  function r(l, c, u, d, h) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var m = new i(u, d || l, h), f = t ? t + c : c;
    return l._events[f] ? l._events[f].fn ? l._events[f] = [l._events[f], m] : l._events[f].push(m) : (l._events[f] = m, l._eventsCount++), l;
  }
  function o(l, c) {
    --l._eventsCount === 0 ? l._events = new s() : delete l._events[c];
  }
  function a() {
    this._events = new s(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var c = [], u, d;
    if (this._eventsCount === 0) return c;
    for (d in u = this._events)
      e.call(u, d) && c.push(t ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
  }, a.prototype.listeners = function(c) {
    var u = t ? t + c : c, d = this._events[u];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var h = 0, m = d.length, f = new Array(m); h < m; h++)
      f[h] = d[h].fn;
    return f;
  }, a.prototype.listenerCount = function(c) {
    var u = t ? t + c : c, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, a.prototype.emit = function(c, u, d, h, m, f) {
    var g = t ? t + c : c;
    if (!this._events[g]) return !1;
    var p = this._events[g], E = arguments.length, y, x;
    if (p.fn) {
      switch (p.once && this.removeListener(c, p.fn, void 0, !0), E) {
        case 1:
          return p.fn.call(p.context), !0;
        case 2:
          return p.fn.call(p.context, u), !0;
        case 3:
          return p.fn.call(p.context, u, d), !0;
        case 4:
          return p.fn.call(p.context, u, d, h), !0;
        case 5:
          return p.fn.call(p.context, u, d, h, m), !0;
        case 6:
          return p.fn.call(p.context, u, d, h, m, f), !0;
      }
      for (x = 1, y = new Array(E - 1); x < E; x++)
        y[x - 1] = arguments[x];
      p.fn.apply(p.context, y);
    } else {
      var S = p.length, v;
      for (x = 0; x < S; x++)
        switch (p[x].once && this.removeListener(c, p[x].fn, void 0, !0), E) {
          case 1:
            p[x].fn.call(p[x].context);
            break;
          case 2:
            p[x].fn.call(p[x].context, u);
            break;
          case 3:
            p[x].fn.call(p[x].context, u, d);
            break;
          case 4:
            p[x].fn.call(p[x].context, u, d, h);
            break;
          default:
            if (!y) for (v = 1, y = new Array(E - 1); v < E; v++)
              y[v - 1] = arguments[v];
            p[x].fn.apply(p[x].context, y);
        }
    }
    return !0;
  }, a.prototype.on = function(c, u, d) {
    return r(this, c, u, d, !1);
  }, a.prototype.once = function(c, u, d) {
    return r(this, c, u, d, !0);
  }, a.prototype.removeListener = function(c, u, d, h) {
    var m = t ? t + c : c;
    if (!this._events[m]) return this;
    if (!u)
      return o(this, m), this;
    var f = this._events[m];
    if (f.fn)
      f.fn === u && (!h || f.once) && (!d || f.context === d) && o(this, m);
    else {
      for (var g = 0, p = [], E = f.length; g < E; g++)
        (f[g].fn !== u || h && !f[g].once || d && f[g].context !== d) && p.push(f[g]);
      p.length ? this._events[m] = p.length === 1 ? p[0] : p : o(this, m);
    }
    return this;
  }, a.prototype.removeAllListeners = function(c) {
    var u;
    return c ? (u = t ? t + c : c, this._events[u] && o(this, u)) : (this._events = new s(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, n.exports = a;
})(ga);
var Sg = ga.exports, Ei = /* @__PURE__ */ Vh(Sg);
class pa {
  constructor(e, t, s, i) {
    this.error = null, this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
    const r = e.config;
    this.hls = e, this.id = t, this.useWorker = !!r.enableWorker, this.onTransmuxComplete = s, this.onFlush = i;
    const o = (c, u) => {
      u = u || {}, u.frag = this.frag, u.id = this.id, c === T.ERROR && (this.error = u.error), this.hls.trigger(c, u);
    };
    this.observer = new Ei(), this.observer.on(T.FRAG_DECRYPTED, o), this.observer.on(T.ERROR, o);
    const a = At(r.preferManagedMediaSource) || {
      isTypeSupported: () => !1
    }, l = {
      mpeg: a.isTypeSupported("audio/mpeg"),
      mp3: a.isTypeSupported('audio/mp4; codecs="mp3"'),
      ac3: a.isTypeSupported('audio/mp4; codecs="ac-3"')
    };
    if (this.useWorker && typeof Worker != "undefined" && (r.workerPath || Gm())) {
      try {
        r.workerPath ? (I.log(`loading Web Worker ${r.workerPath} for "${t}"`), this.workerContext = Km(r.workerPath)) : (I.log(`injecting Web Worker for "${t}"`), this.workerContext = Hm()), this.onwmsg = (d) => this.onWorkerMessage(d);
        const {
          worker: u
        } = this.workerContext;
        u.addEventListener("message", this.onwmsg), u.onerror = (d) => {
          const h = new Error(`${d.message}  (${d.filename}:${d.lineno})`);
          r.enableWorker = !1, I.warn(`Error in "${t}" Web Worker, fallback to inline`), this.hls.trigger(T.ERROR, {
            type: Q.OTHER_ERROR,
            details: C.INTERNAL_EXCEPTION,
            fatal: !1,
            event: "demuxerWorker",
            error: h
          });
        }, u.postMessage({
          cmd: "init",
          typeSupported: l,
          vendor: "",
          id: t,
          config: JSON.stringify(r)
        });
      } catch (u) {
        I.warn(`Error setting up "${t}" Web Worker, fallback to inline`, u), this.resetWorker(), this.error = null, this.transmuxer = new Hr(this.observer, l, r, "", t);
      }
      return;
    }
    this.transmuxer = new Hr(this.observer, l, r, "", t);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker: e,
        objectURL: t
      } = this.workerContext;
      t && self.URL.revokeObjectURL(t), e.removeEventListener("message", this.onwmsg), e.onerror = null, e.terminate(), this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext)
      this.resetWorker(), this.onwmsg = void 0;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
  }
  push(e, t, s, i, r, o, a, l, c, u) {
    var d, h;
    c.transmuxing.start = self.performance.now();
    const {
      transmuxer: m
    } = this, f = o ? o.start : r.start, g = r.decryptdata, p = this.frag, E = !(p && r.cc === p.cc), y = !(p && c.level === p.level), x = p ? c.sn - p.sn : -1, S = this.part ? c.part - this.part.index : -1, v = x === 0 && c.id > 1 && c.id === (p == null ? void 0 : p.stats.chunkCount), D = !y && (x === 1 || x === 0 && (S === 1 || v && S <= 0)), L = self.performance.now();
    (y || x || r.stats.parsing.start === 0) && (r.stats.parsing.start = L), o && (S || !D) && (o.stats.parsing.start = L);
    const _ = !(p && ((d = r.initSegment) == null ? void 0 : d.url) === ((h = p.initSegment) == null ? void 0 : h.url)), A = new vg(E, D, l, y, f, _);
    if (!D || E || _) {
      I.log(`[transmuxer-interface, ${r.type}]: Starting new transmux session for sn: ${c.sn} p: ${c.part} level: ${c.level} id: ${c.id}
        discontinuity: ${E}
        trackSwitch: ${y}
        contiguous: ${D}
        accurateTimeOffset: ${l}
        timeOffset: ${f}
        initSegmentChange: ${_}`);
      const R = new xg(s, i, t, a, u);
      this.configureTransmuxer(R);
    }
    if (this.frag = r, this.part = o, this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "demux",
        data: e,
        decryptdata: g,
        chunkMeta: c,
        state: A
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (m) {
      const R = m.push(e, g, c, A);
      Fs(R) ? (m.async = !0, R.then((w) => {
        this.handleTransmuxComplete(w);
      }).catch((w) => {
        this.transmuxerError(w, c, "transmuxer-interface push error");
      })) : (m.async = !1, this.handleTransmuxComplete(R));
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      transmuxer: t
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "flush",
        chunkMeta: e
      });
    else if (t) {
      let s = t.flush(e);
      Fs(s) || t.async ? (Fs(s) || (s = Promise.resolve(s)), s.then((r) => {
        this.handleFlushResult(r, e);
      }).catch((r) => {
        this.transmuxerError(r, e, "transmuxer-interface flush error");
      })) : this.handleFlushResult(s, e);
    }
  }
  transmuxerError(e, t, s) {
    this.hls && (this.error = e, this.hls.trigger(T.ERROR, {
      type: Q.MEDIA_ERROR,
      details: C.FRAG_PARSING_ERROR,
      chunkMeta: t,
      frag: this.frag || void 0,
      fatal: !1,
      error: e,
      err: e,
      reason: s
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((s) => {
      this.handleTransmuxComplete(s);
    }), this.onFlush(t);
  }
  onWorkerMessage(e) {
    const t = e.data;
    if (!(t != null && t.event)) {
      I.warn(`worker message received with no ${t ? "event name" : "data"}`);
      return;
    }
    const s = this.hls;
    if (this.hls)
      switch (t.event) {
        case "init": {
          var i;
          const r = (i = this.workerContext) == null ? void 0 : i.objectURL;
          r && self.URL.revokeObjectURL(r);
          break;
        }
        case "transmuxComplete": {
          this.handleTransmuxComplete(t.data);
          break;
        }
        case "flush": {
          this.onFlush(t.data);
          break;
        }
        // pass logs from the worker thread to the main logger
        case "workerLog":
          I[t.data.logType] && I[t.data.logType](t.data.message);
          break;
        default: {
          t.data = t.data || {}, t.data.frag = this.frag, t.data.id = this.id, s.trigger(t.event, t.data);
          break;
        }
      }
  }
  configureTransmuxer(e) {
    const {
      transmuxer: t
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      cmd: "configure",
      config: e
    }) : t && t.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
function Ta(n, e) {
  if (n.length !== e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!Ht(n[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function Ht(n, e, t) {
  const s = n["STABLE-RENDITION-ID"];
  return s && !t ? s === e["STABLE-RENDITION-ID"] : !(t || ["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED", "ASSOC-LANGUAGE"]).some((i) => n[i] !== e[i]);
}
function Zn(n, e) {
  return e.label.toLowerCase() === n.name.toLowerCase() && (!e.language || e.language.toLowerCase() === (n.lang || "").toLowerCase());
}
const Kr = 100;
class Ag extends fi {
  constructor(e, t, s) {
    super(e, t, s, "[audio-stream-controller]", j.AUDIO), this.videoBuffer = null, this.videoTrackCC = -1, this.waitingVideoCC = -1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.flushing = !1, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null, this.bufferedTrack = null, this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(T.ERROR, this.onError, this), e.on(T.BUFFER_RESET, this.onBufferReset, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(T.ERROR, this.onError, this), e.off(T.BUFFER_RESET, this.onBufferReset, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: s,
    initPTS: i,
    timescale: r
  }) {
    if (s === "main") {
      const o = t.cc;
      this.initPTS[t.cc] = {
        baseTime: i,
        timescale: r
      }, this.log(`InitPTS for cc: ${o} found from main: ${i}`), this.videoTrackCC = o, this.state === k.WAITING_INIT_PTS && this.tick();
    }
  }
  startLoad(e) {
    if (!this.levels) {
      this.startPosition = e, this.state = k.STOPPED;
      return;
    }
    const t = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(Kr), t > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t, this.state = k.IDLE) : (this.loadedmetadata = !1, this.state = k.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case k.IDLE:
        this.doTickIdle();
        break;
      case k.WAITING_TRACK: {
        var e;
        const {
          levels: s,
          trackId: i
        } = this, r = s == null || (e = s[i]) == null ? void 0 : e.details;
        if (r) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = k.WAITING_INIT_PTS;
        }
        break;
      }
      case k.FRAG_LOADING_WAITING_RETRY: {
        var t;
        const s = performance.now(), i = this.retryDate;
        if (!i || s >= i || (t = this.media) != null && t.seeking) {
          const {
            levels: r,
            trackId: o
          } = this;
          this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded((r == null ? void 0 : r[o]) || null), this.state = k.IDLE;
        }
        break;
      }
      case k.WAITING_INIT_PTS: {
        const s = this.waitingData;
        if (s) {
          const {
            frag: i,
            part: r,
            cache: o,
            complete: a
          } = s;
          if (this.initPTS[i.cc] !== void 0) {
            this.waitingData = null, this.waitingVideoCC = -1, this.state = k.FRAG_LOADING;
            const l = o.flush(), c = {
              frag: i,
              part: r,
              payload: l,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(c), a && super._handleFragmentLoadComplete(c);
          } else if (this.videoTrackCC !== this.waitingVideoCC)
            this.log(`Waiting fragment cc (${i.cc}) cancelled because video is at cc ${this.videoTrackCC}`), this.clearWaitingFragment();
          else {
            const l = this.getLoadPosition(), c = he.bufferInfo(this.mediaBuffer, l, this.config.maxBufferHole);
            Xn(c.end, this.config.maxFragLookUpTolerance, i) < 0 && (this.log(`Waiting fragment cc (${i.cc}) @ ${i.start} cancelled because another fragment at ${c.end} is needed`), this.clearWaitingFragment());
          }
        } else
          this.state = k.IDLE;
      }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = k.IDLE);
  }
  resetLoadingState() {
    this.clearWaitingFragment(), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    const {
      hls: e,
      levels: t,
      media: s,
      trackId: i
    } = this, r = e.config;
    if (!s && (this.startFragRequested || !r.startFragPrefetch) || !(t != null && t[i]))
      return;
    const o = t[i], a = o.details;
    if (!a || a.live && this.levelLastLoaded !== o || this.waitForCdnTuneIn(a)) {
      this.state = k.WAITING_TRACK;
      return;
    }
    const l = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && l && (this.bufferFlushed = !1, this.afterBufferFlushed(l, le.AUDIO, j.AUDIO));
    const c = this.getFwdBufferInfo(l, j.AUDIO);
    if (c === null)
      return;
    const {
      bufferedTrack: u,
      switchingTrack: d
    } = this;
    if (!d && this._streamEnded(c, a)) {
      e.trigger(T.BUFFER_EOS, {
        type: "audio"
      }), this.state = k.ENDED;
      return;
    }
    const h = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, j.MAIN), m = c.len, f = this.getMaxBufferLength(h == null ? void 0 : h.len), g = a.fragments, p = g[0].start;
    let E = this.flushing ? this.getLoadPosition() : c.end;
    if (d && s) {
      const v = this.getLoadPosition();
      u && !Ht(d.attrs, u.attrs) && (E = v), a.PTSKnown && v < p && (c.end > p || c.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), s.currentTime = p + 0.05);
    }
    if (m >= f && !d && E < g[g.length - 1].start)
      return;
    let y = this.getNextFragment(E, a), x = !1;
    if (y && this.isLoopLoading(y, E) && (x = !!y.gap, y = this.getNextFragmentLoopLoading(y, a, c, j.MAIN, f)), !y) {
      this.bufferFlushed = !0;
      return;
    }
    const S = h && y.start > h.end + a.targetduration;
    if (S || // Or wait for main buffer after buffing some audio
    !(h != null && h.len) && c.len) {
      const v = this.getAppendedFrag(y.start, j.MAIN);
      if (v === null || (x || (x = !!v.gap || !!S && h.len === 0), S && !x || x && c.nextStart && c.nextStart < v.end))
        return;
    }
    this.loadFragment(y, o, E);
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.min(Math.max(t, e), this.config.maxMaxBufferLength) : t;
  }
  onMediaDetaching() {
    this.videoBuffer = null, this.bufferFlushed = this.flushing = !1, super.onMediaDetaching();
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((s) => new Gt(s));
  }
  onAudioTrackSwitching(e, t) {
    const s = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: i
    } = this;
    i && (i.abortRequests(), this.removeUnbufferedFrags(i.start)), this.resetLoadingState(), s ? this.setInterval(Kr) : this.resetTransmuxer(), s ? (this.switchingTrack = t, this.state = k.IDLE, this.flushAudioIfNeeded(t)) : (this.switchingTrack = null, this.bufferedTrack = t, this.state = k.STOPPED), this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = this.flushing = !1, this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null, this.startFragRequested = !1, this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(T.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
  }
  onAudioTrackLoaded(e, t) {
    var s;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = t;
      return;
    }
    const {
      levels: i
    } = this, {
      details: r,
      id: o
    } = t;
    if (!i) {
      this.warn(`Audio tracks were reset while loading level ${o}`);
      return;
    }
    this.log(`Audio track ${o} loaded [${r.startSN},${r.endSN}]${r.lastPartSn ? `[part-${r.lastPartSn}-${r.lastPartIndex}]` : ""},duration:${r.totalduration}`);
    const a = i[o];
    let l = 0;
    if (r.live || (s = a.details) != null && s.live) {
      this.checkLiveUpdate(r);
      const u = this.mainDetails;
      if (r.deltaUpdateFailed || !u)
        return;
      if (!a.details && r.hasProgramDateTime && u.hasProgramDateTime)
        js(r, u), l = r.fragments[0].start;
      else {
        var c;
        l = this.alignPlaylists(r, a.details, (c = this.levelLastLoaded) == null ? void 0 : c.details);
      }
    }
    a.details = r, this.levelLastLoaded = a, !this.startFragRequested && (this.mainDetails || !r.live) && this.setStartPosition(this.mainDetails || r, l), this.state === k.WAITING_TRACK && !this.waitForCdnTuneIn(r) && (this.state = k.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: s,
      part: i,
      payload: r
    } = e, {
      config: o,
      trackId: a,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${s.sn} of level ${s.level} will not be buffered`);
      return;
    }
    const c = l[a];
    if (!c) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const u = c.details;
    if (!u) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(s.start);
      return;
    }
    const d = o.defaultAudioCodec || c.audioCodec || "mp4a.40.2";
    let h = this.transmuxer;
    h || (h = this.transmuxer = new pa(this.hls, j.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const m = this.initPTS[s.cc], f = (t = s.initSegment) == null ? void 0 : t.data;
    if (m !== void 0) {
      const p = i ? i.index : -1, E = p !== -1, y = new di(s.level, s.sn, s.stats.chunkCount, r.byteLength, p, E);
      h.push(r, f, d, "", s, i, u.totalduration, !1, y, m);
    } else {
      this.log(`Unknown video PTS for cc ${s.cc}, waiting for video PTS before demuxing audio frag ${s.sn} of [${u.startSN} ,${u.endSN}],track ${a}`);
      const {
        cache: g
      } = this.waitingData = this.waitingData || {
        frag: s,
        part: i,
        cache: new ea(),
        complete: !1
      };
      g.push(new Uint8Array(r)), this.waitingVideoCC = this.videoTrackCC, this.state = k.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
  }
  onBufferCreated(e, t) {
    const s = t.tracks.audio;
    s && (this.mediaBuffer = s.buffer || null), t.tracks.video && (this.videoBuffer = t.tracks.video.buffer || null);
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: i
    } = t;
    if (s.type !== j.AUDIO) {
      if (!this.loadedmetadata && s.type === j.MAIN) {
        const r = this.videoBuffer || this.media;
        r && he.getBuffered(r).length && (this.loadedmetadata = !0);
      }
      return;
    }
    if (this.fragContextChanged(s)) {
      this.warn(`Fragment ${s.sn}${i ? " p: " + i.index : ""} of level ${s.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (s.sn !== "initSegment") {
      this.fragPrevious = s;
      const r = this.switchingTrack;
      r && (this.bufferedTrack = r, this.switchingTrack = null, this.hls.trigger(T.AUDIO_TRACK_SWITCHED, De({}, r)));
    }
    this.fragBufferedComplete(s, i);
  }
  onError(e, t) {
    var s;
    if (t.fatal) {
      this.state = k.ERROR;
      return;
    }
    switch (t.details) {
      case C.FRAG_GAP:
      case C.FRAG_PARSING_ERROR:
      case C.FRAG_DECRYPT_ERROR:
      case C.FRAG_LOAD_ERROR:
      case C.FRAG_LOAD_TIMEOUT:
      case C.KEY_LOAD_ERROR:
      case C.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(j.AUDIO, t);
        break;
      case C.AUDIO_TRACK_LOAD_ERROR:
      case C.AUDIO_TRACK_LOAD_TIMEOUT:
      case C.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === k.WAITING_TRACK && ((s = t.context) == null ? void 0 : s.type) === re.AUDIO_TRACK && (this.state = k.IDLE);
        break;
      case C.BUFFER_APPEND_ERROR:
      case C.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "audio")
          return;
        if (t.details === C.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case C.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushing(e, {
    type: t
  }) {
    t !== le.VIDEO && (this.flushing = !0);
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== le.VIDEO) {
      this.flushing = !1, this.bufferFlushed = !0, this.state === k.ENDED && (this.state = k.IDLE);
      const s = this.mediaBuffer || this.media;
      s && (this.afterBufferFlushed(s, t, j.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(e) {
    var t;
    const s = "audio", {
      hls: i
    } = this, {
      remuxResult: r,
      chunkMeta: o
    } = e, a = this.getCurrentContext(o);
    if (!a) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: l,
      part: c,
      level: u
    } = a, {
      details: d
    } = u, {
      audio: h,
      text: m,
      id3: f,
      initSegment: g
    } = r;
    if (this.fragContextChanged(l) || !d) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = k.PARSING, this.switchingTrack && h && this.completeAudioSwitch(this.switchingTrack), g != null && g.tracks) {
      const p = l.initSegment || l;
      this._bufferInitSegment(u, g.tracks, p, o), i.trigger(T.FRAG_PARSING_INIT_SEGMENT, {
        frag: p,
        id: s,
        tracks: g.tracks
      });
    }
    if (h) {
      const {
        startPTS: p,
        endPTS: E,
        startDTS: y,
        endDTS: x
      } = h;
      c && (c.elementaryStreams[le.AUDIO] = {
        startPTS: p,
        endPTS: E,
        startDTS: y,
        endDTS: x
      }), l.setElementaryStreamInfo(le.AUDIO, p, E, y, x), this.bufferFragmentData(h, l, c, o);
    }
    if (f != null && (t = f.samples) != null && t.length) {
      const p = ve({
        id: s,
        frag: l,
        details: d
      }, f);
      i.trigger(T.FRAG_PARSING_METADATA, p);
    }
    if (m) {
      const p = ve({
        id: s,
        frag: l,
        details: d
      }, m);
      i.trigger(T.FRAG_PARSING_USERDATA, p);
    }
  }
  _bufferInitSegment(e, t, s, i) {
    if (this.state !== k.PARSING)
      return;
    t.video && delete t.video;
    const r = t.audio;
    if (!r)
      return;
    r.id = "audio";
    const o = e.audioCodec;
    this.log(`Init audio buffer, container:${r.container}, codecs[level/parsed]=[${o}/${r.codec}]`), o && o.split(",").length === 1 && (r.levelCodec = o), this.hls.trigger(T.BUFFER_CODECS, t);
    const a = r.initSegment;
    if (a != null && a.byteLength) {
      const l = {
        type: "audio",
        frag: s,
        part: null,
        chunkMeta: i,
        parent: s.type,
        data: a
      };
      this.hls.trigger(T.BUFFER_APPENDING, l);
    }
    this.tickImmediate();
  }
  loadFragment(e, t, s) {
    const i = this.fragmentTracker.getState(e);
    if (this.fragCurrent = e, this.switchingTrack || i === Re.NOT_LOADED || i === Re.PARTIAL) {
      var r;
      if (e.sn === "initSegment")
        this._loadInitSegment(e, t);
      else if ((r = t.details) != null && r.live && !this.initPTS[e.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = k.WAITING_INIT_PTS;
        const o = this.mainDetails;
        o && o.fragments[0].start !== t.details.fragments[0].start && js(t.details, o);
      } else
        this.startFragRequested = !0, super.loadFragment(e, t, s);
    } else
      this.clearTrackerIfNeeded(e);
  }
  flushAudioIfNeeded(e) {
    const {
      media: t,
      bufferedTrack: s
    } = this, i = s == null ? void 0 : s.attrs, r = e.attrs;
    t && i && (i.CHANNELS !== r.CHANNELS || s.name !== e.name || s.lang !== e.lang) && (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null);
  }
  completeAudioSwitch(e) {
    const {
      hls: t
    } = this;
    this.flushAudioIfNeeded(e), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(T.AUDIO_TRACK_SWITCHED, De({}, e));
  }
}
class Lg extends ui {
  constructor(e) {
    super(e, "[audio-track-controller]"), this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(T.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.tracksInGroup = [], this.groupIds = null, this.currentTrack = null, this.trackId = -1, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: s,
      groupId: i,
      details: r
    } = t, o = this.tracksInGroup[s];
    if (!o || o.groupId !== i) {
      this.warn(`Audio track with id:${s} and group:${i} not found in active group ${o == null ? void 0 : o.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Audio track ${s} "${o.name}" lang:${o.lang} group:${i} loaded [${r.startSN}-${r.endSN}]`), s === this.trackId && this.playlistLoaded(s, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const s = t.audioGroups || null, i = this.groupIds;
    let r = this.currentTrack;
    if (!s || (i == null ? void 0 : i.length) !== (s == null ? void 0 : s.length) || s != null && s.some((a) => (i == null ? void 0 : i.indexOf(a)) === -1)) {
      this.groupIds = s, this.trackId = -1, this.currentTrack = null;
      const a = this.tracks.filter((h) => !s || s.indexOf(h.groupId) !== -1);
      if (a.length)
        this.selectDefaultTrack && !a.some((h) => h.default) && (this.selectDefaultTrack = !1), a.forEach((h, m) => {
          h.id = m;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = a;
      const l = this.hls.config.audioPreference;
      if (!r && l) {
        const h = Qe(l, a, wt);
        if (h > -1)
          r = a[h];
        else {
          const m = Qe(l, this.tracks);
          r = this.tracks[m];
        }
      }
      let c = this.findTrackId(r);
      c === -1 && r && (c = this.findTrackId(null));
      const u = {
        audioTracks: a
      };
      this.log(`Updating audio tracks, ${a.length} track(s) found in group(s): ${s == null ? void 0 : s.join(",")}`), this.hls.trigger(T.AUDIO_TRACKS_UPDATED, u);
      const d = this.trackId;
      if (c !== -1 && d === -1)
        this.setAudioTrack(c);
      else if (a.length && d === -1) {
        var o;
        const h = new Error(`No audio track selected for current audio group-ID(s): ${(o = this.groupIds) == null ? void 0 : o.join(",")} track count: ${a.length}`);
        this.warn(h.message), this.hls.trigger(T.ERROR, {
          type: Q.MEDIA_ERROR,
          details: C.AUDIO_TRACK_LOAD_ERROR,
          fatal: !0,
          error: h
        });
      }
    } else this.shouldReloadPlaylist(r) && this.setAudioTrack(this.trackId);
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === re.AUDIO_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && (this.requestScheduled = -1, this.checkRetry(t));
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioOption(e) {
    const t = this.hls;
    if (t.config.audioPreference = e, e) {
      const s = this.allAudioTracks;
      if (this.selectDefaultTrack = !1, s.length) {
        const i = this.currentTrack;
        if (i && Nt(e, i, wt))
          return i;
        const r = Qe(e, this.tracksInGroup, wt);
        if (r > -1) {
          const o = this.tracksInGroup[r];
          return this.setAudioTrack(r), o;
        } else if (i) {
          let o = t.loadLevel;
          o === -1 && (o = t.firstAutoLevel);
          const a = Lm(e, t.levels, s, o, wt);
          if (a === -1)
            return null;
          t.nextLoadLevel = a;
        }
        if (e.channels || e.audioCodec) {
          const o = Qe(e, s);
          if (o > -1)
            return s[o];
        }
      }
    }
    return null;
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn(`Invalid audio track id: ${e}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const s = this.currentTrack, i = t[e], r = i.details && !i.details.live;
    if (e === this.trackId && i === s && r || (this.log(`Switching to audio-track ${e} "${i.name}" lang:${i.lang} group:${i.groupId} channels:${i.channels}`), this.trackId = e, this.currentTrack = i, this.hls.trigger(T.AUDIO_TRACK_SWITCHING, De({}, i)), r))
      return;
    const o = this.switchParams(i.url, s == null ? void 0 : s.details, i.details);
    this.loadPlaylist(o);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      if (!(this.selectDefaultTrack && !i.default) && (!e || Nt(e, i, wt)))
        return s;
    }
    if (e) {
      const {
        name: s,
        lang: i,
        assocLang: r,
        characteristics: o,
        audioCodec: a,
        channels: l
      } = e;
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (Nt({
          name: s,
          lang: i,
          assocLang: r,
          characteristics: o,
          audioCodec: a,
          channels: l
        }, u, wt))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (Ht(e.attrs, u.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (Ht(e.attrs, u.attrs, ["LANGUAGE"]))
          return c;
      }
    }
    return -1;
  }
  loadPlaylist(e) {
    const t = this.currentTrack;
    if (this.shouldLoadPlaylist(t) && t) {
      super.loadPlaylist();
      const s = t.id, i = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      this.log(`loading audio-track playlist ${s} "${t.name}" lang:${t.lang} group:${i}`), this.clearTimer(), this.hls.trigger(T.AUDIO_TRACK_LOADING, {
        url: r,
        id: s,
        groupId: i,
        deliveryDirectives: e || null
      });
    }
  }
}
const Vr = 500;
class Rg extends fi {
  constructor(e, t, s) {
    super(e, t, s, "[subtitle-stream-controller]", j.SUBTITLE), this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.ERROR, this.onError, this), e.on(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(T.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.ERROR, this.onError, this), e.off(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(T.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(e) {
    this.stopLoad(), this.state = k.IDLE, this.setInterval(Vr), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null, this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [], super.onMediaDetaching();
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: s,
      success: i
    } = t;
    if (this.fragPrevious = s, this.state = k.IDLE, !i)
      return;
    const r = this.tracksBuffered[this.currentTrackId];
    if (!r)
      return;
    let o;
    const a = s.start;
    for (let c = 0; c < r.length; c++)
      if (a >= r[c].start && a <= r[c].end) {
        o = r[c];
        break;
      }
    const l = s.start + s.duration;
    o ? o.end = l : (o = {
      start: a,
      end: l
    }, r.push(o)), this.fragmentTracker.fragBuffered(s), this.fragBufferedComplete(s, null);
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: s,
      endOffset: i
    } = t;
    if (s === 0 && i !== Number.POSITIVE_INFINITY) {
      const r = i - 1;
      if (r <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, r), this.tracksBuffered.forEach((o) => {
        for (let a = 0; a < o.length; ) {
          if (o[a].end <= r) {
            o.shift();
            continue;
          } else if (o[a].start < r)
            o[a].start = r;
          else
            break;
          a++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(s, r, j.SUBTITLE);
    }
  }
  onFragBuffered(e, t) {
    if (!this.loadedmetadata && t.frag.type === j.MAIN) {
      var s;
      (s = this.media) != null && s.buffered.length && (this.loadedmetadata = !0);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const s = t.frag;
    (s == null ? void 0 : s.type) === j.SUBTITLE && (t.details === C.FRAG_GAP && this.fragmentTracker.fragBuffered(s, !0), this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== k.STOPPED && (this.state = k.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (this.levels && Ta(this.levels, t)) {
      this.levels = t.map((s) => new Gt(s));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((s) => {
      const i = new Gt(s);
      return this.tracksBuffered[i.id] = [], i;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, j.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    var s;
    if (this.currentTrackId = t.id, !((s = this.levels) != null && s.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const i = this.levels[this.currentTrackId];
    i != null && i.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, i && this.setInterval(Vr);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var s;
    const {
      currentTrackId: i,
      levels: r
    } = this, {
      details: o,
      id: a
    } = t;
    if (!r) {
      this.warn(`Subtitle tracks were reset while loading level ${a}`);
      return;
    }
    const l = r[a];
    if (a >= r.length || !l)
      return;
    this.log(`Subtitle track ${a} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""},duration:${o.totalduration}`), this.mediaBuffer = this.mediaBufferTimeRanges;
    let c = 0;
    if (o.live || (s = l.details) != null && s.live) {
      const d = this.mainDetails;
      if (o.deltaUpdateFailed || !d)
        return;
      const h = d.fragments[0];
      if (!l.details)
        o.hasProgramDateTime && d.hasProgramDateTime ? (js(o, d), c = o.fragments[0].start) : h && (c = h.start, jn(o, c));
      else {
        var u;
        c = this.alignPlaylists(o, l.details, (u = this.levelLastLoaded) == null ? void 0 : u.details), c === 0 && h && (c = h.start, jn(o, c));
      }
    }
    l.details = o, this.levelLastLoaded = l, a === i && (!this.startFragRequested && (this.mainDetails || !o.live) && this.setStartPosition(this.mainDetails || o, c), this.tick(), o.live && !this.fragCurrent && this.media && this.state === k.IDLE && (zs(null, o.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0)));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: s
    } = e, i = t.decryptdata, r = this.hls;
    if (!this.fragContextChanged(t) && s && s.byteLength > 0 && i != null && i.key && i.iv && i.method === "AES-128") {
      const o = performance.now();
      this.decrypter.decrypt(new Uint8Array(s), i.key.buffer, i.iv.buffer).catch((a) => {
        throw r.trigger(T.ERROR, {
          type: Q.MEDIA_ERROR,
          details: C.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: a,
          reason: a.message,
          frag: t
        }), a;
      }).then((a) => {
        const l = performance.now();
        r.trigger(T.FRAG_DECRYPTED, {
          frag: t,
          payload: a,
          stats: {
            tstart: o,
            tdecrypt: l
          }
        });
      }).catch((a) => {
        this.warn(`${a.name}: ${a.message}`), this.state = k.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = k.IDLE;
      return;
    }
    if (this.state === k.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, s = t == null ? void 0 : t[e];
      if (!s || !t.length || !s.details)
        return;
      const {
        config: i
      } = this, r = this.getLoadPosition(), o = he.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], r, i.maxBufferHole), {
        end: a,
        len: l
      } = o, c = this.getFwdBufferInfo(this.media, j.MAIN), u = s.details, d = this.getMaxBufferLength(c == null ? void 0 : c.len) + u.levelTargetDuration;
      if (l > d)
        return;
      const h = u.fragments, m = h.length, f = u.edge;
      let g = null;
      const p = this.fragPrevious;
      if (a < f) {
        const E = i.maxFragLookUpTolerance, y = a > f - E ? 0 : E;
        g = zs(p, h, Math.max(h[0].start, a), y), !g && p && p.start < h[0].start && (g = h[0]);
      } else
        g = h[m - 1];
      if (!g)
        return;
      if (g = this.mapToInitFragWhenRequired(g), g.sn !== "initSegment") {
        const E = g.sn - u.startSN, y = h[E - 1];
        y && y.cc === g.cc && this.fragmentTracker.getState(y) === Re.NOT_LOADED && (g = y);
      }
      this.fragmentTracker.getState(g) === Re.NOT_LOADED && this.loadFragment(g, s, a);
    }
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.max(t, e) : t;
  }
  loadFragment(e, t, s) {
    this.fragCurrent = e, e.sn === "initSegment" ? this._loadInitSegment(e, t) : (this.startFragRequested = !0, super.loadFragment(e, t, s));
  }
  get mediaBufferTimeRanges() {
    return new Dg(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class Dg {
  constructor(e) {
    this.buffered = void 0;
    const t = (s, i, r) => {
      if (i = i >>> 0, i > r - 1)
        throw new DOMException(`Failed to execute '${s}' on 'TimeRanges': The index provided (${i}) is greater than the maximum bound (${r})`);
      return e[i][s];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(s) {
        return t("end", s, e.length);
      },
      start(s) {
        return t("start", s, e.length);
      }
    };
  }
}
class Ig extends ui {
  constructor(e) {
    super(e, "[subtitle-track-controller]"), this.media = null, this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.asyncPollTrackChange = () => this.pollTrackChange(0), this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.onTextTracksChanged = () => {
      if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
        return;
      let t = null;
      const s = _s(this.media.textTracks);
      for (let r = 0; r < s.length; r++)
        if (s[r].mode === "hidden")
          t = s[r];
        else if (s[r].mode === "showing") {
          t = s[r];
          break;
        }
      const i = this.findTrackForTextTrack(t);
      this.subtitleTrack !== i && this.setSubtitleTrack(i);
    }, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, this.onTextTracksChanged = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(T.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, e);
  }
  onMediaDetaching() {
    if (!this.media)
      return;
    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), _s(this.media.textTracks).forEach((t) => {
      Pt(t);
    }), this.subtitleTrack = -1, this.media = null;
  }
  onManifestLoading() {
    this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: s,
      groupId: i,
      details: r
    } = t, o = this.tracksInGroup[s];
    if (!o || o.groupId !== i) {
      this.warn(`Subtitle track with id:${s} and group:${i} not found in active group ${o == null ? void 0 : o.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Subtitle track ${s} "${o.name}" lang:${o.lang} group:${i} loaded [${r.startSN}-${r.endSN}]`), s === this.trackId && this.playlistLoaded(s, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const s = t.subtitleGroups || null, i = this.groupIds;
    let r = this.currentTrack;
    if (!s || (i == null ? void 0 : i.length) !== (s == null ? void 0 : s.length) || s != null && s.some((o) => (i == null ? void 0 : i.indexOf(o)) === -1)) {
      this.groupIds = s, this.trackId = -1, this.currentTrack = null;
      const o = this.tracks.filter((u) => !s || s.indexOf(u.groupId) !== -1);
      if (o.length)
        this.selectDefaultTrack && !o.some((u) => u.default) && (this.selectDefaultTrack = !1), o.forEach((u, d) => {
          u.id = d;
        });
      else if (!r && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = o;
      const a = this.hls.config.subtitlePreference;
      if (!r && a) {
        this.selectDefaultTrack = !1;
        const u = Qe(a, o);
        if (u > -1)
          r = o[u];
        else {
          const d = Qe(a, this.tracks);
          r = this.tracks[d];
        }
      }
      let l = this.findTrackId(r);
      l === -1 && r && (l = this.findTrackId(null));
      const c = {
        subtitleTracks: o
      };
      this.log(`Updating subtitle tracks, ${o.length} track(s) found in "${s == null ? void 0 : s.join(",")}" group-id`), this.hls.trigger(T.SUBTITLE_TRACKS_UPDATED, c), l !== -1 && this.trackId === -1 && this.setSubtitleTrack(l);
    } else this.shouldReloadPlaylist(r) && this.setSubtitleTrack(this.trackId);
  }
  findTrackId(e) {
    const t = this.tracksInGroup, s = this.selectDefaultTrack;
    for (let i = 0; i < t.length; i++) {
      const r = t[i];
      if (!(s && !r.default || !s && !e) && (!e || Nt(r, e)))
        return i;
    }
    if (e) {
      for (let i = 0; i < t.length; i++) {
        const r = t[i];
        if (Ht(e.attrs, r.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return i;
      }
      for (let i = 0; i < t.length; i++) {
        const r = t[i];
        if (Ht(e.attrs, r.attrs, ["LANGUAGE"]))
          return i;
      }
    }
    return -1;
  }
  findTrackForTextTrack(e) {
    if (e) {
      const t = this.tracksInGroup;
      for (let s = 0; s < t.length; s++) {
        const i = t[s];
        if (Zn(i, e))
          return s;
      }
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === re.SUBTITLE_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1, this.setSubtitleTrack(e);
  }
  setSubtitleOption(e) {
    if (this.hls.config.subtitlePreference = e, e) {
      const t = this.allSubtitleTracks;
      if (this.selectDefaultTrack = !1, t.length) {
        const s = this.currentTrack;
        if (s && Nt(e, s))
          return s;
        const i = Qe(e, this.tracksInGroup);
        if (i > -1) {
          const r = this.tracksInGroup[i];
          return this.setSubtitleTrack(i), r;
        } else {
          if (s)
            return null;
          {
            const r = Qe(e, t);
            if (r > -1)
              return t[r];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentTrack;
    if (this.shouldLoadPlaylist(t) && t) {
      const s = t.id, i = t.groupId;
      let r = t.url;
      if (e)
        try {
          r = e.addDirectives(r);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      this.log(`Loading subtitle playlist for id ${s}`), this.hls.trigger(T.SUBTITLE_TRACK_LOADING, {
        url: r,
        id: s,
        groupId: i,
        deliveryDirectives: e || null
      });
    }
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = _s(e.textTracks), s = this.currentTrack;
    let i;
    if (s && (i = t.filter((r) => Zn(s, r))[0], i || this.warn(`Unable to find subtitle TextTrack with name "${s.name}" and language "${s.lang}"`)), [].slice.call(t).forEach((r) => {
      r.mode !== "disabled" && r !== i && (r.mode = "disabled");
    }), i) {
      const r = this.subtitleDisplay ? "showing" : "hidden";
      i.mode !== r && (i.mode = r);
    }
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e) {
    const t = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (e < -1 || e >= t.length || !H(e)) {
      this.warn(`Invalid subtitle track id: ${e}`);
      return;
    }
    this.clearTimer(), this.selectDefaultTrack = !1;
    const s = this.currentTrack, i = t[e] || null;
    if (this.trackId = e, this.currentTrack = i, this.toggleTrackModes(), !i) {
      this.hls.trigger(T.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
      return;
    }
    const r = !!i.details && !i.details.live;
    if (e === this.trackId && i === s && r)
      return;
    this.log(`Switching to subtitle-track ${e}` + (i ? ` "${i.name}" lang:${i.lang} group:${i.groupId}` : ""));
    const {
      id: o,
      groupId: a = "",
      name: l,
      type: c,
      url: u
    } = i;
    this.hls.trigger(T.SUBTITLE_TRACK_SWITCH, {
      id: o,
      groupId: a,
      name: l,
      type: c,
      url: u
    });
    const d = this.switchParams(i.url, s == null ? void 0 : s.details, i.details);
    this.loadPlaylist(d);
  }
}
class bg {
  constructor(e) {
    this.buffers = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.buffers = e;
  }
  append(e, t, s) {
    const i = this.queues[t];
    i.push(e), i.length === 1 && !s && this.executeNext(t);
  }
  insertAbort(e, t) {
    this.queues[t].unshift(e), this.executeNext(t);
  }
  appendBlocker(e) {
    let t;
    const s = new Promise((r) => {
      t = r;
    }), i = {
      execute: t,
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: () => {
      }
    };
    return this.append(i, e), s;
  }
  executeNext(e) {
    const t = this.queues[e];
    if (t.length) {
      const s = t[0];
      try {
        s.execute();
      } catch (i) {
        I.warn(`[buffer-operation-queue]: Exception executing "${e}" SourceBuffer operation: ${i}`), s.onError(i);
        const r = this.buffers[e];
        r != null && r.updating || this.shiftAndExecuteNext(e);
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues[e].shift(), this.executeNext(e);
  }
  current(e) {
    return this.queues[e][0];
  }
}
const Wr = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class _g {
  constructor(e) {
    this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendSource = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this.log = void 0, this.warn = void 0, this.error = void 0, this._onEndStreaming = (s) => {
      this.hls && this.hls.pauseBuffering();
    }, this._onStartStreaming = (s) => {
      this.hls && this.hls.resumeBuffering();
    }, this._onMediaSourceOpen = () => {
      const {
        media: s,
        mediaSource: i
      } = this;
      this.log("Media source opened"), s && (s.removeEventListener("emptied", this._onMediaEmptied), this.updateMediaElementDuration(), this.hls.trigger(T.MEDIA_ATTACHED, {
        media: s,
        mediaSource: i
      })), i && i.removeEventListener("sourceopen", this._onMediaSourceOpen), this.checkPendingTracks();
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: s,
        _objectUrl: i
      } = this;
      s !== i && I.error(`Media element src was set while attaching MediaSource (${i} > ${s})`);
    }, this.hls = e;
    const t = "[buffer-controller]";
    this.appendSource = Uf(At(e.config.preferManagedMediaSource)), this.log = I.log.bind(I, t), this.warn = I.warn.bind(I, t), this.error = I.error.bind(I, t), this._initSourceBuffer(), this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null, this.hls = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.BUFFER_RESET, this.onBufferReset, this), e.on(T.BUFFER_APPENDING, this.onBufferAppending, this), e.on(T.BUFFER_CODECS, this.onBufferCodecs, this), e.on(T.BUFFER_EOS, this.onBufferEos, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(T.FRAG_PARSED, this.onFragParsed, this), e.on(T.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.BUFFER_RESET, this.onBufferReset, this), e.off(T.BUFFER_APPENDING, this.onBufferAppending, this), e.off(T.BUFFER_CODECS, this.onBufferCodecs, this), e.off(T.BUFFER_EOS, this.onBufferEos, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(T.FRAG_PARSED, this.onFragParsed, this), e.off(T.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {}, this.operationQueue = new bg(this.sourceBuffer), this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    }, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    let s = 2;
    (t.audio && !t.video || !t.altAudio) && (s = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = s, this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(e, t) {
    const s = this.media = t.media, i = At(this.appendSource);
    if (s && i) {
      var r;
      const o = this.mediaSource = new i();
      this.log(`created media source: ${(r = o.constructor) == null ? void 0 : r.name}`), o.addEventListener("sourceopen", this._onMediaSourceOpen), o.addEventListener("sourceended", this._onMediaSourceEnded), o.addEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (o.addEventListener("startstreaming", this._onStartStreaming), o.addEventListener("endstreaming", this._onEndStreaming));
      const a = this._objectUrl = self.URL.createObjectURL(o);
      if (this.appendSource)
        try {
          s.removeAttribute("src");
          const l = self.ManagedMediaSource;
          s.disableRemotePlayback = s.disableRemotePlayback || l && o instanceof l, Yr(s), Cg(s, a), s.load();
        } catch {
          s.src = a;
        }
      else
        s.src = a;
      s.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media: e,
      mediaSource: t,
      _objectUrl: s
    } = this;
    if (t) {
      if (this.log("media source detaching"), t.readyState === "open")
        try {
          t.endOfStream();
        } catch (i) {
          this.warn(`onMediaDetaching: ${i.message} while calling endOfStream`);
        }
      this.onBufferReset(), t.removeEventListener("sourceopen", this._onMediaSourceOpen), t.removeEventListener("sourceended", this._onMediaSourceEnded), t.removeEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (t.removeEventListener("startstreaming", this._onStartStreaming), t.removeEventListener("endstreaming", this._onEndStreaming)), e && (e.removeEventListener("emptied", this._onMediaEmptied), s && self.URL.revokeObjectURL(s), this.mediaSrc === s ? (e.removeAttribute("src"), this.appendSource && Yr(e), e.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
    }
    this.hls.trigger(T.MEDIA_DETACHED, void 0);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach((e) => {
      this.resetBuffer(e);
    }), this._initSourceBuffer();
  }
  resetBuffer(e) {
    const t = this.sourceBuffer[e];
    try {
      if (t) {
        var s;
        this.removeBufferListeners(e), this.sourceBuffer[e] = void 0, (s = this.mediaSource) != null && s.sourceBuffers.length && this.mediaSource.removeSourceBuffer(t);
      }
    } catch (i) {
      this.warn(`onBufferReset ${e}`, i);
    }
  }
  onBufferCodecs(e, t) {
    const s = this.getSourceBufferTypes().length, i = Object.keys(t);
    if (i.forEach((o) => {
      if (s) {
        const l = this.tracks[o];
        if (l && typeof l.buffer.changeType == "function") {
          var a;
          const {
            id: c,
            codec: u,
            levelCodec: d,
            container: h,
            metadata: m
          } = t[o], f = fr(l.codec, l.levelCodec), g = f == null ? void 0 : f.replace(Wr, "$1");
          let p = fr(u, d);
          const E = (a = p) == null ? void 0 : a.replace(Wr, "$1");
          if (p && g !== E) {
            o.slice(0, 5) === "audio" && (p = Vs(p, this.appendSource));
            const y = `${h};codecs=${p}`;
            this.appendChangeType(o, y), this.log(`switching codec ${f} to ${p}`), this.tracks[o] = {
              buffer: l.buffer,
              codec: u,
              container: h,
              levelCodec: d,
              metadata: m,
              id: c
            };
          }
        }
      } else
        this.pendingTracks[o] = t[o];
    }), s)
      return;
    const r = Math.max(this.bufferCodecEventsExpected - 1, 0);
    this.bufferCodecEventsExpected !== r && (this.log(`${r} bufferCodec event(s) expected ${i.join(",")}`), this.bufferCodecEventsExpected = r), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks();
  }
  appendChangeType(e, t) {
    const {
      operationQueue: s
    } = this, i = {
      execute: () => {
        const r = this.sourceBuffer[e];
        r && (this.log(`changing ${e} sourceBuffer type to ${t}`), r.changeType(t)), s.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (r) => {
        this.warn(`Failed to change ${e} SourceBuffer type`, r);
      }
    };
    s.append(i, e, !!this.pendingTracks[e]);
  }
  onBufferAppending(e, t) {
    const {
      hls: s,
      operationQueue: i,
      tracks: r
    } = this, {
      data: o,
      type: a,
      frag: l,
      part: c,
      chunkMeta: u
    } = t, d = u.buffering[a], h = self.performance.now();
    d.start = h;
    const m = l.stats.buffering, f = c ? c.stats.buffering : null;
    m.start === 0 && (m.start = h), f && f.start === 0 && (f.start = h);
    const g = r.audio;
    let p = !1;
    a === "audio" && (g == null ? void 0 : g.container) === "audio/mpeg" && (p = !this.lastMpegAudioChunk || u.id === 1 || this.lastMpegAudioChunk.sn !== u.sn, this.lastMpegAudioChunk = u);
    const E = l.start, y = {
      execute: () => {
        if (d.executeStart = self.performance.now(), p) {
          const x = this.sourceBuffer[a];
          if (x) {
            const S = E - x.timestampOffset;
            Math.abs(S) >= 0.1 && (this.log(`Updating audio SourceBuffer timestampOffset to ${E} (delta: ${S}) sn: ${l.sn})`), x.timestampOffset = E);
          }
        }
        this.appendExecutor(o, a);
      },
      onStart: () => {
      },
      onComplete: () => {
        const x = self.performance.now();
        d.executeEnd = d.end = x, m.first === 0 && (m.first = x), f && f.first === 0 && (f.first = x);
        const {
          sourceBuffer: S
        } = this, v = {};
        for (const D in S)
          v[D] = he.getBuffered(S[D]);
        this.appendErrors[a] = 0, a === "audio" || a === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(T.BUFFER_APPENDED, {
          type: a,
          frag: l,
          part: c,
          chunkMeta: u,
          parent: l.type,
          timeRanges: v
        });
      },
      onError: (x) => {
        const S = {
          type: Q.MEDIA_ERROR,
          parent: l.type,
          details: C.BUFFER_APPEND_ERROR,
          sourceBufferName: a,
          frag: l,
          part: c,
          chunkMeta: u,
          error: x,
          err: x,
          fatal: !1
        };
        if (x.code === DOMException.QUOTA_EXCEEDED_ERR)
          S.details = C.BUFFER_FULL_ERROR;
        else {
          const v = ++this.appendErrors[a];
          S.details = C.BUFFER_APPEND_ERROR, this.warn(`Failed ${v}/${s.config.appendErrorMaxRetry} times to append segment in "${a}" sourceBuffer`), v >= s.config.appendErrorMaxRetry && (S.fatal = !0);
        }
        s.trigger(T.ERROR, S);
      }
    };
    i.append(y, a, !!this.pendingTracks[a]);
  }
  onBufferFlushing(e, t) {
    const {
      operationQueue: s
    } = this, i = (r) => ({
      execute: this.removeExecutor.bind(this, r, t.startOffset, t.endOffset),
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(T.BUFFER_FLUSHED, {
          type: r
        });
      },
      onError: (o) => {
        this.warn(`Failed to remove from ${r} SourceBuffer`, o);
      }
    });
    t.type ? s.append(i(t.type), t.type) : this.getSourceBufferTypes().forEach((r) => {
      s.append(i(r), r);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: s,
      part: i
    } = t, r = [], o = i ? i.elementaryStreams : s.elementaryStreams;
    o[le.AUDIOVIDEO] ? r.push("audiovideo") : (o[le.AUDIO] && r.push("audio"), o[le.VIDEO] && r.push("video"));
    const a = () => {
      const l = self.performance.now();
      s.stats.buffering.end = l, i && (i.stats.buffering.end = l);
      const c = i ? i.stats : s.stats;
      this.hls.trigger(T.FRAG_BUFFERED, {
        frag: s,
        part: i,
        stats: c,
        id: s.type
      });
    };
    r.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${s.type} level: ${s.level} sn: ${s.sn}`), this.blockBuffers(a, r);
  }
  onFragChanged(e, t) {
    this.trimBuffers();
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    this.getSourceBufferTypes().reduce((i, r) => {
      const o = this.sourceBuffer[r];
      return o && (!t.type || t.type === r) && (o.ending = !0, o.ended || (o.ended = !0, this.log(`${r} sourceBuffer now EOS`))), i && !!(!o || o.ended);
    }, !0) && (this.log("Queueing mediaSource.endOfStream()"), this.blockBuffers(() => {
      this.getSourceBufferTypes().forEach((r) => {
        const o = this.sourceBuffer[r];
        o && (o.ending = !1);
      });
      const {
        mediaSource: i
      } = this;
      if (!i || i.readyState !== "open") {
        i && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${i.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), i.endOfStream();
    }));
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
  }
  trimBuffers() {
    const {
      hls: e,
      details: t,
      media: s
    } = this;
    if (!s || t === null || !this.getSourceBufferTypes().length)
      return;
    const r = e.config, o = s.currentTime, a = t.levelTargetDuration, l = t.live && r.liveBackBufferLength !== null ? r.liveBackBufferLength : r.backBufferLength;
    if (H(l) && l > 0) {
      const c = Math.max(l, a), u = Math.floor(o / a) * a - c;
      this.flushBackBuffer(o, a, u);
    }
    if (H(r.frontBufferFlushThreshold) && r.frontBufferFlushThreshold > 0) {
      const c = Math.max(r.maxBufferLength, r.frontBufferFlushThreshold), u = Math.max(c, a), d = Math.floor(o / a) * a + u;
      this.flushFrontBuffer(o, a, d);
    }
  }
  flushBackBuffer(e, t, s) {
    const {
      details: i,
      sourceBuffer: r
    } = this;
    this.getSourceBufferTypes().forEach((a) => {
      const l = r[a];
      if (l) {
        const c = he.getBuffered(l);
        if (c.length > 0 && s > c.start(0)) {
          if (this.hls.trigger(T.BACK_BUFFER_REACHED, {
            bufferEnd: s
          }), i != null && i.live)
            this.hls.trigger(T.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: s
            });
          else if (l.ended && c.end(c.length - 1) - e < t * 2) {
            this.log(`Cannot flush ${a} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(T.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: s,
            type: a
          });
        }
      }
    });
  }
  flushFrontBuffer(e, t, s) {
    const {
      sourceBuffer: i
    } = this;
    this.getSourceBufferTypes().forEach((o) => {
      const a = i[o];
      if (a) {
        const l = he.getBuffered(a), c = l.length;
        if (c < 2)
          return;
        const u = l.start(c - 1), d = l.end(c - 1);
        if (s > u || e >= u && e <= d)
          return;
        if (a.ended && e - d < 2 * t) {
          this.log(`Cannot flush ${o} front buffer while SourceBuffer is in ended state`);
          return;
        }
        this.hls.trigger(T.BUFFER_FLUSHING, {
          startOffset: u,
          endOffset: 1 / 0,
          type: o
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")
      return;
    const {
      details: e,
      hls: t,
      media: s,
      mediaSource: i
    } = this, r = e.fragments[0].start + e.totalduration, o = s.duration, a = H(i.duration) ? i.duration : 0;
    e.live && t.config.liveDurationInfinity ? (i.duration = 1 / 0, this.updateSeekableRange(e)) : (r > a && r > o || !H(o)) && (this.log(`Updating Media Source duration to ${r.toFixed(3)}`), i.duration = r);
  }
  updateSeekableRange(e) {
    const t = this.mediaSource, s = e.fragments;
    if (s.length && e.live && t != null && t.setLiveSeekableRange) {
      const r = Math.max(0, s[0].start), o = Math.max(r, r + e.totalduration);
      this.log(`Media Source duration is set to ${t.duration}. Setting seekable range to ${r}-${o}.`), t.setLiveSeekableRange(r, o);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected: e,
      operationQueue: t,
      pendingTracks: s
    } = this, i = Object.keys(s).length;
    if (i && (!e || i === 2 || "audiovideo" in s)) {
      this.createSourceBuffers(s), this.pendingTracks = {};
      const r = this.getSourceBufferTypes();
      if (r.length)
        this.hls.trigger(T.BUFFER_CREATED, {
          tracks: this.tracks
        }), r.forEach((o) => {
          t.executeNext(o);
        });
      else {
        const o = new Error("could not create source buffer for media codec(s)");
        this.hls.trigger(T.ERROR, {
          type: Q.MEDIA_ERROR,
          details: C.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: !0,
          error: o,
          reason: o.message
        });
      }
    }
  }
  createSourceBuffers(e) {
    const {
      sourceBuffer: t,
      mediaSource: s
    } = this;
    if (!s)
      throw Error("createSourceBuffers called when mediaSource was null");
    for (const r in e)
      if (!t[r]) {
        var i;
        const o = e[r];
        if (!o)
          throw Error(`source buffer exists for track ${r}, however track does not`);
        let a = ((i = o.levelCodec) == null ? void 0 : i.indexOf(",")) === -1 ? o.levelCodec : o.codec;
        a && r.slice(0, 5) === "audio" && (a = Vs(a, this.appendSource));
        const l = `${o.container};codecs=${a}`;
        this.log(`creating sourceBuffer(${l})`);
        try {
          const c = t[r] = s.addSourceBuffer(l), u = r;
          this.addBufferListener(u, "updatestart", this._onSBUpdateStart), this.addBufferListener(u, "updateend", this._onSBUpdateEnd), this.addBufferListener(u, "error", this._onSBUpdateError), this.appendSource && this.addBufferListener(u, "bufferedchange", (d, h) => {
            const m = h.removedRanges;
            m != null && m.length && this.hls.trigger(T.BUFFER_FLUSHED, {
              type: r
            });
          }), this.tracks[r] = {
            buffer: c,
            codec: a,
            container: o.container,
            levelCodec: o.levelCodec,
            metadata: o.metadata,
            id: o.id
          };
        } catch (c) {
          this.error(`error while trying to add sourceBuffer: ${c.message}`), this.hls.trigger(T.ERROR, {
            type: Q.MEDIA_ERROR,
            details: C.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: c,
            sourceBufferName: r,
            mimeType: l
          });
        }
      }
  }
  get mediaSrc() {
    var e;
    const t = ((e = this.media) == null ? void 0 : e.firstChild) || this.media;
    return t == null ? void 0 : t.src;
  }
  _onSBUpdateStart(e) {
    const {
      operationQueue: t
    } = this;
    t.current(e).onStart();
  }
  _onSBUpdateEnd(e) {
    var t;
    if (((t = this.mediaSource) == null ? void 0 : t.readyState) === "closed") {
      this.resetBuffer(e);
      return;
    }
    const {
      operationQueue: s
    } = this;
    s.current(e).onComplete(), s.shiftAndExecuteNext(e);
  }
  _onSBUpdateError(e, t) {
    var s;
    const i = new Error(`${e} SourceBuffer error. MediaSource readyState: ${(s = this.mediaSource) == null ? void 0 : s.readyState}`);
    this.error(`${i}`, t), this.hls.trigger(T.ERROR, {
      type: Q.MEDIA_ERROR,
      details: C.BUFFER_APPENDING_ERROR,
      sourceBufferName: e,
      error: i,
      fatal: !1
    });
    const r = this.operationQueue.current(e);
    r && r.onError(i);
  }
  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(e, t, s) {
    const {
      media: i,
      mediaSource: r,
      operationQueue: o,
      sourceBuffer: a
    } = this, l = a[e];
    if (!i || !r || !l) {
      this.warn(`Attempting to remove from the ${e} SourceBuffer, but it does not exist`), o.shiftAndExecuteNext(e);
      return;
    }
    const c = H(i.duration) ? i.duration : 1 / 0, u = H(r.duration) ? r.duration : 1 / 0, d = Math.max(0, t), h = Math.min(s, c, u);
    h > d && (!l.ending || l.ended) ? (l.ended = !1, this.log(`Removing [${d},${h}] from the ${e} SourceBuffer`), l.remove(d, h)) : o.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const s = this.sourceBuffer[t];
    if (!s) {
      if (!this.pendingTracks[t])
        throw new Error(`Attempting to append to the ${t} SourceBuffer, but it does not exist`);
      return;
    }
    s.ended = !1, s.appendBuffer(e);
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.getSourceBufferTypes()) {
    if (!t.length) {
      this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
      return;
    }
    const {
      operationQueue: s
    } = this, i = t.map((r) => s.appendBlocker(r));
    Promise.all(i).then(() => {
      e(), t.forEach((r) => {
        const o = this.sourceBuffer[r];
        o != null && o.updating || s.shiftAndExecuteNext(r);
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(e, t, s) {
    const i = this.sourceBuffer[e];
    if (!i)
      return;
    const r = s.bind(this, e);
    this.listeners[e].push({
      event: t,
      listener: r
    }), i.addEventListener(t, r);
  }
  removeBufferListeners(e) {
    const t = this.sourceBuffer[e];
    t && this.listeners[e].forEach((s) => {
      t.removeEventListener(s.event, s.listener);
    });
  }
}
function Yr(n) {
  const e = n.querySelectorAll("source");
  [].slice.call(e).forEach((t) => {
    n.removeChild(t);
  });
}
function Cg(n, e) {
  const t = self.document.createElement("source");
  t.type = "video/mp4", t.src = e, n.appendChild(t);
}
const wg = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, Ea = (n) => String.fromCharCode(wg[n] || n), Ve = 15, rt = 100, Mg = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, kg = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, Fg = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, Pg = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, Og = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class Ng {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const s = typeof t == "function" ? t() : t;
      I.log(`${this.time} [${e}] ${s}`);
    }
  }
}
const Et = function(e) {
  const t = [];
  for (let s = 0; s < e.length; s++)
    t.push(e[s].toString(16));
  return t;
};
class ya {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      e.hasOwnProperty(i) && (this[i] = e[i]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class Ug {
  constructor() {
    this.uchar = " ", this.penState = new ya();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class Bg {
  constructor(e) {
    this.chars = [], this.pos = 0, this.currPenState = new ya(), this.cueStartTime = null, this.logger = void 0;
    for (let t = 0; t < rt; t++)
      this.chars.push(new Ug());
    this.logger = e;
  }
  equals(e) {
    for (let t = 0; t < rt; t++)
      if (!this.chars[t].equals(e.chars[t]))
        return !1;
    return !0;
  }
  copy(e) {
    for (let t = 0; t < rt; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < rt; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > rt && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = rt);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let s = this.pos + 1; s < t + 1; s++)
        this.chars[s].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = Ea(e);
    if (this.pos >= rt) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < rt; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let s = 0; s < rt; s++) {
      const i = this.chars[s].uchar;
      i !== " " && (t = !1), e.push(i);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class Dn {
  constructor(e) {
    this.rows = [], this.currRow = Ve - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let t = 0; t < Ve; t++)
      this.rows.push(new Bg(e));
    this.logger = e;
  }
  reset() {
    for (let e = 0; e < Ve; e++)
      this.rows[e].clear();
    this.currRow = Ve - 1;
  }
  equals(e) {
    let t = !0;
    for (let s = 0; s < Ve; s++)
      if (!this.rows[s].equals(e.rows[s])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < Ve; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Ve; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + JSON.stringify(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let a = 0; a < Ve; a++)
        this.rows[a].clear();
      const r = this.currRow + 1 - this.nrRollUpRows, o = this.lastOutputScreen;
      if (o) {
        const a = o.rows[r].cueStartTime, l = this.logger.time;
        if (a !== null && l !== null && a < l)
          for (let c = 0; c < this.nrRollUpRows; c++)
            this.rows[t - this.nrRollUpRows + c + 1].copy(o.rows[r + c]);
      }
    }
    this.currRow = t;
    const s = this.rows[this.currRow];
    if (e.indent !== null) {
      const r = e.indent, o = Math.max(r - 1, 0);
      s.setCursor(e.indent), e.color = s.chars[o].penState.foreground;
    }
    const i = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(i);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let s = "", i = -1;
    for (let r = 0; r < Ve; r++) {
      const o = this.rows[r].getTextString();
      o && (i = r + 1, e ? t.push("Row " + i + ": '" + o + "'") : t.push(o.trim()));
    }
    return t.length > 0 && (e ? s = "[" + t.join(" | ") + "]" : s = t.join(`
`)), s;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class qr {
  constructor(e, t, s) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new Dn(s), this.nonDisplayedMemory = new Dn(s), this.lastOutputScreen = new Dn(s), this.currRollUpRow = this.displayedMemory.rows[Ve - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = s;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[Ve - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let s = 0; s < e.length; s++)
      this.writeScreen.insertChar(e[s]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const s = Math.floor(e / 2) - 16, i = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = i[s];
    }
    this.logger.log(2, "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class zr {
  constructor(e, t, s) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = Gg(), this.logger = void 0;
    const i = this.logger = new Ng();
    this.channels = [null, new qr(e, t, i), new qr(e + 1, s, i)];
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    this.logger.time = e;
    for (let s = 0; s < t.length; s += 2) {
      const i = t[s] & 127, r = t[s + 1] & 127;
      let o = !1, a = null;
      if (i === 0 && r === 0)
        continue;
      this.logger.log(3, () => "[" + Et([t[s], t[s + 1]]) + "] -> (" + Et([i, r]) + ")");
      const l = this.cmdHistory;
      if (i >= 16 && i <= 31) {
        if ($g(i, r, l)) {
          As(null, null, l), this.logger.log(3, () => "Repeated command (" + Et([i, r]) + ") is dropped");
          continue;
        }
        As(i, r, this.cmdHistory), o = this.parseCmd(i, r), o || (o = this.parseMidrow(i, r)), o || (o = this.parsePAC(i, r)), o || (o = this.parseBackgroundAttributes(i, r));
      } else
        As(null, null, l);
      if (!o && (a = this.parseChars(i, r), a)) {
        const u = this.currentChannel;
        u && u > 0 ? this.channels[u].insertChars(a) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
      }
      !o && !a && this.logger.log(2, () => "Couldn't parse cleaned data " + Et([i, r]) + " orig: " + Et([t[s], t[s + 1]]));
    }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const s = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, i = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(s || i))
      return !1;
    const r = e === 20 || e === 21 || e === 23 ? 1 : 2, o = this.channels[r];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? o.ccRCL() : t === 33 ? o.ccBS() : t === 34 ? o.ccAOF() : t === 35 ? o.ccAON() : t === 36 ? o.ccDER() : t === 37 ? o.ccRU(2) : t === 38 ? o.ccRU(3) : t === 39 ? o.ccRU(4) : t === 40 ? o.ccFON() : t === 41 ? o.ccRDC() : t === 42 ? o.ccTR() : t === 43 ? o.ccRTD() : t === 44 ? o.ccEDM() : t === 45 ? o.ccCR() : t === 46 ? o.ccENM() : t === 47 && o.ccEOC() : o.ccTO(t - 32), this.currentChannel = r, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let s = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? s = 1 : s = 2, s !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const i = this.channels[s];
      return i ? (i.ccMIDROW(t), this.logger.log(3, () => "MIDROW (" + Et([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let s;
    const i = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, r = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(i || r))
      return !1;
    const o = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? s = o === 1 ? Mg[e] : Fg[e] : s = o === 1 ? kg[e] : Pg[e];
    const a = this.channels[o];
    return a ? (a.setPAC(this.interpretPAC(s, t)), this.currentChannel = o, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let s;
    const i = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? s = t - 96 : s = t - 64, i.underline = (s & 1) === 1, s <= 13 ? i.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(s / 2)] : s <= 15 ? (i.italics = !0, i.color = "white") : i.indent = Math.floor((s - 16) / 2) * 4, i;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let s, i = null, r = null;
    if (e >= 25 ? (s = 2, r = e - 8) : (s = 1, r = e), r >= 17 && r <= 19) {
      let o;
      r === 17 ? o = t + 80 : r === 18 ? o = t + 112 : o = t + 144, this.logger.log(2, () => "Special char '" + Ea(o) + "' in channel " + s), i = [o];
    } else e >= 32 && e <= 127 && (i = t === 0 ? [e] : [e, t]);
    return i && this.logger.log(3, () => "Char codes =  " + Et(i).join(",")), i;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const s = (e === 16 || e === 24) && t >= 32 && t <= 47, i = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(s || i))
      return !1;
    let r;
    const o = {};
    e === 16 || e === 24 ? (r = Math.floor((t - 32) / 2), o.background = Og[r], t % 2 === 1 && (o.background = o.background + "_semi")) : t === 45 ? o.background = "transparent" : (o.foreground = "black", t === 47 && (o.underline = !0));
    const a = e <= 23 ? 1 : 2;
    return this.channels[a].setBkgData(o), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    As(null, null, this.cmdHistory);
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const s = this.channels[t];
      s && s.cueSplitAtTime(e);
    }
  }
}
function As(n, e, t) {
  t.a = n, t.b = e;
}
function $g(n, e, t) {
  return t.a === n && t.b === e;
}
function Gg() {
  return {
    a: null,
    b: null
  };
}
class Ls {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, s) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = s, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
var yi = (function() {
  if ($t != null && $t.VTTCue)
    return self.VTTCue;
  const n = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(a, l) {
    if (typeof l != "string" || !Array.isArray(a))
      return !1;
    const c = l.toLowerCase();
    return ~a.indexOf(c) ? c : !1;
  }
  function s(a) {
    return t(n, a);
  }
  function i(a) {
    return t(e, a);
  }
  function r(a, ...l) {
    let c = 1;
    for (; c < arguments.length; c++) {
      const u = arguments[c];
      for (const d in u)
        a[d] = u[d];
    }
    return a;
  }
  function o(a, l, c) {
    const u = this, d = {
      enumerable: !0
    };
    u.hasBeenReset = !1;
    let h = "", m = !1, f = a, g = l, p = c, E = null, y = "", x = !0, S = "auto", v = "start", D = 50, L = "middle", _ = 50, A = "middle";
    Object.defineProperty(u, "id", r({}, d, {
      get: function() {
        return h;
      },
      set: function(R) {
        h = "" + R;
      }
    })), Object.defineProperty(u, "pauseOnExit", r({}, d, {
      get: function() {
        return m;
      },
      set: function(R) {
        m = !!R;
      }
    })), Object.defineProperty(u, "startTime", r({}, d, {
      get: function() {
        return f;
      },
      set: function(R) {
        if (typeof R != "number")
          throw new TypeError("Start time must be set to a number.");
        f = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "endTime", r({}, d, {
      get: function() {
        return g;
      },
      set: function(R) {
        if (typeof R != "number")
          throw new TypeError("End time must be set to a number.");
        g = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "text", r({}, d, {
      get: function() {
        return p;
      },
      set: function(R) {
        p = "" + R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "region", r({}, d, {
      get: function() {
        return E;
      },
      set: function(R) {
        E = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "vertical", r({}, d, {
      get: function() {
        return y;
      },
      set: function(R) {
        const w = s(R);
        if (w === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        y = w, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "snapToLines", r({}, d, {
      get: function() {
        return x;
      },
      set: function(R) {
        x = !!R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "line", r({}, d, {
      get: function() {
        return S;
      },
      set: function(R) {
        if (typeof R != "number" && R !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        S = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "lineAlign", r({}, d, {
      get: function() {
        return v;
      },
      set: function(R) {
        const w = i(R);
        if (!w)
          throw new SyntaxError("An invalid or illegal string was specified.");
        v = w, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "position", r({}, d, {
      get: function() {
        return D;
      },
      set: function(R) {
        if (R < 0 || R > 100)
          throw new Error("Position must be between 0 and 100.");
        D = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "positionAlign", r({}, d, {
      get: function() {
        return L;
      },
      set: function(R) {
        const w = i(R);
        if (!w)
          throw new SyntaxError("An invalid or illegal string was specified.");
        L = w, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "size", r({}, d, {
      get: function() {
        return _;
      },
      set: function(R) {
        if (R < 0 || R > 100)
          throw new Error("Size must be between 0 and 100.");
        _ = R, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "align", r({}, d, {
      get: function() {
        return A;
      },
      set: function(R) {
        const w = i(R);
        if (!w)
          throw new SyntaxError("An invalid or illegal string was specified.");
        A = w, this.hasBeenReset = !0;
      }
    })), u.displayState = void 0;
  }
  return o.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, o;
})();
class Hg {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function xa(n) {
  function e(s, i, r, o) {
    return (s | 0) * 3600 + (i | 0) * 60 + (r | 0) + parseFloat(o || 0);
  }
  const t = n.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class Kg {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, s) {
    return s ? this.has(e) ? this.values[e] : t[s] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, s) {
    for (let i = 0; i < s.length; ++i)
      if (t === s[i]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const s = parseFloat(t);
      if (s >= 0 && s <= 100)
        return this.set(e, s), !0;
    }
    return !1;
  }
}
function va(n, e, t, s) {
  const i = s ? n.split(s) : [n];
  for (const r in i) {
    if (typeof i[r] != "string")
      continue;
    const o = i[r].split(t);
    if (o.length !== 2)
      continue;
    const a = o[0], l = o[1];
    e(a, l);
  }
}
const Jn = new yi(0, 0, ""), Rs = Jn.align === "middle" ? "middle" : "center";
function Vg(n, e, t) {
  const s = n;
  function i() {
    const a = xa(n);
    if (a === null)
      throw new Error("Malformed timestamp: " + s);
    return n = n.replace(/^[^\sa-zA-Z-]+/, ""), a;
  }
  function r(a, l) {
    const c = new Kg();
    va(a, function(h, m) {
      let f;
      switch (h) {
        case "region":
          for (let g = t.length - 1; g >= 0; g--)
            if (t[g].id === m) {
              c.set(h, t[g].region);
              break;
            }
          break;
        case "vertical":
          c.alt(h, m, ["rl", "lr"]);
          break;
        case "line":
          f = m.split(","), c.integer(h, f[0]), c.percent(h, f[0]) && c.set("snapToLines", !1), c.alt(h, f[0], ["auto"]), f.length === 2 && c.alt("lineAlign", f[1], ["start", Rs, "end"]);
          break;
        case "position":
          f = m.split(","), c.percent(h, f[0]), f.length === 2 && c.alt("positionAlign", f[1], ["start", Rs, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          c.percent(h, m);
          break;
        case "align":
          c.alt(h, m, ["start", Rs, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = c.get("region", null), l.vertical = c.get("vertical", "");
    let u = c.get("line", "auto");
    u === "auto" && Jn.line === -1 && (u = -1), l.line = u, l.lineAlign = c.get("lineAlign", "start"), l.snapToLines = c.get("snapToLines", !0), l.size = c.get("size", 100), l.align = c.get("align", Rs);
    let d = c.get("position", "auto");
    d === "auto" && Jn.position === 50 && (d = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = d;
  }
  function o() {
    n = n.replace(/^\s+/, "");
  }
  if (o(), e.startTime = i(), o(), n.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + s);
  n = n.slice(3), o(), e.endTime = i(), o(), r(n, e);
}
function Sa(n) {
  return n.replace(/<br(?: \/)?>/gi, `
`);
}
class Wg {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new Hg(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function s() {
      let r = t.buffer, o = 0;
      for (r = Sa(r); o < r.length && r[o] !== "\r" && r[o] !== `
`; )
        ++o;
      const a = r.slice(0, o);
      return r[o] === "\r" && ++o, r[o] === `
` && ++o, t.buffer = r.slice(o), a;
    }
    function i(r) {
      va(r, function(o, a) {
      }, /:/);
    }
    try {
      let r = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        r = s();
        const a = r.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(a != null && a[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let o = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (o ? o = !1 : r = s(), t.state) {
          case "HEADER":
            /:/.test(r) ? i(r) : r || (t.state = "ID");
            continue;
          case "NOTE":
            r || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(r)) {
              t.state = "NOTE";
              break;
            }
            if (!r)
              continue;
            if (t.cue = new yi(0, 0, ""), t.state = "CUE", r.indexOf("-->") === -1) {
              t.cue.id = r;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              Vg(r, t.cue, t.regionList);
            } catch {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const a = r.indexOf("-->") !== -1;
              if (!r || a && (o = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += r;
            }
            continue;
          case "BADCUE":
            r || (t.state = "ID");
        }
      }
    } catch {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const Yg = /\r\n|\n\r|\n|\r/g, In = function(e, t, s = 0) {
  return e.slice(s, s + t.length) === t;
}, qg = function(e) {
  let t = parseInt(e.slice(-3));
  const s = parseInt(e.slice(-6, -4)), i = parseInt(e.slice(-9, -7)), r = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!H(t) || !H(s) || !H(i) || !H(r))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * s, t += 60 * 1e3 * i, t += 3600 * 1e3 * r, t;
}, bn = function(e) {
  let t = 5381, s = e.length;
  for (; s; )
    t = t * 33 ^ e.charCodeAt(--s);
  return (t >>> 0).toString();
};
function xi(n, e, t) {
  return bn(n.toString()) + bn(e.toString()) + bn(t);
}
const zg = function(e, t, s) {
  let i = e[t], r = e[i.prevCC];
  if (!r || !r.new && i.new) {
    e.ccOffset = e.presentationOffset = i.start, i.new = !1;
    return;
  }
  for (; (o = r) != null && o.new; ) {
    var o;
    e.ccOffset += i.start - r.start, i.new = !1, i = r, r = e[i.prevCC];
  }
  e.presentationOffset = s;
};
function jg(n, e, t, s, i, r, o) {
  const a = new Wg(), l = Ze(new Uint8Array(n)).trim().replace(Yg, `
`).split(`
`), c = [], u = e ? hg(e.baseTime, e.timescale) : 0;
  let d = "00:00.000", h = 0, m = 0, f, g = !0;
  a.oncue = function(p) {
    const E = t[s];
    let y = t.ccOffset;
    const x = (h - u) / 9e4;
    if (E != null && E.new && (m !== void 0 ? y = t.ccOffset = E.start : zg(t, s, x)), x) {
      if (!e) {
        f = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      y = x - t.presentationOffset;
    }
    const S = p.endTime - p.startTime, v = Be((p.startTime + y - m) * 9e4, i * 9e4) / 9e4;
    p.startTime = Math.max(v, 0), p.endTime = Math.max(v + S, 0);
    const D = p.text.trim();
    p.text = decodeURIComponent(encodeURIComponent(D)), p.id || (p.id = xi(p.startTime, p.endTime, D)), p.endTime > 0 && c.push(p);
  }, a.onparsingerror = function(p) {
    f = p;
  }, a.onflush = function() {
    if (f) {
      o(f);
      return;
    }
    r(c);
  }, l.forEach((p) => {
    if (g)
      if (In(p, "X-TIMESTAMP-MAP=")) {
        g = !1, p.slice(16).split(",").forEach((E) => {
          In(E, "LOCAL:") ? d = E.slice(6) : In(E, "MPEGTS:") && (h = parseInt(E.slice(7)));
        });
        try {
          m = qg(d) / 1e3;
        } catch (E) {
          f = E;
        }
        return;
      } else p === "" && (g = !1);
    a.parse(p + `
`);
  }), a.flush();
}
const _n = "stpp.ttml.im1t", Aa = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, La = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, Xg = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function jr(n, e, t, s) {
  const i = te(new Uint8Array(n), ["mdat"]);
  if (i.length === 0) {
    s(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const r = i.map((a) => Ze(a)), o = dg(e.baseTime, 1, e.timescale);
  try {
    r.forEach((a) => t(Qg(a, o)));
  } catch (a) {
    s(a);
  }
}
function Qg(n, e) {
  const i = new DOMParser().parseFromString(n, "text/xml").getElementsByTagName("tt")[0];
  if (!i)
    throw new Error("Invalid ttml");
  const r = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, o = Object.keys(r).reduce((d, h) => (d[h] = i.getAttribute(`ttp:${h}`) || r[h], d), {}), a = i.getAttribute("xml:space") !== "preserve", l = Xr(Cn(i, "styling", "style")), c = Xr(Cn(i, "layout", "region")), u = Cn(i, "body", "[begin]");
  return [].map.call(u, (d) => {
    const h = Ra(d, a);
    if (!h || !d.hasAttribute("begin"))
      return null;
    const m = Mn(d.getAttribute("begin"), o), f = Mn(d.getAttribute("dur"), o);
    let g = Mn(d.getAttribute("end"), o);
    if (m === null)
      throw Qr(d);
    if (g === null) {
      if (f === null)
        throw Qr(d);
      g = m + f;
    }
    const p = new yi(m - e, g - e, h);
    p.id = xi(p.startTime, p.endTime, p.text);
    const E = c[d.getAttribute("region")], y = l[d.getAttribute("style")], x = Zg(E, y, l), {
      textAlign: S
    } = x;
    if (S) {
      const v = Xg[S];
      v && (p.lineAlign = v), p.align = S;
    }
    return ve(p, x), p;
  }).filter((d) => d !== null);
}
function Cn(n, e, t) {
  const s = n.getElementsByTagName(e)[0];
  return s ? [].slice.call(s.querySelectorAll(t)) : [];
}
function Xr(n) {
  return n.reduce((e, t) => {
    const s = t.getAttribute("xml:id");
    return s && (e[s] = t), e;
  }, {});
}
function Ra(n, e) {
  return [].slice.call(n.childNodes).reduce((t, s, i) => {
    var r;
    return s.nodeName === "br" && i ? t + `
` : (r = s.childNodes) != null && r.length ? Ra(s, e) : e ? t + s.textContent.trim().replace(/\s+/g, " ") : t + s.textContent;
  }, "");
}
function Zg(n, e, t) {
  const s = "http://www.w3.org/ns/ttml#styling";
  let i = null;
  const r = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], o = n != null && n.hasAttribute("style") ? n.getAttribute("style") : null;
  return o && t.hasOwnProperty(o) && (i = t[o]), r.reduce((a, l) => {
    const c = wn(e, s, l) || wn(n, s, l) || wn(i, s, l);
    return c && (a[l] = c), a;
  }, {});
}
function wn(n, e, t) {
  return n && n.hasAttributeNS(e, t) ? n.getAttributeNS(e, t) : null;
}
function Qr(n) {
  return new Error(`Could not parse ttml timestamp ${n}`);
}
function Mn(n, e) {
  if (!n)
    return null;
  let t = xa(n);
  return t === null && (Aa.test(n) ? t = Jg(n, e) : La.test(n) && (t = e0(n, e))), t;
}
function Jg(n, e) {
  const t = Aa.exec(n), s = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + s / e.frameRate;
}
function e0(n, e) {
  const t = La.exec(n), s = Number(t[1]);
  switch (t[2]) {
    case "h":
      return s * 3600;
    case "m":
      return s * 60;
    case "ms":
      return s * 1e3;
    case "f":
      return s / e.frameRate;
    case "t":
      return s / e.tickRate;
  }
  return s;
}
class t0 {
  constructor(e) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = Jr(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(T.FRAG_LOADING, this.onFragLoading, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this), e.on(T.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(T.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(T.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(T.FRAG_LOADING, this.onFragLoading, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this), e.off(T.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(T.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(T.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = null, this.cea608Parser1 = this.cea608Parser2 = void 0;
  }
  initCea608Parsers() {
    if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
      const e = new Ls(this, "textTrack1"), t = new Ls(this, "textTrack2"), s = new Ls(this, "textTrack3"), i = new Ls(this, "textTrack4");
      this.cea608Parser1 = new zr(1, e, t), this.cea608Parser2 = new zr(3, s, i);
    }
  }
  addCues(e, t, s, i, r) {
    let o = !1;
    for (let a = r.length; a--; ) {
      const l = r[a], c = s0(l[0], l[1], t, s);
      if (c >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], s), o = !0, c / (s - t) > 0.5))
        return;
    }
    if (o || r.push([t, s]), this.config.renderTextTracksNatively) {
      const a = this.captionsTracks[e];
      this.Cues.newCue(a, t, s, i);
    } else {
      const a = this.Cues.newCue(null, t, s, i);
      this.hls.trigger(T.CUES_PARSED, {
        type: "captions",
        cues: a,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: s,
    initPTS: i,
    timescale: r
  }) {
    const {
      unparsedVttFrags: o
    } = this;
    s === "main" && (this.initPTS[t.cc] = {
      baseTime: i,
      timescale: r
    }), o.length && (this.unparsedVttFrags = [], o.forEach((a) => {
      this.onFragLoaded(T.FRAG_LOADED, a);
    }));
  }
  getExistingTrack(e, t) {
    const {
      media: s
    } = this;
    if (s)
      for (let i = 0; i < s.textTracks.length; i++) {
        const r = s.textTracks[i];
        if (Zr(r, {
          name: e,
          lang: t
        }))
          return r;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: s,
      media: i
    } = this, {
      label: r,
      languageCode: o
    } = t[e], a = this.getExistingTrack(r, o);
    if (a)
      s[e] = a, Pt(s[e]), Wo(s[e], i);
    else {
      const l = this.createTextTrack("captions", r, o);
      l && (l[e] = !0, s[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const s = t.label, i = {
      _id: e,
      label: s,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = i, this.hls.trigger(T.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [i]
    });
  }
  createTextTrack(e, t, s) {
    const i = this.media;
    if (i)
      return i.addTextTrack(e, t, s);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks: e
    } = this;
    Object.keys(e).forEach((t) => {
      Pt(e[t]), delete e[t];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = Jr(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let s = 0; s < t.length; s++)
        Pt(t[s]);
  }
  onSubtitleTracksUpdated(e, t) {
    const s = t.subtitleTracks || [], i = s.some((r) => r.textCodec === _n);
    if (this.config.enableWebVTT || i && this.config.enableIMSC1) {
      if (Ta(this.tracks, s)) {
        this.tracks = s;
        return;
      }
      if (this.textTracks = [], this.tracks = s, this.config.renderTextTracksNatively) {
        const o = this.media, a = o ? _s(o.textTracks) : null;
        if (this.tracks.forEach((l, c) => {
          let u;
          if (a) {
            let d = null;
            for (let h = 0; h < a.length; h++)
              if (a[h] && Zr(a[h], l)) {
                d = a[h], a[h] = null;
                break;
              }
            d && (u = d);
          }
          if (u)
            Pt(u);
          else {
            const d = Da(l);
            u = this.createTextTrack(d, l.name, l.lang), u && (u.mode = "disabled");
          }
          u && this.textTracks.push(u);
        }), a != null && a.length) {
          const l = a.filter((c) => c !== null).map((c) => c.label);
          l.length && I.warn(`Media element contains unused subtitle tracks: ${l.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
        }
      } else if (this.tracks.length) {
        const o = this.tracks.map((a) => ({
          label: a.name,
          kind: a.type.toLowerCase(),
          default: a.default,
          subtitleTrack: a
        }));
        this.hls.trigger(T.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: o
        });
      }
    }
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((s) => {
      const i = /(?:CC|SERVICE)([1-4])/.exec(s.instreamId);
      if (!i)
        return;
      const r = `textTrack${i[1]}`, o = this.captionsProperties[r];
      o && (o.label = s.name, s.lang && (o.languageCode = s.lang), o.media = s);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t == null ? void 0 : t.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    if (this.enabled && t.frag.type === j.MAIN) {
      var s, i;
      const {
        cea608Parser1: r,
        cea608Parser2: o,
        lastSn: a
      } = this, {
        cc: l,
        sn: c
      } = t.frag, u = (s = (i = t.part) == null ? void 0 : i.index) != null ? s : -1;
      r && o && (c !== a + 1 || c === a && u !== this.lastPartIndex + 1 || l !== this.lastCc) && (r.reset(), o.reset()), this.lastCc = l, this.lastSn = c, this.lastPartIndex = u;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: s,
      payload: i
    } = t;
    if (s.type === j.SUBTITLE)
      if (i.byteLength) {
        const r = s.decryptdata, o = "stats" in t;
        if (r == null || !r.encrypted || o) {
          const a = this.tracks[s.level], l = this.vttCCs;
          l[s.cc] || (l[s.cc] = {
            start: s.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = s.cc), a && a.textCodec === _n ? this._parseIMSC1(s, i) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(T.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: s,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const s = this.hls;
    jr(t, this.initPTS[e.cc], (i) => {
      this._appendCues(i, e.level), s.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (i) => {
      I.log(`Failed to parse IMSC1: ${i}`), s.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: i
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: s,
      payload: i
    } = e, {
      initPTS: r,
      unparsedVttFrags: o
    } = this, a = r.length - 1;
    if (!r[s.cc] && a === -1) {
      o.push(e);
      return;
    }
    const l = this.hls, c = (t = s.initSegment) != null && t.data ? $e(s.initSegment.data, new Uint8Array(i)) : i;
    jg(c, this.initPTS[s.cc], this.vttCCs, s.cc, s.start, (u) => {
      this._appendCues(u, s.level), l.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: s
      });
    }, (u) => {
      const d = u.message === "Missing initPTS for VTT MPEGTS";
      d ? o.push(e) : this._fallbackToIMSC1(s, i), I.log(`Failed to parse VTT cue: ${u}`), !(d && a > s.cc) && l.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: s,
        error: u
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const s = this.tracks[e.level];
    s.textCodec || jr(t, this.initPTS[e.cc], () => {
      s.textCodec = _n, this._parseIMSC1(e, t);
    }, () => {
      s.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const s = this.hls;
    if (this.config.renderTextTracksNatively) {
      const i = this.textTracks[t];
      if (!i || i.mode === "disabled")
        return;
      e.forEach((r) => Yo(i, r));
    } else {
      const i = this.tracks[t];
      if (!i)
        return;
      const r = i.default ? "default" : "subtitles" + t;
      s.trigger(T.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: r
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: s
    } = t;
    s.type === j.SUBTITLE && this.onFragLoaded(T.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    this.initCea608Parsers();
    const {
      cea608Parser1: s,
      cea608Parser2: i
    } = this;
    if (!this.enabled || !s || !i)
      return;
    const {
      frag: r,
      samples: o
    } = t;
    if (!(r.type === j.MAIN && this.closedCaptionsForLevel(r) === "NONE"))
      for (let a = 0; a < o.length; a++) {
        const l = o[a].bytes;
        if (l) {
          const c = this.extractCea608Data(l);
          s.addData(o[a].pts, c[0]), i.addData(o[a].pts, c[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: s,
    endOffsetSubtitles: i,
    type: r
  }) {
    const {
      media: o
    } = this;
    if (!(!o || o.currentTime < s)) {
      if (!r || r === "video") {
        const {
          captionsTracks: a
        } = this;
        Object.keys(a).forEach((l) => Yn(a[l], t, s));
      }
      if (this.config.renderTextTracksNatively && t === 0 && i !== void 0) {
        const {
          textTracks: a
        } = this;
        Object.keys(a).forEach((l) => Yn(a[l], t, i));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], s = e[0] & 31;
    let i = 2;
    for (let r = 0; r < s; r++) {
      const o = e[i++], a = 127 & e[i++], l = 127 & e[i++];
      if (a === 0 && l === 0)
        continue;
      if ((4 & o) !== 0) {
        const u = 3 & o;
        (u === 0 || u === 1) && (t[u].push(a), t[u].push(l));
      }
    }
    return t;
  }
}
function Da(n) {
  return n.characteristics && /transcribes-spoken-dialog/gi.test(n.characteristics) && /describes-music-and-sound/gi.test(n.characteristics) ? "captions" : "subtitles";
}
function Zr(n, e) {
  return !!n && n.kind === Da(e) && Zn(e, n);
}
function s0(n, e, t, s) {
  return Math.min(e, s) - Math.max(n, t);
}
function Jr() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
class vi {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.BUFFER_CODECS, this.onBufferCodecs, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(T.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.BUFFER_CODECS, this.onBufferCodecs, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const s = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(s) && this.restrictedLevels.push({
      bitrate: s.bitrate,
      height: s.height,
      width: s.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(e, t) {
    const s = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, s.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onLevelsUpdated(e, t) {
    this.timer && H(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls, s = this.getMaxLevel(e.length - 1);
        s !== this.autoLevelCapping && I.log(`Setting autoLevelCapping to ${s}: ${e[s].height}p@${e[s].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), t.autoLevelCapping = s, t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const s = t.filter((i, r) => this.isLevelAllowed(i) && r <= e);
    return this.clientRect = null, vi.getMaxLevelByMediaSize(s, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const s = e.getBoundingClientRect();
      t.width = s.width, t.height = s.height, !t.width && !t.height && (t.width = s.right - s.left || e.width || 0, t.height = s.bottom - s.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return e;
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((s) => e.bitrate === s.bitrate && e.width === s.width && e.height === s.height);
  }
  static getMaxLevelByMediaSize(e, t, s) {
    if (!(e != null && e.length))
      return -1;
    const i = (a, l) => l ? a.width !== l.width || a.height !== l.height : !0;
    let r = e.length - 1;
    const o = Math.max(t, s);
    for (let a = 0; a < e.length; a += 1) {
      const l = e[a];
      if ((l.width >= o || l.height >= o) && i(l, e[a + 1])) {
        r = a;
        break;
      }
    }
    return r;
  }
}
class n0 {
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const s = this.hls.config;
    if (s.capLevelOnFPSDrop) {
      const i = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = i, i && typeof i.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), s.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(e, t, s) {
    const i = performance.now();
    if (t) {
      if (this.lastTime) {
        const r = i - this.lastTime, o = s - this.lastDroppedFrames, a = t - this.lastDecodedFrames, l = 1e3 * o / r, c = this.hls;
        if (c.trigger(T.FPS_DROP, {
          currentDropped: o,
          currentDecoded: a,
          totalDroppedFrames: s
        }), l > 0 && o > c.config.fpsDroppedMonitoringThreshold * a) {
          let u = c.currentLevel;
          I.warn("drop FPS ratio greater than max allowed value for currentLevel: " + u), u > 0 && (c.autoLevelCapping === -1 || c.autoLevelCapping >= u) && (u = u - 1, c.trigger(T.FPS_DROP_LEVEL_CAPPING, {
            level: u,
            droppedLevel: c.currentLevel
          }), c.autoLevelCapping = u, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = i, this.lastDroppedFrames = s, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
const Ds = "[eme]";
class Ut {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = Ut.CDMCleanupPromise ? [Ut.CDMCleanupPromise] : [], this.onMediaEncrypted = this._onMediaEncrypted.bind(this), this.onWaitingForKey = this._onWaitingForKey.bind(this), this.debug = I.debug.bind(I, Ds), this.log = I.log.bind(I, Ds), this.warn = I.warn.bind(I, Ds), this.error = I.error.bind(I, Ds), this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null, this.config = null;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(T.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(T.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(T.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(T.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: s
    } = this.config, i = t[e];
    if (i)
      return i.licenseUrl;
    if (e === me.WIDEVINE && s)
      return s;
    throw new Error(`no license server URL configured for key-system "${e}"`);
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, s = t[e];
    if (s)
      return s.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, s = (o, a, l) => !!o && l.indexOf(o) === a, i = t.map((o) => o.audioCodec).filter(s), r = t.map((o) => o.videoCodec).filter(s);
    return i.length + r.length === 0 && r.push("avc1.42e01e"), new Promise((o, a) => {
      const l = (c) => {
        const u = c.shift();
        this.getMediaKeysPromise(u, i, r).then((d) => o({
          keySystem: u,
          mediaKeys: d
        })).catch((d) => {
          c.length ? l(c) : d instanceof Ue ? a(d) : a(new Ue({
            type: Q.KEY_SYSTEM_ERROR,
            details: C.KEY_SYSTEM_NO_ACCESS,
            error: d,
            fatal: !0
          }, d.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: s
    } = this.config;
    if (typeof s != "function") {
      let i = `Configured requestMediaKeySystemAccess is not a function ${s}`;
      return Mo === null && self.location.protocol === "http:" && (i = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(i));
    }
    return s(e, t);
  }
  getMediaKeysPromise(e, t, s) {
    const i = uf(e, t, s, this.config.drmSystemOptions), r = this.keySystemAccessPromises[e];
    let o = r == null ? void 0 : r.keySystemAccess;
    if (!o) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${JSON.stringify(i)}`), o = this.requestMediaKeySystemAccess(e, i);
      const a = this.keySystemAccessPromises[e] = {
        keySystemAccess: o
      };
      return o.catch((l) => {
        this.log(`Failed to obtain access to key-system "${e}": ${l}`);
      }), o.then((l) => {
        this.log(`Access for key-system "${l.keySystem}" obtained`);
        const c = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), a.mediaKeys = l.createMediaKeys().then((u) => (this.log(`Media-keys created for "${e}"`), c.then((d) => d ? this.setMediaKeysServerCertificate(u, e, d) : u))), a.mediaKeys.catch((u) => {
          this.error(`Failed to create media-keys for "${e}"}: ${u}`);
        }), a.mediaKeys;
      });
    }
    return o.then(() => r.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: s
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${ze.hexDump(e.keyId || [])}`);
    const i = s.createSession(), r = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: s,
      mediaKeysSession: i,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(r), r;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const s = this.createMediaKeySessionContext(e), i = this.getKeyIdString(t), r = "cenc";
      this.keyIdToKeySessionPromise[i] = this.generateRequestWithPreferredKeySession(s, r, t.pssh, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return ze.hexDump(e.keyId);
  }
  updateKeySession(e, t) {
    var s;
    const i = e.mediaKeysSession;
    return this.log(`Updating key-session "${i.sessionId}" for keyID ${ze.hexDump(((s = e.decryptdata) == null ? void 0 : s.keyId) || [])}
      } (data length: ${t && t.byteLength})`), i.update(t);
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    return new Promise((t, s) => {
      const i = mn(this.config), r = e.map(or).filter((o) => !!o && i.indexOf(o) !== -1);
      return this.getKeySystemSelectionPromise(r).then(({
        keySystem: o
      }) => {
        const a = ar(o);
        a ? t(a) : s(new Error(`Unable to find format for key-system "${o}"`));
      }).catch(s);
    });
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, s = this.getKeyIdString(t), i = `(keyId: ${s} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${i}`);
    let r = this.keyIdToKeySessionPromise[s];
    return r || (r = this.keyIdToKeySessionPromise[s] = this.getKeySystemForKeyPromise(t).then(({
      keySystem: o,
      mediaKeys: a
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${i}`), this.attemptSetMediaKeys(o, a).then(() => {
      this.throwIfDestroyed();
      const l = this.createMediaKeySessionContext({
        keySystem: o,
        mediaKeys: a,
        decryptdata: t
      });
      return this.generateRequestWithPreferredKeySession(l, "cenc", t.pssh, "playlist-key");
    }))), r.catch((o) => this.handleError(o))), r;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof Ue ? this.hls.trigger(T.ERROR, e.data) : this.hls.trigger(T.ERROR, {
      type: Q.KEY_SYSTEM_ERROR,
      details: C.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const t = this.getKeyIdString(e), s = this.keyIdToKeySessionPromise[t];
    if (!s) {
      const i = or(e.keyFormat), r = i ? [i] : mn(this.config);
      return this.attemptKeySystemAccess(r);
    }
    return s;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = mn(this.config)), e.length === 0)
      throw new Ue({
        type: Q.KEY_SYSTEM_ERROR,
        details: C.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  _onMediaEncrypted(e) {
    const {
      initDataType: t,
      initData: s
    } = e;
    if (this.debug(`"${e.type}" event: init data type: "${t}"`), s === null)
      return;
    let i, r;
    if (t === "sinf" && this.config.drmSystems[me.FAIRPLAY]) {
      const u = Ae(new Uint8Array(s));
      try {
        const d = oi(JSON.parse(u).sinf), h = $o(new Uint8Array(d));
        if (!h)
          return;
        i = h.subarray(8, 24), r = me.FAIRPLAY;
      } catch {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      const u = Pf(s);
      if (u === null)
        return;
      u.version === 0 && u.systemId === wo.WIDEVINE && u.data && (i = u.data.subarray(8, 24)), r = cf(u.systemId);
    }
    if (!r || !i)
      return;
    const o = ze.hexDump(i), {
      keyIdToKeySessionPromise: a,
      mediaKeySessions: l
    } = this;
    let c = a[o];
    for (let u = 0; u < l.length; u++) {
      const d = l[u], h = d.decryptdata;
      if (h.pssh || !h.keyId)
        continue;
      const m = ze.hexDump(h.keyId);
      if (o === m || h.uri.replace(/-/g, "").indexOf(o) !== -1) {
        c = a[m], delete a[m], h.pssh = new Uint8Array(s), h.keyId = i, c = a[o] = c.then(() => this.generateRequestWithPreferredKeySession(d, t, s, "encrypted-event-key-match"));
        break;
      }
    }
    c || (c = a[o] = this.getKeySystemSelectionPromise([r]).then(({
      keySystem: u,
      mediaKeys: d
    }) => {
      var h;
      this.throwIfDestroyed();
      const m = new ss("ISO-23001-7", o, (h = ar(u)) != null ? h : "");
      return m.pssh = new Uint8Array(s), m.keyId = i, this.attemptSetMediaKeys(u, d).then(() => {
        this.throwIfDestroyed();
        const f = this.createMediaKeySessionContext({
          decryptdata: m,
          keySystem: u,
          mediaKeys: d
        });
        return this.generateRequestWithPreferredKeySession(f, t, s, "encrypted-event-no-match");
      });
    })), c.catch((u) => this.handleError(u));
  }
  _onWaitingForKey(e) {
    this.log(`"${e.type}" event`);
  }
  attemptSetMediaKeys(e, t) {
    const s = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const i = Promise.all(s).then(() => {
      if (!this.media)
        throw new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(t);
    });
    return this.setMediaKeysQueue.push(i), i.then(() => {
      this.log(`Media-keys set for "${e}"`), s.push(i), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((r) => s.indexOf(r) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, s, i) {
    var r, o;
    const a = (r = this.config.drmSystems) == null || (o = r[e.keySystem]) == null ? void 0 : o.generateRequest;
    if (a)
      try {
        const f = a.call(this.hls, t, s, e);
        if (!f)
          throw new Error("Invalid response from configured generateRequest filter");
        t = f.initDataType, s = e.decryptdata.pssh = f.initData ? new Uint8Array(f.initData) : null;
      } catch (f) {
        var l;
        if (this.warn(f.message), (l = this.hls) != null && l.config.debug)
          throw f;
      }
    if (s === null)
      return this.log(`Skipping key-session request for "${i}" (no initData)`), Promise.resolve(e);
    const c = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${i}": ${c} (init data type: ${t} length: ${s ? s.byteLength : null})`);
    const u = new Ei(), d = e._onmessage = (f) => {
      const g = e.mediaKeysSession;
      if (!g) {
        u.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: p,
        message: E
      } = f;
      this.log(`"${p}" message event for session "${g.sessionId}" message size: ${E.byteLength}`), p === "license-request" || p === "license-renewal" ? this.renewLicense(e, E).catch((y) => {
        this.handleError(y), u.emit("error", y);
      }) : p === "license-release" ? e.keySystem === me.FAIRPLAY && (this.updateKeySession(e, Vn("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${p}"`);
    }, h = e._onkeystatuseschange = (f) => {
      if (!e.mediaKeysSession) {
        u.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const p = e.keyStatus;
      u.emit("keyStatus", p), p === "expired" && (this.warn(`${e.keySystem} expired for key ${c}`), this.renewKeySession(e));
    };
    e.mediaKeysSession.addEventListener("message", d), e.mediaKeysSession.addEventListener("keystatuseschange", h);
    const m = new Promise((f, g) => {
      u.on("error", g), u.on("keyStatus", (p) => {
        p.startsWith("usable") ? f() : p === "output-restricted" ? g(new Ue({
          type: Q.KEY_SYSTEM_ERROR,
          details: C.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : p === "internal-error" ? g(new Ue({
          type: Q.KEY_SYSTEM_ERROR,
          details: C.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${p}"`)) : p === "expired" ? g(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${p}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(t, s).then(() => {
      var f;
      this.log(`Request generated for key-session "${(f = e.mediaKeysSession) == null ? void 0 : f.sessionId}" keyId: ${c}`);
    }).catch((f) => {
      throw new Ue({
        type: Q.KEY_SYSTEM_ERROR,
        details: C.KEY_SYSTEM_NO_SESSION,
        error: f,
        fatal: !1
      }, `Error generating key-session request: ${f}`);
    }).then(() => m).catch((f) => {
      throw u.removeAllListeners(), this.removeSession(e), f;
    }).then(() => (u.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((t, s) => {
      this.log(`key status change "${t}" for keyStatuses keyId: ${ze.hexDump("buffer" in s ? new Uint8Array(s.buffer, s.byteOffset, s.byteLength) : new Uint8Array(s))} session keyId: ${ze.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = t;
    });
  }
  fetchServerCertificate(e) {
    const t = this.config, s = t.loader, i = new s(t), r = this.getServerCertificateUrl(e);
    return r ? (this.log(`Fetching server certificate for "${e}"`), new Promise((o, a) => {
      const l = {
        responseType: "arraybuffer",
        url: r
      }, c = t.certLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (h, m, f, g) => {
          o(h.data);
        },
        onError: (h, m, f, g) => {
          a(new Ue({
            type: Q.KEY_SYSTEM_ERROR,
            details: C.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: De({
              url: l.url,
              data: void 0
            }, h)
          }, `"${e}" certificate request failed (${r}). Status: ${h.code} (${h.text})`));
        },
        onTimeout: (h, m, f) => {
          a(new Ue({
            type: Q.KEY_SYSTEM_ERROR,
            details: C.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${r})`));
        },
        onAbort: (h, m, f) => {
          a(new Error("aborted"));
        }
      };
      i.load(l, u, d);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, s) {
    return new Promise((i, r) => {
      e.setServerCertificate(s).then((o) => {
        this.log(`setServerCertificate ${o ? "success" : "not supported by CDM"} (${s == null ? void 0 : s.byteLength}) on "${t}"`), i(e);
      }).catch((o) => {
        r(new Ue({
          type: Q.KEY_SYSTEM_ERROR,
          details: C.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: o,
          fatal: !0
        }, o.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((s) => this.updateKeySession(e, new Uint8Array(s)).catch((i) => {
      throw new Ue({
        type: Q.KEY_SYSTEM_ERROR,
        details: C.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: i,
        fatal: !0
      }, i.message);
    }));
  }
  unpackPlayReadyKeyMessage(e, t) {
    const s = String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    if (!s.includes("PlayReadyKeyMessage"))
      return e.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), t;
    const i = new DOMParser().parseFromString(s, "application/xml"), r = i.querySelectorAll("HttpHeader");
    if (r.length > 0) {
      let u;
      for (let d = 0, h = r.length; d < h; d++) {
        var o, a;
        u = r[d];
        const m = (o = u.querySelector("name")) == null ? void 0 : o.textContent, f = (a = u.querySelector("value")) == null ? void 0 : a.textContent;
        m && f && e.setRequestHeader(m, f);
      }
    }
    const l = i.querySelector("Challenge"), c = l == null ? void 0 : l.textContent;
    if (!c)
      throw new Error("Cannot find <Challenge> in key message");
    return Vn(atob(c));
  }
  setupLicenseXHR(e, t, s, i) {
    const r = this.config.licenseXhrSetup;
    return r ? Promise.resolve().then(() => {
      if (!s.decryptdata)
        throw new Error("Key removed");
      return r.call(this.hls, e, t, s, i);
    }).catch((o) => {
      if (!s.decryptdata)
        throw o;
      return e.open("POST", t, !0), r.call(this.hls, e, t, s, i);
    }).then((o) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: o || i
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: i
    }));
  }
  requestLicense(e, t) {
    const s = this.config.keyLoadPolicy.default;
    return new Promise((i, r) => {
      const o = this.getLicenseServerUrl(e.keySystem);
      this.log(`Sending license request to URL: ${o}`);
      const a = new XMLHttpRequest();
      a.responseType = "arraybuffer", a.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return r(new Error("invalid state"));
        if (a.readyState === 4)
          if (a.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = a.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const c = this.config.licenseResponseCallback;
            if (c)
              try {
                l = c.call(this.hls, a, o, e);
              } catch (u) {
                this.error(u);
              }
            i(l);
          } else {
            const l = s.errorRetry, c = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > c || a.status >= 400 && a.status < 500)
              r(new Ue({
                type: Q.KEY_SYSTEM_ERROR,
                details: C.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: a,
                response: {
                  url: o,
                  data: void 0,
                  code: a.status,
                  text: a.statusText
                }
              }, `License Request XHR failed (${o}). Status: ${a.status} (${a.statusText})`));
            else {
              const u = c - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${u} attempts left`), this.requestLicense(e, t).then(i, r);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = a, this.setupLicenseXHR(a, o, e, t).then(({
        xhr: l,
        licenseChallenge: c
      }) => {
        e.keySystem == me.PLAYREADY && (c = this.unpackPlayReadyKeyMessage(l, c)), l.send(c);
      });
    });
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const s = t.media;
    this.media = s, s.addEventListener("encrypted", this.onMediaEncrypted), s.addEventListener("waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media, t = this.mediaKeySessions;
    e && (e.removeEventListener("encrypted", this.onMediaEncrypted), e.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, ss.clearKeyUriToKeyIdMap();
    const s = t.length;
    Ut.CDMCleanupPromise = Promise.all(t.map((i) => this.removeSession(i)).concat(e == null ? void 0 : e.setMediaKeys(null).catch((i) => {
      this.log(`Could not clear media keys: ${i}`);
    }))).then(() => {
      s && (this.log("finished closing key sessions and clearing media keys"), t.length = 0);
    }).catch((i) => {
      this.log(`Could not close sessions and clear media keys: ${i}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const s = t.reduce((i, r) => (i.indexOf(r.keyFormat) === -1 && i.push(r.keyFormat), i), []);
      this.log(`Selecting key-system from session-keys ${s.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(s);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: s
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session ${t.sessionId}`), e._onmessage && (t.removeEventListener("message", e._onmessage), e._onmessage = void 0), e._onkeystatuseschange && (t.removeEventListener("keystatuseschange", e._onkeystatuseschange), e._onkeystatuseschange = void 0), s && s.readyState !== XMLHttpRequest.DONE && s.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const i = this.mediaKeySessions.indexOf(e);
      return i > -1 && this.mediaKeySessions.splice(i, 1), t.remove().catch((r) => {
        this.log(`Could not remove session: ${r}`);
      }).then(() => t.close()).catch((r) => {
        this.log(`Could not close session: ${r}`);
      });
    }
  }
}
Ut.CDMCleanupPromise = void 0;
class Ue extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
var Ce;
(function(n) {
  n.MANIFEST = "m", n.AUDIO = "a", n.VIDEO = "v", n.MUXED = "av", n.INIT = "i", n.CAPTION = "c", n.TIMED_TEXT = "tt", n.KEY = "k", n.OTHER = "o";
})(Ce || (Ce = {}));
var ei;
(function(n) {
  n.DASH = "d", n.HLS = "h", n.SMOOTH = "s", n.OTHER = "o";
})(ei || (ei = {}));
var xt;
(function(n) {
  n.OBJECT = "CMCD-Object", n.REQUEST = "CMCD-Request", n.SESSION = "CMCD-Session", n.STATUS = "CMCD-Status";
})(xt || (xt = {}));
const i0 = {
  [xt.OBJECT]: ["br", "d", "ot", "tb"],
  [xt.REQUEST]: ["bl", "dl", "mtp", "nor", "nrr", "su"],
  [xt.SESSION]: ["cid", "pr", "sf", "sid", "st", "v"],
  [xt.STATUS]: ["bs", "rtp"]
};
class Kt {
  constructor(e, t) {
    this.value = void 0, this.params = void 0, Array.isArray(e) && (e = e.map((s) => s instanceof Kt ? s : new Kt(s))), this.value = e, this.params = t;
  }
}
class Ia {
  constructor(e) {
    this.description = void 0, this.description = e;
  }
}
const r0 = "Dict";
function o0(n) {
  return Array.isArray(n) ? JSON.stringify(n) : n instanceof Map ? "Map{}" : n instanceof Set ? "Set{}" : typeof n == "object" ? JSON.stringify(n) : String(n);
}
function a0(n, e, t, s) {
  return new Error(`failed to ${n} "${o0(e)}" as ${t}`, {
    cause: s
  });
}
const eo = "Bare Item", l0 = "Boolean", c0 = "Byte Sequence", u0 = "Decimal", d0 = "Integer";
function h0(n) {
  return n < -999999999999999 || 999999999999999 < n;
}
const f0 = /[\x00-\x1f\x7f]+/, m0 = "Token", g0 = "Key";
function et(n, e, t) {
  return a0("serialize", n, e, t);
}
function p0(n) {
  if (typeof n != "boolean")
    throw et(n, l0);
  return n ? "?1" : "?0";
}
function T0(n) {
  return btoa(String.fromCharCode(...n));
}
function E0(n) {
  if (ArrayBuffer.isView(n) === !1)
    throw et(n, c0);
  return `:${T0(n)}:`;
}
function ba(n) {
  if (h0(n))
    throw et(n, d0);
  return n.toString();
}
function y0(n) {
  return `@${ba(n.getTime() / 1e3)}`;
}
function _a(n, e) {
  if (n < 0)
    return -_a(-n, e);
  const t = Math.pow(10, e);
  if (Math.abs(n * t % 1 - 0.5) < Number.EPSILON) {
    const i = Math.floor(n * t);
    return (i % 2 === 0 ? i : i + 1) / t;
  } else
    return Math.round(n * t) / t;
}
function x0(n) {
  const e = _a(n, 3);
  if (Math.floor(Math.abs(e)).toString().length > 12)
    throw et(n, u0);
  const t = e.toString();
  return t.includes(".") ? t : `${t}.0`;
}
const v0 = "String";
function S0(n) {
  if (f0.test(n))
    throw et(n, v0);
  return `"${n.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function A0(n) {
  return n.description || n.toString().slice(7, -1);
}
function to(n) {
  const e = A0(n);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(e) === !1)
    throw et(e, m0);
  return e;
}
function ti(n) {
  switch (typeof n) {
    case "number":
      if (!H(n))
        throw et(n, eo);
      return Number.isInteger(n) ? ba(n) : x0(n);
    case "string":
      return S0(n);
    case "symbol":
      return to(n);
    case "boolean":
      return p0(n);
    case "object":
      if (n instanceof Date)
        return y0(n);
      if (n instanceof Uint8Array)
        return E0(n);
      if (n instanceof Ia)
        return to(n);
    default:
      throw et(n, eo);
  }
}
function si(n) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(n) === !1)
    throw et(n, g0);
  return n;
}
function Si(n) {
  return n == null ? "" : Object.entries(n).map(([e, t]) => t === !0 ? `;${si(e)}` : `;${si(e)}=${ti(t)}`).join("");
}
function Ca(n) {
  return n instanceof Kt ? `${ti(n.value)}${Si(n.params)}` : ti(n);
}
function L0(n) {
  return `(${n.value.map(Ca).join(" ")})${Si(n.params)}`;
}
function R0(n, e = {
  whitespace: !0
}) {
  if (typeof n != "object")
    throw et(n, r0);
  const t = n instanceof Map ? n.entries() : Object.entries(n), s = e != null && e.whitespace ? " " : "";
  return Array.from(t).map(([i, r]) => {
    r instanceof Kt || (r = new Kt(r));
    let o = si(i);
    return r.value === !0 ? o += Si(r.params) : (o += "=", Array.isArray(r.value) ? o += L0(r) : o += Ca(r)), o;
  }).join(`,${s}`);
}
function D0(n, e) {
  return R0(n, e);
}
const I0 = (n) => n === "ot" || n === "sf" || n === "st", b0 = (n) => typeof n == "number" ? H(n) : n != null && n !== "" && n !== !1;
function _0(n, e) {
  const t = new URL(n), s = new URL(e);
  if (t.origin !== s.origin)
    return n;
  const i = t.pathname.split("/").slice(1), r = s.pathname.split("/").slice(1, -1);
  for (; i[0] === r[0]; )
    i.shift(), r.shift();
  for (; r.length; )
    r.shift(), i.unshift("..");
  return i.join("/");
}
function C0() {
  try {
    return crypto.randomUUID();
  } catch {
    try {
      const e = URL.createObjectURL(new Blob()), t = e.toString();
      return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
    } catch {
      let t = (/* @__PURE__ */ new Date()).getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (i) => {
        const r = (t + Math.random() * 16) % 16 | 0;
        return t = Math.floor(t / 16), (i == "x" ? r : r & 3 | 8).toString(16);
      });
    }
  }
}
const Ps = (n) => Math.round(n), w0 = (n, e) => (e != null && e.baseUrl && (n = _0(n, e.baseUrl)), encodeURIComponent(n)), Is = (n) => Ps(n / 100) * 100, M0 = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: Ps,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: Ps,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: Is,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: Is,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: Is,
  /**
   * Next Object Request URL encoded
   */
  nor: w0,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: Is,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: Ps
};
function k0(n, e) {
  const t = {};
  if (n == null || typeof n != "object")
    return t;
  const s = Object.keys(n).sort(), i = ve({}, M0, e == null ? void 0 : e.formatters), r = e == null ? void 0 : e.filter;
  return s.forEach((o) => {
    if (r != null && r(o))
      return;
    let a = n[o];
    const l = i[o];
    l && (a = l(a, e)), !(o === "v" && a === 1) && (o == "pr" && a === 1 || b0(a) && (I0(o) && typeof a == "string" && (a = new Ia(a)), t[o] = a));
  }), t;
}
function wa(n, e = {}) {
  return n ? D0(k0(n, e), ve({
    whitespace: !1
  }, e)) : "";
}
function F0(n, e = {}) {
  if (!n)
    return {};
  const t = Object.entries(n), s = Object.entries(i0).concat(Object.entries((e == null ? void 0 : e.customHeaderMap) || {})), i = t.reduce((r, o) => {
    var a, l;
    const [c, u] = o, d = ((a = s.find((h) => h[1].includes(c))) == null ? void 0 : a[0]) || xt.REQUEST;
    return (l = r[d]) != null || (r[d] = {}), r[d][c] = u, r;
  }, {});
  return Object.entries(i).reduce((r, [o, a]) => (r[o] = wa(a, e), r), {});
}
function P0(n, e, t) {
  return ve(n, F0(e, t));
}
const O0 = "CMCD";
function N0(n, e = {}) {
  if (!n)
    return "";
  const t = wa(n, e);
  return `${O0}=${encodeURIComponent(t)}`;
}
const so = /CMCD=[^&#]+/;
function U0(n, e, t) {
  const s = N0(e, t);
  if (!s)
    return n;
  if (so.test(n))
    return n.replace(so, s);
  const i = n.includes("?") ? "&" : "?";
  return `${n}${i}${s}`;
}
class B0 {
  // eslint-disable-line no-restricted-globals
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.includeKeys = void 0, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (i) => {
      try {
        this.apply(i, {
          ot: Ce.MANIFEST,
          su: !this.initialized
        });
      } catch (r) {
        I.warn("Could not generate manifest CMCD data.", r);
      }
    }, this.applyFragmentData = (i) => {
      try {
        const r = i.frag, o = this.hls.levels[r.level], a = this.getObjectType(r), l = {
          d: r.duration * 1e3,
          ot: a
        };
        (a === Ce.VIDEO || a === Ce.AUDIO || a == Ce.MUXED) && (l.br = o.bitrate / 1e3, l.tb = this.getTopBandwidth(a) / 1e3, l.bl = this.getBufferLength(a)), this.apply(i, l);
      } catch (r) {
        I.warn("Could not generate segment CMCD data.", r);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: s
    } = t;
    s != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = s.sessionId || C0(), this.cid = s.contentId, this.useHeaders = s.useHeaders === !0, this.includeKeys = s.includeKeys, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHED, this.onMediaDetached, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHED, this.onMediaDetached, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null, this.onWaiting = this.onPlaying = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var s, i;
    this.audioBuffer = (s = t.tracks.audio) == null ? void 0 : s.buffer, this.videoBuffer = (i = t.tracks.video) == null ? void 0 : i.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: 1,
      sf: ei.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    ve(t, this.createData());
    const s = t.ot === Ce.INIT || t.ot === Ce.VIDEO || t.ot === Ce.MUXED;
    this.starved && s && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering);
    const {
      includeKeys: i
    } = this;
    i && (t = Object.keys(t).reduce((r, o) => (i.includes(o) && (r[o] = t[o]), r), {})), this.useHeaders ? (e.headers || (e.headers = {}), P0(e.headers, t)) : e.url = U0(e.url, t);
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return Ce.TIMED_TEXT;
    if (e.sn === "initSegment")
      return Ce.INIT;
    if (t === "audio")
      return Ce.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? Ce.VIDEO : Ce.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, s;
    const i = this.hls;
    if (e === Ce.AUDIO)
      s = i.audioTracks;
    else {
      const r = i.maxAutoLevel, o = r > -1 ? r + 1 : i.levels.length;
      s = i.levels.slice(0, o);
    }
    for (const r of s)
      r.bitrate > t && (t = r.bitrate);
    return t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.hls.media, s = e === Ce.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !s || !t ? NaN : he.bufferInfo(s, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, s = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new s(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, o, a) {
        t(r), this.loader.load(r, o, a);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, s = e || this.config.loader;
    return class {
      constructor(r) {
        this.loader = void 0, this.loader = new s(r);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(r, o, a) {
        t(r), this.loader.load(r, o, a);
      }
    };
  }
}
const $0 = 3e5;
class G0 {
  constructor(e) {
    this.hls = void 0, this.log = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this.pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.log = I.log.bind(I, "[content-steering]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.ERROR, this.onError, this));
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri) {
      if (this.updated) {
        const e = this.timeToLoad * 1e3 - (performance.now() - this.updated);
        if (e > 0) {
          this.scheduleRefresh(this.uri, e);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((s) => s !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: s
    } = t;
    s !== null && (this.pathwayId = s.pathwayId, this.uri = s.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: s
    } = t;
    if ((s == null ? void 0 : s.action) === be.SendAlternateToPenaltyBox && s.flags === Ke.MoveAllAlternatesMatchingHost) {
      const i = this.levels;
      let r = this.pathwayPriority, o = this.pathwayId;
      if (t.context) {
        const {
          groupId: a,
          pathwayId: l,
          type: c
        } = t.context;
        a && i ? o = this.getPathwayForGroupId(a, c, o) : l && (o = l);
      }
      o in this.penalizedPathways || (this.penalizedPathways[o] = performance.now()), !r && i && (r = i.reduce((a, l) => (a.indexOf(l.pathwayId) === -1 && a.push(l.pathwayId), a), [])), r && r.length > 1 && (this.updatePathwayPriority(r), s.resolved = this.pathwayId !== o), s.resolved || I.warn(`Could not resolve ${t.details} ("${t.error.message}") with content-steering for Pathway: ${o} levels: ${i && i.length} priorities: ${JSON.stringify(r)} penalized: ${JSON.stringify(this.penalizedPathways)}`);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const s = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${s}"`), t = this.getLevelsForPathway(s), this.pathwayId = s;
    }
    return t.length !== e.length ? (this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t) : e;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this.pathwayPriority = e;
    let t;
    const s = this.penalizedPathways, i = performance.now();
    Object.keys(s).forEach((r) => {
      i - s[r] > $0 && delete s[r];
    });
    for (let r = 0; r < e.length; r++) {
      const o = e[r];
      if (o in s)
        continue;
      if (o === this.pathwayId)
        return;
      const a = this.hls.nextLoadLevel, l = this.hls.levels[a];
      if (t = this.getLevelsForPathway(o), t.length > 0) {
        this.log(`Setting Pathway to "${o}"`), this.pathwayId = o, Xo(t), this.hls.trigger(T.LEVELS_UPDATED, {
          levels: t
        });
        const c = this.hls.levels[a];
        l && c && this.levels && (c.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && c.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${c.bitrate}`), this.hls.nextLoadLevel = a);
        break;
      }
    }
  }
  getPathwayForGroupId(e, t, s) {
    const i = this.getLevelsForPathway(s).concat(this.levels || []);
    for (let r = 0; r < i.length; r++)
      if (t === re.AUDIO_TRACK && i[r].hasAudioGroup(e) || t === re.SUBTITLE_TRACK && i[r].hasSubtitleGroup(e))
        return i[r].pathwayId;
    return s;
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const s = {}, i = {};
    e.forEach((r) => {
      const {
        ID: o,
        "BASE-ID": a,
        "URI-REPLACEMENT": l
      } = r;
      if (t.some((u) => u.pathwayId === o))
        return;
      const c = this.getLevelsForPathway(a).map((u) => {
        const d = new ge(u.attrs);
        d["PATHWAY-ID"] = o;
        const h = d.AUDIO && `${d.AUDIO}_clone_${o}`, m = d.SUBTITLES && `${d.SUBTITLES}_clone_${o}`;
        h && (s[d.AUDIO] = h, d.AUDIO = h), m && (i[d.SUBTITLES] = m, d.SUBTITLES = m);
        const f = Ma(u.uri, d["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l), g = new Gt({
          attrs: d,
          audioCodec: u.audioCodec,
          bitrate: u.bitrate,
          height: u.height,
          name: u.name,
          url: f,
          videoCodec: u.videoCodec,
          width: u.width
        });
        if (u.audioGroups)
          for (let p = 1; p < u.audioGroups.length; p++)
            g.addGroupId("audio", `${u.audioGroups[p]}_clone_${o}`);
        if (u.subtitleGroups)
          for (let p = 1; p < u.subtitleGroups.length; p++)
            g.addGroupId("text", `${u.subtitleGroups[p]}_clone_${o}`);
        return g;
      });
      t.push(...c), no(this.audioTracks, s, l, o), no(this.subtitleTracks, i, l, o);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, s = t.loader;
    this.loader && this.loader.destroy(), this.loader = new s(t);
    let i;
    try {
      i = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (i.protocol !== "data:") {
      const u = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      i.searchParams.set("_HLS_pathway", this.pathwayId), i.searchParams.set("_HLS_throughput", "" + u);
    }
    const r = {
      responseType: "json",
      url: i.href
    }, o = t.steeringManifestLoadPolicy.default, a = o.errorRetry || o.timeoutRetry || {}, l = {
      loadPolicy: o,
      timeout: o.maxLoadTimeMs,
      maxRetry: a.maxNumRetry || 0,
      retryDelay: a.retryDelayMs || 0,
      maxRetryDelay: a.maxRetryDelayMs || 0
    }, c = {
      onSuccess: (u, d, h, m) => {
        this.log(`Loaded steering manifest: "${i}"`);
        const f = u.data;
        if (f.VERSION !== 1) {
          this.log(`Steering VERSION ${f.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = f.TTL;
        const {
          "RELOAD-URI": g,
          "PATHWAY-CLONES": p,
          "PATHWAY-PRIORITY": E
        } = f;
        if (g)
          try {
            this.uri = new self.URL(g, i).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${g}`);
            return;
          }
        this.scheduleRefresh(this.uri || h.url), p && this.clonePathways(p);
        const y = {
          steeringManifest: f,
          url: i.toString()
        };
        this.hls.trigger(T.STEERING_MANIFEST_LOADED, y), E && this.updatePathwayPriority(E);
      },
      onError: (u, d, h, m) => {
        if (this.log(`Error loading steering manifest: ${u.code} ${u.text} (${d.url})`), this.stopLoad(), u.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${d.url} no longer available`);
          return;
        }
        let f = this.timeToLoad * 1e3;
        if (u.code === 429) {
          const g = this.loader;
          if (typeof (g == null ? void 0 : g.getResponseHeader) == "function") {
            const p = g.getResponseHeader("Retry-After");
            p && (f = parseFloat(p) * 1e3);
          }
          this.log(`Steering manifest ${d.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || d.url, f);
      },
      onTimeout: (u, d, h) => {
        this.log(`Timeout loading steering manifest (${d.url})`), this.scheduleRefresh(this.uri || d.url);
      }
    };
    this.log(`Requesting steering manifest: ${i}`), this.loader.load(r, l, c);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      var s;
      const i = (s = this.hls) == null ? void 0 : s.media;
      if (i && !i.ended) {
        this.loadSteeringManifest(e);
        return;
      }
      this.scheduleRefresh(e, this.timeToLoad * 1e3);
    }, t);
  }
}
function no(n, e, t, s) {
  n && Object.keys(e).forEach((i) => {
    const r = n.filter((o) => o.groupId === i).map((o) => {
      const a = ve({}, o);
      return a.details = void 0, a.attrs = new ge(a.attrs), a.url = a.attrs.URI = Ma(o.url, o.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), a.groupId = a.attrs["GROUP-ID"] = e[i], a.attrs["PATHWAY-ID"] = s, a;
    });
    n.push(...r);
  });
}
function Ma(n, e, t, s) {
  const {
    HOST: i,
    PARAMS: r,
    [t]: o
  } = s;
  let a;
  e && (a = o == null ? void 0 : o[e], a && (n = a));
  const l = new self.URL(n);
  return i && !a && (l.host = i), r && Object.keys(r).sort().forEach((c) => {
    c && l.searchParams.set(c, r[c]);
  }), l.href;
}
const H0 = /^age:\s*[\d.]+\s*$/im;
class ka {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new tn(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, s) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = s, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e || !t)
      return;
    const s = this.loader = new self.XMLHttpRequest(), i = this.stats;
    i.loading.first = 0, i.loaded = 0, i.aborted = !1;
    const r = this.xhrSetup;
    r ? Promise.resolve().then(() => {
      if (!(this.loader !== s || this.stats.aborted))
        return r(s, t.url);
    }).catch((o) => {
      if (!(this.loader !== s || this.stats.aborted))
        return s.open("GET", t.url, !0), r(s, t.url);
    }).then(() => {
      this.loader !== s || this.stats.aborted || this.openAndSendXhr(s, t, e);
    }).catch((o) => {
      this.callbacks.onError({
        code: s.status,
        text: o.message
      }, t, s, i);
    }) : this.openAndSendXhr(s, t, e);
  }
  openAndSendXhr(e, t, s) {
    e.readyState || e.open("GET", t.url, !0);
    const i = t.headers, {
      maxTimeToFirstByteMs: r,
      maxLoadTimeMs: o
    } = s.loadPolicy;
    if (i)
      for (const a in i)
        e.setRequestHeader(a, i[a]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), s.timeout = r && H(r) ? r : o, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), s.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: s
    } = this;
    if (!e || !t)
      return;
    const i = t.readyState, r = this.config;
    if (!s.aborted && i >= 2 && (s.loading.first === 0 && (s.loading.first = Math.max(self.performance.now(), s.loading.start), r.timeout !== r.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), r.timeout = r.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), r.loadPolicy.maxLoadTimeMs - (s.loading.first - s.loading.start)))), i === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const o = t.status, a = t.responseType !== "text";
      if (o >= 200 && o < 300 && (a && t.response || t.responseText !== null)) {
        s.loading.end = Math.max(self.performance.now(), s.loading.first);
        const l = a ? t.response : t.responseText, c = t.responseType === "arraybuffer" ? l.byteLength : l.length;
        if (s.loaded = s.total = c, s.bwEstimate = s.total * 8e3 / (s.loading.end - s.loading.first), !this.callbacks)
          return;
        const u = this.callbacks.onProgress;
        if (u && u(s, e, l, t), !this.callbacks)
          return;
        const d = {
          url: t.responseURL,
          data: l,
          code: o
        };
        this.callbacks.onSuccess(d, s, e, t);
      } else {
        const l = r.loadPolicy.errorRetry, c = s.retry, u = {
          url: e.url,
          data: void 0,
          code: o
        };
        qs(l, c, !1, u) ? this.retry(l) : (I.error(`${o} while loading ${e.url}`), this.callbacks.onError({
          code: o,
          text: t.statusText
        }, e, t, s));
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const e = this.config.loadPolicy.timeoutRetry, t = this.stats.retry;
    if (qs(e, t, !0))
      this.retry(e);
    else {
      var s;
      I.warn(`timeout while loading ${(s = this.context) == null ? void 0 : s.url}`);
      const i = this.callbacks;
      i && (this.abortInternal(), i.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: s
    } = this;
    this.retryDelay = ci(e, s.retry), s.retry++, I.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t == null ? void 0 : t.url}, retrying ${s.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && H0.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
function K0() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const V0 = /(\d+)-(\d+)\/(\d+)/;
class io {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || z0, this.controller = new self.AbortController(), this.stats = new tn();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    this.controller && !this.stats.loading.end && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, s) {
    const i = this.stats;
    if (i.loading.start)
      throw new Error("Loader can only be used once.");
    i.loading.start = self.performance.now();
    const r = W0(e, this.controller.signal), o = s.onProgress, a = e.responseType === "arraybuffer", l = a ? "byteLength" : "length", {
      maxTimeToFirstByteMs: c,
      maxLoadTimeMs: u
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = s, this.request = this.fetchSetup(e, r), self.clearTimeout(this.requestTimeout), t.timeout = c && H(c) ? c : u, this.requestTimeout = self.setTimeout(() => {
      this.abortInternal(), s.onTimeout(i, e, this.response);
    }, t.timeout), self.fetch(this.request).then((d) => {
      this.response = this.loader = d;
      const h = Math.max(self.performance.now(), i.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = u, this.requestTimeout = self.setTimeout(() => {
        this.abortInternal(), s.onTimeout(i, e, this.response);
      }, u - (h - i.loading.start)), !d.ok) {
        const {
          status: m,
          statusText: f
        } = d;
        throw new j0(f || "fetch, bad network response", m, d);
      }
      return i.loading.first = h, i.total = q0(d.headers) || i.total, o && H(t.highWaterMark) ? this.loadProgressively(d, i, e, t.highWaterMark, o) : a ? d.arrayBuffer() : e.responseType === "json" ? d.json() : d.text();
    }).then((d) => {
      const h = this.response;
      if (!h)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), i.loading.end = Math.max(self.performance.now(), i.loading.first);
      const m = d[l];
      m && (i.loaded = i.total = m);
      const f = {
        url: h.url,
        data: d,
        code: h.status
      };
      o && !H(t.highWaterMark) && o(i, e, d, h), s.onSuccess(f, i, e, h);
    }).catch((d) => {
      if (self.clearTimeout(this.requestTimeout), i.aborted)
        return;
      const h = d && d.code || 0, m = d ? d.message : null;
      s.onError({
        code: h,
        text: m
      }, e, d ? d.details : null, i);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, s, i = 0, r) {
    const o = new ea(), a = e.body.getReader(), l = () => a.read().then((c) => {
      if (c.done)
        return o.dataLength && r(t, s, o.flush(), e), Promise.resolve(new ArrayBuffer(0));
      const u = c.value, d = u.length;
      return t.loaded += d, d < i || o.dataLength ? (o.push(u), o.dataLength >= i && r(t, s, o.flush(), e)) : r(t, s, u, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function W0(n, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(ve({}, n.headers))
  };
  return n.rangeEnd && t.headers.set("Range", "bytes=" + n.rangeStart + "-" + String(n.rangeEnd - 1)), t;
}
function Y0(n) {
  const e = V0.exec(n);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function q0(n) {
  const e = n.get("Content-Range");
  if (e) {
    const s = Y0(e);
    if (H(s))
      return s;
  }
  const t = n.get("Content-Length");
  if (t)
    return parseInt(t);
}
function z0(n, e) {
  return new self.Request(n.url, e);
}
class j0 extends Error {
  constructor(e, t, s) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = s;
  }
}
const X0 = /\s/, Q0 = {
  newCue(n, e, t, s) {
    const i = [];
    let r, o, a, l, c;
    const u = self.VTTCue || self.TextTrackCue;
    for (let h = 0; h < s.rows.length; h++)
      if (r = s.rows[h], a = !0, l = 0, c = "", !r.isEmpty()) {
        var d;
        for (let g = 0; g < r.chars.length; g++)
          X0.test(r.chars[g].uchar) && a ? l++ : (c += r.chars[g].uchar, a = !1);
        r.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const m = Sa(c.trim()), f = xi(e, t, m);
        n != null && (d = n.cues) != null && d.getCueById(f) || (o = new u(e, t, m), o.id = f, o.line = h + 1, o.align = "left", o.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), i.push(o));
      }
    return n && i.length && (i.sort((h, m) => h.line === "auto" || m.line === "auto" ? 0 : h.line > 8 && m.line > 8 ? m.line - h.line : h.line - m.line), i.forEach((h) => Yo(n, h))), i;
  }
}, Z0 = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, Fa = De(De({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: ka,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: Rm,
  bufferController: _g,
  capLevelController: vi,
  errorController: fm,
  fpsController: n0,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: Mo,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableID3MetadataCues: !0,
  useMediaCapabilities: !0,
  certLoadPolicy: {
    default: Z0
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, J0()), {}, {
  subtitleStreamController: Rg,
  subtitleTrackController: Ig,
  timelineController: t0,
  audioStreamController: Ag,
  audioTrackController: Lg,
  emeController: Ut,
  cmcdController: B0,
  contentSteeringController: G0
});
function J0() {
  return {
    cueHandler: Q0,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function ep(n, e) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const t = ni(n), s = ["manifest", "level", "frag"], i = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return s.forEach((r) => {
    const o = `${r === "level" ? "playlist" : r}LoadPolicy`, a = e[o] === void 0, l = [];
    i.forEach((c) => {
      const u = `${r}Loading${c}`, d = e[u];
      if (d !== void 0 && a) {
        l.push(u);
        const h = t[o].default;
        switch (e[o] = {
          default: h
        }, c) {
          case "TimeOut":
            h.maxLoadTimeMs = d, h.maxTimeToFirstByteMs = d;
            break;
          case "MaxRetry":
            h.errorRetry.maxNumRetry = d, h.timeoutRetry.maxNumRetry = d;
            break;
          case "RetryDelay":
            h.errorRetry.retryDelayMs = d, h.timeoutRetry.retryDelayMs = d;
            break;
          case "MaxRetryTimeout":
            h.errorRetry.maxRetryDelayMs = d, h.timeoutRetry.maxRetryDelayMs = d;
            break;
        }
      }
    }), l.length && I.warn(`hls.js config: "${l.join('", "')}" setting(s) are deprecated, use "${o}": ${JSON.stringify(e[o])}`);
  }), De(De({}, t), e);
}
function ni(n) {
  return n && typeof n == "object" ? Array.isArray(n) ? n.map(ni) : Object.keys(n).reduce((e, t) => (e[t] = ni(n[t]), e), {}) : n;
}
function tp(n) {
  const e = n.loader;
  e !== io && e !== ka ? (I.log("[config]: Custom loader detected, cannot enable progressive streaming"), n.progressive = !1) : K0() && (n.loader = io, n.progressive = !0, n.enableSoftwareAES = !0, I.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
let kn;
class sp extends ui {
  constructor(e, t) {
    super(e, "[level-controller]"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const s = this.hls.config.preferManagedMediaSource, i = [], r = {}, o = {};
    let a = !1, l = !1, c = !1;
    t.levels.forEach((u) => {
      var d, h;
      const m = u.attrs;
      let {
        audioCodec: f,
        videoCodec: g
      } = u;
      ((d = f) == null ? void 0 : d.indexOf("mp4a.40.34")) !== -1 && (kn || (kn = /chrome|firefox/i.test(navigator.userAgent)), kn && (u.audioCodec = f = void 0)), f && (u.audioCodec = f = Vs(f, s)), ((h = g) == null ? void 0 : h.indexOf("avc1")) === 0 && (g = u.videoCodec = Hf(g));
      const {
        width: p,
        height: E,
        unknownCodecs: y
      } = u;
      if (a || (a = !!(p && E)), l || (l = !!g), c || (c = !!f), y != null && y.length || f && !En(f, "audio", s) || g && !En(g, "video", s))
        return;
      const {
        CODECS: x,
        "FRAME-RATE": S,
        "HDCP-LEVEL": v,
        "PATHWAY-ID": D,
        RESOLUTION: L,
        "VIDEO-RANGE": _
      } = m, R = `${`${D || "."}-`}${u.bitrate}-${L}-${S}-${x}-${_}-${v}`;
      if (r[R])
        if (r[R].uri !== u.url && !u.attrs["PATHWAY-ID"]) {
          const w = o[R] += 1;
          u.attrs["PATHWAY-ID"] = new Array(w + 1).join(".");
          const B = new Gt(u);
          r[R] = B, i.push(B);
        } else
          r[R].addGroupId("audio", m.AUDIO), r[R].addGroupId("text", m.SUBTITLES);
      else {
        const w = new Gt(u);
        r[R] = w, o[R] = 1, i.push(w);
      }
    }), this.filterAndSortMediaOptions(i, t, a, l, c);
  }
  filterAndSortMediaOptions(e, t, s, i, r) {
    let o = [], a = [], l = e;
    if ((s || i) && r && (l = l.filter(({
      videoCodec: f,
      videoRange: g,
      width: p,
      height: E
    }) => (!!f || !!(p && E)) && tm(g))), l.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          t.levels.length && this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(t.levels[0].attrs)}`);
          const f = new Error("no level with compatible codecs found in manifest");
          this.hls.trigger(T.ERROR, {
            type: Q.MEDIA_ERROR,
            details: C.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: f,
            reason: f.message
          });
        }
      });
      return;
    }
    if (t.audioTracks) {
      const {
        preferManagedMediaSource: f
      } = this.hls.config;
      o = t.audioTracks.filter((g) => !g.audioCodec || En(g.audioCodec, "audio", f)), ro(o);
    }
    t.subtitles && (a = t.subtitles, ro(a));
    const c = l.slice(0);
    l.sort((f, g) => {
      if (f.attrs["HDCP-LEVEL"] !== g.attrs["HDCP-LEVEL"])
        return (f.attrs["HDCP-LEVEL"] || "") > (g.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (s && f.height !== g.height)
        return f.height - g.height;
      if (f.frameRate !== g.frameRate)
        return f.frameRate - g.frameRate;
      if (f.videoRange !== g.videoRange)
        return Ws.indexOf(f.videoRange) - Ws.indexOf(g.videoRange);
      if (f.videoCodec !== g.videoCodec) {
        const p = hr(f.videoCodec), E = hr(g.videoCodec);
        if (p !== E)
          return E - p;
      }
      if (f.uri === g.uri && f.codecSet !== g.codecSet) {
        const p = Ks(f.codecSet), E = Ks(g.codecSet);
        if (p !== E)
          return E - p;
      }
      return f.averageBitrate !== g.averageBitrate ? f.averageBitrate - g.averageBitrate : 0;
    });
    let u = c[0];
    if (this.steering && (l = this.steering.filterParsedLevels(l), l.length !== c.length)) {
      for (let f = 0; f < c.length; f++)
        if (c[f].pathwayId === l[0].pathwayId) {
          u = c[f];
          break;
        }
    }
    this._levels = l;
    for (let f = 0; f < l.length; f++)
      if (l[f] === u) {
        var d;
        this._firstLevel = f;
        const g = u.bitrate, p = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${l.length} level(s) found, first bitrate: ${g}`), ((d = this.hls.userConfig) == null ? void 0 : d.abrEwmaDefaultEstimate) === void 0) {
          const E = Math.min(g, this.hls.config.abrEwmaDefaultEstimateMax);
          E > p && p === Fa.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = E);
        }
        break;
      }
    const h = r && !i, m = {
      levels: l,
      audioTracks: o,
      subtitleTracks: a,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: r,
      video: i,
      altAudio: !h && o.some((f) => !!f.url)
    };
    this.hls.trigger(T.MANIFEST_PARSED, m), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const u = new Error("invalid level idx"), d = e < 0;
      if (this.hls.trigger(T.ERROR, {
        type: Q.OTHER_ERROR,
        details: C.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: d,
        error: u,
        reason: u.message
      }), d)
        return;
      e = Math.min(e, t.length - 1);
    }
    const s = this.currentLevelIndex, i = this.currentLevel, r = i ? i.attrs["PATHWAY-ID"] : void 0, o = t[e], a = o.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = o, s === e && o.details && i && r === a)
      return;
    this.log(`Switching to level ${e} (${o.height ? o.height + "p " : ""}${o.videoRange ? o.videoRange + " " : ""}${o.codecSet ? o.codecSet + " " : ""}@${o.bitrate})${a ? " with Pathway " + a : ""} from level ${s}${r ? " with Pathway " + r : ""}`);
    const l = {
      level: e,
      attrs: o.attrs,
      details: o.details,
      bitrate: o.bitrate,
      averageBitrate: o.averageBitrate,
      maxBitrate: o.maxBitrate,
      realBitrate: o.realBitrate,
      width: o.width,
      height: o.height,
      codecSet: o.codecSet,
      audioCodec: o.audioCodec,
      videoCodec: o.videoCodec,
      audioGroups: o.audioGroups,
      subtitleGroups: o.subtitleGroups,
      loaded: o.loaded,
      loadError: o.loadError,
      fragmentError: o.fragmentError,
      name: o.name,
      id: o.id,
      uri: o.uri,
      url: o.url,
      urlId: 0,
      audioGroupIds: o.audioGroupIds,
      textGroupIds: o.textGroupIds
    };
    this.hls.trigger(T.LEVEL_SWITCHING, l);
    const c = o.details;
    if (!c || c.live) {
      const u = this.switchParams(o.uri, i == null ? void 0 : i.details, c);
      this.loadPlaylist(u);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === re.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === j.MAIN) {
      const s = t.elementaryStreams;
      if (!Object.keys(s).some((r) => !!s[r]))
        return;
      const i = this._levels[t.level];
      i != null && i.loadError && (this.log(`Resetting level error count of ${i.loadError} on frag buffered`), i.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var s;
    const {
      level: i,
      details: r
    } = t, o = this._levels[i];
    if (!o) {
      var a;
      this.warn(`Invalid level index ${i}`), (a = t.deliveryDirectives) != null && a.skip && (r.deltaUpdateFailed = !0);
      return;
    }
    i === this.currentLevelIndex ? (o.fragmentError === 0 && (o.loadError = 0), this.playlistLoaded(i, t, o.details)) : (s = t.deliveryDirectives) != null && s.skip && (r.deltaUpdateFailed = !0);
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentLevelIndex, s = this.currentLevel;
    if (s && this.shouldLoadPlaylist(s)) {
      let i = s.uri;
      if (e)
        try {
          i = e.addDirectives(i);
        } catch (o) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${o}`);
        }
      const r = s.attrs["PATHWAY-ID"];
      this.log(`Loading level index ${t}${(e == null ? void 0 : e.msn) !== void 0 ? " at sn " + e.msn + " part " + e.part : ""} with${r ? " Pathway " + r : ""} ${i}`), this.clearTimer(), this.hls.trigger(T.LEVEL_LOADING, {
        url: i,
        level: t,
        pathwayId: s.attrs["PATHWAY-ID"],
        id: 0,
        // Deprecated Level urlId
        deliveryDirectives: e || null
      });
    }
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e) {
    var t;
    const s = this._levels.filter((i, r) => r !== e ? !0 : (this.steering && this.steering.removeLevel(i), i === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, i.details && i.details.fragments.forEach((o) => o.level = -1)), !1));
    Xo(s), this._levels = s, this.currentLevelIndex > -1 && (t = this.currentLevel) != null && t.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.hls.trigger(T.LEVELS_UPDATED, {
      levels: s
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    this._levels = t;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: e,
      maxAutoLevel: t,
      maxHdcpLevel: s
    } = this.hls;
    this._maxAutoLevel !== t && (this._maxAutoLevel = t, this.hls.trigger(T.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: e,
      levels: this.levels,
      maxAutoLevel: t,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: s
    }));
  }
}
function ro(n) {
  const e = {};
  n.forEach((t) => {
    const s = t.groupId || "";
    t.id = e[s] = e[s] || 0, e[s]++;
  });
}
class np {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const s in this.keyUriToKeyInfo) {
      const i = this.keyUriToKeyInfo[s].loader;
      if (i) {
        var t;
        if (e && e !== ((t = i.context) == null ? void 0 : t.frag.type))
          return;
        i.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, t = C.KEY_LOAD_ERROR, s, i, r) {
    return new ot({
      type: Q.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: r,
      error: s,
      networkDetails: i
    });
  }
  loadClear(e, t) {
    if (this.emeController && this.config.emeEnabled) {
      const {
        sn: s,
        cc: i
      } = e;
      for (let r = 0; r < t.length; r++) {
        const o = t[r];
        if (i <= o.cc && (s === "initSegment" || o.sn === "initSegment" || s < o.sn)) {
          this.emeController.selectKeySystemFormat(o).then((a) => {
            o.setKeyFormat(a);
          });
          break;
        }
      }
    }
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var s, i;
    t && e.setKeyFormat(t);
    const r = e.decryptdata;
    if (!r) {
      const c = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, C.KEY_LOAD_ERROR, c));
    }
    const o = r.uri;
    if (!o)
      return Promise.reject(this.createKeyLoadError(e, C.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${o}"`)));
    let a = this.keyUriToKeyInfo[o];
    if ((s = a) != null && s.decryptdata.key)
      return r.key = a.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: a
      });
    if ((i = a) != null && i.keyLoadPromise) {
      var l;
      switch ((l = a.mediaKeySessionContext) == null ? void 0 : l.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return a.keyLoadPromise.then((c) => (r.key = c.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: a
          }));
      }
    }
    switch (a = this.keyUriToKeyInfo[o] = {
      decryptdata: r,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, r.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return r.keyFormat === "identity" ? this.loadKeyHTTP(a, e) : this.loadKeyEME(a, e);
      case "AES-128":
        return this.loadKeyHTTP(a, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, C.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${r.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const s = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const i = this.emeController.loadKey(s);
      if (i)
        return (e.keyLoadPromise = i.then((r) => (e.mediaKeySessionContext = r, s))).catch((r) => {
          throw e.keyLoadPromise = null, r;
        });
    }
    return Promise.resolve(s);
  }
  loadKeyHTTP(e, t) {
    const s = this.config, i = s.loader, r = new i(s);
    return t.keyLoader = e.loader = r, e.keyLoadPromise = new Promise((o, a) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, c = s.keyLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (h, m, f, g) => {
          const {
            frag: p,
            keyInfo: E,
            url: y
          } = f;
          if (!p.decryptdata || E !== this.keyUriToKeyInfo[y])
            return a(this.createKeyLoadError(p, C.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), g));
          E.decryptdata.key = p.decryptdata.key = new Uint8Array(h.data), p.keyLoader = null, E.loader = null, o({
            frag: p,
            keyInfo: E
          });
        },
        onError: (h, m, f, g) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, C.KEY_LOAD_ERROR, new Error(`HTTP Error ${h.code} loading key ${h.text}`), f, De({
            url: l.url,
            data: void 0
          }, h)));
        },
        onTimeout: (h, m, f) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, C.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), f));
        },
        onAbort: (h, m, f) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, C.INTERNAL_ABORTED, new Error("key loading aborted"), f));
        }
      };
      r.load(l, u, d);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: s,
      url: i
    } = e, r = s.loader;
    t.keyLoader === r && (t.keyLoader = null, s.loader = null), delete this.keyUriToKeyInfo[i], r && r.destroy();
  }
}
function Pa() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function Oa() {
  if (!At())
    return !1;
  const e = Pa();
  return !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
}
function ip() {
  if (!Oa())
    return !1;
  const n = At();
  return typeof (n == null ? void 0 : n.isTypeSupported) == "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some((e) => n.isTypeSupported(ns(e, "video"))) || ["mp4a.40.2", "fLaC"].some((e) => n.isTypeSupported(ns(e, "audio"))));
}
function rp() {
  var n;
  const e = Pa();
  return typeof (e == null || (n = e.prototype) == null ? void 0 : n.changeType) == "function";
}
const op = 250, Os = 2, ap = 0.1, lp = 0.05;
class cp {
  constructor(e, t, s, i) {
    this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = e, this.media = t, this.fragmentTracker = s, this.hls = i;
  }
  destroy() {
    this.media = null, this.hls = this.fragmentTracker = null;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    const {
      config: s,
      media: i,
      stalled: r
    } = this;
    if (i === null)
      return;
    const {
      currentTime: o,
      seeking: a
    } = i, l = this.seeking && !a, c = !this.seeking && a;
    if (this.seeking = a, o !== e) {
      if (this.moved = !0, a || (this.nudgeRetry = 0), r !== null) {
        if (this.stallReported) {
          const p = self.performance.now() - r;
          I.warn(`playback not stuck anymore @${o}, after ${Math.round(p)}ms`), this.stallReported = !1;
        }
        this.stalled = null;
      }
      return;
    }
    if (c || l) {
      this.stalled = null;
      return;
    }
    if (i.paused && !a || i.ended || i.playbackRate === 0 || !he.getBuffered(i).length) {
      this.nudgeRetry = 0;
      return;
    }
    const u = he.bufferInfo(i, o, 0), d = u.nextStart || 0;
    if (a) {
      const p = u.len > Os, E = !d || t && t.start <= o || d - o > Os && !this.fragmentTracker.getPartialFragment(o);
      if (p || E)
        return;
      this.moved = !1;
    }
    if (!this.moved && this.stalled !== null) {
      var h;
      if (!(u.len > 0) && !d)
        return;
      const E = Math.max(d, u.start || 0) - o, y = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, S = (y == null || (h = y.details) == null ? void 0 : h.live) ? y.details.targetduration * 2 : Os, v = this.fragmentTracker.getPartialFragment(o);
      if (E > 0 && (E <= S || v)) {
        i.paused || this._trySkipBufferHole(v);
        return;
      }
    }
    const m = self.performance.now();
    if (r === null) {
      this.stalled = m;
      return;
    }
    const f = m - r;
    if (!a && f >= op && (this._reportStall(u), !this.media))
      return;
    const g = he.bufferInfo(i, o, s.maxBufferHole);
    this._tryFixBufferStall(g, f);
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t) {
    const {
      config: s,
      fragmentTracker: i,
      media: r
    } = this;
    if (r === null)
      return;
    const o = r.currentTime, a = i.getPartialFragment(o);
    a && (this._trySkipBufferHole(a) || !this.media) || (e.len > s.maxBufferHole || e.nextStart && e.nextStart - o < s.maxBufferHole) && t > s.highBufferWatchdogPeriod * 1e3 && (I.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: s,
      stallReported: i
    } = this;
    if (!i && s) {
      this.stallReported = !0;
      const r = new Error(`Playback stalling at @${s.currentTime} due to low buffer (${JSON.stringify(e)})`);
      I.warn(r.message), t.trigger(T.ERROR, {
        type: Q.MEDIA_ERROR,
        details: C.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: r,
        buffer: e.len
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    const {
      config: t,
      hls: s,
      media: i
    } = this;
    if (i === null)
      return 0;
    const r = i.currentTime, o = he.bufferInfo(i, r, 0), a = r < o.start ? o.start : o.nextStart;
    if (a) {
      const l = o.len <= t.maxBufferHole, c = o.len > 0 && o.len < 1 && i.readyState < 3, u = a - r;
      if (u > 0 && (l || c)) {
        if (u > t.maxBufferHole) {
          const {
            fragmentTracker: h
          } = this;
          let m = !1;
          if (r === 0) {
            const f = h.getAppendedFrag(0, j.MAIN);
            f && a < f.end && (m = !0);
          }
          if (!m) {
            const f = e || h.getAppendedFrag(r, j.MAIN);
            if (f) {
              let g = !1, p = f.end;
              for (; p < a; ) {
                const E = h.getPartialFragment(p);
                if (E)
                  p += E.duration;
                else {
                  g = !0;
                  break;
                }
              }
              if (g)
                return 0;
            }
          }
        }
        const d = Math.max(a + lp, r + ap);
        if (I.warn(`skipping hole, adjusting currentTime from ${r} to ${d}`), this.moved = !0, this.stalled = null, i.currentTime = d, e && !e.gap) {
          const h = new Error(`fragment loaded with buffer holes, seeking from ${r} to ${d}`);
          s.trigger(T.ERROR, {
            type: Q.MEDIA_ERROR,
            details: C.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: h,
            reason: h.message,
            frag: e
          });
        }
        return d;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config: e,
      hls: t,
      media: s,
      nudgeRetry: i
    } = this;
    if (s === null)
      return;
    const r = s.currentTime;
    if (this.nudgeRetry++, i < e.nudgeMaxRetry) {
      const o = r + (i + 1) * e.nudgeOffset, a = new Error(`Nudging 'currentTime' from ${r} to ${o}`);
      I.warn(a.message), s.currentTime = o, t.trigger(T.ERROR, {
        type: Q.MEDIA_ERROR,
        details: C.BUFFER_NUDGE_ON_STALL,
        error: a,
        fatal: !1
      });
    } else {
      const o = new Error(`Playhead still not moving while enough data buffered @${r} after ${e.nudgeMaxRetry} nudges`);
      I.error(o.message), t.trigger(T.ERROR, {
        type: Q.MEDIA_ERROR,
        details: C.BUFFER_STALLED_ERROR,
        error: o,
        fatal: !0
      });
    }
  }
}
const up = 100;
class dp extends fi {
  constructor(e, t, s) {
    super(e, t, s, "[stream-controller]", j.MAIN), this.audioCodecSwap = !1, this.gapController = null, this.level = -1, this._forceStartLoad = !1, this.altAudio = !1, this.audioOnly = !1, this.fragPlaying = null, this.onvplaying = null, this.onvseeked = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(T.ERROR, this.onError, this), e.on(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(T.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this), e.on(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(T.ERROR, this.onError, this), e.off(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(T.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this), e.off(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners(), super.onHandlerDestroying();
  }
  startLoad(e) {
    if (this.levels) {
      const {
        lastCurrentTime: t,
        hls: s
      } = this;
      if (this.stopLoad(), this.setInterval(up), this.level = -1, !this.startFragRequested) {
        let i = s.startLevel;
        i === -1 && (s.config.testBandwidth && this.levels.length > 1 ? (i = 0, this.bitrateTest = !0) : i = s.firstAutoLevel), s.nextLoadLevel = i, this.level = s.loadLevel, this.loadedmetadata = !1;
      }
      t > 0 && e === -1 && (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t), this.state = k.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = k.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case k.WAITING_LEVEL: {
        const {
          levels: t,
          level: s
        } = this, i = t == null ? void 0 : t[s], r = i == null ? void 0 : i.details;
        if (r && (!r.live || this.levelLastLoaded === i)) {
          if (this.waitForCdnTuneIn(r))
            break;
          this.state = k.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = k.IDLE;
          break;
        }
        break;
      }
      case k.FRAG_LOADING_WAITING_RETRY:
        {
          var e;
          const t = self.performance.now(), s = this.retryDate;
          if (!s || t >= s || (e = this.media) != null && e.seeking) {
            const {
              levels: i,
              level: r
            } = this, o = i == null ? void 0 : i[r];
            this.resetStartWhenNotLoaded(o || null), this.state = k.IDLE;
          }
        }
        break;
    }
    this.state === k.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd(), this.checkBuffer(), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: s,
      media: i
    } = this;
    if (t === null || !i && (this.startFragRequested || !e.config.startFragPrefetch) || this.altAudio && this.audioOnly)
      return;
    const r = e.nextLoadLevel;
    if (!(s != null && s[r]))
      return;
    const o = s[r], a = this.getMainFwdBufferInfo();
    if (a === null)
      return;
    const l = this.getLevelDetails();
    if (l && this._streamEnded(a, l)) {
      const g = {};
      this.altAudio && (g.type = "video"), this.hls.trigger(T.BUFFER_EOS, g), this.state = k.ENDED;
      return;
    }
    e.loadLevel !== r && e.manualLevel === -1 && this.log(`Adapting to level ${r} from level ${this.level}`), this.level = e.nextLoadLevel = r;
    const c = o.details;
    if (!c || this.state === k.WAITING_LEVEL || c.live && this.levelLastLoaded !== o) {
      this.level = r, this.state = k.WAITING_LEVEL;
      return;
    }
    const u = a.len, d = this.getMaxBufferLength(o.maxBitrate);
    if (u >= d)
      return;
    this.backtrackFragment && this.backtrackFragment.start > a.end && (this.backtrackFragment = null);
    const h = this.backtrackFragment ? this.backtrackFragment.start : a.end;
    let m = this.getNextFragment(h, c);
    if (this.couldBacktrack && !this.fragPrevious && m && m.sn !== "initSegment" && this.fragmentTracker.getState(m) !== Re.OK) {
      var f;
      const p = ((f = this.backtrackFragment) != null ? f : m).sn - c.startSN, E = c.fragments[p - 1];
      E && m.cc === E.cc && (m = E, this.fragmentTracker.removeFragment(E));
    } else this.backtrackFragment && a.len && (this.backtrackFragment = null);
    if (m && this.isLoopLoading(m, h)) {
      if (!m.gap) {
        const p = this.audioOnly && !this.altAudio ? le.AUDIO : le.VIDEO, E = (p === le.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        E && this.afterBufferFlushed(E, p, j.MAIN);
      }
      m = this.getNextFragmentLoopLoading(m, c, a, j.MAIN, d);
    }
    m && (m.initSegment && !m.initSegment.data && !this.bitrateTest && (m = m.initSegment), this.loadFragment(m, o, h));
  }
  loadFragment(e, t, s) {
    const i = this.fragmentTracker.getState(e);
    this.fragCurrent = e, i === Re.NOT_LOADED || i === Re.PARTIAL ? e.sn === "initSegment" ? this._loadInitSegment(e, t) : this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : (this.startFragRequested = !0, super.loadFragment(e, t, s)) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, j.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let s;
      const i = this.getAppendedFrag(t.currentTime);
      i && i.start > 1 && this.flushMainBuffer(0, i.start - 1);
      const r = this.getLevelDetails();
      if (r != null && r.live) {
        const a = this.getMainFwdBufferInfo();
        if (!a || a.len < r.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const a = this.hls.nextLoadLevel, l = e[a], c = this.fragLastKbps;
        c && this.fragCurrent ? s = this.fragCurrent.duration * l.maxBitrate / (1e3 * c) + 1 : s = 0;
      } else
        s = 0;
      const o = this.getBufferedFrag(t.currentTime + s);
      if (o) {
        const a = this.followingBufferedFrag(o);
        if (a) {
          this.abortCurrentFrag();
          const l = a.maxStartPTS ? a.maxStartPTS : a.start, c = a.duration, u = Math.max(o.end, l + Math.min(Math.max(c - this.config.maxFragLookUpTolerance, c * (this.couldBacktrack ? 0.5 : 0.125)), c * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(u, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case k.KEY_LOADING:
      case k.FRAG_LOADING:
      case k.FRAG_LOADING_WAITING_RETRY:
      case k.PARSING:
      case k.PARSED:
        this.state = k.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const s = t.media;
    this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), s.addEventListener("playing", this.onvplaying), s.addEventListener("seeked", this.onvseeked), this.gapController = new cp(this.config, s, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media: e
    } = this;
    e && this.onvplaying && this.onvseeked && (e.removeEventListener("playing", this.onvplaying), e.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), super.onMediaDetaching();
  }
  onMediaPlaying() {
    this.tick();
  }
  onMediaSeeked() {
    const e = this.media, t = e ? e.currentTime : null;
    H(t) && this.log(`Media seeked to ${t.toFixed(3)}`);
    const s = this.getMainFwdBufferInfo();
    if (s === null || s.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${s ? s.len : "empty"})`);
      return;
    }
    this.tick();
  }
  onManifestLoading() {
    this.log("Trigger BUFFER_RESET"), this.hls.trigger(T.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = this.fragLastKbps = 0, this.levels = this.fragPlaying = this.backtrackFragment = this.levelLastLoaded = null, this.altAudio = this.audioOnly = this.startFragRequested = !1;
  }
  onManifestParsed(e, t) {
    let s = !1, i = !1;
    t.levels.forEach((r) => {
      const o = r.audioCodec;
      o && (s = s || o.indexOf("mp4a.40.2") !== -1, i = i || o.indexOf("mp4a.40.5") !== -1);
    }), this.audioCodecSwitch = s && i && !rp(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: s
    } = this;
    if (!s || this.state !== k.IDLE)
      return;
    const i = s[t.level];
    (!i.details || i.details.live && this.levelLastLoaded !== i || this.waitForCdnTuneIn(i.details)) && (this.state = k.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var s;
    const {
      levels: i
    } = this, r = t.level, o = t.details, a = o.totalduration;
    if (!i) {
      this.warn(`Levels were reset while loading level ${r}`);
      return;
    }
    this.log(`Level ${r} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""}, cc [${o.startCC}, ${o.endCC}] duration:${a}`);
    const l = i[r], c = this.fragCurrent;
    c && (this.state === k.FRAG_LOADING || this.state === k.FRAG_LOADING_WAITING_RETRY) && c.level !== t.level && c.loader && this.abortCurrentFrag();
    let u = 0;
    if (o.live || (s = l.details) != null && s.live) {
      var d;
      if (this.checkLiveUpdate(o), o.deltaUpdateFailed)
        return;
      u = this.alignPlaylists(o, l.details, (d = this.levelLastLoaded) == null ? void 0 : d.details);
    }
    if (l.details = o, this.levelLastLoaded = l, this.hls.trigger(T.LEVEL_UPDATED, {
      details: o,
      level: r
    }), this.state === k.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(o))
        return;
      this.state = k.IDLE;
    }
    this.startFragRequested ? o.live && this.synchronizeToLiveEdge(o) : this.setStartPosition(o, u), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: s,
      part: i,
      payload: r
    } = e, {
      levels: o
    } = this;
    if (!o) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${s.sn} of level ${s.level} will not be buffered`);
      return;
    }
    const a = o[s.level], l = a.details;
    if (!l) {
      this.warn(`Dropping fragment ${s.sn} of level ${s.level} after level details were reset`), this.fragmentTracker.removeFragment(s);
      return;
    }
    const c = a.videoCodec, u = l.PTSKnown || !l.live, d = (t = s.initSegment) == null ? void 0 : t.data, h = this._getAudioCodec(a), m = this.transmuxer = this.transmuxer || new pa(this.hls, j.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), f = i ? i.index : -1, g = f !== -1, p = new di(s.level, s.sn, s.stats.chunkCount, r.byteLength, f, g), E = this.initPTS[s.cc];
    m.push(r, d, h, c, s, i, l.totalduration, u, p, E);
  }
  onAudioTrackSwitching(e, t) {
    const s = this.altAudio;
    if (!!!t.url) {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const o = this.fragCurrent;
        o && (this.log("Switching to main audio track, cancel main fragment load"), o.abortRequests(), this.fragmentTracker.removeFragment(o)), this.resetTransmuxer(), this.resetLoadingState();
      } else this.audioOnly && this.resetTransmuxer();
      const r = this.hls;
      s && (r.trigger(T.BUFFER_FLUSHING, {
        startOffset: 0,
        endOffset: Number.POSITIVE_INFINITY,
        type: null
      }), this.fragmentTracker.removeAllFragments()), r.trigger(T.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const s = t.id, i = !!this.hls.audioTracks[s].url;
    if (i) {
      const r = this.videoBuffer;
      r && this.mediaBuffer !== r && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = r);
    }
    this.altAudio = i, this.tick();
  }
  onBufferCreated(e, t) {
    const s = t.tracks;
    let i, r, o = !1;
    for (const a in s) {
      const l = s[a];
      if (l.id === "main") {
        if (r = a, i = l, a === "video") {
          const c = s[a];
          c && (this.videoBuffer = c.buffer);
        }
      } else
        o = !0;
    }
    o && i ? (this.log(`Alternate track found, use ${r}.buffered to schedule main fragment loading`), this.mediaBuffer = i.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: s,
      part: i
    } = t;
    if (s && s.type !== j.MAIN)
      return;
    if (this.fragContextChanged(s)) {
      this.warn(`Fragment ${s.sn}${i ? " p: " + i.index : ""} of level ${s.level} finished buffering, but was aborted. state: ${this.state}`), this.state === k.PARSED && (this.state = k.IDLE);
      return;
    }
    const r = i ? i.stats : s.stats;
    this.fragLastKbps = Math.round(8 * r.total / (r.buffering.end - r.loading.first)), s.sn !== "initSegment" && (this.fragPrevious = s), this.fragBufferedComplete(s, i);
  }
  onError(e, t) {
    var s;
    if (t.fatal) {
      this.state = k.ERROR;
      return;
    }
    switch (t.details) {
      case C.FRAG_GAP:
      case C.FRAG_PARSING_ERROR:
      case C.FRAG_DECRYPT_ERROR:
      case C.FRAG_LOAD_ERROR:
      case C.FRAG_LOAD_TIMEOUT:
      case C.KEY_LOAD_ERROR:
      case C.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(j.MAIN, t);
        break;
      case C.LEVEL_LOAD_ERROR:
      case C.LEVEL_LOAD_TIMEOUT:
      case C.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === k.WAITING_LEVEL && ((s = t.context) == null ? void 0 : s.type) === re.LEVEL && (this.state = k.IDLE);
        break;
      case C.BUFFER_APPEND_ERROR:
      case C.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "main")
          return;
        if (t.details === C.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case C.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media: e,
      gapController: t
    } = this;
    if (!(!e || !t || !e.readyState)) {
      if (this.loadedmetadata || !he.getBuffered(e).length) {
        const s = this.state !== k.IDLE ? this.fragCurrent : null;
        t.poll(this.lastCurrentTime, s);
      }
      this.lastCurrentTime = e.currentTime;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = k.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== le.AUDIO || this.audioOnly && !this.altAudio) {
      const s = (t === le.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(s, t, j.MAIN), this.tick();
    }
  }
  onLevelsUpdated(e, t) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level), this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let s = this.startPosition;
    if (s >= 0 && t < s) {
      if (e.seeking) {
        this.log(`could not seek to ${s}, already seeking at ${t}`);
        return;
      }
      const i = he.getBuffered(e), o = (i.length ? i.start(0) : 0) - s;
      o > 0 && (o < this.config.maxBufferHole || o < this.config.maxFragLookUpTolerance) && (this.log(`adjusting start position by ${o} to match buffer start`), s += o, this.startPosition = s), this.log(`seek to target start position ${s} from current time ${t}`), e.currentTime = s;
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((s) => {
      const {
        hls: i
      } = this;
      if (!s || this.fragContextChanged(e))
        return;
      t.fragmentError = 0, this.state = k.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const r = e.stats;
      r.parsing.start = r.parsing.end = r.buffering.start = r.buffering.end = self.performance.now(), i.trigger(T.FRAG_LOADED, s), e.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    var t;
    const s = "main", {
      hls: i
    } = this, {
      remuxResult: r,
      chunkMeta: o
    } = e, a = this.getCurrentContext(o);
    if (!a) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: l,
      part: c,
      level: u
    } = a, {
      video: d,
      text: h,
      id3: m,
      initSegment: f
    } = r, {
      details: g
    } = u, p = this.altAudio ? void 0 : r.audio;
    if (this.fragContextChanged(l)) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = k.PARSING, f) {
      if (f != null && f.tracks) {
        const x = l.initSegment || l;
        this._bufferInitSegment(u, f.tracks, x, o), i.trigger(T.FRAG_PARSING_INIT_SEGMENT, {
          frag: x,
          id: s,
          tracks: f.tracks
        });
      }
      const E = f.initPTS, y = f.timescale;
      H(E) && (this.initPTS[l.cc] = {
        baseTime: E,
        timescale: y
      }, i.trigger(T.INIT_PTS_FOUND, {
        frag: l,
        id: s,
        initPTS: E,
        timescale: y
      }));
    }
    if (d && g && l.sn !== "initSegment") {
      const E = g.fragments[l.sn - 1 - g.startSN], y = l.sn === g.startSN, x = !E || l.cc > E.cc;
      if (r.independent !== !1) {
        const {
          startPTS: S,
          endPTS: v,
          startDTS: D,
          endDTS: L
        } = d;
        if (c)
          c.elementaryStreams[d.type] = {
            startPTS: S,
            endPTS: v,
            startDTS: D,
            endDTS: L
          };
        else if (d.firstKeyFrame && d.independent && o.id === 1 && !x && (this.couldBacktrack = !0), d.dropped && d.independent) {
          const _ = this.getMainFwdBufferInfo(), A = (_ ? _.end : this.getLoadPosition()) + this.config.maxBufferHole, R = d.firstKeyFramePTS ? d.firstKeyFramePTS : S;
          if (!y && A < R - this.config.maxBufferHole && !x) {
            this.backtrack(l);
            return;
          } else x && (l.gap = !0);
          l.setElementaryStreamInfo(d.type, l.start, v, l.start, L, !0);
        } else y && S > Os && (l.gap = !0);
        l.setElementaryStreamInfo(d.type, S, v, D, L), this.backtrackFragment && (this.backtrackFragment = l), this.bufferFragmentData(d, l, c, o, y || x);
      } else if (y || x)
        l.gap = !0;
      else {
        this.backtrack(l);
        return;
      }
    }
    if (p) {
      const {
        startPTS: E,
        endPTS: y,
        startDTS: x,
        endDTS: S
      } = p;
      c && (c.elementaryStreams[le.AUDIO] = {
        startPTS: E,
        endPTS: y,
        startDTS: x,
        endDTS: S
      }), l.setElementaryStreamInfo(le.AUDIO, E, y, x, S), this.bufferFragmentData(p, l, c, o);
    }
    if (g && m != null && (t = m.samples) != null && t.length) {
      const E = {
        id: s,
        frag: l,
        details: g,
        samples: m.samples
      };
      i.trigger(T.FRAG_PARSING_METADATA, E);
    }
    if (g && h) {
      const E = {
        id: s,
        frag: l,
        details: g,
        samples: h.samples
      };
      i.trigger(T.FRAG_PARSING_USERDATA, E);
    }
  }
  _bufferInitSegment(e, t, s, i) {
    if (this.state !== k.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && delete t.audio;
    const {
      audio: r,
      video: o,
      audiovideo: a
    } = t;
    if (r) {
      let l = e.audioCodec;
      const c = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        l && (l.indexOf("mp4a.40.5") !== -1 ? l = "mp4a.40.2" : l = "mp4a.40.5");
        const u = r.metadata;
        u && "channelCount" in u && (u.channelCount || 1) !== 1 && c.indexOf("firefox") === -1 && (l = "mp4a.40.5");
      }
      l && l.indexOf("mp4a.40.5") !== -1 && c.indexOf("android") !== -1 && r.container !== "audio/mpeg" && (l = "mp4a.40.2", this.log(`Android: force audio codec to ${l}`)), e.audioCodec && e.audioCodec !== l && this.log(`Swapping manifest audio codec "${e.audioCodec}" for "${l}"`), r.levelCodec = l, r.id = "main", this.log(`Init audio buffer, container:${r.container}, codecs[selected/level/parsed]=[${l || ""}/${e.audioCodec || ""}/${r.codec}]`);
    }
    o && (o.levelCodec = e.videoCodec, o.id = "main", this.log(`Init video buffer, container:${o.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${o.codec}]`)), a && this.log(`Init audiovideo buffer, container:${a.container}, codecs[level/parsed]=[${e.codecs}/${a.codec}]`), this.hls.trigger(T.BUFFER_CODECS, t), Object.keys(t).forEach((l) => {
      const u = t[l].initSegment;
      u != null && u.byteLength && this.hls.trigger(T.BUFFER_APPENDING, {
        type: l,
        data: u,
        frag: s,
        part: null,
        chunkMeta: i,
        parent: s.type
      });
    }), this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, j.MAIN);
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = k.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const s = e.currentTime;
      if (he.isBuffered(e, s) ? t = this.getAppendedFrag(s) : he.isBuffered(e, s + 0.1) && (t = this.getAppendedFrag(s + 0.1)), t) {
        this.backtrackFragment = null;
        const i = this.fragPlaying, r = t.level;
        (!i || t.sn !== i.sn || i.level !== r) && (this.fragPlaying = t, this.hls.trigger(T.FRAG_CHANGED, {
          frag: t
        }), (!i || i.level !== r) && this.hls.trigger(T.LEVEL_SWITCHED, {
          level: r
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    const e = this.media;
    return e ? this.fragPlaying || this.getAppendedFrag(e.currentTime) : null;
  }
  get currentProgramDateTime() {
    const e = this.media;
    if (e) {
      const t = e.currentTime, s = this.currentFrag;
      if (s && H(t) && H(s.programDateTime)) {
        const i = s.programDateTime + (t - s.start) * 1e3;
        return new Date(i);
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class Te {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.5.13";
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return Oa();
  }
  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return ip();
  }
  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return At();
  }
  static get Events() {
    return T;
  }
  static get ErrorTypes() {
    return Q;
  }
  static get ErrorDetails() {
    return C;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return Te.defaultConfig ? Te.defaultConfig : Fa;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    Te.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this.started = !1, this._emitter = new Ei(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null, this.triggeringException = void 0, Zh(e.debug || !1, "Hls instance");
    const t = this.config = ep(Te.DefaultConfig, e);
    this.userConfig = e, t.progressive && tp(t);
    const {
      abrController: s,
      bufferController: i,
      capLevelController: r,
      errorController: o,
      fpsController: a
    } = t, l = new o(this), c = this.abrController = new s(this), u = this.bufferController = new i(this), d = this.capLevelController = new r(this), h = new a(this), m = new qf(this), f = new Zf(this), g = t.contentSteeringController, p = g ? new g(this) : null, E = this.levelController = new sp(this, p), y = new Im(this), x = new np(this.config), S = this.streamController = new dp(this, y, x);
    d.setStreamController(S), h.setStreamController(S);
    const v = [m, E, S];
    p && v.splice(1, 0, p), this.networkControllers = v;
    const D = [c, u, d, h, f, y];
    this.audioTrackController = this.createController(t.audioTrackController, v);
    const L = t.audioStreamController;
    L && v.push(new L(this, y, x)), this.subtitleTrackController = this.createController(t.subtitleTrackController, v);
    const _ = t.subtitleStreamController;
    _ && v.push(new _(this, y, x)), this.createController(t.timelineController, D), x.emeController = this.emeController = this.createController(t.emeController, D), this.cmcdController = this.createController(t.cmcdController, D), this.latencyController = this.createController(Jf, D), this.coreComponents = D, v.push(l);
    const A = l.onErrorOut;
    typeof A == "function" && this.on(T.ERROR, A, l);
  }
  createController(e, t) {
    if (e) {
      const s = new e(this);
      return t && t.push(s), s;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, s = this) {
    this._emitter.on(e, t, s);
  }
  once(e, t, s = this) {
    this._emitter.once(e, t, s);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, s = this, i) {
    this._emitter.off(e, t, s, i);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, s) {
    return this._emitter.emit(e, t, s);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (s) {
      if (I.error("An internal error happened while handling event " + e + '. Error message: "' + s.message + '". Here is a stacktrace:', s), !this.triggeringException) {
        this.triggeringException = !0;
        const i = e === T.ERROR;
        this.trigger(T.ERROR, {
          type: Q.OTHER_ERROR,
          details: C.INTERNAL_EXCEPTION,
          fatal: i,
          event: e,
          error: s
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    I.log("destroy"), this.trigger(T.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    I.log("attachMedia"), this._media = e, this.trigger(T.MEDIA_ATTACHING, {
      media: e
    });
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    I.log("detachMedia"), this.trigger(T.MEDIA_DETACHING, void 0), this._media = null;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, s = this.url, i = this.url = ri.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, I.log(`loadSource:${i}`), t && s && (s !== i || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(T.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1) {
    I.log(`startLoad(${e})`), this.started = !0, this.networkControllers.forEach((t) => {
      t.startLoad(e);
    });
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    I.log("stopLoad"), this.started = !1, this.networkControllers.forEach((e) => {
      e.stopLoad();
    });
  }
  /**
   * Resumes stream controller segment loading if previously started.
   */
  resumeBuffering() {
    this.started && this.networkControllers.forEach((e) => {
      "fragmentLoader" in e && e.startLoad(-1);
    });
  }
  /**
   * Stops stream controller segment loading without changing 'started' state like stopLoad().
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.networkControllers.forEach((e) => {
      "fragmentLoader" in e && e.stopLoad();
    });
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    I.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    I.log("recoverMediaError");
    const e = this._media;
    this.detachMedia(), e && this.attachMedia(e);
  }
  removeLevel(e) {
    this.levelController.removeLevel(e);
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    I.log(`set currentLevel:${e}`), this.levelController.manualLevel = e, this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    I.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    I.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    I.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const e = this.levelController.startLevel;
    return e === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : e;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    I.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  set bandwidthEstimate(e) {
    this.abrController.resetEstimator(e);
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (I.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    em(e) && this._maxHdcpLevel !== e && (this._maxHdcpLevel = e, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e) return 0;
    const s = e.length;
    for (let i = 0; i < s; i++)
      if (e[i].maxBitrate >= t)
        return i;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: s
    } = this;
    let i;
    if (t === -1 && e != null && e.length ? i = e.length - 1 : i = t, s)
      for (let r = i; r--; ) {
        const o = e[r].attrs["HDCP-LEVEL"];
        if (o && o <= s)
          return r;
      }
    return i;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = e;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(e) {
    var t;
    return (t = this.audioTrackController) == null ? void 0 : t.setAudioOption(e);
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(e) {
    var t;
    return (t = this.subtitleTrackController) == null || t.setSubtitleOption(e), null;
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const e = this.audioTrackController;
    return e ? e.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
Te.defaultConfig = void 0;
const Na = "application/vnd.apple.mpegurl", hp = ["hvc1.1.6.L93.B0", "hev1.1.6.L93.B0", "hvc1.2.4.L93.B0", "hev1.2.4.L93.B0"];
function Zs(n) {
  return /hevc|h\.?265|hev1|hvc1/i.test(n != null ? n : "");
}
function Ua(n) {
  var a;
  if (typeof document == "undefined")
    return null;
  const e = Zs(n), t = (a = n == null ? void 0 : n.trim()) != null ? a : "", s = /^(hvc1|hev1)\./i.test(t) ? [t] : hp, i = Te.getMediaSource();
  if (e ? Te.isMSESupported() && s.some((l) => i == null ? void 0 : i.isTypeSupported(`video/mp4; codecs="${l}"`)) : Te.isSupported())
    return "hls.js";
  const o = document.createElement("video");
  return o.canPlayType(Na) && (!e || s.some((l) => o.canPlayType(`video/mp4; codecs="${l}"`))) ? "native" : null;
}
function Ba({
  liveTimeMs: n,
  playbackStartTimeMs: e,
  video: t
}) {
  return !t || !Number.isFinite(t.currentTime) ? null : e == null ? n != null ? n : Date.now() : e + Math.round(t.currentTime * 1e3);
}
function fp({
  playlistDurationSec: n,
  value: e
}) {
  return e == null || !Number.isFinite(e) ? null : $a({
    playlistDurationSec: n,
    value: e
  });
}
function $a({
  playlistDurationSec: n,
  value: e
}) {
  return Number.isFinite(e) ? Math.min(Math.max(e, 0), Math.max(n - 1, 0)) : 0;
}
function mp(n, e, t) {
  return Number.isFinite(n) ? Math.min(Math.max(n, e), t) : e;
}
const gp = {
  backBufferLength: 2,
  liveBackBufferLength: 2,
  maxBufferLength: 8,
  maxBufferSize: 20 * 1e3 * 1e3,
  maxMaxBufferLength: 12,
  startFragPrefetch: !1,
  testBandwidth: !1
}, pp = /* @__PURE__ */ new Set([
  Te.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
  Te.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
  Te.ErrorDetails.BUFFER_ADD_CODEC_ERROR
]);
function Tp({
  codecNotSupportedMessageRef: n,
  desiredPlayingRef: e,
  hlsNotSupportedMessageRef: t,
  hlsPlaybackErrorMessageRef: s,
  hlsUrl: i,
  pendingSeekSecRef: r,
  pendingSeekShouldPlayRef: o,
  playbackKey: a,
  playbackMode: l,
  playlistDurationSec: c,
  setError: u,
  setPaused: d,
  sourceBlocked: h,
  sourceReady: m,
  videoCodec: f,
  videoRef: g
}) {
  se(() => {
    const p = g.current;
    if (!p)
      return;
    if (u(null), p.controls = !1, p.muted = !0, p.playsInline = !0, !m || h) {
      Fn(p), d(!0);
      return;
    }
    let E = null, y = null, x = !0, S = !1, v = !1;
    const D = fp({
      playlistDurationSec: c,
      value: r.current
    }), L = l === "archive" && D != null, _ = async () => {
      if (!(!x || v || !e.current && !o.current))
        try {
          await p.play(), x && (o.current = !1, d(p.paused));
        } catch {
          x && d(p.paused);
        }
    }, A = () => {
      const N = r.current;
      if (N == null || !Number.isFinite(N)) {
        _();
        return;
      }
      try {
        const $ = $a({
          playlistDurationSec: c,
          value: N
        });
        p.currentTime = $, r.current = null, _();
      } catch {
      }
    }, R = (N) => {
      v = !0, E == null || E.stopLoad(), p.pause(), d(!0), u(N);
    }, w = () => {
      y == null || y(), y = null, E == null || E.destroy(), E = null, Fn(p), S = !0, p.src = i;
    }, B = () => {
      if (!S || !p.error)
        return;
      const N = p.error.code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED;
      R({
        kind: N ? "unsupported-codec" : p.error.code === MediaError.MEDIA_ERR_NETWORK ? "network" : "media",
        message: N ? n.current : s.current,
        reason: p.error.message,
        recoverable: !1
      });
    };
    p.addEventListener("loadedmetadata", A), p.addEventListener("canplay", A), p.addEventListener("error", B);
    const M = Ua(f);
    if (M === "hls.js") {
      E = new Te({
        ...gp,
        autoStartLoad: !L,
        lowLatencyMode: !1,
        startPosition: D != null ? D : -1
      });
      const N = (G, W) => {
        if (Ha(W)) {
          R(Pn(W, n.current));
          return;
        }
        if (W.fatal) {
          if (Ga(W)) {
            if (p.canPlayType(Na)) {
              w();
              return;
            }
            R(Pn(W, n.current));
            return;
          }
          if (W.type === Te.ErrorTypes.NETWORK_ERROR) {
            E == null || E.startLoad(D != null ? D : -1);
            return;
          }
          if (W.type === Te.ErrorTypes.MEDIA_ERROR) {
            E == null || E.recoverMediaError();
            return;
          }
          R(Pn(W, s.current));
        }
      }, $ = () => {
        A(), L && (E == null || E.startLoad(D));
      };
      E.on(Te.Events.ERROR, N), E.on(Te.Events.MANIFEST_PARSED, $), E.loadSource(i), E.attachMedia(p), y = () => {
        E == null || E.off(Te.Events.ERROR, N), E == null || E.off(Te.Events.MANIFEST_PARSED, $);
      };
    } else M === "native" ? w() : R({
      kind: Zs(f) ? "unsupported-codec" : "unsupported-browser",
      message: Zs(f) ? n.current : t.current,
      recoverable: !1
    });
    return r.current == null && _(), () => {
      x = !1, p.removeEventListener("loadedmetadata", A), p.removeEventListener("canplay", A), p.removeEventListener("error", B), y == null || y(), E == null || E.destroy(), Fn(p);
    };
  }, [
    n,
    e,
    t,
    s,
    i,
    r,
    o,
    a,
    l,
    c,
    u,
    d,
    h,
    m,
    f,
    g
  ]);
}
function Fn(n) {
  n.pause(), n.removeAttribute("src"), n.load();
}
function Ga(n) {
  return pp.has(n.details);
}
function Pn(n, e) {
  var s, i;
  const t = (i = (s = n.error) == null ? void 0 : s.message) != null ? i : n.reason;
  return {
    details: n.details,
    fatal: n.fatal,
    hlsType: n.type,
    kind: Ep(n),
    message: e,
    ...t ? { reason: t } : {},
    recoverable: !1
  };
}
function Ep(n) {
  return Ha(n) || Ga(n) ? "unsupported-codec" : n.type === Te.ErrorTypes.NETWORK_ERROR ? "network" : n.type === Te.ErrorTypes.MEDIA_ERROR ? "media" : "hls";
}
function Ha(n) {
  var e, t, s;
  return n.details !== Te.ErrorDetails.FRAG_PARSING_ERROR ? !1 : /Unsupported .+ in M2TS found/i.test((s = (t = (e = n.error) == null ? void 0 : e.message) != null ? t : n.reason) != null ? s : "");
}
const yp = 300, oo = 250, xp = 1e4;
function vp({
  controlledRevision: n,
  controlledTimeMs: e,
  effectiveMissingArchiveTimeMs: t,
  getLivePlaybackTimeMs: s,
  isPlaybackControlled: i,
  onPlaybackBoundsEnd: r,
  onPlaybackTimeChange: o,
  paused: a,
  playbackBounds: l,
  playbackMode: c,
  playbackStartTimeMs: u,
  playbackStartTimeMsRef: d,
  setCurrentTimeMs: h,
  setLiveEdgeMs: m,
  streamUnavailable: f,
  videoRef: g
}) {
  const p = ae(n), E = ae(null);
  se(() => {
    d.current = u;
  }, [u, d]), se(() => {
    const x = p.current;
    i && n != null && x != null && n !== x && (E.current = null), (!i || e == null) && (E.current = null), p.current = n;
  }, [n, e, i]);
  const y = q(() => {
    if (f || t != null)
      return;
    const x = g.current, S = Ba({
      liveTimeMs: s(),
      playbackStartTimeMs: d.current,
      video: x
    });
    if (S == null)
      return;
    if (i && e != null) {
      let D = E.current;
      if ((D == null ? void 0 : D.revision) !== n) {
        const R = S - e;
        if (R < -oo || R > xp)
          return;
        D = {
          rawTimeMs: S,
          revision: n,
          targetTimeMs: e
        }, E.current = D;
      }
      const L = D.targetTimeMs + Math.max(0, S - D.rawTimeMs), _ = L - e;
      if (_ < 0)
        return;
      if (_ < oo) {
        h(e);
        return;
      }
      const A = ao({
        playbackBounds: l,
        playbackMode: c,
        timeMs: L
      });
      if (A != null) {
        h(A), o == null || o(A, c), r == null || r(A);
        return;
      }
      h(L), o == null || o(L, c);
      return;
    }
    const v = ao({
      playbackBounds: l,
      playbackMode: c,
      timeMs: S
    });
    if (v != null) {
      h(v), o == null || o(v, c), r == null || r(v);
      return;
    }
    h(S), o == null || o(S, c), d.current == null && m(
      (D) => D == null ? S : Math.max(D, S)
    );
  }, [
    e,
    n,
    t,
    s,
    i,
    r,
    o,
    l,
    c,
    d,
    h,
    m,
    f,
    g
  ]);
  return se(() => {
    if (a || f || t != null)
      return;
    const x = setInterval(y, yp);
    return () => {
      clearInterval(x);
    };
  }, [t, a, f, y]), {
    updateCurrentTime: y
  };
}
function ao({
  playbackBounds: n,
  playbackMode: e,
  timeMs: t
}) {
  return e === "archive" && (n == null ? void 0 : n.locked) === !0 && t >= n.endMs ? n.endMs : null;
}
function Sp({
  desiredPlayingRef: n,
  initialPlaybackState: e,
  pendingSeekSecRef: t,
  pendingSeekShouldPlayRef: s,
  playbackState: i,
  setCurrentTimeMs: r
}) {
  var d;
  const o = ae(null), a = ae(i != null), l = (d = i == null ? void 0 : i.timeMs) != null ? d : null, [c, u] = ne(
    () => lo({
      initialPlaybackState: e,
      playbackState: i
    })
  );
  return fo(() => {
    var m, f;
    if (!i) {
      const g = a.current;
      if (a.current = !1, o.current = null, g) {
        const p = lo({
          initialPlaybackState: e,
          playbackState: void 0
        });
        t.current = p.mode === "archive" ? 0 : null, s.current = n.current, r(
          p.mode === "archive" ? p.playbackStartTimeMs : (m = e == null ? void 0 : e.timeMs) != null ? m : Date.now()
        ), u((E) => Ap(p, E.key + 1));
      }
      return;
    }
    if (a.current = !0, o.current === i.revision)
      return;
    o.current = i.revision;
    const h = Ka(i);
    t.current = h.mode === "archive" ? 0 : null, s.current = n.current, r(
      h.mode === "archive" ? h.playbackStartTimeMs : (f = i.timeMs) != null ? f : Date.now()
    ), u(h);
  }, [
    n,
    e,
    t,
    s,
    i,
    r
  ]), se(() => {
    l != null && r(l);
  }, [l, r]), {
    isPlaybackControlled: i != null,
    localPlaybackState: c,
    playbackKey: c.key,
    playbackMode: c.mode,
    playbackStartTimeMs: c.playbackStartTimeMs,
    setLocalPlaybackState: u
  };
}
function Ap(n, e) {
  return {
    ...n,
    key: e
  };
}
function Ka(n) {
  var e;
  return (n == null ? void 0 : n.mode) === "archive" && n.timeMs != null ? {
    mode: "archive",
    playbackStartTimeMs: n.timeMs,
    key: n.revision
  } : {
    mode: "live",
    playbackStartTimeMs: null,
    key: (e = n == null ? void 0 : n.revision) != null ? e : 0
  };
}
function lo({
  initialPlaybackState: n,
  playbackState: e
}) {
  return e ? Ka(e) : (n == null ? void 0 : n.mode) === "archive" && n.timeMs != null ? {
    mode: "archive",
    playbackStartTimeMs: n.timeMs,
    key: 0
  } : {
    mode: "live",
    playbackStartTimeMs: null,
    key: 0
  };
}
function Lp({
  controlsMode: n,
  error: e,
  missingArchiveTimeMs: t,
  onControlsModeChange: s,
  paused: i,
  playerRootRef: r,
  streamUnavailable: o
}) {
  const [a, l] = ne(!1), [c, u] = ne(!1), [d, h] = ne(n != null ? n : "auto"), m = n != null ? n : d, f = q(
    (_) => {
      h((A) => {
        const R = n != null ? n : A, w = typeof _ == "function" ? _(R) : _;
        return s == null || s(w), w;
      });
    },
    [s, n]
  ), g = Ee(
    () => !o && (m === "pinned" || m === "auto" && (a || c || i || e != null || t != null)),
    [c, a, m, e, t, i, o]
  ), p = q(() => {
    var A;
    u(!1);
    const _ = document.activeElement;
    _ instanceof HTMLElement && ((A = r.current) != null && A.contains(_)) && _.blur();
  }, [r]), E = q(() => {
    p(), f("hidden");
  }, [p, f]), y = q(() => {
    p(), f("auto");
  }, [p, f]), x = q(() => {
    f((_) => _ === "pinned" ? (p(), "auto") : "pinned");
  }, [p, f]), S = q((_) => {
    _.currentTarget.contains(_.relatedTarget) || u(!1);
  }, []), v = q(() => {
    u(!0);
  }, []), D = q((_) => {
    l(!0);
  }, []), L = q((_) => {
    l(!1);
  }, []);
  return {
    clearControlsFocus: p,
    controlsMode: m,
    controlsVisible: g,
    handleBlurCapture: S,
    handleFocusCapture: v,
    handlePointerEnter: D,
    handlePointerLeave: L,
    hideControls: E,
    showControls: y,
    togglePinControls: x
  };
}
function Rp({
  archiveRanges: n,
  archiveRangesLoading: e,
  canSeekArchive: t,
  desiredPlayingRef: s,
  dvrWindow: i,
  isPlaybackControlled: r,
  liveAvailable: o,
  onLiveModeRequest: a,
  onPlaybackTimeChange: l,
  onTimelineSeek: c,
  pendingSeekSecRef: u,
  pendingSeekShouldPlayRef: d,
  playbackMode: h,
  playbackStartTimeMsRef: m,
  playlistDurationSec: f,
  getLivePlaybackTimeMs: g,
  setCurrentTimeMs: p,
  setLocalPlaybackState: E,
  setMissingArchiveTimeMs: y,
  setPaused: x,
  timelineWindow: S,
  videoRef: v
}) {
  se(() => {
    if (r || o || h !== "live")
      return;
    const _ = sh({
      archiveRanges: n,
      dvrWindow: i
    });
    _ != null && (y(null), u.current = 0, d.current = s.current, p(_), E((A) => ({
      mode: "archive",
      playbackStartTimeMs: _,
      key: A.key + 1
    })));
  }, [
    n,
    s,
    i,
    r,
    o,
    h,
    u,
    d,
    p,
    E,
    y
  ]);
  const D = q(
    (_) => {
      if (!t || !S)
        return;
      const A = mp(_, S.startMs, S.endMs), R = e || rs(n, A), w = v.current;
      if (r || c) {
        p(A), R ? (w == null || w.pause(), s.current = !0, d.current = !0, x(!1), y(null)) : (w == null || w.pause(), y(A), u.current = null, d.current = !1), c == null || c(A);
        return;
      }
      if (!R) {
        w == null || w.pause(), p(A), y(A), u.current = null, d.current = !1, E((N) => ({
          mode: "archive",
          playbackStartTimeMs: A,
          key: N.key
        })), l == null || l(A, "archive");
        return;
      }
      y(null);
      const B = m.current, M = B == null ? null : (A - B) / 1e3;
      if (p(A), l == null || l(A, "archive"), w && M != null && M >= 0 && M <= f) {
        try {
          w.currentTime = M, s.current && w.play().catch(() => {
            x(!0);
          });
        } catch {
          u.current = M;
        }
        return;
      }
      u.current = 0, d.current = s.current, E((N) => ({
        mode: "archive",
        playbackStartTimeMs: A,
        key: N.key + 1
      }));
    },
    [
      n,
      e,
      t,
      s,
      r,
      c,
      l,
      u,
      d,
      m,
      f,
      p,
      E,
      y,
      x,
      S,
      v
    ]
  );
  return {
    handleLiveMode: q(() => {
      if (!o)
        return;
      if (r || a) {
        a == null || a();
        return;
      }
      y(null), u.current = null, d.current = !1;
      const _ = g();
      p(_), l == null || l(_, "live"), E((A) => ({
        mode: "live",
        playbackStartTimeMs: null,
        key: A.key + 1
      }));
    }, [
      r,
      o,
      g,
      a,
      l,
      u,
      d,
      p,
      E,
      y
    ]),
    handleTimelineSeek: D
  };
}
function Dp({
  desiredPlayingRef: n,
  pendingSeekSecRef: e,
  pendingSeekShouldPlayRef: t,
  playbackMode: s,
  playbackStartTimeMsRef: i,
  selectedVideoTrackId: r,
  onSelectedVideoTrackIdChange: o,
  sourceUrl: a,
  videoRef: l,
  videoTracks: c,
  videoTracksLoading: u
}) {
  var R, w, B;
  const [d, h] = ne(() => ({
    sourceUrl: a,
    trackId: r != null ? r : null
  })), m = d.sourceUrl === a ? d.trackId : null, f = r === void 0 ? m : r, g = c.length === 0 ? null : Ip({
    playbackMode: s,
    videoTracks: c
  }), p = f == null ? null : (R = c.find((M) => M.id === f)) != null ? R : null, E = p != null && (ii({
    playbackMode: s,
    track: p
  }) || p.id === (g == null ? void 0 : g.id)), y = c.length === 0 || E ? f : (w = g == null ? void 0 : g.id) != null ? w : null, x = q(
    (M) => {
      h({
        sourceUrl: a,
        trackId: M
      }), o == null || o(M);
    },
    [o, a]
  );
  se(() => {
    f === y || y == null || o == null || o(y);
  }, [o, f, y]);
  const S = q(() => {
    const M = i.current, N = Ba({
      playbackStartTimeMs: M,
      video: l.current
    });
    M == null || N == null || (e.current = Math.max((N - M) / 1e3, 0), t.current = n.current);
  }, [n, e, t, i, l]), v = q(
    (M) => {
      M !== y && (S(), x(M));
    },
    [S, y, x]
  ), D = y == null ? null : (B = c.find((M) => M.id === y)) != null ? B : null, L = s === "live" && c.length > 0 && !c.some((M) => ii({ playbackMode: s, track: M })) ? D != null ? D : c[0] : null, A = u && y != null || !u && (c.length === 0 || D != null);
  return {
    handleVideoTrackChange: v,
    selectedVideoTrack: D,
    selectedVideoTrackId: y,
    trackSelectionReady: A,
    unsupportedLiveTrack: L
  };
}
function Ip({
  playbackMode: n,
  videoTracks: e
}) {
  var t;
  return (t = e.find((s) => ii({ playbackMode: n, track: s }))) != null ? t : e[0];
}
function ii({
  playbackMode: n,
  track: e
}) {
  return n !== "live" ? !0 : !Zs(e.codec) || Ua(e.codec) != null;
}
function bp({
  archiveRanges: n,
  archiveRangesLoading: e,
  currentTimeMs: t,
  playbackMode: s,
  playbackStartTimeMs: i,
  resetKey: r
}) {
  const [o, a] = ne(null), [l, c] = ne(
    null
  ), u = Ee(
    () => _p({
      archiveRanges: n,
      archiveRangesLoading: e,
      currentTimeMs: t,
      playbackMode: s,
      playbackStartTimeMs: i
    }),
    [n, e, t, s, i]
  ), d = u === void 0 ? o : u, h = l != null && d == null && s === "archive" && t != null && !e && rs(n, t) ? t : null;
  return se(() => {
    l !== d && c(d);
  }, [d, l]), se(() => {
    u !== null || o == null || a(null);
  }, [u, o]), se(() => {
    a(null);
  }, [r]), {
    archiveResumeTimeMs: h,
    effectiveMissingArchiveTimeMs: d,
    missingArchiveTimeMs: o,
    setMissingArchiveTimeMs: a
  };
}
function _p({
  archiveRanges: n,
  archiveRangesLoading: e,
  currentTimeMs: t,
  playbackMode: s,
  playbackStartTimeMs: i
}) {
  if (s !== "archive")
    return null;
  const r = t != null ? t : i;
  if (r == null)
    return null;
  if (!e)
    return rs(n, r) ? null : r;
}
const Qt = 3600;
function Cp({
  archiveResumeTimeMs: n,
  displayedPlaybackMode: e,
  effectiveMissingArchiveTimeMs: t,
  error: s,
  streamLiveAvailable: i,
  streamUnavailable: r,
  unsupportedLiveTrackError: o
}) {
  const a = e === "live" && i === !1 && !r, l = r || o != null || n != null || t != null || a, c = o != null ? o : s;
  return {
    liveUnavailableInLiveMode: a,
    playbackUnavailable: l,
    visibleError: c
  };
}
function wp(n) {
  return n == null || !Number.isFinite(n.startMs) || !Number.isFinite(n.endMs) || n.startMs >= n.endMs ? null : n;
}
function Mp({
  activePlaybackBounds: n,
  activePlaybackRate: e,
  archiveRanges: t,
  archiveRangesError: s,
  archiveRangesLoading: i,
  canSeekArchive: r,
  controlsMode: o,
  currentTimeMs: a,
  displayedPlaybackMode: l,
  fullscreen: c,
  handleArchiveCalendarDaySelect: u,
  handlePlaybackRateChange: d,
  handleTimelineZoomIn: h,
  handleTimelineZoomOut: m,
  handleVideoTrackChange: f,
  hideControls: g,
  paused: p,
  selectedVideoTrackId: E,
  timelineZoomDisabled: y,
  toggleFullscreen: x,
  togglePinControls: S,
  togglePlay: v,
  videoTracks: D
}) {
  return {
    archiveCalendarDisabled: (n == null ? void 0 : n.locked) === !0 || !r,
    archiveRanges: t,
    archiveRangesError: s,
    archiveRangesLoading: i,
    controlsMode: o,
    currentTimeMs: a,
    fullscreen: c,
    onArchiveCalendarDaySelect: u,
    onFullscreenToggle: x,
    onHideControls: g,
    onPlaybackRateChange: d,
    onPinToggle: S,
    onPlayToggle: v,
    onTimelineZoomIn: h,
    onTimelineZoomOut: m,
    onVideoTrackChange: f,
    paused: p,
    playbackRate: e,
    playbackRateDisabled: l !== "archive",
    selectedVideoTrackId: E,
    timelineZoomDisabled: y,
    videoTracks: D
  };
}
function kp(n) {
  return $n.includes(n) ? n : 1;
}
function Fp(n, e) {
  n && (n.defaultPlaybackRate !== e && (n.defaultPlaybackRate = e), n.playbackRate !== e && (n.playbackRate = e));
}
function co(n) {
  return n != null && n.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA;
}
function Pp({
  hlsUrl: n,
  playbackKey: e,
  playbackUnavailable: t,
  videoRef: s,
  visibleError: i
}) {
  const [r, o] = ne(!0), [a, l] = ne(!1);
  se(() => {
    const h = s.current, m = co(h);
    l(m), o(!m);
  }, [n, e, s]), se(() => {
    if (t || i != null) {
      o(!1);
      return;
    }
    a || o(!0);
  }, [a, t, i]);
  const c = q(() => {
    !a && !co(s.current) && o(!0);
  }, [a, s]), u = q(() => {
    l(!0), o(!1);
  }, []);
  return {
    markMediaError: q(() => {
      l(!1), o(!1);
    }, []),
    markMediaLoading: c,
    markMediaReady: u,
    showMediaLoader: r && !a && !t && i == null
  };
}
function Op() {
  const [n, e] = ne(null);
  return {
    liveEdgeMs: n,
    setLiveEdgeMs: e
  };
}
function Np({
  dvrWindow: n,
  liveAvailable: e,
  onLiveStatusChange: t,
  setLiveEdgeMs: s,
  streamLiveAvailable: i,
  streamLiveEdgeMs: r
}) {
  se(() => {
    if (!n) {
      s(null);
      return;
    }
    s(
      (o) => o == null ? n.endMs : Math.max(o, n.endMs)
    );
  }, [n, s]), se(() => {
    t == null || t({
      liveAvailable: i,
      liveEdgeMs: r
    });
  }, [t, i, r]), se(() => {
    !e || r == null || s(
      (o) => o == null ? r : Math.max(o, r)
    );
  }, [e, s, r]);
}
function Up({
  playbackMode: n,
  timelineViewport: e,
  timelineWindowLoaded: t
}) {
  return e == null || e.mode === "fixed" && !t || e.mode === "live-follow" && n !== "live" ? null : e;
}
function Bp({
  activePlaybackBounds: n,
  displayedPlaybackMode: e,
  onPlayerSettingsChange: t,
  playerSettings: s,
  timelineWindowLoaded: i
}) {
  var E;
  const [r, o] = ne(null), [a, l] = ne(1), c = kp((E = s == null ? void 0 : s.playbackRate) != null ? E : a), u = e === "archive" ? c : 1, d = Ee(() => {
    var x;
    const y = (n == null ? void 0 : n.locked) === !0 ? {
      mode: "fixed",
      startMs: n.startMs,
      endMs: n.endMs
    } : (x = s == null ? void 0 : s.timelineViewport) != null ? x : r;
    return Up({
      playbackMode: e,
      timelineViewport: y,
      timelineWindowLoaded: i
    });
  }, [
    n,
    e,
    r,
    s == null ? void 0 : s.timelineViewport,
    i
  ]), h = q(
    (y) => {
      t == null || t({ selectedVideoTrackId: y }, { immediate: !0 });
    },
    [t]
  ), m = q(
    (y) => {
      t == null || t({ controlsMode: y }, { immediate: !0 });
    },
    [t]
  ), f = q(
    (y) => {
      t == null && l(y), t == null || t({ playbackRate: y }, { immediate: !0 });
    },
    [t]
  ), g = q(
    (y) => {
      n != null && n.locked || (t == null && o(y), t == null || t({ timelineViewport: y }, { immediate: !0 }));
    },
    [n == null ? void 0 : n.locked, t]
  ), p = q(() => {
    o(null);
  }, []);
  return {
    activePlaybackRate: u,
    clearLocalTimelineViewport: p,
    effectiveTimelineViewport: d,
    handleControlsModeChange: m,
    handlePlaybackRateChange: f,
    handleSelectedVideoTrackIdChange: h,
    handleTimelineViewportChange: g
  };
}
function $p(n, e) {
  const [t, s] = ne(n);
  return se(() => {
    const i = window.setTimeout(() => {
      s(n);
    }, e);
    return () => {
      window.clearTimeout(i);
    };
  }, [e, n]), t;
}
const bs = /* @__PURE__ */ new Map(), Va = "preview-image", Gp = 180, uo = 1e3;
function Hp({
  authToken: n,
  archiveRanges: e,
  enabled: t,
  previewTimeMs: s,
  sourceUrl: i
}) {
  const r = s == null ? null : Math.floor(s / uo) * uo, o = $p(r, Gp), a = r != null && o === r ? o : null, l = `${i}:${n != null ? n : ""}`, c = q(
    (d) => {
      const h = bs.get(l);
      h == null || h.delete(d.endpoint);
    },
    [l]
  ), u = q(
    (d) => {
      var m;
      const h = (m = bs.get(l)) != null ? m : /* @__PURE__ */ new Set();
      h.add(d.endpoint), bs.set(l, h);
    },
    [l]
  );
  return Ee(() => {
    var p;
    const d = {
      available: void 0,
      media: [],
      rememberFailedMedia: u,
      rememberLoadedMedia: c,
      timeMs: null
    };
    if (!t || a == null)
      return d;
    const h = rs(e, a);
    if (!h)
      return {
        available: h,
        media: [],
        rememberFailedMedia: u,
        rememberLoadedMedia: c,
        timeMs: a
      };
    const m = Rt(i), g = ((p = bs.get(l)) != null ? p : /* @__PURE__ */ new Set()).has(Va) ? [] : [
      Kp({
        authToken: n,
        config: m,
        timeMs: a
      })
    ];
    return {
      available: h,
      media: g,
      rememberFailedMedia: u,
      rememberLoadedMedia: c,
      timeMs: a
    };
  }, [
    e,
    n,
    t,
    l,
    u,
    c,
    i,
    a
  ]);
}
function Kp({
  authToken: n,
  config: e,
  timeMs: t
}) {
  return {
    endpoint: Va,
    type: "image",
    url: $d({
      authToken: n,
      config: e,
      timeMs: t
    })
  };
}
function Vp({
  activePlaybackBounds: n,
  archiveRanges: e,
  canSeekArchive: t,
  currentTimeMs: s,
  displayedPlaybackMode: i,
  displayedPlaybackStartTimeMs: r,
  effectiveTimelineViewport: o,
  handleLiveMode: a,
  handleTimelineSeek: l,
  handleTimelineViewportChange: c,
  sourceUrl: u,
  streamAuthToken: d,
  timelineDisplayWindow: h,
  timelineLiveAvailable: m
}) {
  var L, _;
  const [f, g] = ne(null), [p, E] = ne(null), y = Hp({
    archiveRanges: e,
    authToken: d,
    enabled: t,
    previewTimeMs: f,
    sourceUrl: u
  }), x = q(
    (A) => {
      n != null && n.locked || !t || (c({
        mode: "fixed",
        startMs: A.dayStartMs,
        endMs: A.dayEndMs
      }), l(A.firstArchiveTimeMs));
    },
    [n == null ? void 0 : n.locked, t, l, c]
  ), S = q(() => {
    E((A) => {
      var R;
      return {
        direction: "in",
        revision: ((R = A == null ? void 0 : A.revision) != null ? R : 0) + 1
      };
    });
  }, []), v = q(() => {
    E((A) => {
      var R;
      return {
        direction: "out",
        revision: ((R = A == null ? void 0 : A.revision) != null ? R : 0) + 1
      };
    });
  }, []), D = {
    archiveRanges: e,
    currentTimeMs: s,
    durationSec: Qt,
    liveAvailable: m,
    mode: i,
    onLive: a,
    onPreviewTimeChange: g,
    onSeek: l,
    onThumbnailMediaError: y.rememberFailedMedia,
    onThumbnailMediaLoad: y.rememberLoadedMedia,
    onTimelineViewportChange: c,
    playbackStartTimeMs: r,
    seekable: t,
    thumbnailAvailable: y.available,
    thumbnailMedia: y.media,
    thumbnailTimeMs: y.timeMs,
    timelineViewport: o,
    timelineZoomCommand: p,
    viewportLocked: (n == null ? void 0 : n.locked) === !0,
    windowEndMs: (L = h == null ? void 0 : h.endMs) != null ? L : null,
    windowStartMs: (_ = h == null ? void 0 : h.startMs) != null ? _ : null
  };
  return {
    handleArchiveCalendarDaySelect: x,
    handleTimelineZoomIn: S,
    handleTimelineZoomOut: v,
    timelineProps: D,
    timelineZoomDisabled: (n == null ? void 0 : n.locked) === !0 || !t
  };
}
function Wp({
  activePlaybackBounds: n,
  applyActivePlaybackRate: e,
  handleLiveMode: t,
  markMediaError: s,
  markMediaLoading: i,
  markMediaReady: r,
  playbackMode: o,
  setPaused: a,
  timelineLiveAvailable: l,
  updateCurrentTime: c
}) {
  return {
    onCanPlay: () => {
      e(), r();
    },
    onEnded: () => {
      o === "archive" && l && !(n != null && n.locked) && t();
    },
    onError: () => {
      s();
    },
    onLoadedData: () => {
      e(), r();
    },
    onLoadedMetadata: () => {
      e(), r();
    },
    onLoadStart: () => {
      i();
    },
    onPause: () => a(!0),
    onPlay: () => {
      e(), a(!1);
    },
    onPlaying: () => {
      e(), r();
    },
    onRateChange: e,
    onSeeked: () => {
      e(), r();
    },
    onSeeking: () => {
      i();
    },
    onTimeUpdate: c,
    onWaiting: () => {
      i();
    }
  };
}
function Yp({
  sourceUrl: n,
  autoplay: e = !0,
  initialPlaybackState: t,
  playbackBounds: s,
  playbackState: i,
  playerSettings: r,
  onLiveStatusChange: o,
  onLiveModeRequest: a,
  onArchiveUnavailable: l,
  onPlayerSettingsChange: c,
  onPlaybackTimeChange: u,
  onTimelineSeek: d
}) {
  var Ri, Di, Ii, bi, _i, Ci, wi;
  const { t: h } = lt("hlsFlussonicVideoPlayer"), m = ae(null), f = ae(null), g = ae(n), p = ae(h("errors.hlsPlayback")), E = ae(h("errors.codecNotSupported")), y = ae(h("errors.hlsNotSupported")), x = ae(e), S = ae(null), v = ae(null), D = ae(!1), [L, _] = ne(!e), [A, R] = ne(null), [w, B] = ne(null), { liveEdgeMs: M, setLiveEdgeMs: N } = Op(), $ = Ee(() => Rt(n), [n]), { isPlaybackControlled: G, playbackKey: W, playbackMode: U, playbackStartTimeMs: P, setLocalPlaybackState: O } = Sp({
    desiredPlayingRef: x,
    initialPlaybackState: t,
    pendingSeekSecRef: v,
    pendingSeekShouldPlayRef: D,
    playbackState: i,
    setCurrentTimeMs: R
  }), K = G && i != null && i.revision !== W ? i : null, V = (Ri = K == null ? void 0 : K.mode) != null ? Ri : U, J = (K == null ? void 0 : K.mode) === "archive" ? (Di = K.timeMs) != null ? Di : P : (K == null ? void 0 : K.mode) === "live" ? null : P, Z = (Ii = K == null ? void 0 : K.revision) != null ? Ii : W, ie = G && (i == null ? void 0 : i.timeMs) != null ? i.timeMs : A, X = Ee(() => wp(s), [s]), {
    archiveRanges: oe,
    canSeekArchive: Me,
    dvrWindow: Pe,
    liveAvailable: ct,
    streamUnavailable: Ge,
    streamAuthToken: ut,
    streamLiveAvailable: gt,
    streamLiveEdgeMs: Ne,
    timelineWindow: dt,
    videoTracks: tt
  } = Bh({
    liveEdgeMs: M,
    playbackMode: U,
    playbackStartTimeMs: P,
    playlistDurationSec: Qt,
    sourceUrl: n
  }), { getLivePlaybackTimeMs: Ye } = Kh({
    liveAvailable: ct,
    streamLiveEdgeMs: Ne
  });
  Np({
    dvrWindow: Pe,
    liveAvailable: ct,
    onLiveStatusChange: o,
    setLiveEdgeMs: N,
    streamLiveAvailable: gt,
    streamLiveEdgeMs: Ne
  });
  const ee = X != null && X.locked ? !1 : ct, st = X != null && X.locked ? {
    endMs: X.endMs,
    startMs: X.startMs
  } : dt, {
    activePlaybackRate: Oe,
    clearLocalTimelineViewport: pt,
    effectiveTimelineViewport: Dt,
    handleControlsModeChange: It,
    handlePlaybackRateChange: nn,
    handleSelectedVideoTrackIdChange: rn,
    handleTimelineViewportChange: bt
  } = Bp({
    activePlaybackBounds: X,
    displayedPlaybackMode: V,
    onPlayerSettingsChange: c,
    playerSettings: r,
    timelineWindowLoaded: dt != null
  }), {
    handleVideoTrackChange: on,
    selectedVideoTrack: Vt,
    selectedVideoTrackId: He,
    trackSelectionReady: an,
    unsupportedLiveTrack: as
  } = Dp({
    desiredPlayingRef: x,
    onSelectedVideoTrackIdChange: rn,
    pendingSeekSecRef: v,
    pendingSeekShouldPlayRef: D,
    playbackMode: U,
    playbackStartTimeMsRef: S,
    selectedVideoTrackId: r == null ? void 0 : r.selectedVideoTrackId,
    sourceUrl: n,
    videoRef: f,
    videoTracks: tt.data,
    videoTracksLoading: tt.loading
  }), ls = `${n}:${He != null ? He : "auto"}:${W}`, Wt = q(() => {
    Fp(f.current, Oe);
  }, [Oe]), ln = Ee(
    () => as == null ? null : {
      kind: "unsupported-codec",
      message: h("errors.codecNotSupported"),
      recoverable: !1
    },
    [h, as]
  ), cs = Ee(
    () => kd({
      config: $,
      playbackMode: U,
      playbackStartTimeMs: P,
      playlistDurationSec: Qt,
      videoTrackId: He
    }),
    [$, U, P, He]
  ), _t = He != null ? He : (bi = tt.data[0]) == null ? void 0 : bi.id, us = Gh({
    archiveRanges: oe.data,
    archiveRangesError: oe.error,
    archiveRangesLoading: oe.loading,
    authToken: ut,
    config: $,
    playbackBounds: X,
    videoTrackId: _t != null ? _t : null
  }), { archiveResumeTimeMs: pe, effectiveMissingArchiveTimeMs: Se, setMissingArchiveTimeMs: Ie } = bp({
    archiveRanges: oe.data,
    archiveRangesLoading: oe.loading,
    currentTimeMs: ie,
    playbackMode: V,
    playbackStartTimeMs: J,
    resetKey: Z
  }), { liveUnavailableInLiveMode: Tt, playbackUnavailable: cn, visibleError: un } = Cp({
    archiveResumeTimeMs: pe,
    displayedPlaybackMode: V,
    effectiveMissingArchiveTimeMs: Se,
    error: w,
    streamLiveAvailable: gt,
    streamUnavailable: Ge,
    unsupportedLiveTrackError: ln
  }), { markMediaError: Wa, markMediaLoading: Ya, markMediaReady: qa, showMediaLoader: za } = Pp({
    hlsUrl: cs,
    playbackKey: W,
    playbackUnavailable: cn,
    videoRef: f,
    visibleError: un
  }), { fullscreen: ja, toggleFullscreen: Xa } = Kd({
    elementRef: m
  }), {
    clearControlsFocus: Qa,
    controlsMode: Ai,
    controlsVisible: Za,
    handleBlurCapture: Ja,
    handleFocusCapture: el,
    handlePointerEnter: tl,
    handlePointerLeave: sl,
    hideControls: nl,
    showControls: il,
    togglePinControls: rl
  } = Lp({
    controlsMode: r == null ? void 0 : r.controlsMode,
    error: un,
    missingArchiveTimeMs: Se,
    onControlsModeChange: It,
    paused: L,
    playerRootRef: m,
    streamUnavailable: Ge
  }), { handleLiveMode: Li, handleTimelineSeek: ol } = Rp({
    archiveRanges: oe.data,
    archiveRangesLoading: oe.loading,
    canSeekArchive: Me,
    desiredPlayingRef: x,
    dvrWindow: Pe,
    isPlaybackControlled: G,
    liveAvailable: ee,
    onLiveModeRequest: a,
    onPlaybackTimeChange: u,
    onTimelineSeek: d,
    pendingSeekSecRef: v,
    pendingSeekShouldPlayRef: D,
    playbackMode: U,
    playbackStartTimeMsRef: S,
    playlistDurationSec: Qt,
    getLivePlaybackTimeMs: Ye,
    setCurrentTimeMs: R,
    setLocalPlaybackState: O,
    setMissingArchiveTimeMs: Ie,
    setPaused: _,
    timelineWindow: dt,
    videoRef: f
  }), {
    handleArchiveCalendarDaySelect: al,
    handleTimelineZoomIn: ll,
    handleTimelineZoomOut: cl,
    timelineProps: ul,
    timelineZoomDisabled: dl
  } = Vp({
    activePlaybackBounds: X,
    archiveRanges: oe.data,
    canSeekArchive: Me,
    currentTimeMs: ie,
    displayedPlaybackMode: V,
    displayedPlaybackStartTimeMs: J,
    effectiveTimelineViewport: Dt,
    handleLiveMode: Li,
    handleTimelineSeek: ol,
    handleTimelineViewportChange: bt,
    sourceUrl: n,
    streamAuthToken: ut,
    timelineDisplayWindow: st,
    timelineLiveAvailable: ee
  });
  se(() => {
    !G || Se == null || l == null || l(Se);
  }, [Se, G, l]), se(() => {
    if (pe == null || (R(pe), Ie(null), G))
      return;
    const ye = f.current;
    ye == null || ye.pause(), v.current = 0, D.current = x.current, _(!x.current), O((Yt) => ({
      mode: "archive",
      playbackStartTimeMs: pe,
      key: Yt.key + 1
    }));
  }, [
    pe,
    x,
    G,
    v,
    D,
    R,
    O,
    Ie,
    _,
    f
  ]), Tp({
    codecNotSupportedMessageRef: E,
    desiredPlayingRef: x,
    hlsNotSupportedMessageRef: y,
    hlsPlaybackErrorMessageRef: p,
    hlsUrl: cs,
    pendingSeekSecRef: v,
    pendingSeekShouldPlayRef: D,
    playbackKey: W,
    playbackMode: U,
    playlistDurationSec: Qt,
    setError: B,
    setPaused: _,
    sourceBlocked: cn,
    sourceReady: an,
    videoCodec: (_i = Vt == null ? void 0 : Vt.codec) != null ? _i : null,
    videoRef: f
  }), se(() => {
    Wt();
  }, [Wt, ls]);
  const hl = q(
    (ye) => {
      if (!(X != null && X.locked))
        return;
      const Yt = f.current;
      if (x.current = !1, D.current = !1, Yt) {
        const Mi = S.current, ds = Mi == null ? null : (ye - Mi) / 1e3;
        ds != null && Number.isFinite(ds) && ds >= 0 && (Yt.currentTime = ds), Yt.pause();
      }
      R(ye), _(!0);
    },
    [X == null ? void 0 : X.locked]
  ), { updateCurrentTime: fl } = vp({
    controlledRevision: (Ci = i == null ? void 0 : i.revision) != null ? Ci : null,
    controlledTimeMs: (wi = i == null ? void 0 : i.timeMs) != null ? wi : null,
    effectiveMissingArchiveTimeMs: Se,
    getLivePlaybackTimeMs: Ye,
    isPlaybackControlled: G,
    onPlaybackBoundsEnd: hl,
    onPlaybackTimeChange: u,
    paused: L,
    playbackBounds: X,
    playbackMode: U,
    playbackStartTimeMs: P,
    playbackStartTimeMsRef: S,
    setCurrentTimeMs: R,
    setLiveEdgeMs: N,
    streamUnavailable: cn,
    videoRef: f
  });
  se(() => {
    E.current = h("errors.codecNotSupported"), p.current = h("errors.hlsPlayback"), y.current = h("errors.hlsNotSupported");
  }, [h]), se(() => {
    const ye = v.current;
    R(
      U === "archive" ? P != null ? P + Math.round((ye != null ? ye : 0) * 1e3) : null : Ye()
    );
  }, [Ye, U, P, W]), se(() => {
    x.current = e;
    const ye = f.current;
    ye && (e ? ye.play().catch(() => {
      _(!0);
    }) : ye.pause());
  }, [e]), se(() => {
    g.current !== n && (g.current = n, Ie(null), pt(), v.current = null, D.current = !1, G || O((ye) => ({
      mode: "live",
      playbackStartTimeMs: null,
      key: ye.key + 1
    })));
  }, [pt, G, O, Ie, n]);
  const ml = () => {
    const ye = f.current;
    if (ye)
      if (ye.paused) {
        if (Qa(), X != null && X.locked && ie != null && ie >= X.endMs) {
          x.current = !0, D.current = !0, _(!1), d == null || d(X.startMs);
          return;
        }
        x.current = !0, ye.play().catch(() => {
        });
      } else
        x.current = !1, ye.pause();
  }, gl = Mp({
    activePlaybackBounds: X,
    activePlaybackRate: Oe,
    archiveRanges: oe.data,
    archiveRangesError: oe.error,
    archiveRangesLoading: oe.loading,
    canSeekArchive: Me,
    controlsMode: Ai,
    currentTimeMs: ie,
    displayedPlaybackMode: V,
    fullscreen: ja,
    handleArchiveCalendarDaySelect: al,
    handlePlaybackRateChange: nn,
    handleTimelineZoomIn: ll,
    handleTimelineZoomOut: cl,
    handleVideoTrackChange: on,
    hideControls: nl,
    paused: L,
    selectedVideoTrackId: He,
    timelineZoomDisabled: dl,
    toggleFullscreen: Xa,
    togglePinControls: rl,
    togglePlay: ml,
    videoTracks: tt.data
  }), pl = Wp({
    activePlaybackBounds: X,
    applyActivePlaybackRate: Wt,
    handleLiveMode: Li,
    markMediaError: Wa,
    markMediaLoading: Ya,
    markMediaReady: qa,
    playbackMode: U,
    setPaused: _,
    timelineLiveAvailable: ee,
    updateCurrentTime: fl
  });
  return {
    controlsOverlayVisible: Za,
    controlsProps: gl,
    dvrExportState: us,
    playerRootRef: m,
    restoreControlsButton: {
      onClick: il,
      title: h("controls.showPanel"),
      visible: Ai === "hidden" && !Ge
    },
    rootHandlers: {
      onBlurCapture: Ja,
      onFocusCapture: el,
      onPointerEnter: tl,
      onPointerLeave: sl
    },
    status: {
      effectiveMissingArchiveTimeMs: Se,
      liveUnavailableInLiveMode: Tt,
      showMediaLoader: za,
      streamUnavailable: Ge,
      visibleError: un
    },
    timelineProps: ul,
    videoElementKey: ls,
    videoHandlers: pl,
    videoRef: f
  };
}
const qp = "Play", zp = "Pause", jp = "Video quality", Xp = "Playback speed", Qp = "Player settings", Zp = { title: "Archive calendar", open: "Open archive calendar", previousMonth: "Previous month", nextMonth: "Next month", loading: "Checking archive calendar", error: "Failed to load archive calendar", empty: "No recorded days", recordedDay: "Day with recording", openDay: "Open recording for day" }, Jp = { zoomIn: "Zoom timeline in", zoomOut: "Zoom timeline out", seek: "Seek video timeline" }, eT = { unpinPanel: "Unpin panel", pinPanel: "Pin panel", hidePanel: "Hide panel", showPanel: "Show panel" }, tT = { interval: "Download interval", availableFragment: "Download available fragment", starting: "Starting download", checking: "Checking archive", noTrack: "Video quality is unavailable", noArchive: "No recording in selected interval", archiveError: "Failed to check archive", multiple: "Select fragment to download", error: "Failed to download interval" }, sT = { enter: "Enter fullscreen", exit: "Exit fullscreen", toggle: "Fullscreen" }, nT = { hlsPlayback: "Video playback error", hlsNotSupported: "HLS playback is not supported in this browser", codecNotSupported: "The video codec is not supported on this device", liveUnavailable: "Live stream is unavailable", streamUnavailable: "No live stream or recording available", noArchive: "No video for the selected time" }, iT = {
  play: qp,
  pause: zp,
  videoQuality: jp,
  playbackRate: Xp,
  settings: Qp,
  calendar: Zp,
  timeline: Jp,
  controls: eT,
  download: tT,
  fullscreen: sT,
  errors: nT
}, rT = { hlsFlussonicVideoPlayer: iT }, oT = "Reproducir", aT = "Pausa", lT = "Calidad de video", cT = "Velocidad de reproduccion", uT = "Configuracion del reproductor", dT = { title: "Calendario del archivo", open: "Abrir calendario del archivo", previousMonth: "Mes anterior", nextMonth: "Mes siguiente", loading: "Comprobando calendario del archivo", error: "No se pudo cargar el calendario del archivo", empty: "No hay dias con grabacion", recordedDay: "Dia con grabacion", openDay: "Abrir grabacion del dia" }, hT = { zoomIn: "Acercar linea de tiempo", zoomOut: "Alejar linea de tiempo", seek: "Buscar en la linea de tiempo del video" }, fT = { unpinPanel: "Desanclar panel", pinPanel: "Anclar panel", hidePanel: "Ocultar panel", showPanel: "Mostrar panel" }, mT = { interval: "Descargar intervalo", availableFragment: "Descargar fragmento disponible", starting: "Iniciando descarga", checking: "Comprobando archivo", noTrack: "La calidad de video no esta disponible", noArchive: "No hay grabacion en el intervalo seleccionado", archiveError: "No se pudo comprobar el archivo", multiple: "Seleccionar fragmento para descargar", error: "No se pudo descargar el intervalo" }, gT = { enter: "Abrir pantalla completa", exit: "Salir de pantalla completa", toggle: "Pantalla completa" }, pT = { hlsPlayback: "Error de reproduccion de video", hlsNotSupported: "La reproduccion HLS no es compatible con este navegador", codecNotSupported: "El codec de video no es compatible con este dispositivo", liveUnavailable: "La transmision en vivo no esta disponible", streamUnavailable: "No hay transmision en vivo ni grabacion disponible", noArchive: "No hay video para la hora seleccionada" }, TT = {
  play: oT,
  pause: aT,
  videoQuality: lT,
  playbackRate: cT,
  settings: uT,
  calendar: dT,
  timeline: hT,
  controls: fT,
  download: mT,
  fullscreen: gT,
  errors: pT
}, ET = { hlsFlussonicVideoPlayer: TT }, yT = "Воспроизвести", xT = "Пауза", vT = "Качество видео", ST = "Скорость воспроизведения", AT = "Настройки плеера", LT = { title: "Календарь архива", open: "Открыть календарь архива", previousMonth: "Предыдущий месяц", nextMonth: "Следующий месяц", loading: "Проверка календаря архива", error: "Не удалось загрузить календарь архива", empty: "Нет дней с записью", recordedDay: "День с записью", openDay: "Открыть запись за день" }, RT = { zoomIn: "Приблизить таймлайн", zoomOut: "Отдалить таймлайн", seek: "Перемотка видео по таймлайну" }, DT = { unpinPanel: "Открепить панель", pinPanel: "Закрепить панель", hidePanel: "Скрыть панель", showPanel: "Показать панель" }, IT = { interval: "Скачать интервал", availableFragment: "Скачать доступный фрагмент", starting: "Запуск скачивания", checking: "Проверка архива", noTrack: "Качество видео недоступно", noArchive: "В выбранном интервале нет записи", archiveError: "Не удалось проверить архив", multiple: "Выберите фрагмент для скачивания", error: "Не удалось скачать интервал" }, bT = { enter: "Открыть полноэкранный режим", exit: "Выйти из полноэкранного режима", toggle: "Полноэкранный режим" }, _T = { hlsPlayback: "Ошибка воспроизведения видео", hlsNotSupported: "Воспроизведение HLS не поддерживается в этом браузере", codecNotSupported: "Кодек видео не поддерживается на этом устройстве", liveUnavailable: "Live-трансляция недоступна", streamUnavailable: "Нет трансляции и записи", noArchive: "Видео за выбранное время отсутствует" }, CT = {
  play: yT,
  pause: xT,
  videoQuality: vT,
  playbackRate: ST,
  settings: AT,
  calendar: LT,
  timeline: RT,
  controls: DT,
  download: IT,
  fullscreen: bT,
  errors: _T
}, wT = { hlsFlussonicVideoPlayer: CT }, MT = { ru: wT, en: rT, es: ET }, kT = {
  caches: ["localStorage", "cookie"],
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupQuerystring: "lng",
  order: ["localStorage", "cookie", "querystring", "path"]
}, Ns = Pl.createInstance();
Ns.use(Ol).use(kl).init({
  detection: kT,
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  },
  react: {
    useSuspense: !1
  },
  resources: MT
});
function FT(n) {
  var D;
  const { title: e = "video", style: t, camNameAvailable: s, additionalInfoElement: i, displayTimeOffsetMs: r } = n, {
    controlsOverlayVisible: o,
    controlsProps: a,
    dvrExportState: l,
    playerRootRef: c,
    restoreControlsButton: u,
    rootHandlers: d,
    status: h,
    timelineProps: m,
    videoElementKey: f,
    videoHandlers: g,
    videoRef: p
  } = Yp(n), { effectiveMissingArchiveTimeMs: E, liveUnavailableInLiveMode: y, showMediaLoader: x, streamUnavailable: S, visibleError: v } = h;
  return /* @__PURE__ */ de(
    "div",
    {
      className: nt.root,
      "data-hls-video-player-root": !0,
      ref: c,
      style: {
        ...t,
        position: (D = t == null ? void 0 : t.position) != null ? D : "relative"
      },
      ...d,
      children: [
        /* @__PURE__ */ F("video", { className: nt.video, ref: p, ...g }, f),
        x && /* @__PURE__ */ F("div", { className: nt.loadingOverlay, children: /* @__PURE__ */ F(ho, { size: "l" }) }),
        E != null && /* @__PURE__ */ F(Sd, { displayTimeOffsetMs: r, timeMs: E }),
        y && /* @__PURE__ */ F(vd, {}),
        S && /* @__PURE__ */ F(Ad, {}),
        s && /* @__PURE__ */ F("div", { className: nt.cameraNameBadge, children: e }),
        i,
        /* @__PURE__ */ F(jl, { displayTimeOffsetMs: r, exportState: l, title: e }),
        /* @__PURE__ */ de(
          "div",
          {
            className: ue(nt.controlsOverlay, o && nt.controlsOverlayVisible),
            "data-carousel-drag-disabled": !0,
            children: [
              /* @__PURE__ */ F(iu, { ...m, displayTimeOffsetMs: r }),
              /* @__PURE__ */ F(pd, { ...a, displayTimeOffsetMs: r })
            ]
          }
        ),
        u.visible && /* @__PURE__ */ F(
          "button",
          {
            className: nt.restoreControlsButton,
            "data-carousel-drag-disabled": !0,
            onClick: u.onClick,
            title: u.title,
            type: "button",
            children: /* @__PURE__ */ F(wl, {})
          }
        ),
        v && /* @__PURE__ */ F("div", { className: nt.errorOverlay, children: /* @__PURE__ */ F("span", { className: nt.errorOverlayMessage, children: v.message }) })
      ]
    }
  );
}
function WT({ locale: n, ...e }) {
  return se(() => {
    !n || Ns.language === n || Ns.changeLanguage(n);
  }, [n]), /* @__PURE__ */ F(Fl, { i18n: Ns, children: /* @__PURE__ */ F(FT, { ...e }) });
}
export {
  WT as FlussonicHlsVideoPlayer,
  $n as HLS_PLAYBACK_RATE_OPTIONS
};
//# sourceMappingURL=hls-flussonic-video-player.es.js.map
